(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    (typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && typeof require === 'function' ? factory(require('../moment')) : typeof define === 'function' && define.amd ? define(['../moment'], factory) : factory(global.moment);
})(undefined, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return _monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida'
    });

    return es;
});

},{"../moment":2}],2:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    (typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.moment = factory();
})(undefined, function () {
    'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function some(fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            }),
                isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);

            if (m._strict) {
                isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [],
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (_typeof(arguments[i]) === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function keys(obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function func() {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function (tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
                return tok.slice(1);
            }
            return tok;
        }).join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if ((typeof units === 'undefined' ? 'undefined' : _typeof(units)) === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/,
        //       0 - 9
    match2 = /\d\d/,
        //      00 - 99
    match3 = /\d{3}/,
        //     000 - 999
    match4 = /\d{4}/,
        //    0000 - 9999
    match6 = /[+-]?\d{6}/,
        // -999999 - 999999
    match1to2 = /\d\d?/,
        //       0 - 99
    match3to4 = /\d\d\d\d?/,
        //     999 - 9999
    match5to6 = /\d\d\d\d\d\d?/,
        //   99999 - 999999
    match1to3 = /\d{1,3}/,
        //       0 - 999
    match1to4 = /\d{1,4}/,
        //       0 - 9999
    match1to6 = /[+-]?\d{1,6}/,
        // -999999 - 999999
    matchUnsigned = /\d+/,
        //       0 - inf
    matchSigned = /[+-]?\d+/,
        //    -inf - inf
    matchOffset = /Z|[+-]\d\d:?\d\d/gi,
        // +00:00 -00:00 +0000 -0000 or Z
    matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
        // +00 -00 +00:00 -00:00 +0000 -0000 or Z
    matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
        // 123456789 123456789.123
    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function func(input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return (n % x + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function indexOf(o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months) ? this._months : this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,

        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6 // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && typeof module !== 'undefined' && module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key + ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],

    // iso time formats and regexes
    isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || format === undefined && input === '') {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }),
        prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    });

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function now() {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,

        // matching against regexp is expensive, do it on demand
        match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if ((typeof duration === 'undefined' ? 'undefined' : _typeof(duration)) === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest = input.filter(function (item) {
                return !isNumber(item) && isString(input);
            }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),

        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
            return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
            return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    });

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (_typeof(eras[i].since)) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (_typeof(eras[i].until)) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
                return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [{
            since: '0001-01-01',
            until: +Infinity,
            offset: 1,
            name: 'Anno Domini',
            narrow: 'AD',
            abbr: 'AD'
        }, {
            since: '0000-12-31',
            until: -Infinity,
            offset: 1,
            name: 'Before Christ',
            narrow: 'BC',
            abbr: 'BC'
        }],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
        ss: 44, // a few seconds to seconds
        s: 45, // seconds to minute
        m: 45, // minutes to hour
        h: 22, // hours to day
        d: 26, // days to month/week
        w: null, // weeks to month
        M: 11 // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];

        if (thresholds.w != null) {
            a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
        }
        a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if ((typeof argWithSuffix === 'undefined' ? 'undefined' : _typeof(argWithSuffix)) === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if ((typeof argThresholds === 'undefined' ? 'undefined' : _typeof(argThresholds)) === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM' // <input type="month" />
    };

    return hooks;
});

},{}],3:[function(require,module,exports){
"use strict";

var _CookieHelper = require("./utils/CookieHelper");

var _Constantes = require("./utils/Constantes");

var Constantes = _interopRequireWildcard(_Constantes);

var _Login = require("./pages/Login");

var _Commons = require("./pages/Commons");

var _Dashboard = require("./pages/Dashboard");

var _InfoPagos = require("./pages/InfoPagos");

var _MiPlan = require("./pages/MiPlan");

var _Seguridad = require("./pages/Seguridad");

var _Wifi = require("./pages/Wifi");

var _helpers = require("./utils/helpers");

var _Portabilidad = require("./pages/Portabilidad");

var _Visita = require("./pages/Visita");

var _Estadocuenta = require("./pages/Estadocuenta");

var _Paquetes = require("./pages/Paquetes");

var _InfoGral = require("./pages/InfoGral");

var _Recargas = require("./pages/Recargas");

var _Home = require("./pages/Home");

var _MiPlanPrepago = require("./pages/MiPlanPrepago");

var _tarjetaTp = require("./pages/tarjeta/tarjetaTp");

var _cambio = require("./pages/cambiodomicilio/cambio");

var _Adicionales = require("./pages/upsell/Adicionales");

var _Revisa = require("./pages/upsell/Revisa");

var _Mapa = require("./pages/cobertura/Mapa");

var _ValidaCookieDev = require("./utils/ValidaCookieDev");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//import { GetRecomen } from "./pages/Recomendados";
var xcov = document.getElementById("x-cover");
if (xcov != undefined) {
    xcov.parentNode.removeChild(xcov);
}

var path = window.location.pathname;
var url = (0, _helpers.Routes)(Constantes.sitioBase);

var ch = new _CookieHelper.CookieHelper();
ch.leakContainer();

var menuHome = new _Commons.Menu();
var dash = new _Dashboard.Dashboard();
var infoPago = new _InfoPagos.InfoPagos();

var loginfunc = null;

var tipoCliente = ch.props.tipocliente;
if (tipoCliente == 1) {
    $("#tituloFP").html("Medios de recarga");
    $("#h3tituloFP").html("Medios de recarga");
    $("#pdescFP").html("Consulta las diferentes opciones de recarga");
    $("#spanReferenciasFP").html("Recarga en banco");
    $("#referenciaLugaresFP").html("Recarga en tiendas");
    $("#ott-vod-link").hide();
} else {
    $("#tituloFP").html("Formas de pago");
    $("#h3tituloFP").html("Formas de pago");
    $("#pdescFP").html("Consulta las diferentes formas de pago.");
    $("#spanReferenciasFP").html("Referencias bancarias");
    $("#referenciaLugaresFP").html("Lugares de pago");
    $("#ott-vod-link").show();
}

if ((0, _helpers.RouteMatcher)(path, url.login)) {
    loginfunc = new _Login.Login();
    //let modalC = new Modals();
}
if ((0, _helpers.RouteMatcher)(path, url.dashboard)) {
    dash.init();
    dash.iniciodashboard();
    menuHome.init();
}
if ((0, _helpers.RouteMatcher)(path, url.home)) {
    menuHome.init();
    menuHome.setActive("#menuLatHome");
    dash.init();
    if (tipoCliente != 1) {
        var miPlanFun = new _MiPlan.MiPlan("N");
        infoPago.init(3);
        infoPago.loadGetEdoCta(1);
        infoPago.loadFirstCard({ first: "false" }, 2);
    } else {
        var miplan = new _MiPlanPrepago.MiPlanPrepago();
        var home = new _Home.HomePrepago();
        var recargas = new _Recargas.Recargas();
        recargas.init();
    }
}
if ((0, _helpers.RouteMatcher)(path, url.edoCuenta)) {
    menuHome.init();
    menuHome.setActive("#menuLatEstado");
    dash.init();
    infoPago.init(2);
    infoPago.loadGetEdoCta(2);
    infoPago.loadFirstCard({ first: "false" }, 2);
    var estadocuenta = new _Estadocuenta.Estadocuenta();
}

if ((0, _helpers.RouteMatcher)(path, url.formasPago)) {
    dash.init();
    menuHome.init();
    menuHome.setActive("#menuLatFormas");
    infoPago.init(1);
    infoPago.loadFirstCard({ first: "false" }, 1);
    infoPago.loadGetEdoCta(2);
    if (tipoCliente == 1) {
        var _recargas = new _Recargas.Recargas();
        _recargas.cargarOferta();
    }
}

if ((0, _helpers.RouteMatcher)(path, url.paquetes)) {
    menuHome.init();
    menuHome.setActive("#menuLatPaquetes");
    dash.init();
    if (tipoCliente == 1) {
        var _miplan = new _MiPlanPrepago.MiPlanPrepago();
    } else {
        var _miPlanFun = new _MiPlan.MiPlan("N");
        var paq = new _Paquetes.Paquetes();
    }
    var addons = new _Adicionales.Adicionales();
}

if ((0, _helpers.RouteMatcher)(path, url.seguridad)) {
    menuHome.init();
    menuHome.setActive("#menuLatSeguridad");
    dash.init();
    var cpass = new _Seguridad.CambioPass();
}

if ((0, _helpers.RouteMatcher)(path, url.infoGeneral)) {
    menuHome.init();
    menuHome.setActive("#menuLatInformacion");
    dash.init();
    var info = new _InfoGral.InfoGral();
}

if ((0, _helpers.RouteMatcher)(path, url.tarjetaTotalplay)) {
    menuHome.init();
    menuHome.setActive("#menuLatTarjeta");
    dash.init();
    var _card = new _tarjetaTp.tarjetaTp();
}

if ((0, _helpers.RouteMatcher)(path, url.cambioDomicilio)) {
    menuHome.init();
    dash.init();
    var card = new _cambio.CambioDom();
}

if ((0, _helpers.RouteMatcher)(path, url.redWifi)) {
    menuHome.init();
    menuHome.setActive("#menuLatWifi");
    dash.init();
    var wifi = new _Wifi.Wifi();
}

/*if (RouteMatcher(path, url.recomendados)) {
    menuHome.init();
    menuHome.setActive("#menuLatRecom");
    dash.init();
    const recomendadosFunc = new GetRecomen();
}*/

if ((0, _helpers.RouteMatcher)(path, url.portabilidad)) {
    menuHome.init();
    menuHome.setActive("#menuLatPorta");
    dash.init();
    var porta = new _Portabilidad.Portabilidad();
}

if ((0, _helpers.RouteMatcher)(path, url.seguimiento)) {
    menuHome.init();
    menuHome.setActive("#menuLatSeguimiento");
    dash.init();
    var visita = new _Visita.Visita();
}

if ((0, _helpers.RouteMatcher)(path, url.mispagos)) {
    menuHome.init();
    menuHome.setActive("#menuLatPagos");
    dash.init();
    var _recargas2 = new _Recargas.Recargas();
    _recargas2.init();
}

if ((0, _helpers.RouteMatcher)(path, url.revisa)) {
    var revisa = new _Revisa.Revisa();
    dash.init();
    menuHome.init();
}

if ((0, _helpers.RouteMatcher)(path, url.hostpostmap)) {
    dash.init();
    menuHome.init();
    var map = new _Mapa.Mapa();
}

var ott = new _Commons.ChangeOTTBehavior();
dash.setListenersSoporte();

var host = window.location.host;
if (host.includes(".dev")) {
    var validacookiedev = new _ValidaCookieDev.ValidaCookieDev();
} else {
    var _xcov = document.getElementById("divCover");
    if (_xcov != undefined) {
        _xcov.parentNode.removeChild(_xcov);
    }
}

},{"./pages/Commons":4,"./pages/Dashboard":5,"./pages/Estadocuenta":6,"./pages/Home":7,"./pages/InfoGral":8,"./pages/InfoPagos":9,"./pages/Login":10,"./pages/MiPlan":11,"./pages/MiPlanPrepago":12,"./pages/Paquetes":13,"./pages/Portabilidad":14,"./pages/Recargas":15,"./pages/Seguridad":16,"./pages/Visita":17,"./pages/Wifi":18,"./pages/cambiodomicilio/cambio":19,"./pages/cobertura/Mapa":20,"./pages/tarjeta/tarjetaTp":42,"./pages/upsell/Adicionales":43,"./pages/upsell/Revisa":44,"./utils/Constantes":48,"./utils/CookieHelper":49,"./utils/ValidaCookieDev":51,"./utils/helpers":53}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Menu = require('./commons/Menu');

Object.defineProperty(exports, 'Menu', {
  enumerable: true,
  get: function get() {
    return _Menu.Menu;
  }
});

var _ChangeOTTBehavior = require('./commons/ChangeOTTBehavior');

Object.defineProperty(exports, 'ChangeOTTBehavior', {
  enumerable: true,
  get: function get() {
    return _ChangeOTTBehavior.ChangeOTTBehavior;
  }
});

var _Modals = require('./commons/Modals');

Object.defineProperty(exports, 'Modals', {
  enumerable: true,
  get: function get() {
    return _Modals.Modals;
  }
});

},{"./commons/ChangeOTTBehavior":21,"./commons/Menu":22,"./commons/Modals":23}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dashboard = require('./dashboard/Dashboard');

Object.defineProperty(exports, 'Dashboard', {
  enumerable: true,
  get: function get() {
    return _Dashboard.Dashboard;
  }
});

},{"./dashboard/Dashboard":24}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Estadocuenta = require('./estado-cuenta/Estadocuenta');

Object.defineProperty(exports, 'Estadocuenta', {
  enumerable: true,
  get: function get() {
    return _Estadocuenta.Estadocuenta;
  }
});

},{"./estado-cuenta/Estadocuenta":25}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HomePrepago = require('./home/HomePrepago');

Object.defineProperty(exports, 'HomePrepago', {
  enumerable: true,
  get: function get() {
    return _HomePrepago.HomePrepago;
  }
});

},{"./home/HomePrepago":28}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InfoGral = require('./informaciongeneral/InfoGral');

Object.defineProperty(exports, 'InfoGral', {
  enumerable: true,
  get: function get() {
    return _InfoGral.InfoGral;
  }
});

},{"./informaciongeneral/InfoGral":31}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InfoPagos = require('./infopagos/InfoPagos');

Object.defineProperty(exports, 'InfoPagos', {
  enumerable: true,
  get: function get() {
    return _InfoPagos.InfoPagos;
  }
});

},{"./infopagos/InfoPagos":29}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LoginFunciones = require('./login/LoginFunciones');

Object.defineProperty(exports, 'Login', {
  enumerable: true,
  get: function get() {
    return _LoginFunciones.Login;
  }
});

},{"./login/LoginFunciones":32}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MiPlan = require('./miplan/MiPlan');

Object.defineProperty(exports, 'MiPlan', {
  enumerable: true,
  get: function get() {
    return _MiPlan.MiPlan;
  }
});

},{"./miplan/MiPlan":33}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MiPlanPrepago = require('./miplan/MiPlanPrepago');

Object.defineProperty(exports, 'MiPlanPrepago', {
  enumerable: true,
  get: function get() {
    return _MiPlanPrepago.MiPlanPrepago;
  }
});

},{"./miplan/MiPlanPrepago":34}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Paquetes = require('./paquetes/Paquetes');

Object.defineProperty(exports, 'Paquetes', {
  enumerable: true,
  get: function get() {
    return _Paquetes.Paquetes;
  }
});

},{"./paquetes/Paquetes":38}],14:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PortabilidadFunciones = require('./portabilidad/PortabilidadFunciones');

Object.defineProperty(exports, 'Portabilidad', {
  enumerable: true,
  get: function get() {
    return _PortabilidadFunciones.Portabilidad;
  }
});

},{"./portabilidad/PortabilidadFunciones":39}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Recargas = require('./misrecargas/Recargas');

Object.defineProperty(exports, 'Recargas', {
  enumerable: true,
  get: function get() {
    return _Recargas.Recargas;
  }
});

},{"./misrecargas/Recargas":36}],16:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Seguridad = require('./seguridad/Seguridad');

Object.defineProperty(exports, 'CambioPass', {
  enumerable: true,
  get: function get() {
    return _Seguridad.CambioPass;
  }
});

},{"./seguridad/Seguridad":41}],17:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VisitaFunciones = require('./seguimiento-visita/VisitaFunciones');

Object.defineProperty(exports, 'Visita', {
  enumerable: true,
  get: function get() {
    return _VisitaFunciones.Visita;
  }
});

},{"./seguimiento-visita/VisitaFunciones":40}],18:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Wifi = require('./wifi/Wifi');

Object.defineProperty(exports, 'Wifi', {
  enumerable: true,
  get: function get() {
    return _Wifi.Wifi;
  }
});

},{"./wifi/Wifi":45}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CambioDom = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

require("moment/locale/es");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CambioDom = exports.CambioDom = function () {
    function CambioDom() {
        _classCallCheck(this, CambioDom);

        this.stepWrp = $('.steps_wrp');
        this.stepPos = [];

        this.listeners();
        this.props = {
            coordsObj: {},
            direccion: {},
            agenda: {},
            ticket: {},
            tipoenviar: "",
            celular: "",
            correo: "",
            listafechas: [],
            fechasdisponibles: [],
            fechaSeleccionada: null,
            turno: null,
            solounturno: null
        };
        this.ch = new _CookieHelper.CookieHelper();
    }

    _createClass(CambioDom, [{
        key: "listeners",
        value: function listeners() {
            var apuntador = this;
            $('.cobertura').hide();
            //on resize
            $(window).resize(function () {
                var active = apuntador.stepWrp.children('.active');

                active = active.attr('id').replace('step', '');
                apuntador.stepWrp.addClass('reloading');
                apuntador.stepWrp.scrollLeft(0);
                setTimeout(function () {
                    apuntador.readSteps();
                    apuntador.toStep(parseInt(active));
                    apuntador.stepWrp.removeClass('reloading');
                }, 2000);
            });
            //back
            $('.back').click(function () {
                var to = parseInt($(this).data('back'));

                $(this).data('back', to - 1);
                apuntador.readSteps();
                apuntador.toStep(to);
            });
            //mostrar modal para captura de dirección
            $('.address_input').click(function () {
                $('#mdlDireccion').modal('show');
            });
            //cobertura
            $('.cobertura').click(function () {
                var input = $('.address_input'),
                    dis = $(this);

                if (input.val() !== "") {
                    dis.hide();
                    $('#map-canvas .spinner-border').removeClass('d-none');
                    //success
                    apuntador.obtenerFactibilidad();
                } else {
                    input.focus();
                    console.log("Sin datos..");
                }
            });

            //solicitar cambio
            //Envío de codigo 
            $('.address_change').click(function () {
                //fields validation
                var fields = $('#entreCalle_1, #entreCalle_2, #refDir '),
                    invalid = 0;

                fields.each(function () {
                    var val = $(this).val();
                    if (val === "") {
                        invalid++;
                    }
                });
                if (!invalid) {
                    apuntador.props.direccion.referenciaInstalacion = $("#refDir").val();
                    apuntador.props.direccion.entreCallesInstalacion = $("#entreCalle_1").val() + ', ' + $("#entreCalle_2").val();
                    apuntador.props.direccion.numeroInteriorInstalacion = $("#int_num").val();
                    apuntador.props.direccion.direccionFacturacion = $('.address_as_billing input').is(':checked') ? '1' : '0';

                    var cadena = localStorage.getItem("dashboardData");
                    var jsonst = JSON.parse(cadena);

                    var arroba = jsonst.bean.correo.split("@");
                    var longitud2 = arroba[0].length;
                    var antesarroba = arroba[0].substr(longitud2 - 3, longitud2);
                    var valor2 = "******" + antesarroba + "@" + arroba[1];
                    apuntador.props.correo = valor2;
                    $('#modalOtrasFormasEnvio #correoEnviar1').text(valor2);

                    var longitud1 = jsonst.bean.celular.length;
                    var valor1 = "** ** ** *" + jsonst.bean.celular.substr(longitud1 - 3, longitud1);
                    apuntador.props.celular = valor1;
                    $('#modalOtrasFormasEnvio #numeroCelular1').text(valor1);
                    $('#spEntreCalle1').hide();
                    $('#spEntreCalle2').hide();
                    $('#spReferencias').hide();
                    $('#modalOtrasFormasEnvio').modal('show');
                } else {
                    if ($("#entreCalle_1").val() == '') {
                        $('#spEntreCalle1').html('Ingresa entre calle');
                        $('#spEntreCalle1').show();
                    } else {
                        $('#spEntreCalle1').html('');
                        $('#spEntreCalle1').hide();
                    }
                    if ($("#entreCalle_2").val() == '') {
                        $('#spEntreCalle2').html('Ingresa entre calle');
                        $('#spEntreCalle2').show();
                    } else {
                        $('#spEntreCalle2').html('');
                        $('#spEntreCalle2').hide();
                    }
                    if ($("#refDir").val() == '') {
                        $('#spReferencias').html('Ingresa referencias del domicilio');
                        $('#spReferencias').show();
                    } else {
                        $('#spReferencias').html('');
                        $('#spReferencias').hide();
                    }
                }
            });

            $('.address_as_billing input').change(function () {
                var isChecked = $(this).is(':checked');
                apuntador.props.direccion.direccionFacturacion = isChecked ? '1' : '0';
                console.log("Se usará dirección facturacion: ", apuntador.props.direccion.direccionFacturacion);
                /*  fields = $('#new_dir,#ext_num,#int_num');
                  fields.each(function(){
                      var bill = '#bill_' + $(this).attr('id');
                        if(isChecked){
                          $(bill).val($(this).val());    
                      }else{
                          $(bill).val('');
                      }
                  });*/
            });
            $('#new_dir,#ext_num,#int_num').change(function () {
                var asBilling = $('.address_as_billing input').is(':checked');

                if (asBilling) {
                    var val = $(this).val(),
                        id = $(this).attr('id');

                    $('#bill_' + id).val(val);
                }
            });

            //modal code
            $('.cod_wrp > input').keyup(function (e) {
                var val = $(this).val(),
                    all = $('.cod_wrp > input'),
                    next,
                    char = e.which,
                    code = '';

                if (/^[0-9]$/.test(val)) {
                    next = $(this).next();

                    $(this).addClass('completed');

                    if (all.length === all.filter('.completed').length) {
                        all.prop('disabled', true);
                        code = all.map(function () {
                            return this.value;
                        }).get().join("");

                        //code validation demo
                        setTimeout(function () {
                            console.log(code);
                            $('.modal.codigo').modal('hide');
                            $('#modalAgendamiento').modal('show');
                        }, 2000);
                    } else {
                        all.filter(':not(.completed)').eq(0).focus();
                    }
                } else {
                    $(this).val('');
                    $(this).removeClass('completed');
                }
            }).focus(function () {
                $(this).val('').removeClass('completed');
            });

            //modal agenda
            $('.month_wrp .day, .sch_wrp button').click(function () {
                var all = $(this).parent().children(),
                    fullDate;

                all.removeClass('active');
                $(this).addClass('active');
                fullDate = ($('.month_wrp .active').data('val') || "ELIJA DÍA") + " de ";
                fullDate += $('.month_selected').data('val') + " de ";
                fullDate += $('.sch_wrp .active').data('val') + " hrs.";
                $('.full_date').text(fullDate);
            });
            $('#modalAgendamiento .cancel').click(function () {
                location.reload();
            });
            $('#modalAgendamiento .confirm').click(function () {
                var modal = $(this).closest('.modal'),
                    month = modal.find('.month_wrp .active'),
                    schedule = modal.find('.sch_wrp .active'),
                    haveMonth = month.length,
                    haveSchedule = schedule.length;

                if (haveMonth && haveSchedule) {
                    modal.modal('hide');
                    $('.modal.finalizado').modal('show').find('.data.dir').text($('.new_dir').text());
                    $('.modal.finalizado').find('.data.dia').text($('.full_date').text());
                } else {
                    if (haveSchedule) {
                        schedule.trigger('click');
                    } else {
                        modal.find('.sch_wrp button').eq(0).trigger('click');
                    }
                }
            });

            //modal finalizado
            $('.modal.finalizado .ok').click(function () {
                //apuntador.toStep(0);
            });
            //Confirma dirección
            $('#btnConfirmAddr').click(function () {
                apuntador.props.direccion = {
                    calleInstalacion: $('#txtCalle').val(),
                    numeroExterior: $('#txtNumExt').val(),
                    colonia: $('#txtColonia').val(),
                    delegacionInstalacion: $('#txtDelMun').val(),
                    codigoPostal: $('#txtCP').val(),
                    ciudad: $('#txtCiudad').val(),
                    estadoInstalacion: $('#txtEstado').val(),
                    concatena: function concatena() {
                        return this.calleInstalacion + ' ' + this.numeroExterior + ', ' + this.colonia + ', ' + this.delegacionInstalacion + ', ' + this.codigoPostal + ', ' + this.ciudad + ', ' + this.estadoInstalacion + ', México';
                    }
                };
                var respValida = apuntador.validarDireccion();
                console.log("RespValida: ", respValida);
                if (respValida) {
                    $('.address_input').val(apuntador.props.direccion.concatena()).trigger('change');
                    $('#mdlDireccion').modal('hide');
                    $('.cobertura').show();
                }
            });

            $('input, textarea').bind("copy paste", function (e) {
                e.preventDefault();
            });

            $('input:not([type=password]), textarea').on('keypress', function (e) {
                var blockSpecialRegex = /[!$(){}[\]:;<+?%'&\/=^\\>]/;
                var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
                if (blockSpecialRegex.test(key)) {
                    e.preventDefault();
                    return false;
                }
            });
            $("input[name=radioCD]").on("click", function () {
                var valor = this.value;
                apuntador.props.tipoenviar = valor;
                console.log("Seleccionado: " + apuntador.props.tipoenviar);
                $(".caja").removeClass("seleccionada");
                $("#caja" + valor).addClass("seleccionada");
            });

            $("#modalOtrasFormasEnvio #botonEnviarCodigo").on("click", function () {
                if (apuntador.props.tipoenviar != "") {
                    $("#validaEnvio").hide();
                    console.log("Se va a enviar por : " + apuntador.props.tipoenviar);
                    var canalEnvio = '';
                    var medio = '';
                    if (apuntador.props.tipoenviar == 'Correo') {
                        canalEnvio = 'C';
                        medio = apuntador.props.correo;
                        //medio = $('#correoEnviar1').text();
                    } else if (apuntador.props.tipoenviar == 'SMS') {
                        canalEnvio = 'S';
                        medio = apuntador.props.celular;
                        //medio = $('#numeroCelular1').text();
                    }
                    console.log("Canal envio token: ", canalEnvio, medio);
                    apuntador.enviaTokenCD(canalEnvio, medio);
                } else {
                    $("#validaEnvio").show();
                }
            });
            $("#linkEnviarSMS").on("click", function () {
                if (apuntador.props.celular != "") {
                    var objeto = {
                        proceso: '1',
                        type: 'S',
                        codapp: 'TPR_MC_003'
                    };
                    apuntador.enviaTokenCD(objeto);
                }
            });
            $("#codigoU4").on("keyup", function () {
                var valor = $("#codigoU1").val() + $("#codigoU2").val() + $("#codigoU3").val() + $("#codigoU4").val();
                console.log("codigo:" + valor);
                if (valor != "" && valor.length == 4) {
                    apuntador.validarTokenCD(valor);
                } else {
                    $(".codigos").find('.codigo').addClass("erroneo");
                }
            });
            $('#botonConfirmaAgendamiento').unbind("click");

            $("#botonConfirmaAgendamiento").on("click", function () {
                console.log("valores agendamiento");
                console.log("Fecha seleccionada: ", apuntador.props.fechaSeleccionada);
                console.log("Turno seleccionado: ", apuntador.props.turno);
                if (apuntador.props.fechaSeleccionada != null && apuntador.props.turno != null) {
                    $("#modalAgendamiento").modal("hide");
                    var turnofinal = "";
                    var horaturno = "";

                    if (apuntador.props.turno == "turno1") {
                        turnofinal = "Matutino";
                        horaturno = "11:00";
                    }

                    if (apuntador.props.turno == "turno2") {
                        turnofinal = "Vespertino";
                        horaturno = "4:00";
                    }

                    apuntador.props.agenda = {
                        shift: turnofinal,
                        comments: 'comentarios',
                        dateScheduled: apuntador.props.fechaSeleccionada.fechaCompleta,
                        horaScheduled: horaturno
                    };
                    apuntador.crearTicket('factible');
                } else {
                    $("#errorAgenda").show();
                }
                $(this).prop("disabled", true);
            });

            $('#btnFinAgendamiento').on('click', function () {
                var ext = /localhost/.test(location.href) || /totalplay.dev/.test(location.href) ? '.html' : '';
                location.href = "/informacion-general" + ext;
            });
        }
    }, {
        key: "obtenerFactibilidad",
        value: function obtenerFactibilidad() {
            $("#modalLoad").modal('show');
            var apuntador = this;
            var url = CONSTANTES.endpoints.validarFactibilidad;
            //console.log("Consulta factibilidad..."+url);
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            apuntador.props.coordsObj = coordenadas;
            apuntador.props.direccion.latitude = coordenadas.latitud;
            apuntador.props.direccion.longitude = coordenadas.longitud;
            console.log("objentrada factibilidad..", apuntador.props.coordsObj);
            var informacionEncriptada = cifraTP(JSON.stringify(apuntador.props.coordsObj));
            var informacion = { "secdata": informacionEncriptada };
            //console.log("informacion",informacion);

            fetch(url, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                $("#modalLoad").modal('hide');
                if (respuesta.codigo == "0") {
                    var respDec = JSON.parse(descifraTP(respuesta.bean));
                    if (respDec.factibilidad == '1') {
                        apuntador.props.direccion.plaza = respDec.Cuidad;
                        apuntador.props.direccion.regionInstalacion = respDec.Region;
                        apuntador.props.direccion.distrito = respDec.distrito;
                        apuntador.props.direccion.zonaInstalacion = respDec.zona;
                        apuntador.props.direccion.cluster = respDec.nombre_cluster;
                        setTimeout(function () {
                            $('.new_dir').text($('.address_input').val());
                            $('#new_dir').val($('.address_input').val());
                            $('#refDir').val('');
                            $('#entreCalle_1').val('');
                            $('#entreCalle_2').val('');
                            $('#int_num').val('');
                            $('.back').data('back', '1');
                            apuntador.readSteps();
                            apuntador.toStep(2);
                            $('#map-canvas .spinner-border').addClass('d-none');
                        }, 1500);
                    } else {
                        apuntador.crearTicket('nofactible');
                    }
                } else {
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html("Ocurrió un problema durante la consulta de la cobertura, intenta más tarde");
                    $('#modalrespuesta').modal('show');
                }
            }).catch(function (err) {
                console.error(err);
                $("#modalLoad").modal('hide');
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "obtenerDisponibilidad",
        value: function obtenerDisponibilidad() {
            var apuntador = this;
            var url = CONSTANTES.endpoints.obtenerDisponibilidad;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            var informacionEncrip = cifraTP(JSON.stringify({ cluster: apuntador.props.direccion.cluster }));
            var secdata = { secdata: informacionEncrip };
            // console.log("Secdata Disponibilidad: ",secdata);
            fetch(url, {
                method: "POST",
                headers: cabeceraMC,
                body: JSON.stringify(secdata)
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                // console.log("Respuesta disponibilidad: ",respuesta);
                $("#modalLoad").modal('hide');
                if (respuesta.codigo == 0) {
                    if (respuesta.bean.fechasDisponibles != null && respuesta.bean.fechasDisponibles != undefined) {
                        apuntador.props.fechasdisponibles = respuesta.bean.fechasDisponibles;
                        apuntador.props.fechasdisponibles.push({ Fecha: '2022-08-19', Mat: 99, Vesp: 99 });
                        console.log('Fechas disponibles:', apuntador.props.fechasdisponibles);
                        if (apuntador.obtenerFechas()) {
                            $('#botonConfirmaAgendamiento').prop("disabled", false);
                            $('#modalAgendamiento').modal('show');
                        } else {
                            $('#modalAgendamiento').modal('hide');
                        }
                    }
                } else {
                    if (respuesta.codigo == -203) {
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                        $("#msjrespuesta").html('Por el momento no contamos con disponibilidad de instalaci&oacute;n en la direcci&oacute;n ingresada. Por favor int&eacute;ntalo m&aacute;s tarde.');
                        $('#modalrespuesta').modal('show');
                    } else {
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                    }
                }
            }).catch(function (err) {
                $("#modalLoad").modal('hide');
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "crearTicket",
        value: function crearTicket(proceso) {
            var apuntador = this;
            $('#modalLoad').modal('show');
            var url = CONSTANTES.endpoints.crearTicketCD;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());
            var objEntrada = {
                proceso: proceso
            };
            if (proceso == 'nofactible') {
                objEntrada.direccion = apuntador.props.direccion.concatena();
            }
            var informacionEncrip = cifraTP(JSON.stringify(objEntrada));
            var secdata = { secdata: informacionEncrip };
            console.log("Secdata ticket " + proceso + ":", secdata);
            fetch(url, {
                method: "POST",
                headers: cabeceraMC,
                body: JSON.stringify(secdata)
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                //console.log("Respuesta crea ticket: ",respuesta);
                //
                if (respuesta.codigo == 0) {
                    var decInfo = JSON.parse(descifraTP(respuesta.bean));
                    console.log('Desencriptado ticket: ', decInfo);
                    if (proceso == 'factible') {

                        apuntador.props.ticket = {
                            id: decInfo.id,
                            ticketNumero: decInfo.ticketNumero,
                            tipoTicket: decInfo.tipoTicket,
                            subtipoTicket: decInfo.subtipoTicket
                        };
                        apuntador.crearAgendamiento();
                        //Llamar a lambda de agendamiento
                    } else {
                        $('#modalLoad').modal('hide');
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html('<p>No detectamos cobertura en el domicilio ingresado, para más' + ' información dirígete a Atención a Clientes con el siguiente folio:</p>' + '<br/> <p style="font-weight: bold; font-size: 16pt;">' + decInfo.ticketNumero + '</p>');
                        $('#modalrespuesta').modal('show');
                        $('#map-canvas .spinner-border').addClass('d-none');
                    }
                } else {
                    $('#modalLoad').modal('hide');
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html('Ocurrió un problema durante tu solicitud, inténtalo más tarde');
                    $('#modalrespuesta').modal('show');
                    $('#map-canvas .spinner-border').addClass('d-none');
                }
            }).catch(function (err) {
                console.error(err);
            });
        }
    }, {
        key: "enviaTokenCD",
        value: function enviaTokenCD(canal, medio) {
            $('#modalLoad').modal('show');
            var apuntador = this;

            var objeto = { proceso: '1', type: canal, codapp: 'TPR_MC_003' };
            // console.log("Info a enviar token : "+JSON.stringify(objeto));
            var informacionEncriptada = cifraTP(JSON.stringify(objeto));
            var informacion = {
                "secdata": informacionEncriptada
            };

            var url = CONSTANTES.endpoints.dobleautenticacion;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                $("#modalLoad").modal('hide');
                console.log("Respuesta envio token: ", respuesta);
                $('#modalOtrasFormasEnvio').modal('hide');
                if (respuesta.codigo == 0) {
                    // console.log("respuesta",respuesta,"canal",canal);
                    $('#canalEnvioCodigo').text(apuntador.props.tipoenviar);
                    $('#medioEnvioCodigo').text(medio);
                    $('#modalConfirmaContratacion').modal('show');
                } else {
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                    $('#modalrespuesta').modal('show');
                }
            }).catch(function (err) {
                console.error(err);
                $("#modalLoad").modal("hide");
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "validarTokenCD",
        value: function validarTokenCD(codigo) {
            $('#modalLoad').modal('show');
            var apuntador = this;

            var objeto = { proceso: '2', code: codigo, codapp: 'TPR_MC_003' };
            console.log("Info a enviar valida token: " + JSON.stringify(objeto));
            var informacionEncriptada = cifraTP(JSON.stringify(objeto));
            var informacion = {
                "secdata": informacionEncriptada
            };

            var url = CONSTANTES.endpoints.dobleautenticacion;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                console.log("Respuesta valida token: ", respuesta);
                $('#modalConfirmaContratacion').modal('hide');
                if (respuesta.status == 0) {
                    console.log("respuesta", respuesta);
                    $("#codigoU1").val('');
                    $("#codigoU2").val('');
                    $("#codigoU3").val('');
                    $("#codigoU4").val('');
                    apuntador.obtenerDisponibilidad();
                } else {
                    $("#modalLoad").modal('hide');
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                    $('#modalrespuesta').modal('show');
                }
            }).catch(function (err) {
                console.error(err);
                $("#modalLoad").modal("hide");

                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "crearAgendamiento",
        value: function crearAgendamiento() {
            console.log("Se va a crear agendamiento, iniciando flujo....");
            var apuntador = this;
            var objAgendamiento = {
                agenda: apuntador.props.agenda,
                ticket: apuntador.props.ticket,
                direccion: apuntador.props.direccion
                //console.log("Datos reunidos para agendamiento: ", objAgendamiento);

            };var informacionEncriptada = cifraTP(JSON.stringify(objAgendamiento));
            var informacion = {
                "secdata": informacionEncriptada
            };

            var url = CONSTANTES.endpoints.crearAgendamiento;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                console.log("Respuesta proceso de agendamiento: ", respuesta);
                var respuesta = JSON.parse(descifraTP(respuesta));
                $("#modalLoad").modal('hide');
                if (respuesta.codigo == 0) {
                    $('.modal.finalizado .data.dir').text(apuntador.props.direccion.concatena());
                    $('.modal.finalizado .data.dia').text($('#fechaFinalTexto').text());
                    $('.modal.finalizado .data.folio').text(respuesta.bean);
                    $('.modal.finalizado').modal('show');
                } else {
                    console.log("Causa problema: ", respuesta.causa);
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                    $('#modalrespuesta').modal('show');
                }
            }).catch(function (err) {
                console.error(err);
                $("#modalLoad").modal("hide");
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "validarDireccion",
        value: function validarDireccion() {
            var apuntador = this;
            var valida = true;

            if (apuntador.props.direccion.calleInstalacion == null || apuntador.props.direccion.calleInstalacion == '' || apuntador.props.direccion.calleInstalacion == undefined) {
                $('#spCalle').html('Ingresa el nombre de la calle');
                $('#spCalle').show();
                valida = false;
            } else {
                $('#spCalle').html('');
                $('#spCalle').hide();
            }
            if (apuntador.props.direccion.numeroExterior == null || apuntador.props.direccion.numeroExterior == '' || apuntador.props.direccion.numeroExterior == undefined) {
                $('#spNumExt').html('Ingresa el número exterior');
                $('#spNumExt').show();
                valida = false;
            } else {
                $('#spNumExt').html('');
                $('#spNumExt').hide();
            }
            if (apuntador.props.direccion.colonia == null || apuntador.props.direccion.colonia == '' || apuntador.props.direccion.colonia == undefined) {
                $('#spColonia').html('Ingresa el nombre de la colonia');
                $('#spColonia').show();
                valida = false;
            } else {
                $('#spColonia').html('');
                $('#spColonia').hide();
            }
            if (apuntador.props.direccion.delegacionInstalacion == null || apuntador.props.direccion.delegacionInstalacion == '' || apuntador.props.direccion.delegacionInstalacion == undefined) {
                $('#spDelMun').html('Ingresa el municipio o alcaldía');
                $('#spDelMun').show();
                valida = false;
            } else {
                $('#spDelMun').html('');
                $('#spDelMun').hide();
            }
            if (apuntador.props.direccion.codigoPostal == null || apuntador.props.direccion.codigoPostal == '' || apuntador.props.direccion.codigoPostal == undefined) {
                $('#spCP').html('Ingresa el código postal');
                $('#spCP').show();
                valida = false;
            } else {
                if (!/(^\d{5}$)/.test(apuntador.props.direccion.codigoPostal)) {
                    $('#spCP').html('Ingresa un código postal válido');
                    $('#spCP').show();
                    valida = false;
                } else {
                    $('#spCP').html('');
                    $('#spCP').hide();
                }
            }
            if (apuntador.props.direccion.ciudad == null || apuntador.props.direccion.ciudad == '' || apuntador.props.direccion.ciudad == undefined) {
                $('#spCiudad').html('Ingresa el nombre de la ciudad');
                $('#spCiudad').show();
                valida = false;
            } else {
                $('#spCiudad').html('');
                $('#spCiudad').hide();
            }
            if (apuntador.props.direccion.estadoInstalacion == null || apuntador.props.direccion.estadoInstalacion == '' || apuntador.props.direccion.estadoInstalacion == undefined) {
                $('#spEstado').html('Ingresa el estado');
                $('#spEstado').show();
                valida = false;
            } else {
                $('#spEstado').html('');
                $('#spEstado').hide();
            }
            return valida;
        }
    }, {
        key: "obtenerFechas",
        value: function obtenerFechas() {
            var apuntador = this;
            //var myDate = new Date("2021-03-28 15:24:36");
            var ini = (0, _moment2.default)();
            var bandera = true;
            ini.add(1, 'days');

            var horaActual = ini.format('HH');
            console.log("------" + horaActual);
            var horaint = parseInt(horaActual);
            //if(ini.format('ddd').includes("sáb"))ini.add(2, 'days')
            if (horaint > 14 && horaint < 19) apuntador.props.solounturno = "V";
            if (horaint >= 19) ini.add(1, 'days');

            var fechaActual = ini.format('MMMM') + " " + ini.format('YYYY');
            $("#mesAnioActual").html(fechaActual);
            /*var fechaInstalacion=ini.format('dddd')+" "+ini.format('DD')+ " de "+ini.format('MMMM');
            $("#fechaInstalacion").html("Instalación disponible desde "+fechaInstalacion);*/

            var fechas = [];
            if (ini != undefined) {
                var i = 1;
                while (i < 11) {
                    var dianombreabrev = ini.format('ddd');
                    var dias = ini.format('dddd');
                    var dianombre = dias[0].toUpperCase() + dias.slice(1);
                    var mesnombre = ini.format('MMMM');
                    //if(!dianombreabrev.includes("sáb") && !dianombreabrev.includes("dom") ){
                    var arrayfecha = {
                        idFecha: i,
                        fechaCompleta: ini.format('YYYY-MM-DD'),
                        dia: ini.format('DD'),
                        nombrediaA: dianombreabrev,
                        nombredia: dianombre,
                        mes: mesnombre,
                        anio: ini.format('YYYY') };
                    fechas.push(arrayfecha);
                    i++;
                    //}
                    ini.add(1, 'days');
                }
            }
            apuntador.props.listafechas = fechas;
            var htmlfechas = "";
            console.log("apuntador.props.listafechas------>", apuntador.props.listafechas);
            if (apuntador.props.fechasdisponibles.length > 1) {
                fechas.forEach(function (item, index) {
                    apuntador.props.fechasdisponibles.forEach(function (elem) {

                        if (elem.Fecha == item.fechaCompleta) {
                            var mat = parseInt(elem.Mat);
                            var vesp = parseInt(elem.Vesp);
                            item.turno1 = mat;
                            item.turno2 = vesp;
                            console.log(elem.Fecha + "-mat" + mat + "-vesp" + vesp);
                            var estatus = "inactiva";
                            if (mat > 0 || vesp > 0) {
                                estatus = "activa";
                            }
                            htmlfechas += "<div class=\"fecha day " + estatus + "\" id=\"" + item.idFecha + "\">\n\t\t\t\t            \t\t\t\t<p>" + item.nombrediaA + "</p>\n\t\t\t\t            \t\t\t\t<p>" + item.dia + "</p>\n\t\t\t\t            \t\t\t</div>";
                        }
                    });
                });
                $("#fechasCalendario").html(htmlfechas);
                bandera = true;
                apuntador.eventosAgendamiento();
            } else {
                bandera = false;
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html('Por el momento no contamos con disponibilidad de instalaci&oacute;n en la direcci&oacute;n ingresada. Por favor int&eacute;ntalo m&aacute;s tarde.');
                $('#modalrespuesta').modal('show');
            }
            return bandera;
        }
    }, {
        key: "eventosAgendamiento",
        value: function eventosAgendamiento() {
            var apuntador = this;
            $(".fecha.activa").on("click", function () {
                var valor = this.id;
                $("#fechasCalendario").find('.fecha').removeClass("seleccionada");
                $(this).addClass('seleccionada');
                apuntador.props.listafechas.forEach(function (item, index) {
                    if (item.idFecha == valor) {
                        console.log("index---" + item.turno1 + "--" + item.turno2);
                        apuntador.props.fechaSeleccionada = item;
                        $("#mesAnioActual").html(item.mes + " " + item.anio);

                        console.log(apuntador.props.solounturno);
                        $(".horario").find('.turno').removeClass("seleccionado");
                        apuntador.props.turno = null;
                        $("#errorAgenda").hide();

                        if (item.turno1 > 0) {
                            $("#turno1").addClass('activo').removeClass('inactivo');
                        }
                        if (item.turno2 > 0) {
                            $("#turno2").addClass('activo').removeClass('inactivo');
                        }

                        var revisarturno = "";
                        //if(apuntador.props.turno!=null)revisarturno=$("#"+apuntador.props.turno).text().toLowerCase();
                        $("#fechaFinalTexto").html(item.nombredia + " " + item.dia + " de " + item.mes + " " + revisarturno);

                        apuntador.eventosdespuesfecha();
                    }
                });
            });
        }
    }, {
        key: "eventosdespuesfecha",
        value: function eventosdespuesfecha() {
            var apuntador = this;
            $(".turno.activo").on("click", function () {
                var valor = this.id;
                apuntador.props.turno = valor;
                var texto = $(this).text();
                $(".horario").find('.turno').removeClass("seleccionado");
                $(this).addClass('seleccionado');
                $("#fechaFinalTexto").html(apuntador.props.fechaSeleccionada.nombredia + " " + apuntador.props.fechaSeleccionada.dia + " de " + apuntador.props.fechaSeleccionada.mes + " " + texto);
                $('#botonConfirmaAgendamiento').prop("disabled", false);
            });
        }
    }, {
        key: "readSteps",
        value: function readSteps() {
            var apuntador = this;

            this.stepPos = [];
            this.stepWrp.children('div').each(function () {
                apuntador.stepPos.push($(this).position().left);
            });
        }
    }, {
        key: "toStep",
        value: function toStep(step) {
            var ext = /localhost/.test(location.href) || /totalplay.dev/.test(location.href) ? '.html' : '';

            if (step) {
                step = step ? step - 1 : 0;
                this.stepWrp.scrollLeft(this.stepPos[step]);
                this.stepWrp.children('div').removeClass('active');
                this.stepWrp.children('div').eq(step).addClass('active');
            } else {
                location.href = "/informacion-general" + ext;
            }
        }
    }]);

    return CambioDom;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49,"moment":2,"moment/locale/es":1}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Mapa = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _ModalMng = require("../../utils/ModalMng");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Mapa = exports.Mapa = function () {
	function Mapa() {
		_classCallCheck(this, Mapa);

		this.ch = new _CookieHelper.CookieHelper();
		this.props = {
			gMapsLoaded: false,
			mapita: null
		};
		this.init();
	}

	_createClass(Mapa, [{
		key: "init",
		value: function init() {
			var modalManager = new _ModalMng.ModalMng();
			modalManager.createModal(CONSTANTES.modals.recomendados);
			this.initialize();
			this.eventosCM();
		}
	}, {
		key: "initialize",
		value: function initialize() {
			var apuntador = this;

			var myLatlng = new google.maps.LatLng(19.4171218, -99.1364414);
			var mapOptions = {
				zoom: 14,
				center: myLatlng,
				mapTypeControl: false,
				streetViewControl: false,
				mapTypeId: google.maps.MapTypeId.ROADMAP
			};

			apuntador.props.mapita = new google.maps.Map(document.getElementById("mapita"), mapOptions);

			navigator.geolocation.getCurrentPosition(function (position) {
				apuntador.getCodigoPostal(position, apuntador);
			}, function () {

				var positionotra = {
					coords: {
						latitude: 19.4171218,
						longitude: -99.1364414
					}
				};
				apuntador.getCodigoPostal(positionotra, apuntador);
			}, {
				enableHightAccuracy: false,
				timeout: Infinity, maximage: 0
			});
		}
	}, {
		key: "eventosCM",
		value: function eventosCM() {
			var apuntador = this;

			$("#btnDesconectarSessiones").on("click", function () {

				apuntador.desconectarDispositivos();
			});

			$(".close").on("click", function () {
				$(".modal-info").hide();
			});
		}
	}, {
		key: "desconectarDispositivos",
		value: function desconectarDispositivos() {
			$('#modalLoad').modal('show');
			$('#desconectarWifi').modal('hide');

			var apuntador = this;
			var url = CONSTANTES.endpoints.clubmovilSesiones;

			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");
			cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

			fetch(url, {
				method: "POST",
				headers: cabeceraMC
			}).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax load sin parametros";
				}
			}).then(function (respuesta) {
				$('#modalLoad').modal('hide');
				try {
					if (respuesta.status == 0) {
						$('#modalLoad').modal('hide');
						$("#msjTitle").html("\xC9xito");
						$('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
						$('#msjrespuesta').html('Tus dispositivos se desconectaron correctamente.');
						$('#modalrespuesta').modal('show');
					} else if (respuesta.status == 1) {
						$("#msjTitle").html("Atenci&oacute;n");
						$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
						$("#msjrespuesta").html("No hay dispositivos conectados.");
						$('#modalrespuesta').modal('show');
					} else {

						$("#msjTitle").html("Atenci&oacute;n");
						$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
						$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
						$('#modalrespuesta').modal('show');
					}
				} catch (e) {
					console.error(e);
					$('#modalLoad').modal('hide');
					$("#msjTitle").html("Atenci&oacute;n");
					$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
					$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
					$('#modalrespuesta').modal('show');
					throw "Error al traer la informacion";
				}
			}).catch(function (err) {
				console.error("err=>" + err);

				$('#modalLoad').modal('hide');
				$("#msjTitle").html("Atenci&oacute;n");
				$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
				$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
				$('#modalrespuesta').modal('show');
			});
		}
	}, {
		key: "obtenerPuntos",
		value: function obtenerPuntos(position, apuntador, codigoPostal) {

			var details = {
				'latitud': position.coords.latitude,
				'longitud': position.coords.longitude,
				'codigoPostal': codigoPostal
			};

			var myLatlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
			apuntador.props.mapita.setCenter(myLatlng);

			var url = CONSTANTES.endpoints.clubmovilUbicacion;

			var cadena = otpyrc2(JSON.stringify(details));
			var secdata = { secdata: cadena };

			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json");
			//cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());


			fetch(url, {
				method: "POST",
				headers: cabeceraMC,
				body: JSON.stringify(secdata)
			}).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax load sin parametros";
				}
			}).then(function (respuesta) {

				if (respuesta.codigo == 0) {
					return apuntador.showMarkers(respuesta.bean.Sitio, myLatlng);
				} else {
					return Promise.reject(new Error("error al obtener puntos"));
				}
			}).catch(function (err) {
				console.error("err=>" + err);
			});
		}
	}, {
		key: "obtenerPuntosSP",
		value: function obtenerPuntosSP(position, apuntador) {

			var details = { 'latitud': position.coords.latitude, 'longitud': position.coords.longitude };
			var myLatlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
			apuntador.props.mapita.setCenter(myLatlng);

			var url = CONSTANTES.endpoints.clubmovilSP;
			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json");
			//cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());


			fetch(url, {
				method: "POST",
				headers: cabeceraMC,
				body: JSON.stringify(details)
			}).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax load sin parametros";
				}
			}).then(function (respuesta) {
				if (respuesta.estatus == 0) {
					return apuntador.showMarkers(respuesta.bean.Sitio, myLatlng);
				} else {
					return Promise.reject(new Error("error al obtener puntos de sitios publicos"));
				}
			}).then(function () {
				console.log("finalizado....");
			}).catch(function (err) {
				console.error("err=>", err);
			});
		}
	}, {
		key: "getCodigoPostal",
		value: function getCodigoPostal(position, apuntador) {
			var lat = position.coords.latitude,
			    lon = position.coords.longitude,
			    codigoPostal = "";
			var key = 'AIzaSyBk_VICCTcOCpTY1cqrog1zLQfOg_37TRk',
			    url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lon + '&sensor=false&key=' + key;

			$.get(url, function (r) {
				if (r.status == "OK") {
					r.results[0].address_components.forEach(function (element) {
						if (element.types[0] == 'postal_code') {
							codigoPostal = element.long_name;
							apuntador.obtenerPuntos(position, apuntador, codigoPostal);
							apuntador.obtenerPuntosSP(position, apuntador);
						}
					});
				} else {
					reject(r);
				}
			});
		}
		/*mapa */

	}, {
		key: "showMarkers",
		value: function showMarkers(coords, jonas) {
			var apuntador = this;
			var image = "/assets/images/clubwifi/wifi.svg";

			var marker = new google.maps.Marker({
				position: jonas,
				map: apuntador.props.mapita,
				title: 'Domicilio localizado',
				icon: "/assets/images/clubwifi/wifi_new.svg"
			});

			coords.forEach(function (el) {
				//if(el.tipo=="Micronegocios"){
				console.log("pintando...", el);
				var marker = new google.maps.Marker({
					position: { lat: parseFloat(el.latitud), lng: parseFloat(el.longitud) },
					map: apuntador.props.mapita,
					icon: image
				});

				marker.addListener("click", function () {
					apuntador.setLabelMarker(el);
				});
				//}
			});

			return Promise.resolve("TRUE");
		}
	}, {
		key: "setLabelMarker",
		value: function setLabelMarker(el) {
			var title = el.nombreSitio,
			    address = el.direccion;

			if ((title && address) != null) {
				/*if (title.includes("PV Totalplay")) {
        var newTitle = title.replace("PV Totalplay,"," ")
        console.log(`%c${newTitle}`,`color:yellow;`)
        $(".title").removeClass(`text-center`);
        $(".title").html(`<strong>${newTitle}</strong><br><strong class="color-title">Negocio Totalplay</strong>`);
        $(".address").html(`${address}`);
    } else {*/
				$(".title").removeClass("text-center");
				$(".title").html("<strong>" + title + "</strong>");
				$(".address").html("" + address);
			} else {
				if (el.tipo != null && el.tipo == "Micronegocios") {
					$(".title").addClass("text-center");
					$(".title").html("<strong class=\"color-title\">Negocio Totalplay</strong>");
					$(".address").html("");
				}
				if (el.tipo != null && el.tipo == "Residencial") {
					$(".title").addClass("text-center");
					$(".title").html("<strong class=\"text-center\">Sin informaci\xF3n</strong>");
					$(".address").html("");
				}
			}
			$(".modal-info").show();
		}
	}]);

	return Mapa;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49,"../../utils/ModalMng":50}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChangeOTTBehavior = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChangeOTTBehavior = exports.ChangeOTTBehavior = function () {
    function ChangeOTTBehavior() {
        _classCallCheck(this, ChangeOTTBehavior);

        this.props = {
            prod: "https://totalgo.totalplay.com.mx:444/TPW/MiTotalPlay.htm",
            qa: "https://ott.totalplay.com.mx/TPW/MiTotalPlay.htm",
            test: {
                status: 0,
                descripcion: "WelformedTokens",
                bean: {
                    "homeUri": "eh8nTdWmV7mvCOLrkdrcigQEEqxldYrONO3VCMOwazUuEG4b57a+6ARACc/1yPJnwx38jzPs9hqDJadm3ebMJg==",
                    "vodUri": "eh8nTdWmV7mvCOLrkdrcigQEEqxldYrONO3VCMOwazUuEG4b57a+6ARACc/1yPJnd107MCJYfE0PnxmQkVxa0la826VZnFiKv7quLhY4/24=",
                    "liveUri": "eh8nTdWmV7mvCOLrkdrcigQEEqxldYrONO3VCMOwazUuEG4b57a+6ARACc/1yPJn9QlP6n+Tn+zwfMyf2maOdw=="
                }
            }
        };
        this.ch = new _CookieHelper.CookieHelper();
        this.init();
    }

    _createClass(ChangeOTTBehavior, [{
        key: "init",
        value: function init() {
            this.changeBehavior();
        }
    }, {
        key: "changeBehavior",
        value: async function changeBehavior() {
            var aClass = this;
            var tvArchor = document.getElementById("ott-tv-link");
            var vodArchor = document.getElementById("ott-vod-link");
            if (tvArchor != null && tvArchor != undefined && vodArchor != null && vodArchor != undefined) {
                this.loadData().then(function (data) {
                    if (data.ok) {
                        return data.json();
                    } else {
                        throw "Error al Obtener OTT";
                    }
                }).then(function (data) {
                    //comentar
                    //data=aClass.props.test;
                    if (data.status == 0) {
                        aClass.addEvent(tvArchor, data.bean.liveUri);
                        aClass.addEvent(vodArchor, data.bean.vodUri);
                    } else {
                        //throw "Ott Conn not Avaliable";
                    }
                }).catch(function (err) {
                    console.error(err);
                });
            }
        }
    }, {
        key: "addEvent",
        value: function addEvent(obj, token) {
            var _this = this;

            obj.href = "#";
            obj.target = "";
            obj.addEventListener("click", function () {
                var form = document.createElement('form');
                form.method = "POST";
                form.action = _this.props.prod;
                form.target = "_blank";
                var hiddenField = document.createElement('input');
                hiddenField.type = 'hidden';
                hiddenField.name = "miTotal";
                hiddenField.value = token;
                form.appendChild(hiddenField);
                document.body.appendChild(form);
                form.submit();
            });
        }
    }, {
        key: "loadData",
        value: function loadData() {
            var apuntador = this;
            var urlser = CONSTANTES.endpoints.ottParams;
            var data = null;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", apuntador.ch.obtenerCookieWeb());
            return fetch(urlser, {
                method: 'POST',
                headers: cabeceraMC
            });
        }
    }]);

    return ChangeOTTBehavior;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Menu = exports.Menu = function () {
  function Menu() {
    _classCallCheck(this, Menu);

    this.ch = new _CookieHelper.CookieHelper();
  }

  _createClass(Menu, [{
    key: "init",
    value: function init() {
      this.pintarheader();
      this.pintamenulateral();
      this.generaClickGeneral();
      this.headerMenu();
      this.cerrarSesion();
      var $cuenta = $(".pop-cuenta");

      $(document).mouseup(function (e) {
        if (!$cuenta.is(e.target) && $cuenta.has(e.target).length === 0) {
          $cuenta.fadeOut();
        }
      });

      $(".btn-avatar").on("click", function () {
        $cuenta.fadeIn();
      });
    }
  }, {
    key: "pintarheader",
    value: function pintarheader() {
      var tipo = this.ch.props.tipocliente;
      if (tipo == 2 || tipo == 3) {
        $("#menuNormal").hide();
        $("#menuMorosos").show();
      }
      if (tipo == 0 || tipo == 1) {
        $("#menuMorosos").hide();
        $("#menuNormal").show();
      }
    }
  }, {
    key: "pintamenulateral",
    value: function pintamenulateral() {
      var apuntador = this;
      var tipo = this.ch.props.tipocliente;
      var menuop1 = document.getElementById("menuLatPagos");
      var menuop3 = document.getElementById("menuLatRecom");
      var menuop4 = document.getElementById("menuLatEstado");

      var arraymenu = ["menuLatHome", "menuLatFormas", "menuLatPaquetes", "menuLatWifi", "menuLatSeguimiento", "menuLatRecom", "menuLatPorta", "menuLatSeguridad", "menuLatInformacion"];

      if (tipo == 3) {
        arraymenu.forEach(function (elem) {
          var item = document.getElementById(elem);
          if (item != null) item.style.display = "none";
        });
        if (menuop4 != null) menuop4.style.display = "none";
        if (menuop1 != null) menuop1.style.display = "flex";
      } else if (tipo == 2) {
        arraymenu.forEach(function (elem) {
          var item = document.getElementById(elem);
          if (item != null) item.style.display = "none";
        });

        if (menuop1 != null) menuop1.style.display = "none";
        if (menuop4 != null) menuop4.style.display = "flex";
      } else if (tipo == 1) {
        if (menuop1 != null) menuop1.style.display = "flex";
        if (menuop3 != null) menuop3.style.display = "none";
        if (menuop4 != null) menuop4.style.display = "none";

        apuntador.menuslidedown();
      } else {

        if (menuop1 != null) menuop1.style.display = "none";
        if (menuop3 != null) menuop3.style.display = "flex";
        if (menuop4 != null) menuop4.style.display = "flex";

        apuntador.menuslidedown();
      }
    }
  }, {
    key: "menuslidedown",
    value: function menuslidedown() {
      var x = document.querySelectorAll("div.ver-mas");
      x.forEach(function (ele) {
        ele.addEventListener("click", function () {
          var menu = document.querySelector(".menu-lateral");
          if (menu != undefined) {
            if (!menu.classList.contains("menuActivo")) {
              menu.classList.add("menuActivo");
            } else {
              menu.classList.remove("menuActivo");
            }
          }
        });
      });
    }
  }, {
    key: "headerMenu",
    value: function headerMenu() {
      //--------------------------------Header menú-----------------------
      var clic = 0;

      $(".btn-menu").click(function () {
        clic++;

        if (clic == 1) {
          $(".menu-mobile").addClass("active");
        }

        if (clic == 2) {
          $(".menu-mobile").removeClass("active");
          clic = 0;
        }
      });
    }
  }, {
    key: "generaClickGeneral",
    value: function generaClickGeneral() {

      var clase = this;
      return new Promise(function (resolve, reject) {
        try {
          var items = document.getElementById("div-menus");
          for (var i = 0; i <= items.childNodes.length; i++) {
            try {
              if (items.childNodes[i].nodeType === 1) {
                var idele = items.childNodes[i].id;
                var itmenu = document.getElementById(idele);
                var eleref = itmenu.getElementsByTagName("a");
                var linkdir = eleref[0].href;
                clase.generaLinkListener(idele, linkdir);
              }
            } catch (e) {}
          }
        } catch (e) {
          console.log("Resolución no válida");
        }
        resolve(true);
      });
    }
  }, {
    key: "generaLinkListener",
    value: function generaLinkListener(id, url) {
      if (screen.availWidth > 768) {
        document.getElementById(id).addEventListener("click", function () {
          window.location = url;
        }, false);
      }
    }
  }, {
    key: "scriptsAgencia",
    value: function scriptsAgencia() {
      var maxHeight = 0;

      var divs = jQuery(".tarjetas-home .tarjetas-espacio");

      jQuery.each(divs, function () {
        var height = jQuery(this).height();
        if (maxHeight < height) maxHeight = height;
      });
      divs.height(maxHeight);

      //resolve(true);
      //});
    }
  }, {
    key: "cerrarSesion",
    value: function cerrarSesion() {
      var apuntador = this;
      //--------------------------------Cerrar sesion-----------------------
      $("#logout").click(function () {
        apuntador.loadData();
      });
    }
  }, {
    key: "loadData",
    value: function loadData() {
      var apuntador = this;
      var urlser = CONSTANTES.endpoints.logout;
      var data = null;
      var cabeceraMC = new Headers();
      cabeceraMC.append("Content-type", "application/json;charset=utf-8");
      cabeceraMC.append("totalplay", apuntador.ch.obtenerCookieWeb());

      $("#modalLoad").modal("show");
      fetch(urlser, {
        method: "POST",
        headers: cabeceraMC
      }).then(function (data) {
        if (data.ok) {
          return data.json();
        } else {
          throw "Error en la llamada Ajax load sin parametros";
        }
      }).then(function (respuesta) {
        if (respuesta.status == 0) {}
      }).catch(function (err) {
        console.log("Informacion no Disponible");
        console.log("err=>" + err);
      }).finally(function () {
        apuntador.ch.dismissCookie();
        apuntador.ch.leakContainer();
      });
    }
  }, {
    key: "setActive",
    value: function setActive(_container) {
      //console.log("Activare el Elemento" + _container);
      var domEle = document.querySelectorAll(_container);
      if (domEle.length == 1) {
        domEle = domEle[0];
        if (domEle.classList.contains("btn-menu-activo")) {
          domEle.classList.remove("btn-menu-activo");
        }
        domEle.classList.add("btn-menu-activo");
      }
    }
  }]);

  return Menu;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49}],23:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Modals = exports.Modals = function () {
    function Modals() {
        _classCallCheck(this, Modals);

        this.props = {
            pageContainer: document.querySelector('.main-index'),
            modalContainer: document.getElementById('modalWelcome'),
            listContainer: document.querySelector('.main-content__list'),
            listElements: [].concat(_toConsumableArray(document.querySelectorAll('.main-content__list .item-content'))),
            indicatorsContainer: document.querySelector('.main-content__indicators'),
            listIndicators: [].concat(_toConsumableArray(document.querySelectorAll('.main-content__indicators .item-index'))),
            itemWidth: document.querySelector('.item-content').clientWidth,
            listLenght: 0,
            focusItem: 0,
            btnPrev: document.querySelector('.item--prev'),
            btnNext: document.querySelector('.item--next'),
            lsgModal: window.localStorage
        };

        this.init();
    }

    _createClass(Modals, [{
        key: 'init',
        value: function init() {

            //Variable para obtener local storage y definir si el Modal de bienvenida es visible.
            var isModalHide = this.props.lsgModal.getItem('isModal');

            //Valida si el Modal es visible, y ejecuta las funciones requeridas
            if (!isModalHide) {
                this.props.listLenght = this.props.listElements.length - 1;
                this.props.listIndicators[0].classList.add('active');
                this.props.btnNext.classList.add('active');

                this.prevItem();
                this.nextItem();
                this.keyEvents();
                this.indicatorEvent();
                this.closeModal();
                this.resize();
            } else {
                this.props.modalContainer.style.cssText = 'display: none;';
            }
        }
    }, {
        key: 'resize',
        value: function resize() {
            var _this = this;

            window.addEventListener('resize', function () {
                _this.props.itemWidth = document.querySelector('.item-content').clientWidth;
                var moveLeft = _this.props.focusItem * _this.props.itemWidth;
                _this.props.listContainer.style.cssText = 'left: -' + moveLeft + 'px;';
            });
        }

        //Función que recorre la lista y posiciona al siguiente elemento.

    }, {
        key: 'nextItem',
        value: function nextItem() {
            var _this2 = this;

            this.props.btnNext.addEventListener('click', function () {
                _this2.nextFunction();
            });
        }
    }, {
        key: 'nextFunction',
        value: function nextFunction() {
            this.props.btnPrev.classList.add('active');
            this.props.focusItem < this.props.listLenght ? this.props.focusItem++ : this.props.focusItem; //Incrementa el index
            var moveLeft = this.props.focusItem * this.props.itemWidth; //Define cuanto se moverá la lista
            this.props.listContainer.style.cssText = 'left: -' + moveLeft + 'px;'; //Movimiento de la lista
            if (this.props.focusItem === this.props.listLenght) this.props.btnNext.classList.remove('active'); //Si es el último elemento se oculta el botón de siguiente.
            var index = this.props.listIndicators[this.props.focusItem];
            //Agrega la clase al elemento seleccionado y remueve la clase activa de los elementos que no son el seleccionado
            this.props.listIndicators.forEach(function (item) {
                if (item == index) item.classList.add('active');else item.classList.remove('active');
            });
        }

        //Función que recorre la lista y posiciona al elemento anterior.

    }, {
        key: 'prevItem',
        value: function prevItem() {
            var _this3 = this;

            this.props.btnPrev.addEventListener('click', function () {
                _this3.prevFunction();
            });
        }
    }, {
        key: 'prevFunction',
        value: function prevFunction() {
            this.props.btnNext.classList.add('active');
            this.props.focusItem > 0 ? this.props.focusItem-- : this.props.focusItem; //Decremeta el index
            var moveLeft = this.props.focusItem * this.props.itemWidth; //Define cuanto se moverá la lista
            this.props.listContainer.style.cssText = 'left: -' + moveLeft + 'px;'; //Movimiento de la lista
            if (this.props.focusItem === 0) this.props.btnPrev.classList.remove('active'); //Si es el primer elemento se oculta el botón de atrás.
            var index = this.props.listIndicators[this.props.focusItem];
            //Agrega la clase al elemento seleccionado y remueve la clase activa de los elementos que no son el seleccionado
            this.props.listIndicators.forEach(function (item) {
                if (item == index) item.classList.add('active');else item.classList.remove('active');
            });
        }
    }, {
        key: 'indicatorEvent',
        value: function indicatorEvent() {
            var _this4 = this;

            this.props.indicatorsContainer.addEventListener('click', function (e) {
                var target = e.target;
                if (target.classList.contains('item-index')) {
                    _this4.props.focusItem = _this4.props.listIndicators.indexOf(target);
                    var moveLeft = _this4.props.focusItem * _this4.props.itemWidth; //Define cuanto se moverá la lista
                    _this4.props.listContainer.style.cssText = 'left: -' + moveLeft + 'px;'; //Movimiento de la lista
                    if (_this4.props.focusItem === 0) _this4.props.btnPrev.classList.remove('active');else _this4.props.btnPrev.classList.add('active');
                    if (_this4.props.focusItem === _this4.props.listLenght) _this4.props.btnNext.classList.remove('active');else _this4.props.btnNext.classList.add('active');
                    var index = _this4.props.listIndicators[_this4.props.focusItem];
                    //Agrega la clase al elemento seleccionado y remueve la clase activa de los elementos que no son el seleccionado
                    _this4.props.listIndicators.forEach(function (item) {
                        if (item == index) item.classList.add('active');else item.classList.remove('active');
                    });
                }
            });
        }
    }, {
        key: 'keyEvents',
        value: function keyEvents() {
            var _this5 = this;

            document.addEventListener('keydown', function (e) {

                if (e.keyCode === 37) {
                    _this5.prevFunction();
                }
                if (e.keyCode === 39) {
                    _this5.nextFunction();
                }
                if (e.keyCode === 27) {
                    _this5.closeFunction();
                }
            });
        }

        //Función que captura los diferentes eventos para el cierre del Modal.

    }, {
        key: 'closeModal',
        value: function closeModal() {
            var _this6 = this;

            //Botón de cerrar 'X'
            var btnclose = document.querySelector('.main-content__close');
            //Botón de cerrar y no mostrar el modal
            var btnCloseHide = document.getElementById('btnCloseHide');

            btnclose.addEventListener('click', function () {
                _this6.closeFunction();
            });

            btnCloseHide.addEventListener('click', function () {
                _this6.props.lsgModal.setItem('isModal', true);
                _this6.closeFunction();
            });

            //Función para cerrar el Modal al hacer click en una parte diferente al contenido
            this.props.modalContainer.addEventListener('click', function (e) {
                if (document.querySelector('.main-content').contains(e.target)) {} else {
                    _this6.closeFunction();
                }
            });
        }

        //Función general para el cierre del Modal

    }, {
        key: 'closeFunction',
        value: function closeFunction() {
            var _this7 = this;

            this.props.modalContainer.classList.add('hide-modal');
            setTimeout(function () {
                _this7.props.pageContainer.removeChild(_this7.props.modalContainer);
            }, 1000);
        }
    }]);

    return Modals;
}();

},{}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Dashboard = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _ValidacionesGral = require("../../utils/ValidacionesGral");

var val = _interopRequireWildcard(_ValidacionesGral);

var _GenCalendar = require("../home/GenCalendar");

var _ModalMng = require("../../utils/ModalMng");

var _JwtBO = require("../../servicios/bo/JwtBO/JwtBO");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Dashboard = exports.Dashboard = function () {
    function Dashboard() {
        _classCallCheck(this, Dashboard);

        this.jwtBO = new _JwtBO.JwtBO();
        this.ch = new _CookieHelper.CookieHelper();
        this.props = {
            ulCardsContainer: document.querySelector('.user-content-container__list-cards'),
            ulIndicatorsContainer: document.querySelector('.user-content-container__list-indicators'),
            listOfCards: [].concat(_toConsumableArray(document.querySelectorAll('.service-promotion-card'))),
            listIndicators: [].concat(_toConsumableArray(document.querySelectorAll('.indicator-item'))),
            itemWidth: 0,
            moveLeft: 0,
            listLenght: 0,
            focusItem: 0,
            focus: 0,
            advance: 0,
            currentItem: 0,
            correo: "", celular: "",
            tipoenviar: "", tipoenviare: "",
            conregistroamazon: "No",
            segmentacion: null, addons: null, datoscliente: null,
            fueMoroso: null,
            banderaFox: false,
            banderaVSB: false,
            addonsupsell: [],
            addonsupsellN: null,
            promos: null,
            promocionesDisney: null
        };
    }

    _createClass(Dashboard, [{
        key: "init",
        value: function init() {

            var modalManager = new _ModalMng.ModalMng();
            modalManager.createModal(CONSTANTES.modals.recomendados);

            //this.tokenTotalshop();
            this.loadData(CONSTANTES.endpoints.getdatoscliente);
            this.obtenerDatosTarjeta();
            this.solicitarJWT();

            this.listenersAmazonAddon();
            this.setActive();
            this.pintarBanners();
            this.otrosListeners();
            this.carousel('.menu-user-container__user-addons');
        }
    }, {
        key: "otrosListeners",
        value: function otrosListeners() {
            var apuntador = this;
            $("#contrataFox, .bannerFoxMovil").on("click", function () {

                var bandera = false;
                var seleccionados = [];
                var canales = [];
                apuntador.props.addonsupsell.forEach(function (item) {
                    if (item.nombre.includes("STAR")) {
                        bandera = true;
                        item.cantidad = 1;
                        seleccionados.push(item);
                    }
                    if (item.detalle != null && item.tipo == "Canales") {
                        canales.push(item);
                    }
                });
                if (bandera) {
                    localStorage.setItem("canales", JSON.stringify(canales));
                    localStorage.setItem("adicionales", JSON.stringify(seleccionados));
                    window.location = "Revisa.html";
                } else {
                    window.location = "Paquetes.html";
                }
            });

            $(".contratarVSB").on("click", function () {
                var bandera = false;
                var seleccionados = [];
                var equipos = [];
                var costos = [];
                apuntador.props.addonsupsellN.forEach(function (item) {
                    if (item.nombre.includes("video sounbox") || item.nombre.includes("video soundbox")) {
                        bandera = true;
                        item.cantidad = 1;
                        seleccionados.push(item);
                    }
                    if (item.detalle != null && item.tipo == "Equipos") {
                        equipos.push(item);
                    }
                    if (item.tipo == "Costo") {
                        costos.push(item);
                    }
                });
                if (bandera) {
                    localStorage.setItem("equipos", JSON.stringify(equipos));
                    localStorage.setItem("costos", JSON.stringify(costos));
                    localStorage.setItem("adicionales", JSON.stringify(seleccionados));
                    window.location = "Revisa.html";
                } else {
                    window.location = "Paquetes.html";
                }
            });

            /*$('#bannervideosoundBox button').click(function(){
                $('#upsellModal').modal('show')
            });
              $('#bannervideosoundBox .close').click(function(){
                $('#upsellModal').modal('hide');
            });*/

            //clubWifi modal
            $('#clubWifiBanner').click(function () {
                $('#clubWifi').modal('show');
            });
            $('#clubWifi').on('shown.bs.modal', function () {
                apuntador.carousel('.modalSlider', 'div', true);
            });
            //open terms
            $('#clubWifi .modal-body > a').click(function () {
                $('#clubWifi').modal('hide');
                $('#terminos').modal('show');
            });
            //accept terms
            $('#terminos .modal-body > a').click(function () {
                var label = $(this).parent().find('.label'),
                    accept = label.find('input');

                if (accept.is(':checked')) {
                    label.removeClass('invalid');
                    $('#terminos').modal('hide');

                    $(".caja").removeClass("seleccionada");
                    $("input[name=optradio]").prop('checked', false);

                    apuntador.props.tipoenviar = "radio2";
                    apuntador.generarAutenticacion(2);
                } else {
                    label.addClass('invalid');
                }
            });

            $("#codigo4C").keyup(function () {
                var valor = $("#codigo1C").val() + $("#codigo2C").val() + $("#codigo3C").val() + $("#codigo4C").val();
                if (valor != "" && valor.length == 4) {
                    apuntador.validarAutenticacion(valor, 2);
                }
            });

            $("#enviarDeNuevo").click(function () {
                apuntador.props.tipoenviar = "radio2";
                apuntador.generarAutenticacion(2);
            });

            $("#otrasFormas").click(function () {
                $('#codigo').modal('hide');
                $('#modalOtrasFormas').modal('show');
            });

            $("input[name=optradio]").on("click", function () {
                var valor = this.id;
                apuntador.props.tipoenviar = valor;
                $(".cajaCM").removeClass("seleccionada");
                $("#cajaCM" + valor).addClass("seleccionada");
            });

            $("#botonEnviarCodigoCC").on("click", function () {

                $("#validaEnvioCM").hide();
                $("#codigo1C").val("");
                $("#codigo2C").val("");
                $("#codigo3C").val("");
                $("#codigo4C").val("");
                if (apuntador.props.tipoenviar != "") {
                    $("#modalOtrasFormas").modal("hide");
                    apuntador.generarAutenticacion(2);
                } else {
                    $("#validaEnvioCM").show();
                }
            });

            $("#btnCancelarWifi").on("click", function () {
                apuntador.props.tipoenviar = "radio2";
                apuntador.generarAutenticacion(2);
            });
            /* disney */
            $("#contrataUDisney").on("click", function () {

                var seleccionados = [];
                var equipos = [];
                var bandera = false;
                apuntador.props.addonsupsellN.forEach(function (item) {

                    if (item.nombre.toUpperCase() == "DISNEY+") {
                        item.cantidad = 1;
                        equipos.push(item);
                        seleccionados.push(item);
                        bandera = true;
                    }
                });
                if (bandera) {
                    localStorage.setItem("streamings", JSON.stringify(equipos));
                    localStorage.setItem("adicionales", JSON.stringify(seleccionados));
                    window.location = "Revisa.html";
                }
            });

            $("#contrataUStar").on("click", function () {
                var seleccionados = [];
                var equipos = [];
                var bandera = false;
                apuntador.props.addonsupsellN.forEach(function (item) {
                    if (item.nombre.toUpperCase() == "STAR+") {
                        bandera = true;
                        item.cantidad = 1;
                        equipos.push(item);
                        seleccionados.push(item);
                    }
                });

                if (bandera) {
                    localStorage.setItem("streamings", JSON.stringify(equipos));
                    localStorage.setItem("adicionales", JSON.stringify(seleccionados));
                    window.location = "Revisa.html";
                }
            });

            $("#contrataUCombo").on("click", function () {
                var seleccionados = [];
                var equipos = [];
                var bandera = false;

                apuntador.props.addonsupsellN.forEach(function (item) {
                    if (item.nombre.toUpperCase().includes("COMBO")) {
                        item.cantidad = 1;
                        equipos.push(item);
                        seleccionados.push(item);
                        bandera = true;
                    }
                });

                if (bandera) {
                    localStorage.setItem("streamings", JSON.stringify(equipos));
                    localStorage.setItem("adicionales", JSON.stringify(seleccionados));
                    window.location = "Revisa.html";
                }
            });

            $("#btnMigracionStar").on("click", function () {
                var seleccionados = [];
                var equipos = [];
                var bandera = false;
                apuntador.props.addonsupsellN.forEach(function (item) {
                    if (item.nombre.toUpperCase() == "STAR+") {
                        bandera = true;
                        item.cantidad = 1;
                        equipos.push(item);
                        seleccionados.push(item);
                    }
                });

                if (bandera) {
                    localStorage.setItem("streamings", JSON.stringify(equipos));
                    localStorage.setItem("adicionales", JSON.stringify(seleccionados));
                    window.location = "Revisa.html";
                }
            });
        }
    }, {
        key: "getDatosToken",
        value: function getDatosToken() {
            var bean = null;
            return new Promise(function (resolve, reject) {
                if (localStorage != null && localStorage != undefined) {
                    var _bean = localStorage.getItem(CONSTANTES.storedKeys.storeshop);
                    if (_bean != null && _bean != undefined) {
                        _bean = JSON.parse(_bean);
                        _bean.stored = true;
                        resolve(_bean);
                    } else {
                        _bean = { "stored": false };
                        resolve(_bean);
                    }
                } else {
                    bean = { "stored": false };
                    resolve(bean);
                }
            });
        }
    }, {
        key: "solicitarJWT",
        value: function solicitarJWT() {
            var _this = this;

            var apuntador = this;

            this.getDatosToken().then(function (res) {
                if (res.stored) {

                    apuntador.tokenTotalshop();
                } else {

                    _this.jwtBO.solicitaSesionTotalShop().then(function (res) {
                        localStorage.setItem("sesionTTSHP", JSON.stringify(res));
                        localStorage.setItem("sesionTTSHP_Estatus", "0");

                        var redireccion = _this.jwtBO.redireccionar(null);
                        if (redireccion == false) {
                            ;
                            apuntador.tokenTotalshop();
                        } else {
                            if (_this.jwtBO.usuarioValido()) {
                                _this.jwtBO.getInfoRedirect(redireccion);
                            } else {
                                console.log("usuario no valido.....");
                            }
                        }
                    }, function (err) {
                        console.log("error al  solicitar JWT", err);
                    });
                }
            });
        }
    }, {
        key: "tokenTotalshop",
        value: function tokenTotalshop() {
            var _this2 = this;

            if (this.jwtBO.usuarioValido()) {
                $("#getTokenTotalshop").show();
            } else {
                $("#getTokenTotalshop").remove();
            }
            $("#getTokenTotalshop").click(function (e) {
                e.preventDefault();
                if (_this2.jwtBO.usuarioValido()) {
                    _this2.jwtBO.validaTokenRedirecciona(null);
                } else {
                    $("#getTokenTotalshop").remove();
                }
            });
        }
        /*<li class="service-promotion-card upsellMovil" id="bannerFoxR">
                    <div class="spinner-border text-light m-5" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
        </li>*/

    }, {
        key: "pintarBanners",
        value: function pintarBanners() {
            var apuntadorClase = this;
            /*  <li class="service-promotion-card upsellMovil" id="bannerFoxR">
                    <div class="img-service" style="display: flex; justify-content: center;">
                        <img  src="assets/images/banners/Beneficios.png" alt="APP" style="width: 80%">
                    </div>
                    <span class="card-info" style="    bottom: 70px;font-weight: bold;font-size: 14px;">
                    ¡AGRADECEMOS TU LEALTAD CON MÁS <strong class="yllw">RAPIDEZ Y MÁS BENEFICIOS!</strong>
                    </span>
                </li>
            */
            var primerbanner = " \n            <li class=\"service-promotion-card upsellMovil\" id=\"bannerFoxR\">\n                <img  src=\"assets/images/banners/BannerMegasMovil.png\" style=\"width: 100%; height:100%;\" >\n            </li>\n\n            <li class=\"service-promotion-card darkBlue\">\n                <div class=\"spinner-border text-light m-5\" role=\"status\">\n                    <span class=\"sr-only\">Loading...</span>\n                </div\n            </li>\n\n            <li class=\"service-promotion-card\" style=\"\">\n            <div class=\"spinner-border text-light m-5\" role=\"status\">\n                <span class=\"sr-only\">Loading...</span>\n            </div\n        </li> ";

            var htmlbannerspost = primerbanner + "\n             <li class=\"service-promotion-card white sombraCaja\">\n                <div class=\"img-service\" style=\"width: 80%;\">\n                    <img src=\"assets/images/banners/EdoCta.png\" alt=\"APP\">\n                </div>\n                <img class=\"img-logo\" src=\"assets/images/banners/Atencion.png\" alt=\"\" style=\"bottom: 120px;\">\n                <span class=\"card-info\" style=\"bottom: 60px;\">\n                    <strong style=\"font-weight: bolder;font-size:18px;\">Tu estado de cuenta mejor\xF3 para ti</strong>\n                </span>\n                <a href=\"https://www.totalplay.com.mx/archivos/pdf/conoce-tu-estado-de-cuenta-s.pdf\" target=\"_blank\"\n                    style=\"position: absolute;display: contents;\">\n                    <span class=\"btn__blue__outline\">\xA1Descubre m\xE1s!</span>\n                </a>\n           </li>\n            <li class=\"service-promotion-card black sombraCaja\">\n                <div class=\"img-service\">\n                    <img src=\"assets/images/banners/cover@3x-tablet.png\" alt=\"APP\">\n                </div>\n                <img class=\"img-logo\" src=\"assets/images/banners/logo@3x.png\" alt=\"\">\n                <span class=\"card-info\">Lo mejor de Totalplay en la palma de tu mano.</span>\n                <div class=\"card-apps\">\n                    <a href=\"https://apps.apple.com/mx/app/totalplay/id847892109\" target=\"blank\" >\n                    <img src=\"assets/images/apple.png\" alt=\"\"></a>\n                    <a href=\"https://play.google.com/store/apps/details?id=com.TotalPlay.totalplay&hl=es_MX\" target=\"blank\" >\n                    <img src=\"assets/images/google.png\" alt=\"\"></a>\n                </div>\n            </li>";

            var htmlbannerspre = " <li class=\"service-promotion-card amazon-llaves sombraCaja\">\n                <div class=\"img-service\">\n                    <img src=\"assets/images/banners/Amazon/Imagen_Juego_Llaves.jpg\" alt=\"APP\">\n                </div>\n                <img class=\"img-logo\" src=\"assets/images/banners/Amazon/Logotipo_amazon.png\" width=\"125\">\n                <span class=\"card-info\">Usa tu  cuenta independiente a Totalplay</span>\n                <span class=\"btn__blue__solid\" id=\"amazonInfo\">M\xE1s informaci\xF3n</span>\n            </li>\n\n             <li class=\"service-promotion-card black sombraCaja\">\n                <div class=\"img-service\">\n                    <img src=\"assets/images/banners/prepago/Netflix/arte.png\" alt=\"APP\">\n                </div>\n                <img class=\"img-logo\" src=\"assets/images/banners/prepago/Netflix/logo.png\" alt=\"\">\n                <span class=\"card-info\" style=\"font-size: 18px;\">Usa tu  cuenta independiente a Totalplay</span>\n            </li>\n\n             <li class=\"service-promotion-card black sombraCaja\">\n                <div class=\"img-service\">\n                    <img src=\"assets/images/banners/prepago/App/arte.png\" alt=\"APP\">\n                </div>\n                <img class=\"img-logo\" src=\"assets/images/banners/prepago/App/logo.png\" alt=\"\">\n                <span class=\"card-info\" style=\"font-size: 18px;\">Lo mejor de Totalplay en la palma de tu mano.</span>\n                <div class=\"card-apps\">\n                    <a href=\"https://apps.apple.com/mx/app/totalplay/id847892109\" target=\"blank\" >\n                    <img src=\"assets/images/apple.png\" alt=\"\"></a>\n                    <a href=\"https://play.google.com/store/apps/details?id=com.TotalPlay.totalplay&hl=es_MX\" target=\"blank\" >\n                    <img src=\"assets/images/google.png\" alt=\"\"></a>\n                </div>\n            </li>\n\n            <li class=\"service-promotion-card black sombraCaja\">\n                <div class=\"img-service\">\n                    <img src=\"assets/images/banners/prepago/Prepago/Arte.png\" alt=\"APP\">\n                </div>\n                <img class=\"img-logo\" src=\"assets/images/banners/prepago/Prepago/logo.png\">\n                <span class=\"card-info\" style=\"font-size: 18px;\">Mant\xE9n una recarga vigente y sigue conectado</span>\n                <a class=\"btn__blue__outline\" href=\"#\" \n                onclick=\"setTimeout(function(){location.replace('FormasPago.html')},2500);\">Recargar ahora</a>\n            </li>";

            //$("#contenedorBanners").html(htmlbannerspre);
            if (this.ch.props.tipocliente == 1) {
                $("#contenedorBanners").html(htmlbannerspre);
            } else {
                $("#contenedorBanners").html(htmlbannerspost);
            }

            setTimeout(this.bannersCarousel, 2000);
        }
    }, {
        key: "revisarSegmentacion",
        value: function revisarSegmentacion() {
            var apuntador = this;
            var url = CONSTANTES.endpoints.obtenersegmentacion;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                if (respuesta.status == "0") {
                    apuntador.props.segmentacion = respuesta.bean;
                    if (respuesta.bean.oferta != null && respuesta.bean.oferta != undefined) {
                        //if(respuesta.bean.oferta.dias.includes("30"))respuesta.bean.oferta.dias="60 días";
                        $('#numeroDiasAmazon').html(respuesta.bean.oferta.dias);
                        $('#numeroDiasAmazon2').html(respuesta.bean.oferta.dias);

                        if (respuesta.bean.val.estatus != null && respuesta.bean.val.estatus != undefined) {
                            apuntador.props.conregistroamazon = respuesta.bean.val.estatus;
                        }
                        apuntador.pintarBannersAmazon("S");
                    } else {
                        apuntador.revisarDisney();
                        //apuntador.pintarBannersAmazon("N"); 
                    }
                } else {
                    apuntador.revisarDisney();
                    //apuntador.pintarBannersAmazon("N");
                }
            }).catch(function (err) {
                console.error("error segmentacion......", err);
                apuntador.revisarDisney();
                //apuntador.pintarBannersAmazon("N");
            });
        }
    }, {
        key: "pintarBannersAmazon",
        value: function pintarBannersAmazon(valor) {
            var apuntador = this;
            var banner = "\n            <div class=\"img-service img-netflix\">\n                <img  src=\"assets/images/banners/Netflix/ArteNetflix.png\" alt=\"APP\">\n            </div>\n            <img class=\"img-logo\"  style=\"bottom: 110px;\" src=\"assets/images/banners/Netflix/logo-netflix.png\" alt=\"\">\n            <span class=\"card-info\" style=\"font-size: 14px; bottom: 50px;\">Crece tu plan con Netflix incluido. Llama al 800 188 7735</span>\n            <a class=\"tipoboton\" href=\"tel: 8773500 188 \" >\n                <span class=\"btn__blue__outline\">Lo quiero</span>\n            </a>";

            if (valor == "N") {
                $('#contenedorBanners li:nth-child(2)').addClass("service-promotion-card-netflix");
                $('#contenedorBanners li:nth-child(2)').html(banner);
            } else {
                var conaddon = "N";
                this.esperarconaddon().then(function () {
                    apuntador.props.addons.forEach(function (item) {
                        if (item.partner == "Amazon") {
                            conaddon = "S";
                        }
                    });
                    console.log("*******", apuntador.props.conregistroamazon, "-", conaddon, "*******");
                    if (conaddon == "N" && apuntador.props.segmentacion.planunbox == "N"
                    //&& apuntador.props.datoscliente.constb=="S" 
                    && apuntador.props.segmentacion.oferta != null) {
                        var textobanner = "",
                            botonbanner = "";
                        if (apuntador.props.segmentacion.conpromocion == "N") {
                            textobanner = "Los primeros <span style=\"font-size: 18px;\n                        font-weight: bold;\" id=numeroDiasAmazon>" + apuntador.props.segmentacion.oferta.dias + "</span> <br> van por nuestra cuenta.";
                            botonbanner = "M\xE1s informaci\xF3n";
                        } else {
                            textobanner = "Contrata tu membresía Amazon Prime";
                            botonbanner = "Contrata ahora";
                            $("#tituloAA").html("Disfruta de todos los beneficios de Amazon Prime, pagando $99 pesos al mes.");
                            $("#tituloAAA").html("el cargo de <span>$99 al mes.</span>");
                            $("#precioAA").hide();
                        }
                        $('#contenedorBanners li:nth-child(2)').html("<div class=\"img-service img-serviceAmazon\">\n                        <img src=\"assets/images/banners/Amazon/amazonLOTR.jpg\" alt=\"APP\">\n                    </div>\n                    <span class=\"text-white textoMovil\" style=\"font-size: 25px; z-index:999;margin-top: 50% !important\"></span>\n                    <img style=\"z-index:999 !important;\" src=\"assets/images/banners/Amazon/amazonPrimeVideo.png\" width=\"120\">\n                    <span class=\"text-white\" style=\"font-size: 20px;height: 70px !important;margin-top:30px; text-align: center; z-index:999 !important;\">" + textobanner + "</span>\n                    <span class=\"btn__blue__outline\" style=\"width: 200px;\">" + botonbanner + "</span>\n                    <a class=\"tipoboton\" id=\"botonPromoAmazon\" data-toggle=\"modal\" data-target=\"#modalAmazonAddon\" >\n                        <span class=\"btn__blue__outline\" style=\"width: 200px;\">" + botonbanner + "</span>\n                    </a>");
                        // $('#contenedorBanners li:nth-child(2)').css("background-image","linear-gradient(to top, #002860, #00214f, #011a3e, #03132e, #00081f)");
                        // $('#contenedorBanners li:nth-child(2) .img-logo').css("width","100%");
                        $('#contenedorBanners li:nth-child(2)').addClass("service-promotion-card-amazon");
                    } else if (conaddon == "S" && apuntador.props.fueMoroso == "Si" && apuntador.props.conregistroamazon != "Activo" && apuntador.props.segmentacion.tipoplan == "MATCH") {
                        var textobanner = "Reactiva tu membresía Amazon Prime";
                        var botonbanner = "Reactivar ahora";

                        $('#contenedorBanners li:nth-child(2)').html("<div class=\"img-service img-serviceAmazon\">\n                        <img src=\"assets/images/banners/Amazon/ArteMiTiO.jpg\" alt=\"APP\">\n                    </div>\n                    <img class=\"img-logo img-logoAmazon\" src=\"assets/images/banners/Amazon/primeroVideoLogo.png\" alt=\"\">\n                    <span class=\"card-info\">" + textobanner + "</span>\n                    <span class=\"btn__blue__outline\" style=\"width: 200px;\" id=\"botonAmazonR\">" + botonbanner + "</span>\n                    ");
                        $('#contenedorBanners li:nth-child(2)').addClass("service-promotion-card-amazon");
                        apuntador.accionesamazonaddon();
                    } else {
                        apuntador.revisarDisney();
                        //$('#contenedorBanners li:nth-child(2)').addClass("service-promotion-card-netflix");
                        //$('#contenedorBanners li:nth-child(2)').html(banner);
                    }
                }).catch(function (e) {
                    console.log("ERROR AL ESPERAR ADDONS " + e);
                    $('#contenedorBanners li:nth-child(2)').addClass("service-promotion-card-netflix");
                    $('#contenedorBanners li:nth-child(2)').html(banner);
                });
            }
        }
    }, {
        key: "accionesamazonaddon",
        value: function accionesamazonaddon() {
            var apuntador = this;
            $("#botonAmazonR").on("click", function () {
                apuntador.iraAmazon("addon");
            });
        }
    }, {
        key: "esperarconaddon",
        value: function esperarconaddon() {
            var apuntador = this;
            return new Promise(function (resolve, reject) {
                var contador = 0;
                var interval = setInterval(function () {
                    if (apuntador.props.addons != null && apuntador.props.datoscliente != null && apuntador.props.fueMoroso != null) {

                        clearInterval(interval);

                        resolve("FOUND_ADDONS");
                    }
                }, 300);
            });
        }
    }, {
        key: "listenersAmazonAddon",
        value: function listenersAmazonAddon() {
            var apuntador = this;
            $('#botonActivarAmazonAddon').on("click", function () {
                //limpiar datos modal 
                apuntador.props.tipoenviar = "";
                $(".caja").removeClass("seleccionada");
                $("input[name=optradio]").prop('checked', false);
                //llenar datos
                $("#numeroCelular").html(apuntador.props.celular);
                $("#correoEnviar").html(apuntador.props.correo);
                $("#modalAmazonAddon").modal("hide");
                $("#modalAmazonAuth").modal("show");
            });

            $("input[name=optradio]").on("click", function () {
                var valor = this.id;
                apuntador.props.tipoenviar = valor;
                $(".caja").removeClass("seleccionada");
                $("#caja" + valor).addClass("seleccionada");
            });

            $("#botonEnviarAutenticacion").on("click", function () {
                //limpiar modal
                $("#validaEnvio").hide();
                $("#codigo1").val("");
                $("#codigo2").val("");
                $("#codigo3").val("");
                $("#codigo4").val("");
                if (apuntador.props.tipoenviar != "") {
                    $("#modalAmazonAuth").modal("hide");
                    apuntador.generarAutenticacion(1);
                } else {
                    $("#validaEnvio").show();
                }
            });

            $("#codigo4").keyup(function () {
                var valor = $("#codigo1").val() + $("#codigo2").val() + $("#codigo3").val() + $("#codigo4").val();
                if (valor != "" && valor.length == 4) {
                    $("#codigoAmazon").modal('hide');
                    $('#modalLoad').modal('show');
                    apuntador.validarAutenticacion(valor, 1);
                }
            });

            $('#otraformacodigo').on('click', function () {
                $('#codigoAmazon').modal('hide');
                $('#modalAmazonAuth').modal('show');
            });
        }
    }, {
        key: "generarAutenticacion",
        value: function generarAutenticacion(canal) {
            $('#modalLoad').modal('show');
            var apuntador = this;
            var tipoenvio = "",
                valorenvio = "",
                valorenviooculto = "";
            if (apuntador.props.tipoenviar == "radio1") {
                tipoenvio = "Correo";
                apuntador.props.tipoenviare = "correo";
                valorenvio = apuntador.props.datoscliente.correo;
                valorenviooculto = apuntador.props.correo;
            }
            if (apuntador.props.tipoenviar == "radio2") {
                tipoenvio = "SMS";
                apuntador.props.tipoenviare = "celular";
                valorenvio = apuntador.props.datoscliente.celular;
                valorenviooculto = apuntador.props.celular;
            }

            var objeto = { tipoautenticacion: tipoenvio, valor: valorenvio };

            var informacionEncriptada = otpyrc2(JSON.stringify(objeto));
            var informacion = {
                "secdata": informacionEncriptada
            };

            var url = CONSTANTES.endpoints.generarauth;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                $("#modalLoad").modal('hide');
                if (respuesta.status == 0) {
                    console.log("respuesta", respuesta, "canal", canal);
                    if (canal == 1) {
                        $('#medioContacto').html(apuntador.props.tipoenviare);
                        $('#medioContactoId').html(valorenviooculto);
                        $('#codigoAmazon').modal('show');
                    } else {

                        $('#medioContacto1').html(apuntador.props.tipoenviare);
                        $('#medioContactoId1').html(valorenviooculto);
                        $('#codigo').modal('show');
                    }
                } else {
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                    $('#modalrespuesta').modal('show');
                }
            }).catch(function (err) {
                console.error(err);
                $("#modalLoad").modal("hide");

                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "validarAutenticacion",
        value: function validarAutenticacion(valor, canal) {

            var apuntador = this;
            var objeto = { codigo: valor, cuenta: apuntador.props.datoscliente.cuenta };
            var url = CONSTANTES.endpoints.verificarauth;

            fetch(url, {
                method: "POST",
                body: JSON.stringify(objeto)
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                if (respuesta.codigo == 0) {
                    if (canal == 1) {
                        if (apuntador.props.conregistroamazon == "Activo") {
                            $("#modalLoad").modal("hide");
                            $("#msjTitle").html("Atenci&oacute;n");
                            $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                            $("#msjrespuesta").html("Usted ya cuenta con un adicional registrado.");
                            $('#modalrespuesta').modal('show');
                        } else if (apuntador.props.conregistroamazon == "Pendiete" || apuntador.props.conregistroamazon.includes("Pendiente")) {
                            apuntador.irAmazonAddon();
                        } else {
                            apuntador.generarRegistro();
                        }
                    } else {
                        var pathname = window.location.pathname;
                        if (pathname.includes("dashboard")) {
                            apuntador.unirmeClub();
                        } else {
                            apuntador.desUnirmeClub();
                        }
                    }
                } else {
                    $('#codigo').modal('hide');
                    $("#modalLoad").modal("hide");
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                    $('#modalrespuesta').modal('show');
                }
            }).catch(function (err) {
                console.error(err);
                $("#modalLoad").modal("hide");
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "generarRegistro",
        value: function generarRegistro() {
            var apunta = this;
            if (apunta.props.segmentacion != null && apunta.props.segmentacion.oferta != null && apunta.props.segmentacion.oferta != undefined && apunta.props.segmentacion.oferta != "") {
                var segobj = apunta.props.segmentacion;
                if (segobj.conpromocion == "S") segobj.conpromocion = "Y";
                var segmento = segobj.segmentacion;
                if (segobj.segmentacion == "") segmento = "PLATA";

                var objeto = {
                    segmentacion: segmento,
                    poid: segobj.oferta.idproducto,
                    conpromocion: segobj.conpromocion
                };
                var informacionEncriptada = otpyrc2(JSON.stringify(objeto));
                var informacion = { "secdata": informacionEncriptada };

                var url = CONSTANTES.endpoints.generarregistro;
                var cabeceraMC = new Headers();
                cabeceraMC.append("Content-type", "application/json;charset=utf-8");
                cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

                var payload = {
                    method: "POST",
                    headers: cabeceraMC,
                    body: JSON.stringify(informacion)
                };

                fetch(url, payload).then(function (data) {
                    if (data.ok) {
                        return data.json();
                    } else {
                        throw "Error en la llamada Ajax load sin parametros";
                    }
                }).then(function (respuesta) {
                    try {
                        if (respuesta.status == 0) {
                            apunta.irAmazonAddon();
                        } else {
                            $('#modalLoad').modal('hide');
                            $("#msjTitle").html("Atenci&oacute;n");
                            $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                            $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                            $('#modalrespuesta').modal('show');
                        }
                    } catch (e) {
                        console.error(e);
                        $('#modalLoad').modal('hide');
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                        $('#modalrespuesta').modal('show');
                        throw "Error al traer la informacion";
                    }
                }).catch(function (err) {
                    console.error("err=>" + err);
                    $('#modalLoad').modal('hide');
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                });
            } else {
                $('#modalLoad').modal('hide');
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            }
        }
    }, {
        key: "irAmazonAddon",
        value: function irAmazonAddon() {
            var apunta = this;
            var url = CONSTANTES.endpoints.obtenerurlamazon;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var payload = {
                method: "POST",
                headers: cabeceraMC
            };
            fetch(url, payload).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0) {

                        $("#linkAmazonAddon").attr("href", respuesta.bean.redirectUrl);
                        $('#modalLoad').modal('hide');
                        $("#modalAmazonAddonActiva").modal("show");
                    } else {
                        $('#modalLoad').modal('hide');
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                    }
                } catch (e) {
                    console.error(e);
                    $('#modalLoad').modal('hide');
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                console.error("err=>" + err);
                $('#modalLoad').modal('hide');
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "iniciodashboard",
        value: function iniciodashboard() {
            $('#spinnersSaldo').show();
            if (this.ch.props.tipocliente == 1) {
                $("#ott-vod-link").hide();
                $("#opcionesUsuario").css("width", "250px");
                this.recargaActual();
            } else {
                $("#ott-vod-link").show();
                var valorw = "392px";
                if (window.innerWidth < 768) {
                    valorw = "320px";
                }
                $("#opcionesUsuario").css("width", valorw);

                this.validaBundle();
                this.revisarClubWifi();

                //esto para revisar carrusel
                this.escribirsaldo();
                this.revisarMigracion();
            }
        }
    }, {
        key: "recargaActual",
        value: function recargaActual() {

            var url = CONSTANTES.endpoints.getRecargaActual;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var apuntador = this;
            var key = CONSTANTES.storedKeys.recargaprepago;
            this.getDashBoardData(key).then(function (bean) {
                if (bean.stored) {
                    return bean;
                } else {

                    return fetch(url, {
                        method: "POST",
                        headers: cabeceraMC
                    });
                }
            }).then(function (data) {
                if (data.constructor == {}.constructor) {
                    return data;
                } else {
                    if (data.ok) {
                        return data.json();
                    } else {
                        throw "Error en la llamada Ajax a Dashboard";
                    }
                }
            }).then(function (respuesta) {
                $('#spinnersSaldo').hide();
                //$("#user-prepago").show();
                try {
                    if (respuesta.status == 0) {
                        apuntador.storedata(respuesta, key);
                        var objBean = respuesta.bean;
                        if (respuesta.bean != undefined) {
                            if (respuesta.bean.fechaCorta != undefined) {
                                $("#leyendaPrepago").html("Tu Recarga vence el");
                                $("#fechaPrepago").html(respuesta.bean.fechaCorta.fechaFin);
                                $("#linkrecarga").html("Realizar una recarga");
                                //$("#diasRestantes").html(val.prettifyDate(respuesta.bean.tiempoRestante));
                                $("#btnCalendario").css("display", "flex");
                                var gc = new _GenCalendar.GenCalendar();
                                gc.generaCalendario(respuesta.bean);
                            }
                        }
                    } else {

                        $("#leyendaPrepago").html("Tu Recarga est&aacute;");
                        $("#fechaPrepago").html("Vencida");
                        $("#linkrecarga").html("Realizar una recarga");
                        $("#btnCalendario").css("display", "none");
                    }
                } catch (e) {
                    $("#leyendaPrepago").html("Sin informaci&oacute;n");
                    $("#fechaPrepago").html("Sin informaci&oacute;n");
                    console.error(e);
                    throw "Error al traer la informaci0n";
                }
            }).catch(function (err) {
                $('#spinnersSaldo').hide();
                //$("#user-prepago").show();
                $("#leyendaPrepago").html("Sin informaci&oacute;n");
                $("#fechaPrepago").html("Sin informaci&oacute;n");
                console.error(err);
            });
        }
    }, {
        key: "setListenersSoporte",
        value: function setListenersSoporte() {
            var apuntador = this;

            $(".uno").attr("onclick", "window.open('https://apps.apple.com/mx/app/totalplay/id847892109')");
            $(".dos").attr("onclick", "window.open('https://play.google.com/store/apps/details?id=com.TotalPlay.totalplay&hl=es_MX')");

            $("#btnvamos").on("click", function () {
                //apuntador.iranetflix();
                $("#modalNetflix").modal("hide");
            });

            $("#botonActivarAmazon").on("click", function () {
                $("#modalAmazon").modal("hide");
            });

            $('#amazonInfo').click(function () {
                $("#modalAmazon").modal("show");
            });

            $("#botonRectivarAmazon").on("click", function () {
                $("#modalAmazonAddonReactiva").modal("hide");
            });

            $("#btnActivarAhoraAmazon").on("click", function () {
                $("#modalAmazonAddonActiva").modal("hide");
            });
        }
    }, {
        key: "validaBundle",
        value: function validaBundle() {
            var apuntador = this;
            var url = CONSTANTES.endpoints.obtenerbundle;
            var data = null;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0) {
                        if (respuesta.bean != undefined) {
                            var objBean = respuesta.bean;

                            var storebundle = CONSTANTES.storedKeys.storebundle;
                            apuntador.storedata(respuesta, storebundle);

                            Object.keys(objBean).forEach(function (key) {
                                var domQry = "#" + key;
                                var arrayDOM = document.querySelectorAll(domQry);
                                if (arrayDOM.length > 0) {
                                    arrayDOM.forEach(function (objDOM) {
                                        objDOM.innerHTML = objBean[key].toLowerCase();
                                    });
                                }
                            });

                            apuntador.props.addons = respuesta.bean.listaAdodns;
                            apuntador.props.promos = respuesta.bean.listaPromos;
                            console.log("respuesta.bean.eEnrutado" + respuesta.bean.eEnrutado);
                            var fueMorosoantes = "No";

                            if (respuesta.bean.eEnrutado != null && respuesta.bean.eEnrutado != undefined) {
                                fueMorosoantes = respuesta.bean.eEnrutado;
                            }
                            apuntador.props.fueMoroso = fueMorosoantes;

                            if (respuesta.bean.tipoBundle == "Netflix") {
                                apuntador.revisarestatus(fueMorosoantes);
                            }

                            if (respuesta.bean.tipoBundle == "Amazon") {
                                apuntador.revisarestatusamazon(fueMorosoantes);
                            } else if (respuesta.bean.teniaAmazon == "Si" && fueMorosoantes == "Si") {
                                apuntador.revisarestatusamazon("Si");
                            }

                            respuesta.bean.listaAdodns.forEach(function (item) {
                                if (item.partner.includes("Disney") || item.partner.includes("Combo") || item.partner.includes("Star")) {

                                    apuntador.revisarestatusdisney(item.partner);
                                }
                            });
                        }
                    } else {
                        apuntador.pintarBannersAmazon("N");
                    }
                } catch (e) {
                    apuntador.pintarBannersAmazon("N");
                    console.error(e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                apuntador.pintarBannersAmazon("N");
                console.error("err=>" + err);
            });
        }
    }, {
        key: "revisarestatus",
        value: function revisarestatus(fueMoroso) {
            var apuntador = this;
            var url = CONSTANTES.endpoints.verificarnetflix;
            var data = null;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {

                try {
                    if (respuesta.status == 0) {
                        var storenet2 = CONSTANTES.storedKeys.storenet2;
                        apuntador.storedata(respuesta, storenet2);
                        if (respuesta.bean.isActive == "N") {
                            var textobanner = "Vincula tu cuenta";
                            if (fueMoroso == "Si") {
                                textobanner = "Reactiva tu cuenta";
                            }

                            $("#carruselRedimirLicencias").prepend("\n                       <div id=\"user-bundle\" class=\"user-addon\">\n                            <span>Tu paquete incluye</span>\n                            <img src=\"assets/images/bundle/netflix/netflix-app.svg\" alt=\"App de Netflix\">\n                            <span id=\"btnModalNetflix\">" + textobanner + "</span>\n                        </div>");
                            //$("#user-bundle").show();
                            //$('#spinnersSaldo').hide();
                            apuntador.accionesbundle();
                            apuntador.carousel('.menu-user-container__user-addons');
                        }
                    }
                } catch (e) {
                    console.error(e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                console.error("err=>" + err);
            });
        }
    }, {
        key: "iranetflix",
        value: function iranetflix() {
            $('#modalLoad').modal('show');
            var apunta = this;
            var url = CONSTANTES.endpoints.generartok;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var payload = {
                method: "POST",
                headers: cabeceraMC
            };
            fetch(url, payload).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0 && respuesta.bean.Token != undefined && respuesta.bean.Token != null && respuesta.bean.Token != "") {
                        $("#linkNetflix").attr("href", CONSTANTES.EndpointNetflix + respuesta.bean.Token);
                        $('#modalLoad').modal('hide');
                        $("#modalNetflix").modal("show");
                    } else {
                        $("#modalNetflix").modal("hide");
                        $('#modalLoad').modal('hide');

                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                    }
                } catch (e) {
                    console.error(e);
                    $("#modalNetflix").modal("hide");
                    $('#modalLoad').modal('hide');

                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                console.error("err=>" + err);
                $("#modalNetflix").modal("hide");
                $('#modalLoad').modal('hide');

                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "revisarestatusamazon",
        value: function revisarestatusamazon(fueMoroso) {
            var apuntador = this;
            var url = CONSTANTES.endpoints.obtenerestatusamazon;
            var data = null;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0) {
                        if (respuesta.bean.isActive == "N") {
                            console.log("*******fueMoroso" + fueMoroso);
                            var banner3 = "";
                            if (fueMoroso == "Si") {
                                banner3 = "<span id=\"btnModalAA\" style=\"cursor:pointer\">Reactiva tu membres\xEDa</span>\n                            <img src=\"assets/images/bundle/amazon/logo-app.svg\" alt=\"App amazon\">";
                            } else {
                                banner3 = "<span>Tu paquete incluye</span>\n                            <img src=\"assets/images/bundle/amazon/logo-app.svg\" alt=\"App amazon\">\n                            <span id=\"btnModalAmazon\">Activalo ahora</span>";
                            }

                            $("#carruselRedimirLicencias").prepend("\n                            <div id=\"user-bundle\" class=\"user-addon\">" + banner3 + "</div>");

                            apuntador.accionesbundle();
                            apuntador.carousel('.menu-user-container__user-addons');
                        }
                    }
                } catch (e) {
                    console.error(e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                console.error("err=>" + err);
            });
        }
    }, {
        key: "iraAmazon",
        value: function iraAmazon(tipo) {
            $('#modalLoad').modal('show');
            var apunta = this;
            var url = CONSTANTES.endpoints.obtenerurlamazon;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var payload = {
                method: "POST",
                headers: cabeceraMC
            };
            fetch(url, payload).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0) {
                        if (tipo == "bundle") {
                            $("#linkAmazon").attr("href", respuesta.bean.redirectUrl);
                            $('#modalLoad').modal('hide');
                            $("#modalAmazon").modal("show");
                        }
                        if (tipo == "addon") {
                            $("#linkReactivaAmazon").attr("href", respuesta.bean.redirectUrl);
                            $('#modalLoad').modal('hide');
                            $("#modalAmazonAddonReactiva").modal("show");
                        }
                    } else {
                        $("#modalAmazon").modal("hide");
                        $('#modalLoad').modal('hide');

                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                    }
                } catch (e) {
                    console.error(e);
                    $("#modalAmazon").modal("hide");
                    $('#modalLoad').modal('hide');

                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                console.error("err=>" + err);
                $("#modalAmazon").modal("hide");
                $('#modalLoad').modal('hide');

                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "revisarestatusdisney",
        value: function revisarestatusdisney(tipo) {
            var apuntador = this;
            var url = CONSTANTES.endpoints.obtenerEstatusDisney;
            var data = null;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0) {
                        if (respuesta.bean.isActivated == "N") {

                            var img = "",
                                clase = "";

                            if (tipo == "Star+") {
                                img = "star.svg";clase = "star";
                            }
                            if (tipo == "Disney+") {
                                img = "disney.svg";clase = "disney";
                            }
                            if (tipo.includes("Combo")) {
                                img = "combo.svg";clase = "combo";
                            }

                            $("#carruselRedimirLicencias").prepend("\n                            <div id=\"user-bundle\" class=\"user-addon\">\n                                <span>Activa tu suscripci\xF3n</span>\n                                <img src=\"assets/images/adicionales/" + img + "\" alt=\"App disney\" class=\"mx-auto\"/>\n                                <span class=\"" + clase + "\">\n                                    <a id=\"btnModalDisney\" target=\"blank\" >Activar ahora</a>\n                                </span>\n                            </div>");

                            //apuntador.accionesbundle();
                            apuntador.carousel('.menu-user-container__user-addons');
                            apuntador.iraDisney(tipo);
                        }
                    }
                } catch (e) {
                    console.error(e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                console.error("err=>" + err);
            });
        }
    }, {
        key: "iraDisney",
        value: function iraDisney(tipo) {
            //$('#modalLoad').modal('show');
            var apunta = this;
            var url = CONSTANTES.endpoints.obtenerUrlDisney;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var payload = {
                method: "POST",
                headers: cabeceraMC
            };
            fetch(url, payload).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {

                try {
                    console.log("url disney..", respuesta);
                    if (respuesta.status == 0) {
                        $("#btnModalDisney").attr("href", respuesta.bean.token);

                        /*$("#susDisneyTitutlo").html("Comienza tu activación en "+tipo);
                        $("#linkDisneyA").attr("href",respuesta.bean.token);
                        $('#modalLoad').modal('hide');
                        $("#modalDisneyA").modal("show");*/
                    }
                    /*else{
                        $("#modalDisneyA").modal("hide");
                        $('#modalLoad').modal('hide');
                          $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                    }*/
                } catch (e) {
                    console.error(e);
                    /*$("#modalDisneyA").modal("hide");
                    $('#modalLoad').modal('hide');
                      $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');*/
                    throw "Error al traer la informacion de la url";
                }
            }).catch(function (err) {
                console.error("err=>" + err);
                /*$("#modalDisneyA").modal("hide");
                $('#modalLoad').modal('hide');
                  $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');*/
            });
        }
    }, {
        key: "accionesbundle",
        value: function accionesbundle() {
            var apuntador = this;

            $("#btnModalAmazon").on("click", function () {
                apuntador.iraAmazon("bundle");
            });

            $("#btnModalAA").on("click", function () {
                apuntador.iraAmazon("addon");
            });

            $("#btnModalNetflix").on("click", function () {
                apuntador.iranetflix();
            });

            /*$("#btnModalDisney").on("click",function(){
                var valor=this.class;
                console.log("-----------------------------classLis",valor);
                apuntador.iraDisney(valor);
            });*/
        }
    }, {
        key: "escribirsaldo",
        value: function escribirsaldo() {
            var apunta = this;
            var url = CONSTANTES.endpoints.saldo;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var payload = {
                method: "POST",
                headers: cabeceraMC
            };
            fetch(url, payload).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {

                try {
                    if (respuesta.status == 0) {
                        if (respuesta.bean != undefined) {
                            var saldoActCmp = parseFloat(respuesta.bean.saldoActual.replace("$", "").replace(",", ""));

                            if (respuesta.bean.statusCuenta == "sinsaldo") {
                                $("#statuspago").html("Sin saldo pendiente");
                                $("#cantSaldo").html(respuesta.bean.saldoActual);
                            }

                            var ppp = parseFloat(respuesta.bean.totalPagoDesc.replace("$", "").replace(",", ""));
                            var ppl = parseFloat(respuesta.bean.totalPago.replace("$", "").replace(",", ""));

                            if (respuesta.bean.statusCuenta == "prontopago") {
                                $("#statuspago").html("Saldo pendiente");
                                if (saldoActCmp != ppl) {
                                    saldoActCmp = ppp - (ppl - saldoActCmp);
                                    $("#cantSaldo").html('$' + saldoActCmp);
                                } else {
                                    $("#cantSaldo").html(respuesta.bean.totalPagoDesc);
                                }
                            }

                            if (respuesta.bean.statusCuenta == "limitepago") {
                                $("#statuspago").html("Saldo pendiente");
                                if (saldoActCmp != ppl) {
                                    $("#cantSaldo").html("$" + saldoActCmp);
                                } else {
                                    $("#cantSaldo").html(respuesta.bean.totalPago);
                                }
                            }

                            if (respuesta.bean.statusCuenta == "moroso") {
                                $("#statuspago").html("Saldo pendiente");
                                //$("#statuspago").html("Saldo pendiente <br> SIN SERVICIO");
                                $("#cantSaldo").html(respuesta.bean.saldoActual);
                            }

                            //$("#user-saldo").show();
                            //$('#spinnersSaldo').hide();
                        } else {
                            $("#statuspago").html("Sin información");
                            $("#cantSaldo").html("<br>");
                            //$("#user-saldo").show();
                            $('#spinnersSaldo').hide();
                        }
                    }
                } catch (e) {
                    console.error(e);
                    throw "Error al traer la informacion";
                    $("#statuspago").html("Sin información");
                    $("#cantSaldo").html("<br>");
                    //$("#user-saldo").show();
                    $('#spinnersSaldo').hide();
                }
            }).catch(function (err) {
                console.error("err=>" + err);
            });
        }
    }, {
        key: "getMobileOperatingSystem",
        value: function getMobileOperatingSystem() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // Windows Phone debe ir primero porque su UA tambien contiene "Android"
            if (/windows phone/i.test(userAgent)) {
                return "Windows Phone";
            }

            if (/android/i.test(userAgent)) {
                return "Android";
            }

            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iOS";
            }

            if (/Win32|Win64|Windows|WinCE/.test(userAgent)) {
                return "Desktop Windows";
            }

            if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
                return "Desktop Macintosh";
            }

            return "desconocido";
        }
    }, {
        key: "loadData",
        value: function loadData(url) {
            $('#spinnersName').show();
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());
            var apuntador = this;
            var key = CONSTANTES.storedKeys.dashboard;
            this.getDashBoardData(key).then(function (bean) {
                if (bean.stored) {
                    return bean;
                } else {
                    return fetch(url, {
                        method: "POST",
                        headers: cabeceraMC
                    });
                }
            }).then(function (data) {
                if (data.constructor == {}.constructor) {
                    return data;
                } else {
                    if (data.ok) {
                        return data.json();
                    } else {
                        throw "Error en la llamada Ajax a Dashboard";
                    }
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0) {
                        //apuntador.solicitarJWT();
                        var objBean = null;
                        if (respuesta.bean.secbase != null) {
                            var devalor = otpyrc4(respuesta.bean.secbase);
                            objBean = JSON.parse(devalor);
                        } else {
                            objBean = respuesta.bean;
                        }
                        if (objBean != null) {
                            var objfinal = { status: 0, descripcion: "Desencriptado", bean: objBean };
                            apuntador.storedata(objfinal, key);
                            apuntador.props.datoscliente = objBean;
                            $('#spinnersName').hide();
                            $('#divNombre').show();

                            Object.keys(objBean).forEach(function (key) {
                                if (key == "nombre") {
                                    var username1 = document.querySelector("#nombrecompleto");
                                    if (username1 != null && username1 != undefined) {
                                        username1.innerHTML = objBean[key].toLowerCase();
                                    }
                                }
                                if (key == "celular") {
                                    var valor = objBean[key];
                                    var longitud1 = valor.length;
                                    var valor1 = "** ** ** *" + valor.substr(longitud1 - 3, longitud1);
                                    apuntador.props.celular = valor1;
                                }
                                if (key == "correo") {
                                    var valorcorreo = objBean[key];
                                    var arroba = valorcorreo.split("@");
                                    var longitud2 = arroba[0].length;
                                    var antesarroba = arroba[0].substr(longitud2 - 3, longitud2);
                                    var valor2 = "******" + antesarroba + "@" + arroba[1];
                                    apuntador.props.correo = valor2;
                                }

                                var domQry = "#" + key;
                                var arrayDOM = document.querySelectorAll(domQry);
                                if (arrayDOM.length > 0) {
                                    arrayDOM.forEach(function (objDOM) {
                                        objDOM.innerHTML = objBean[key].toLowerCase();
                                    });
                                }
                            });
                        } else {
                            $('#spinnersName').hide();
                            $('#divNombre').show();

                            throw "No data avaliable";
                        }
                    } else {
                        throw "No data avaliable";
                    }
                } catch (e) {
                    $('#spinnersName').hide();
                    $('#divNombre').show();

                    console.error(e);
                    throw "Error al traer la informaci0n";
                }
            }).catch(function (err) {
                $('#spinnersName').hide();
                $('#divNombre').show();
                console.error(err);
            });
        }
    }, {
        key: "obtenerDatosTarjeta",
        value: function obtenerDatosTarjeta() {

            var url = CONSTANTES.endpoints.creditoTarjeta;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                if (respuesta.status == 0) {

                    $("#menuLatTarjeta").css("display", "flex");
                    var tarjetita = respuesta.bean[0];
                    var saldopagarTC = parseFloat((tarjetita.saldo_actual + "").replace("-", "")).toFixed(2);
                    $(".cantSaldoCreditoP").html("$" + saldopagarTC);

                    var sadloFormato = Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(saldopagarTC);
                    $(".cantSaldoCredito").html(sadloFormato);

                    $(".fechalimiteCredito").html(respuesta.bean[0].fecha_limite_pago);
                    $("#tarjetaCredito").show();
                    $("#pendienteCredito").show();

                    var longitud1 = tarjetita.terminacion_tarjeta.length;
                    var tarjeta = tarjetita.terminacion_tarjeta.substring(longitud1 - 4, longitud1);
                    $(".num_tarjeta").html("Tarjeta " + tarjeta);

                    var creditoD = Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(tarjetita.credito_disponible);
                    $(".creditoDisponible").html(creditoD);

                    var creditoL = Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(tarjetita.limite_credito);
                    $(".cantLimiteCredito").html(creditoL);

                    $(".fechalimitepagocredito").html(tarjetita.fecha_limite_pago);
                    $(".fechacortecredito").html(tarjetita.fecha_corte);

                    var saldoMinimo = Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(tarjetita.pago_minimo);
                    $(".pagominimo").html(saldoMinimo);

                    var saldoSinInteres = Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(tarjetita.pago_no_genera_intereses);
                    $(".pagonogenerarintereses").html(saldoSinInteres);

                    //$("#nombrecredito").html(tarjetita.nombre);
                    $("#nomInicio").html(tarjetita.nombre + "!");
                    $("#vigencia").html(tarjetita.vigencia);

                    if (tarjetita.status_tarjeta.toUpperCase() == "ACTIVA") $("#id_demo").prop("checked", false);
                    if (tarjetita.status_tarjeta.toUpperCase() == "BLOQUEADA") $("#id_demo").prop("checked", true);

                    $("#nombrecredito").html(tarjetita.nombre);
                    $("#saldoAnterior").html(tarjetita.saldo_anterior);
                    $("#interesPeriodo").html(tarjetita.interes_periodo);
                    $("#comisionesCobradas").html(tarjetita.comisiones_cobradas);
                }
            }).catch(function (error) {});
        }
    }, {
        key: "storedata",
        value: function storedata(respuesta, key) {
            if (localStorage != null && localStorage != undefined) localStorage.setItem(key, JSON.stringify(respuesta));
        }
    }, {
        key: "getDashBoardData",
        value: function getDashBoardData(key) {
            var bean = null;
            return new Promise(function (resolve, reject) {
                if (localStorage != null && localStorage != undefined) {
                    var _bean2 = localStorage.getItem(key);
                    if (_bean2 != null && _bean2 != undefined) {
                        _bean2 = JSON.parse(_bean2);
                        _bean2.stored = true;
                        resolve(_bean2);
                    } else {
                        _bean2 = { "stored": false };
                        resolve(_bean2);
                    }
                } else {
                    bean = { "stored": false };
                    resolve(bean);
                }
            });
        }

        //================ js IPTV ====================================
        //Funcion para conocer el tamaño de pantalla al realizar un resize

    }, {
        key: "resizeWindow",
        value: function resizeWindow() {
            var _this3 = this;

            window.addEventListener('resize', function () {
                if (window.innerWidth < 768) {
                    _this3.props.initPosition = (window.innerWidth - _this3.props.itemWidth) / 2;
                    _this3.props.ulCardsContainer.style.cssText = "left: " + _this3.props.initPosition + "px;";
                    _this3.props.listIndicators[_this3.props.focusItem].classList.remove('active');
                    _this3.props.listIndicators[0].classList.add('active');
                    //this.touchHandler();
                    _this3.indicatorEvent();
                } else {
                    _this3.props.ulCardsContainer.removeAttribute('style');
                    _this3.props.ulCardsContainer.style.cssText = 'left: 0;';
                    _this3.touchHandler(), false;
                }
            });
        } //
        //Funcion para mover la lista mediante los botones de indicadores

    }, {
        key: "indicatorEvent",
        value: function indicatorEvent() {
            var _this4 = this;

            this.props.ulIndicatorsContainer.addEventListener('click', function (e) {
                var target = e.target;
                if (target.classList.contains('indicator-item')) {
                    _this4.props.focusItem = _this4.props.listIndicators.indexOf(target);
                    var moveLeft = _this4.props.focusItem > 0 ? _this4.props.focusItem * _this4.props.itemWidth : _this4.props.moveLeft;
                    if (_this4.props.focusItem > 0) _this4.props.ulCardsContainer.style.cssText = "left: -" + moveLeft + "px;";else if (_this4.props.focusItem === 0) _this4.props.ulCardsContainer.style.cssText = "left: " + _this4.props.initPosition + "px;";else if (_this4.props.focusItem === _this4.props.listLenght) _this4.props.ulCardsContainer.style.cssText = "left: -" + (moveLeft + _this4.props.initPosition) + "px;";
                    var index = _this4.props.listIndicators[_this4.props.focusItem];
                    //Agrega la clase al elemento seleccionado y remueve la clase activa de los elementos que no son el seleccionado
                    _this4.props.listIndicators.forEach(function (item) {
                        if (item == index) item.classList.add('active');else item.classList.remove('active');
                    });
                }
            });
        }
        //Funcion que captura lso eventos en la pantalla de dispositivo

    }, {
        key: "touchHandler",
        value: function touchHandler() {
            var _this5 = this;

            var initTouches = 0;
            var moveInString = false;

            if (window.innerWidth < 415) {
                //Obtiene la posicion inicial del elemento que hace contacto con la pantalla
                this.props.ulCardsContainer.addEventListener('touchstart', function (e) {
                    e.preventDefault();
                    initTouches = e.changedTouches[0].clientX; //derecha - izquierda  izquierda a derecha  
                    moveInString = initTouches > window.innerWidth / 2 ? true : false;
                }, false);

                //
                this.props.ulCardsContainer.addEventListener('touchmove', function (e) {
                    e.preventDefault();
                    //let moveX = e.changedTouches[0].clientX;
                    //let dif = this.props.initPosition - (initTouches - moveX);
                }, false);

                //Mueve el contenedor de la lista de acuerdo al elmento focus actual
                this.props.ulCardsContainer.addEventListener('touchend', function (e) {
                    e.preventDefault();
                    if (moveInString) {
                        _this5.props.focusItem < _this5.props.listLenght ? _this5.props.focusItem++ : _this5.props.focusItem;
                        var moveToRight = _this5.props.focusItem * _this5.props.itemWidth;
                        _this5.props.ulCardsContainer.style.cssText = "left: -" + moveToRight + "px;";
                        if (_this5.props.focusItem > 0) _this5.props.ulCardsContainer.style.cssText = "left: -" + moveToRight + "px;";else if (_this5.props.focusItem === _this5.props.listLenght) _this5.props.ulCardsContainer.style.cssText = "left: -" + (moveToRight + _this5.props.initPosition) + "px;";
                    } else {
                        _this5.props.focusItem > 0 ? _this5.props.focusItem-- : _this5.props.focusItem;
                        var _moveToRight = _this5.props.focusItem * _this5.props.itemWidth;
                        _this5.props.ulCardsContainer.style.cssText = _this5.props.focusItem === 0 ? "left: " + _this5.props.initPosition + "px;" : "left: -" + _moveToRight + "px;";
                    }
                    //clase active en elemento seleccionado
                    var index = _this5.props.listIndicators[_this5.props.focusItem];
                    _this5.props.listIndicators.forEach(function (item) {
                        if (item == index) item.classList.add('active');else item.classList.remove('active');
                    });
                }, false);
            } else {}
        } //

        //================ fin js IPTV ====================================

    }, {
        key: "setActive",
        value: function setActive() {
            var apuntador = this;

            $(".mas-bundle").on("click", function () {
                var num = $('.mas-bundle').index(this) + 1;
                $("#descBundle" + num).show();

                if ($(this).hasClass('menos-bundle')) {
                    $("#descBundle" + num).css("display", "none");
                    $(this).removeClass('menos-bundle');
                } else {
                    $(this).addClass('menos-bundle');
                }
            });
            $(".mas-VSB").on("click", function () {
                var num = $('.mas-VSB').index(this) + 1;
                $("#descVSB" + num).show();

                if ($(this).hasClass('menos-VSB')) {
                    $("#descVSB" + num).css("display", "none");
                    $(this).removeClass('menos-VSB');
                } else {
                    $(this).addClass('menos-VSB');
                }
            });
        }
    }, {
        key: "ocultarDescripcion",
        value: function ocultarDescripcion() {
            $('.hideDescription').each(function (event) {
                $(this).removeClass('hideDescription');
                $(this).css('display', 'none');
            });
        }
    }, {
        key: "carousel",
        value: function carousel(container, children, imgClick) {
            if ($(container).length) {
                var wrp = $(container),
                    elmts = typeof children === "string" ? wrp.children(children) : wrp.children('div'),
                    elmtsCount = elmts.length,
                    elmtsPos = [],
                    nav = wrp.next('nav');

                nav.html('');
                nav.append(new Array(++elmtsCount).join('<div class="dot"></div>'));
                elmts.each(function () {
                    var lft = $(this).position().left;
                    elmtsPos.push(Math.floor(lft));
                });

                wrp.animate({ scrollLeft: elmtsPos[0] });
                nav.children().eq(0).addClass('active');
                //dot click
                nav.children().click(function () {
                    var i = $(this).index(),
                        pos = Math.ceil(elmtsPos[i]);

                    wrp.animate({ scrollLeft: pos });
                    nav.children().removeClass('active');
                    $(this).addClass('active');
                });
                //slide img click
                imgClick = typeof imgClick !== "undefined" ? imgClick : 0;
                if (imgClick) {
                    elmts.find('img').click(function () {
                        var i = $(this).parent().index(),
                            limit = elmts.length - 1,
                            pos;

                        i = i == limit ? 0 : i + 1;
                        pos = Math.ceil(elmtsPos[i]);
                        wrp.animate({ scrollLeft: pos });
                        nav.children().removeClass('active');
                        nav.children().eq(i).addClass('active');
                    });
                }
            }
        }
    }, {
        key: "bannersCarousel",
        value: function bannersCarousel() {
            var wrp = $('#contenedorBanners'),
                elmts = wrp.children('li'),
                elmtsCount = elmts.length,
                elmtsPos = [],
                slideWidthReff = elmts.eq(0).width(),
                air = wrp.outerWidth() - slideWidthReff,
                nav = wrp.next('nav'),
                onViewPort = function onViewPort(range, scroll, index) {
                var begin = scroll > elmtsPos[index] - range,
                    limit = scroll < elmtsPos[index] + range + slideWidthReff;

                return begin && limit;
            };;

            nav.html('');
            nav.append(new Array(++elmtsCount).join('<div class="dot"></div>'));
            elmts.each(function () {
                var lft = $(this).position().left - air / 2;

                elmtsPos.push(Math.floor(lft));
            });
            wrp.animate({ scrollLeft: elmtsPos[0] });
            nav.children().eq(0).addClass('active');
            nav.children().click(function () {
                var i = $(this).index(),
                    pos = Math.ceil(elmtsPos[i]);

                wrp.animate({ scrollLeft: pos });
                nav.children().removeClass('active');
                $(this).addClass('active');
            });

            wrp.scroll(function () {
                var fromLeft = $(this).scrollLeft();

                elmtsPos.forEach(function (e, i) {
                    if (onViewPort(air, fromLeft, i)) {
                        nav.children().removeClass('active');
                        nav.children().eq(i).addClass('active');
                    }
                });
            });
        }

        //********************************** club movil ************************************


    }, {
        key: "revisarClubWifi",
        value: function revisarClubWifi() {
            var apuntador = this;

            var banner = "\n    <div class=\"img-service\">\n        <img src=\"assets/images/banners/Hogarseguro/Arte.jpg\" alt=\"APP\">\n    </div>\n    <img class=\"img-logo\" src=\"assets/images/banners/Hogarseguro/Logo.png\" alt=\"\">\n    <span class=\"card-info\">Protege a los que m\xE1s amas en tu hogar</span>\n    <a href=\"https://www.totalplay.com.mx/hogar-seguro/hogar-seguro\" target=\"_blank\" \n    rel=\"noopener noreferrer\" style=\"position: absolute;display: contents;\">\n        <span class=\"btn__blue__outline\">Conoce m\xE1s</span>\n    </a>\n    ";

            var url = CONSTANTES.endpoints.clubmovilConsultar;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.codigo == "0") {

                        $('#contenedorBanners li:nth-child(3)').removeClass("black").addClass("white sombraCaja");
                        $('#contenedorBanners li:nth-child(3)').html(banner);
                    } else {
                        var banner1 = "\n                <div class=\"img-service\">\n                    <img src=\"assets/images/clubwifi/club_wifi_travel_big.png\" alt=\"APP\">\n                </div>\n                <span class=\"card-info\" style=\"font-size: 14px; bottom: 75px;\">\n                <strong style=\"font-weight: bold\">Se parte de Club Totalplay Wifi</strong>\n                Internet m\xE1s f\xE1cil, r\xE1pido y seguro sin costo adicional</span><br>\n                <span class=\"btn__blue__outline\" data-toggle=\"modal\" data-target=\"#clubWifi\">Conoce m\xE1s</span>";

                        $('#contenedorBanners li:nth-child(3)').removeClass("black").addClass("white");
                        $('#contenedorBanners li:nth-child(3)').html(banner1);
                    }
                } catch (e) {
                    $('#contenedorBanners li:nth-child(3)').removeClass("black").addClass("white sombraCaja");
                    $('#contenedorBanners li:nth-child(3)').html(banner);
                }
            }).catch(function (err) {
                console.error(err);
                $('#contenedorBanners li:nth-child(3)').removeClass("black").addClass("white sombraCaja");
                $('#contenedorBanners li:nth-child(3)').html(banner);
            });
        }
    }, {
        key: "unirmeClub",
        value: function unirmeClub() {
            $('#codigo').modal('hide');
            $("#modalLoad").modal('show');

            var apuntador = this;
            var url = CONSTANTES.endpoints.clubmovilActivar;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                $('#modalLoad').modal('hide');
                try {
                    if (respuesta.codigo == 0) {
                        $('#modalLoad').modal('hide');
                        $('#listo').modal('show');
                    } else {

                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                        $('#modalrespuesta').modal('show');
                    }
                } catch (e) {
                    console.error(e);
                    $('#modalLoad').modal('hide');

                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                console.error("err=>" + err);
                $('#modalLoad').modal('hide');

                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "desUnirmeClub",
        value: function desUnirmeClub() {

            $('#codigo').modal('hide');
            $("#modalLoad").modal('show');
            var apuntador = this;
            var url = CONSTANTES.endpoints.clubmovilDesactivar;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                $('#modalLoad').modal('hide');
                try {
                    if (respuesta.codigo == 0) {
                        $('#modalLoad').modal('hide');
                        $('#listoD').modal('show');
                    } else {
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                        $('#modalrespuesta').modal('show');
                    }
                } catch (e) {
                    console.error(e);
                    $('#modalLoad').modal('hide');
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                console.error("err=>" + err);
                $('#modalLoad').modal('hide');

                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }

        /*=========================== DISNEY ======================================*/

    }, {
        key: "revisarMigracion",
        value: function revisarMigracion() {
            var apuntador = this;
            var url = CONSTANTES.endpoints.obtenerEstatusMigracion;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                if (respuesta.status == 0) {
                    apuntador.props.promocionesDisney = respuesta.bean;
                }

                apuntador.obtenerAdicionales(apuntador.props.promocionesDisney);
            }).catch(function (err) {
                console.error("error en servicio migracion..........", err);
            });
        }
    }, {
        key: "obtenerAdicionales",
        value: function obtenerAdicionales(promosDisney) {
            console.log("bandera antes de consultar adiiconales: ", promosDisney);
            var apuntador = this;
            var url = CONSTANTES.endpoints.obteneraddons;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                body: JSON.stringify(promosDisney),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                if (respuesta.codigo == 0) {
                    apuntador.props.addonsupsellN = respuesta.bean;

                    //apuntador.revisarVSB(respuesta.bean);
                    apuntador.revisarSegmentacion();
                    //apuntador.revisarDisney(respuesta.bean,promoDisney, migracion);
                } else {
                    apuntador.revisarSegmentacion();
                }
            }).catch(function (err) {
                console.error(err);
                apuntador.revisarSegmentacion();
            });
        }
    }, {
        key: "revisarVSB",
        value: function revisarVSB(addons) {
            var banderaVSB = false;
            var precio = 0;
            addons.forEach(function (item) {
                if (item.nombre.includes("video sounbox") || item.nombre.includes("video soundbox")) {
                    banderaVSB = true;
                    precio = item.precio;
                    if (item.promocion != null && item.promocion != undefined && item.descuento != undefined && item.descuento != null) {
                        precio = item.precio - item.descuento;
                    }
                }
            });

            if (banderaVSB) {
                if (screen.width > 712) {
                    $("#idPrecioTT1").html("$" + precio + " al mes");
                    $("#bannervideosoundBox").show();
                } else {
                    var bannerMovil = "\n                    <div class=\"img-service\" data-toggle=\"modal\" data-target=\"#upsellModal\">\n                        <img src=\"assets/images/banners/tv/SoundBox_Movil.png\">\n                    </div>\n                    <span class=\"card-info text-white\" style=\"height: auto;font-size: 16px;\">\n                       El plan que necesitas con el nuevo <strong class=\"yllw\">Totalplay TV</strong><br>\n                       Consulta paquetes participantes al <strong class=\"yllw\">800 188 77 35</strong>\n                    </span> ";
                    $('#contenedorBanners li:nth-child(1)').html(bannerMovil);
                }
            } else {

                var bannerNetfliz = "\n            <div class=\"img-service img-netflix\">\n                <img  src=\"assets/images/banners/Netflix/ArteNetflix.png\" alt=\"APP\">\n            </div>\n            <img class=\"img-logo\"  style=\"bottom: 110px;\" src=\"assets/images/banners/Netflix/logo-netflix.png\" alt=\"\">\n            <span class=\"card-info\" style=\"font-size: 14px; bottom: 50px;\">Crece tu plan con Netflix incluido. Llama al 800 188 7735</span>\n            <a class=\"tipoboton\" href=\"tel: 800 188 7735\">\n                <span class=\"btn__blue__outline\">Lo quiero</span>\n            </a>";
                $('#contenedorBanners li:nth-child(1)').removeClass("upsellMovil").addClass(" black service-promotion-card-netflix");
                $('#contenedorBanners li:nth-child(1)').html(bannerNetfliz);
            }
        }
    }, {
        key: "revisarDisney",
        value: function revisarDisney() {
            var apuntador = this;
            var addons = apuntador.props.addonsupsellN;

            var banderaCombo = false;
            var banderaOtroComprado = true;
            var promocion = "Suscríbete con cargo a tu <br>estado de cuenta";

            addons.forEach(function (item) {
                if (item.nombre.toUpperCase() == "DISNEY+") {
                    banderaOtroComprado = false;
                    if (item.promocion != null && item.promocion != undefined) {
                        $("#describe1Disney").html(item.detalle.descripcion1);
                        $("#promocion1Disney").show();

                        $("#describeDisney").html("Disfruta de Disney+ con un \n                        " + item.detalle.promocion + "\n                        <br><span style=\"font-size: 22px\">*Promo: " + item.descuento + "</span>");
                    }
                }

                if (item.nombre.toUpperCase() == "STAR+") {
                    banderaOtroComprado = false;
                    if (item.promocion != null && item.promocion != undefined) {
                        $("#describe1Star").html(item.detalle.descripcion1);
                        $("#promocion1Star").show();

                        $("#describeStar").html("Disfruta de Star+ con un \n                        " + item.detalle.promocion + "\n                        <br><span style=\"font-size: 22px\">*Promo: " + item.descuento + "</span>");
                    }
                }

                if (item.nombre.toUpperCase().includes("COMBO")) {
                    banderaCombo = true;

                    if (item.promocion != null && item.promocion != undefined) {
                        //promocion=item.promocion+"<br>Disponible en tus dispositivos móviles";
                        //promocion="50% de descuento x 3 meses<br>Disponible en tus dispositivos móviles";
                        promocion = "Suscríbete y obtén 30% de <br> descuento x 6 meses";
                        $("#describeCombo").html("Disfruta de Disney+ y Star+ con un \n                        " + item.detalle.promocion + "\n                        <br><span style=\"font-size: 22px\">*Promo: " + item.descuento + "</span>");
                        $("#describe1Combo").html(item.detalle.descripcion1);
                        $("#promocion1Combo").show();
                    }
                }
            });

            if (banderaCombo) {
                var htmlCompra = "contrataDisneyStar";
                if (banderaOtroComprado) htmlCompra = "modalCombo";
                $('#contenedorBanners li:nth-child(2)').html("\n                <div class=\"img-service\">\n                    <img src=\"assets/images/banners/disney_star/ArteDisneyHome.jpg\" alt=\"APP\">\n                </div>\n                <img class=\"img-logo\" src=\"assets/images/banners/disney_star/logoDisneyHome.png\">\n                <span class=\"card-info w-100\" style=\"font-size: 16px;\">" + promocion + "</span>\n                <span class=\"btn__blue__outline\" data-toggle=\"modal\" data-target=\"#" + htmlCompra + "\"\n                      style=\"font-size: 16px;\">M\xE1s informaci\xF3n</span>\n            ");

                $('#contenedorBanners li:nth-child(2)').addClass("disney").removeClass("white");
                apuntador.listenersDisney();
            } else {
                apuntador.pintarBannersAmazon("N");
                //apuntador.revisarSegmentacion(); 
            }
        }
    }, {
        key: "listenersDisney",
        value: function listenersDisney() {
            //disney & star modal
            var selectCombo = $('#contrataDisneyStar'),
                offers = $('.modal.star_disney'),
                combo = $('#modalCombo'),
                disneyPlus = $('#DisneyPlus'),
                starPlus = $('#StarPlus');

            $('#showDisneyStar').click(function () {
                selectCombo.modal('show');
            });
            selectCombo.find('.close').click(function () {
                selectCombo.modal('hide');
            });
            offers.find('.back').click(function () {
                offers.modal('hide');
                selectCombo.modal('show');
            });
            offers.find('.dolby_close').click(function () {
                offers.modal('hide');
            });
            //combo
            selectCombo.find('a.combo').click(function () {
                selectCombo.modal('hide');
                combo.modal('show');
            });
            //disney plus
            selectCombo.find('a.disney').click(function () {
                selectCombo.modal('hide');
                disneyPlus.modal('show');
            });
            //star plus
            selectCombo.find('a.star').click(function () {
                selectCombo.modal('hide');
                starPlus.modal('show');
            });
        }
    }]);

    return Dashboard;
}();

},{"../../servicios/bo/JwtBO/JwtBO":46,"../../utils/Constantes":48,"../../utils/CookieHelper":49,"../../utils/ModalMng":50,"../../utils/ValidacionesGral":52,"../home/GenCalendar":27}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Estadocuenta = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _ModalMng = require("../../utils/ModalMng");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

require("moment/locale/es");

var _regimenes = require("./regimenes.json");

var _regimenes2 = _interopRequireDefault(_regimenes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Estadocuenta = exports.Estadocuenta = function () {
    function Estadocuenta() {
        _classCallCheck(this, Estadocuenta);

        this.ch = new _CookieHelper.CookieHelper();
        this.props = {
            arrayFacturas: [],
            fechaFactura: "",
            tipoenviar: "",
            celular: "",
            correo: ""
        };
        this.init();
    }

    _createClass(Estadocuenta, [{
        key: "init",
        value: function init() {
            var apunta = this;
            apunta.obtenerDetalleFactura();
            apunta.descargaDocumentos();
            apunta.datosFiscales();
        }
    }, {
        key: "datosFiscales",
        value: function datosFiscales() {
            var apuntador = this;
            apuntador.consultaDatosFiscales();

            $("#rfSelTipoP").on("change", function () {
                var tipo = this.value;
                $(".personaMoral").hide();
                $(".personaFisica").hide();
                var tipoP = '';
                if (tipo == 1) tipoP = "Fisica";else if (tipo == 2) tipoP = "Moral";
                if (tipoP != undefined && tipoP != '') {
                    $(".persona" + tipoP).show();
                    apuntador.llenaRegimen(tipoP);
                }
            });
            $("input[name=radioFiscales]").on("click", function () {
                var valor = this.value;
                apuntador.props.tipoenviar = valor;
                console.log("Seleccionado: " + apuntador.props.tipoenviar);
                $(".caja").removeClass("seleccionada");
                $("#caja" + valor).addClass("seleccionada");
            });

            $("#botonEnviarCodigo").on("click", function () {
                if (apuntador.props.tipoenviar != "") {
                    $("#validaEnvio").hide();
                    console.log("Se va a enviar por : " + apuntador.props.tipoenviar);
                    var canalEnvio = '';
                    var medio = '';
                    if (apuntador.props.tipoenviar == 'Correo') {
                        canalEnvio = 'C';
                        medio = apuntador.props.correo;
                        //medio = $('#correoEnviar1').text();
                    } else if (apuntador.props.tipoenviar == 'SMS') {
                        canalEnvio = 'S';
                        medio = apuntador.props.celular;
                        //medio = $('#numeroCelular1').text();
                    }
                    console.log("Canal envio token: ", canalEnvio, medio);
                    apuntador.enviaTokenRF(canalEnvio, medio);
                } else {
                    $("#validaEnvio").show();
                }
            });

            $('#btnDatosFiscales').click(function () {
                var cadena = localStorage.getItem("dashboardData");
                var jsonst = JSON.parse(cadena);
                console.log("DATOS!!!: ", jsonst);

                var arroba = jsonst.bean.correo.split("@");
                var longitud2 = arroba[0].length;
                var antesarroba = arroba[0].substr(longitud2 - 3, longitud2);
                var valor2 = "******" + antesarroba + "@" + arroba[1];
                apuntador.props.correo = valor2;
                $('#correoEnviar1').text(valor2);

                var longitud1 = jsonst.bean.celular.length;
                var valor1 = "** ** ** *" + jsonst.bean.celular.substr(longitud1 - 3, longitud1);
                apuntador.props.celular = valor1;
                $('#numeroCelular1').text(valor1);
                if (apuntador.validaFormRF()) $('#modalOtrasFormasEnvio').modal('show');
            });

            $("#linkEnviarSMS").on("click", function () {
                if (apuntador.props.celular != "") {
                    var objeto = {
                        proceso: '1',
                        type: 'S',
                        codapp: 'TPR_MC_001'
                    };
                    apuntador.enviaTokenRF(objeto);
                }
            });

            /*$("#linkOtrasFormas").on("click",function(){
            //limpiar datos
            $(".caja").removeClass("seleccionada");
                $("input[name=radioFiscales]").prop('checked',false);
                $("#validaEnvio").hide();
            $("#modalConfirmaContratacion").modal("hide");
            $("#modalOtrasFormasEnvio").modal("show");
            });*/

            $("#codigoU4").on("keyup", function () {
                var valor = $("#codigoU1").val() + $("#codigoU2").val() + $("#codigoU3").val() + $("#codigoU4").val();
                console.log("codigo:" + valor);
                if (valor != "" && valor.length == 4) {
                    apuntador.validarTokenRF(valor);
                } else {
                    $(".codigos").find('.codigo').addClass("erroneo");
                }
            });
        }
    }, {
        key: "consultaDatosFiscales",
        value: function consultaDatosFiscales() {
            var apuntador = this;
            //$("#modalLoad").modal("show");
            var headersDF = new Headers();
            headersDF.append("Content-type", "application/json;charset=utf-8");
            headersDF.append("totalplay", this.ch.obtenerCookieWeb());
            var url = CONSTANTES.endpoints.reformafiscalconsultar;
            var dataF = {};
            var bandera = false;

            fetch(url, {
                method: 'POST',
                headers: headersDF
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en el servicio";
                }
            }).then(function (respuesta) {
                //$("#modalLoad").modal("hide");
                console.log(respuesta);
                if (respuesta.codigo == 0) {
                    dataF = descifraTP(respuesta.bean);
                    if (dataF != undefined && dataF != "") dataF = JSON.parse(dataF);
                    console.log("dataF", dataF);
                    var comparacion = false;
                    if (dataF.FederalRegister.includes('XAXX010101000') || dataF.FederalRegister.includes('XAXX01010100')) comparacion = true;
                    //dataF.FederalRegister < 'XAXX010101000' ? false : (dataF.FederalRegister > 'XAXX010101000' ? false : true);

                    if (dataF != undefined && !comparacion) {
                        $('#contFiscales').show();
                        console.log('Se llenan datos fiscales');

                        $('#rfTxtRfc').val(dataF.FederalRegister);
                        $('#rfTxtCp').val(dataF.PostalCode);
                        if (dataF.KindPerson == 'FISICA ACT') {
                            $('#rfSelTipoP').text(1);
                            $('#rfLblTipoP').text('Persona física');
                            apuntador.llenaRegimen('Fisica');
                            $('#rfTxtNombre').val(dataF.Data.Names);
                            $('#rfTxtAPat').val(dataF.Data.PaternalSurname);
                            $('#rfTxtAMat').val(dataF.Data.MaternalSurname);
                            $('#regimenFiscal').val(dataF.TaxRegime);
                            $(".personaFisica").show();
                            $(".personaMoral").hide();
                        } else if (dataF.KindPerson == 'MORAL') {
                            $('#rfSelTipoP').text(2);
                            $('#rfLblTipoP').text('Persona moral');
                            apuntador.llenaRegimen('Moral');
                            $('#rfTxtRazonS').val(dataF.BusinessName);
                            $('#regimenFiscal').val(dataF.TaxRegime);
                            $('.personaMoral').show();
                            $('.personaFisica').hide();
                        }
                    } else {
                        $('#contFiscales').hide();
                    }
                } else {
                    $('#contFiscales').hide();
                    /*$('#modalLoad').modal('hide');
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                    $('#modalrespuesta').modal('show');*/
                }
            }).catch(function (err) {
                console.log("ocurrio un error al obtener datos de facturacion", err);
                $('#contFiscales').hide();
                /*$("#modalLoad").modal("hide");
                $('#modalLoad').modal('hide');
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');*/
            });
        }
    }, {
        key: "llenaRegimen",
        value: function llenaRegimen(tipoPersona) {
            var htmlregimenes = "<option value=\"0\">R\xE9gimen fiscal*</option>";
            _regimenes2.default.regimenes.forEach(function (item) {
                if (item.tipoPersona == tipoPersona) {
                    htmlregimenes += "<option value=\"" + item.id + "\">" + item.descripcion + "</option>";
                }
            });
            $("#regimenFiscal").html(htmlregimenes);
        }
    }, {
        key: "editaDatosFiscales",
        value: function editaDatosFiscales(datos) {
            var apuntador = this;
            $("#modalLoad").modal("show");
            var headersDF = new Headers();
            headersDF.append("Content-type", "application/json;charset=utf-8");
            headersDF.append("totalplay", this.ch.obtenerCookieWeb());

            var informacion = {
                "secdata": cifraTP(JSON.stringify(datos))
            };
            var url = CONSTANTES.endpoints.reformafiscaleditar;
            console.log("Datos enviados a editar: ", informacion);
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(informacion),
                headers: headersDF
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en el servicio";
                }
            }).then(function (respuesta) {
                $("#modalLoad").modal("hide");
                console.log("Respuesta edicion: ", respuesta);
                if (respuesta.codigo == 0) {
                    apuntador.creaTicket();
                } else {
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                    $('#modalrespuesta').modal('show');
                }
            });
        }
    }, {
        key: "enviaTokenRF",
        value: function enviaTokenRF(canal, medio) {
            $('#modalLoad').modal('show');
            var apuntador = this;

            var objeto = { proceso: '1', type: canal, codapp: 'TPR_MC_001' };
            console.log("Info a enviar token: " + JSON.stringify(objeto));
            var informacionEncriptada = cifraTP(JSON.stringify(objeto));
            var informacion = {
                "secdata": informacionEncriptada
            };

            var url = CONSTANTES.endpoints.dobleautenticacion;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                $("#modalLoad").modal('hide');
                console.log("Respuesta envio token: ", respuesta);
                if (respuesta.codigo == 0) {
                    $('#modalOtrasFormasEnvio').modal('hide');
                    console.log("respuesta", respuesta, "canal", canal);
                    $('#canalEnvioCodigo').text(apuntador.props.tipoenviar);
                    $('#medioEnvioCodigo').text(medio);
                    $('#modalConfirmaContratacion').modal('show');
                } else {
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                    $('#modalrespuesta').modal('show');
                }
            }).catch(function (err) {
                console.error(err);
                $("#modalLoad").modal("hide");

                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "validarTokenRF",
        value: function validarTokenRF(codigo) {
            $('#modalLoad').modal('show');
            var apuntador = this;

            var objeto = { proceso: '2', code: codigo, codapp: 'TPR_MC_001' };
            console.log("Info a enviar token: " + JSON.stringify(objeto));
            var informacionEncriptada = cifraTP(JSON.stringify(objeto));
            var informacion = {
                "secdata": informacionEncriptada
            };

            var url = CONSTANTES.endpoints.dobleautenticacion;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                $("#modalLoad").modal('hide');
                console.log("Respuesta envio token: ", respuesta);
                if (respuesta.status == 0) {
                    $('#modalConfirmaContratacion').modal('hide');
                    console.log("respuesta", respuesta);
                    var tipoPersona = $("#rfSelTipoP").text();
                    var editData = {};
                    var regimenF = $("#regimenFiscal").val() == 0 ? ' ' : $("#regimenFiscal option:selected").text();
                    editData = {
                        "tipoPersona": tipoPersona,
                        "noRegimen": $("#regimenFiscal").val(),
                        "cp": $("#rfTxtCp").val(),
                        "rfc": $("#rfTxtRfc").val(),
                        "regimen": regimenF
                    };
                    if (tipoPersona == 1) {
                        editData.nombre = {
                            "nombre": $("#rfTxtNombre").val(),
                            "aPaterno": $("#rfTxtAPat").val(),
                            "aMaterno": $("#rfTxtAMat").val()
                        };
                    } else if (tipoPersona == 2) {
                        editData.razonSocial = $("#rfTxtRazonS").val();
                    }

                    apuntador.editaDatosFiscales(editData);
                } else if (respuesta.status == -1) {
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html('El código ingresado no es correcto, intenta nuevamente');
                    $('#modalrespuesta').modal('show');
                } else if (respuesta.status == -2) {
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html('El código ingresado ha caducado');
                    $('#modalrespuesta').modal('show');
                } else if (respuesta.status == -3) {
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html('El código ingresado ha sido utilizado anteriormente');
                    $('#modalrespuesta').modal('show');
                } else {
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                    $('#modalrespuesta').modal('show');
                }
            }).catch(function (err) {
                console.error(err);
                $("#modalLoad").modal("hide");

                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "validaFormRF",
        value: function validaFormRF() {
            var valida = true;
            var tipoP = $("#rfSelTipoP").text();
            var regimen = $("#regimenFiscal").val();
            var cp = $("#rfTxtCp").val();
            var rfc = $("#rfTxtRfc").val();
            var nom = $("#rfTxtNombre").val();
            var apeP = $("#rfTxtAPat").val();
            var apeM = $("#rfTxtAMat").val();
            var rs = $("#rfTxtRazonS").val();
            var mensaje = '<p> Verifica nuevamente tu información, recuerda que para recibir tu factura deberás de ingresar los datos correctos <br/><br/>';
            if (tipoP != '' && tipoP != undefined && tipoP != null) {
                if (regimen != '0' && cp != '' && rfc != '') {
                    if (tipoP == 1) {
                        if (nom == '' && apeP == '' && apeM == '') {
                            mensaje += '<label>Debes ingresar tu nombre completo</label><br/>';
                            valida = false;
                        }
                    } else if (tipoP == 2) {
                        if (rs == '') {
                            mensaje += '<label>Ingresa la razón social</label><br/>';
                            valida = false;
                        }
                    }
                    var valCp = /^\d{5}$/;
                    console.log("valida CP: ", valCp.test(cp));
                    if (!valCp.test(cp)) {
                        mensaje += '<label>El código postal debe contener 5 dígitos</label><br/>';
                        valida = false;
                    }
                    var valRfc = '';
                    if (rfc.length == 12) {
                        valRfc = /^(([A-Z]|[a-z]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))$/;
                    } else {
                        valRfc = /^(([A-Z]|[a-z]|\s){1})(([A-Z]|[a-z]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))$/;
                    }
                    console.log("valida RFC", valRfc.test(rfc));
                    if (!valRfc.test(rfc)) {
                        mensaje += '<label>Ingrese un RFC válido</label><br/>';
                        valida = false;
                    } else {
                        $("#rfTxtRfc").val(rfc.toUpperCase());
                    }
                } else {
                    if (cp == '') mensaje += '<label>Ingresa código postal</label><br/>';
                    if (regimen == '0') mensaje += '<label>Selecciona el régimen fiscal</label><br/>';
                    if (rfc == '') mensaje += '<label>Ingresa tu RFC</label><br/>';
                    valida = false;
                }
            }
            mensaje += '</p>';
            if (!valida) {
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(mensaje);
                $('#modalrespuesta').modal('show');
            }
            console.log("Valor de validacion final: ", valida);
            return valida;
        }
    }, {
        key: "creaTicket",
        value: function creaTicket() {
            var apuntador = this;
            $("#modalLoad").modal("show");
            var headersDF = new Headers();
            headersDF.append("Content-type", "application/json;charset=utf-8");
            headersDF.append("totalplay", this.ch.obtenerCookieWeb());

            var url = CONSTANTES.endpoints.reformafiscalcreaticket;

            fetch(url, {
                method: 'POST',
                headers: headersDF
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en el servicio";
                }
            }).then(function (respuesta) {
                $("#modalLoad").modal("hide");
                console.log("Respuesta crea Ticket: ", respuesta);
                if (respuesta.codigo == 0) {
                    $("#msjTitle").html("Confirmación");
                    $('#iconrespuesta').html('<i class=" fas fa-check-circle fa-3x"></i>');
                    $("#msjrespuesta").html('<p class="h1 my-5">Tus datos se han guardado con &eacute;xito</p>' + '<p>Tu factura ser&aacute; emitida en tu siguiente pago.</p>');
                    $('#modalrespuesta').modal('show');
                } else {
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                    $('#modalrespuesta').modal('show');
                }
            });
        }
    }, {
        key: "enviarInterfactura",
        value: function enviarInterfactura(fecha) {
            $('#alertSending').removeAttr('style');
            var apuntador = this;
            var url = CONSTANTES.endpoints.sendinterfact;
            var arrfechita = fecha.split("/");
            var params = JSON.stringify({ "mes": arrfechita[1], "anio": arrfechita[2] });
            var data = null;
            var formdata = undefined;

            if (params != undefined) {
                if (params.data != undefined) {
                    formdata = new URLSearchParams();

                    Object.keys(params.data).forEach(function (key) {
                        formdata.append(key, params.data[key]);
                    });
                }
            }

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                body: JSON.stringify(params),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                try {
                    $('#alertSending').attr('style', 'display:none !important;');

                    if (respuesta.status == 0) {

                        $('#alertSendSuccessfuly').removeAttr('style');
                        setTimeout(function () {
                            $('#alertSendSuccessfuly').attr('style', 'display:none !important;');
                        }, 3000);
                    } else {

                        $('#alertSendWrong').removeAttr('style');
                        setTimeout(function () {
                            $('#alertSendWrong').attr('style', 'display:none !important;');
                        }, 3000);
                    }
                } catch (e) {
                    $('#alertSending').attr('style', 'display:none !important;');
                    $('#alertSendWrong').removeAttr('style');
                    setTimeout(function () {
                        $('#alertSendWrong').attr('style', 'display:none !important;');
                    }, 3000);

                    console.error(e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                $('#alertSending').attr('style', 'display:none !important;');
                $('#alertSendWrong').removeAttr('style');
                setTimeout(function () {
                    $('#alertSendWrong').attr('style', 'display:none !important;');
                }, 3000);
                console.error("err=>" + err);
            });
        }
    }, {
        key: "changeCardsMont",
        value: function changeCardsMont() {
            // funcion para el toggle de iconos
            $('.iconArrowCard').click(function () {
                $(this).toggleClass("fa-chevron-down fa-chevron-up");
            });

            $('.btnDocuments').on('click', function () {
                //$('.div-pronto-pago-down').addClass('d-none');
                //$('.div-pronto-pago-up').addClass('d-none');
                //$('.divDocumentosFacturasPrincipal').removeClass('d-none');

                var id = $(".botonHeader .activa").attr('id');
                console.log("aqui....." + id);
            });

            $('#btnDocumentsReturn').on('click', function () {
                $('.div-pronto-pago-down').removeClass('d-none');
                $('.div-pronto-pago-up').removeClass('d-none');
                $('.divDocumentosFacturasPrincipal').addClass('d-none');
            });

            $('#collapseConsumoServiciosPrimerMes').collapse('show');
            $('#collapseDescuentoPromocionesPrimerMes').collapse('show');

            $('#collapseConsumoServiciosSegundoMes').collapse('show');
            $('#collapseDescuentoPromocionesSegundoMes').collapse('show');

            $('#collapseConsumoServiciosTercerMes').collapse('show');
            $('#collapseDescuentoPromocionesTercerMes').collapse('show');

            $('#collapComplementoPago').collapse('show');
            $('#collapseNotasCredito').collapse('show');

            $('.mostrarOcultarClick').on('click', function () {
                if ($(this).hasClass('validateCollapse')) {
                    $(this).removeClass('validateCollapse');
                    $(this).find('.mostrarOcultar').html('Ocultar');
                } else {
                    $(this).addClass('validateCollapse');
                    $(this).find('.mostrarOcultar').html('Mostrar');
                }
            });
        }
        //--------------------------------------JC------------------------------------------//

    }, {
        key: "obtenerDocumentos",
        value: function obtenerDocumentos(docs, cuenta, anio, mes, nombre) {
            var apunta = this;
            $("#modalLoad").modal("show");
            var headersDF = new Headers();
            //headersDF.append("Content-type", 'text/plain');
            //headersDF.append("Accept", "application/json");

            headersDF.append("Content-type", "application/json;charset=utf-8");
            headersDF.append("totalplay", this.ch.obtenerCookieWeb());

            var url = CONSTANTES.endpoints.obtenerDocumentos;
            var params = {
                "Account": cuenta,
                "Year": anio,
                "Month": mes,
                "Docs": docs
            };
            console.log("parametros", params);

            var resultado = '';
            var bandera = false;

            fetch(url, {
                method: 'POST',
                body: JSON.stringify(params),
                headers: headersDF
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en el servicio";
                }
            }).then(function (respuesta) {

                $("#modalLoad").modal("hide");
                console.log(respuesta);
                if (respuesta.codigo == 0) {
                    var a = document.createElement("a");
                    var tipo = "application/pdf";
                    if (respuesta.bean.Formato.toUpperCase().includes("PDF")) tipo = "application/pdf";
                    if (respuesta.bean.Formato.toUpperCase().includes("ZIP")) tipo = "application/octet-stream";
                    a.href = "data:" + tipo + ";base64," + respuesta.bean.Base64;
                    a.download = nombre + anio + mes + '.' + respuesta.bean.Formato;
                    a.click();
                    resultado = respuesta;
                    return resultado;
                } else {
                    $('#modalLoad').modal('hide');
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                    $('#modalrespuesta').modal('show');
                }
            }).catch(function (err) {
                console.log(err);
                $("#modalLoad").modal("hide");
                $('#modalLoad').modal('hide');
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "descargaDocumentos",
        value: function descargaDocumentos() {

            var apuntador = this;

            $('#edoCtaPDF').click(function () {
                var documentos = "edocta";

                var cuenta = "";var mes = "";var anio = "";
                try {
                    var cadena = localStorage.getItem("dashboardData");
                    var jsonst = JSON.parse(cadena);
                    cuenta = jsonst.bean.cuenta;
                    console.log("apuntador.props.fechaFactura", apuntador.props.fechaFactura);
                    var fechita = apuntador.props.fechaFactura.split("/");
                    anio = fechita[2];
                    mes = fechita[1];
                } catch (error) {
                    console.log("no se puedo obtern cuenta");
                }

                apuntador.obtenerDocumentos(documentos, cuenta, anio, mes, "EstadoDeCuenta");
            });

            $('#edoCtaXML').click(function () {
                var documentos = "cfdis";
                var cuenta = "";var mes = "";var anio = "";
                try {
                    var cadena = localStorage.getItem("dashboardData");
                    var jsonst = JSON.parse(cadena);
                    cuenta = jsonst.bean.cuenta;
                    console.log("apuntador.props.fechaFactura", apuntador.props.fechaFactura);
                    var fechita = apuntador.props.fechaFactura.split("/");
                    anio = fechita[2];
                    mes = fechita[1];
                } catch (error) {
                    console.log("no se puedo obtern cuenta");
                }

                apuntador.obtenerDocumentos(documentos, cuenta, anio, mes, "ComprobanteFiscal");
            });

            $('#facturaPDF').click(function () {
                var documentos = "factura";
                var cuenta = "";var mes = "";var anio = "";
                try {
                    var cadena = localStorage.getItem("dashboardData");
                    var jsonst = JSON.parse(cadena);
                    cuenta = jsonst.bean.cuenta;
                    console.log("apuntador.props.fechaFactura", apuntador.props.fechaFactura);
                    var fechita = apuntador.props.fechaFactura.split("/");
                    anio = fechita[2];
                    mes = fechita[1];
                } catch (error) {
                    console.log("no se puedo obtern cuenta");
                }

                apuntador.obtenerDocumentos(documentos, cuenta, anio, mes, "Factura");
            });
        }
    }, {
        key: "obtenerDetalleFactura",
        value: function obtenerDetalleFactura() {
            var apunta = this;
            var headersDF = new Headers();
            //headersDF.append("Content-type", 'text/plain');
            //headersDF.append("Accept", "application/json");

            headersDF.append("Content-type", "application/json;charset=utf-8");
            headersDF.append("totalplay", this.ch.obtenerCookieWeb());

            var url = CONSTANTES.endpoints.obtenerFacturas;
            var cuenta = "";
            try {
                var cadena = localStorage.getItem("dashboardData");
                var jsonst = JSON.parse(cadena);
                cuenta = jsonst.bean.cuenta;
            } catch (error) {
                console.log("no se puedo obtern cuenta");
            }

            var params = {
                AccountNumber: cuenta
            };

            fetch(url, {
                method: 'POST',
                body: JSON.stringify(params),
                headers: headersDF
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en el servicio";
                }
            }).then(function (respuesta) {
                console.log("respuestaServicio", respuesta);
                $("#spinnersedo").hide();
                if (respuesta.codigo == 0) {
                    var arrayDetalles = respuesta.respuestaServicio;
                    //console.log(respuesta.respuestaServicio)
                    apunta.props.arrayFacturas = arrayDetalles;
                    var plantillabotones = "";
                    var validationDiv = 0;
                    arrayDetalles.forEach(function (element, i) {
                        if (element.StartingPeriod != null && element.EndPeriod != null) {
                            var dateStart = new Date(element.StartingPeriod + 'T10:00:00');
                            var startButton = (0, _moment2.default)(dateStart).format('MMMM');
                            var dateEnd = new Date(element.EndPeriod + 'T10:00:00');
                            var endButton = (0, _moment2.default)(dateEnd).format('MMMM');
                            var periodo = startButton.substr(0, 3) + ' - ' + endButton.substr(0, 3);
                            if (screen.width <= 360) {
                                var periodo = startButton.substr(0, 3) + ' - ' + endButton.substr(0, 3);
                            } else if (screen.width < 768) {
                                var periodo = startButton.substr(0, 4) + ' - ' + endButton.substr(0, 4);
                            } else {
                                var periodo = startButton + ' - ' + endButton;
                            }
                            plantillabotones += "<button class=\"text-black btn button-circle-white text-capitalize \n                                    mx-auto w-auto botonValidacionClick botonHeader\"\n                                    style =\"font-size: 14px !important\" id=\"" + i + "\">" + periodo + "</button>";
                        } else {
                            validationDiv += 1;
                        }
                    });

                    if (validationDiv == 3) {
                        $("#noinformacionedo").show();
                    } else if (validationDiv == 2) {
                        apunta.pintaFactura(2);
                        $('#botonesMesHeader').html(plantillabotones);
                        $("#contenidoFacturas").show();
                        apunta.eventosBotones();
                    } else if (validationDiv == 1) {
                        apunta.pintaFactura(1);
                        $('#botonesMesHeader').html(plantillabotones);
                        $("#contenidoFacturas").show();
                        apunta.eventosBotones();
                    } else if (validationDiv == 0) {
                        apunta.pintaFactura(0);
                        $('#botonesMesHeader').html(plantillabotones);
                        $("#contenidoFacturas").show();
                        apunta.eventosBotones();
                    }

                    $(".botonValidacionClick:nth-child(1").addClass("activa");
                } else {

                    $("#noinformacionedo").show();
                }
            }).catch(function (err) {
                console.log(err);
                $("#spinnersedo").hide();
                $("#noinformacionedo").show();
            });
        }
    }, {
        key: "eventosBotones",
        value: function eventosBotones() {
            var apunta = this;
            $(".botonValidacionClick").on("click", function () {
                var valor = this.id;
                console.log("id...." + valor);
                $(".botonValidacionClick").removeClass("activa");
                $(this).addClass("activa");
                apunta.pintaFactura(valor);
            });

            $('.btnDocuments').on('click', function () {
                var id = $(".botonHeader.activa").attr('id');
                var periodo = $(".botonHeader.activa").text();
                console.log("aqui....." + id);
                apunta.props.arrayFacturas.forEach(function (item, i) {
                    if (id == i) {
                        console.log("item " + item.Date);
                        apunta.props.fechaFactura = item.Date;
                        $('.div-pronto-pago-down').addClass('d-none');
                        $('.div-pronto-pago-up').addClass('d-none');
                        $('.divDocumentosFacturasPrincipal').removeClass('d-none');
                        $(".fechaEdoFacSel").text(periodo);
                    }
                });
            });

            $('.sendInterfac').on('click', function () {
                console.log("-------------------------------------------------");
                var id = $(".botonHeader.activa").attr('id');
                apunta.props.arrayFacturas.forEach(function (item, i) {
                    if (id == i) {
                        apunta.enviarInterfactura(item.Date);
                        console.log("item " + item.Date);
                    }
                });
            });

            $('#btnDocumentsReturn').on('click', function () {
                $('.div-pronto-pago-down').removeClass('d-none');
                $('.div-pronto-pago-up').removeClass('d-none');
                $('.divDocumentosFacturasPrincipal').addClass('d-none');
            });
        }
    }, {
        key: "pintaFactura",
        value: function pintaFactura(valor) {
            var apunta = this;
            console.log("********", apunta.props.arrayFacturas);
            apunta.props.arrayFacturas.forEach(function (item, i) {

                if (i == valor) {

                    $('#nombrePaquetePrincipal').text(localStorage.getItem('pn'));
                    if (item.DateListPrice != null) $('#fechaDivPrincipal').html("<span class=\"dateListPrice\">" + item.DateListPrice + "</span>");
                    if (item.PriceList != null) $('#montoPrecioLista').text("$" + item.PriceList);
                    if (item.PriceSoonPayment != null) $('#montoDivPrincipal').html("$ " + item.PriceSoonPayment + "\n                        <i class=\"fas fa-chevron-down text-primary iconArrowCard ml-1\" style=\"visibility: hidden;\"></i>");

                    var costoPorServicio = 0;
                    $('.tableAddons').remove();

                    var element = item.nuevosAddons;

                    if (element.adicionalesInternet != null && element.adicionalesInternet.length > 0) {
                        $('#tablaNN').append("<tr class=\"tableAddons\"><td><h3>Televisi\xF3n</h3></td></tr>");
                        element.adicionalesInternet.forEach(function (detallesAdicionales) {
                            if (detallesAdicionales.descripcion != null && detallesAdicionales.costo != null) {
                                $('#tablaNN tr:last').after("<tr class=\"fuenteTablaConsumos tableAddons\">\n                                <td><a>" + detallesAdicionales.descripcion + "</a></td>\n                                <td class=\"text-right\"><a>$ " + Number.parseFloat(detallesAdicionales.costo).toFixed(2) + "</a></td>\n                                </tr>");
                                costoPorServicio += Number(detallesAdicionales.costo);
                            }
                        });
                    }

                    if (element.adicionalesTvEnviar != null && element.adicionalesTvEnviar.length > 0) {
                        $('#tablaNN').append("<tr class=\"tableAddons\"><td><h3>Televisi&oacute;n</h3></td></tr>");
                        element.adicionalesTvEnviar.forEach(function (detallesAdicionales) {
                            console.log("tvs....", detallesAdicionales);
                            if (detallesAdicionales.descripcion != null && detallesAdicionales.costo != null) {
                                $('#tablaNN tr:last').after("<tr class=\"fuenteTablaConsumos tableAddons\">\n                                <td><a>" + detallesAdicionales.descripcion + "</a></td>\n                                <td class=\"text-right\"><a>$ " + Number.parseFloat(detallesAdicionales.costo).toFixed(2) + "</a></td>\n                                </tr>");
                                costoPorServicio += Number(detallesAdicionales.costo);
                            }
                        });
                    }

                    if (element.adicionalesTelefonoEnviar != null && element.adicionalesTelefonoEnviar.length > 0) {
                        $('#tablaNN').append("<tr class=\"tableAddons\"><td><h3>Telefon&iacute;a</h3></td></tr>");
                        element.adicionalesTelefonoEnviar.forEach(function (detallesAdicionales) {
                            if (detallesAdicionales.descripcion != null && detallesAdicionales.costo != null) {
                                $('#tablaNN tr:last').after("<tr class=\"fuenteTablaConsumos tableAddons\">\n                                <td><a>" + detallesAdicionales.descripcion + "</a></td>\n                                <td class=\"text-right\"><a>$ " + Number.parseFloat(detallesAdicionales.costo).toFixed(2) + "</a></td>\n                                </tr>");
                                costoPorServicio += Number(detallesAdicionales.costo);
                            }
                        });
                    }

                    if (item.AdjustmentByRounding != null) $('#tablaNN').append("<tr class=\"tableAddons\">\n                                            <td><h3>Ajustes por redondeo</h3></td>\n                                            <td class=\"text-right AdjustmentByRounding\">\n                                             <a class=\"rounding\">" + Number.parseFloat(item.AdjustmentByRounding).toFixed(2) + "</a></td>\n                                        </tr>");
                    $('#montoConsumoPrincipal').html("$ " + Number.parseFloat(costoPorServicio).toFixed(2) + "\n                     <i class=\"fas fa-chevron-down text-primary iconArrowCard ml-1\" \n                     data-toggle=\"collapse\" href=\"#collapseConsumoServicios\" role=\"button\" aria-expanded=\"false\"></i>");

                    if (item.EarlyPaymentDate != null) $("#datePP").html(item.EarlyPaymentDate);
                    if (item.PriceSoonPayment != null) $("#amountPP").html("$ " + item.PriceSoonPayment);
                    console.log("item.DiscountsAndPromotions", item.DiscountsAndPromotions);

                    if (item.DiscountsAndPromotions != null) $("#totalDescuentos").html("$ " + Number.parseFloat(item.DiscountsAndPromotions).toFixed(2) + "<i class=\"fas fa-chevron-down text-primary iconArrowCard ml-1\" data-toggle=\"collapse\" \n                    href=\"#collapseDescuentoPromociones\" role=\"button\" aria-expanded=\"false\"></i>");

                    if (item.Promos) {

                        item.Promos.forEach(function (promo, i) {
                            if (promo.Descr != null) {
                                $('.promosInfo').after("\n                                <tr class=\"fuenteTablaConsumos tableAddons\">\n                                    <td>\n                                        <a>" + promo.Descr + "</a>\n                                    </td>\n                                    <td class=\"text-right\">\n                                        <a>$" + promo.TotalDue + "</a>\n                                    </td>\n                                </tr>\n                            ");
                            }
                        });
                    }
                }
            });
        }
    }]);

    return Estadocuenta;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49,"../../utils/ModalMng":50,"./regimenes.json":26,"moment":2,"moment/locale/es":1}],26:[function(require,module,exports){
module.exports={
    "regimenes":
        [
            {
                "tipoPersona": "Moral",
                "id":"601",
                "descripcion":"General de Ley Personas Morales"
            },
            {
                "tipoPersona": "Moral",
                "id":"603",
                "descripcion":"Personas Morales con Fines no Lucrativos"
            },
            {
                "tipoPersona": "Fisica",
                "id":"605",
                "descripcion":"Sueldos y Salarios e Ingresos Asimilados a Salarios"
            },
            {
                "tipoPersona": "Fisica",
                "id":"606",
                "descripcion":"Arrendamiento"
            },
            {
                "tipoPersona": "Fisica",
                "id":"607",
                "descripcion":"Régimen de Enajenación o Adquisición de Bienes"
            },
            {
                "tipoPersona": "Fisica",
                "id":"608",
                "descripcion":"Demás ingresos"
            },
            {
                "tipoPersona": "Fisica",
                "id":"610",
                "descripcion":"Residentes en el Extranjero sin Establecimiento Permanente en México"
            },
            {
                "tipoPersona": "Moral",
                "id":"610",
                "descripcion":"Residentes en el Extranjero sin Establecimiento Permanente en México"
            },
            {
                "tipoPersona": "Fisica",
                "id":"611",
                "descripcion":"Ingresos por Dividendos (socios y accionistas)"
            },
            {
                "tipoPersona": "Fisica",
                "id":"612",
                "descripcion":"Personas Físicas con Actividades Empresariales y Profesionales"
            },
            {
                "tipoPersona": "Fisica",
                "id":"614",
                "descripcion":"Ingresos por intereses"
            },
            {
                "tipoPersona": "Fisica",
                "id":"615",
                "descripcion":"Régimen de los ingresos por obtención de premios"
            },
            {
                "tipoPersona": "Fisica",
                "id":"616",
                "descripcion":"Sin obligaciones fiscales"
            },
            {
                "tipoPersona": "Moral",
                "id":"620",
                "descripcion":"Sociedades Cooperativas de Producción que optan por diferir sus ingresos"
            },
            {
                "tipoPersona": "Fisica",
                "id":"621",
                "descripcion":"Incorporación Fiscal"
            },
            {
                "tipoPersona": "Moral",
                "id":"622",
                "descripcion":"Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras"
            },
            {
                "tipoPersona": "Moral",
                "id":"623",
                "descripcion":"Opcional para Grupos de Sociedades"
            },
            {
                "tipoPersona": "Moral",
                "id":"624",
                "descripcion":"Coordinados"
            },
            {
                "tipoPersona": "Fisica",
                "id":"625",
                "descripcion":"Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas"
            },
            {
                "tipoPersona": "Fisica",
                "id":"626",
                "descripcion":"Régimen Simplificado de Confianza"
            },
            {
                "tipoPersona": "Moral",
                "id":"626",
                "descripcion":"Régimen Simplificado de Confianza"
            }

        ]
    
}
},{}],27:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GenCalendar = exports.GenCalendar = function () {
    function GenCalendar() {
        _classCallCheck(this, GenCalendar);
    }

    _createClass(GenCalendar, [{
        key: 'generaCalendario',
        value: function generaCalendario(data) {
            var apuntador = this;
            var layoutMes = '<span class="main-modal__calendar--first_month">{{month}}</span>';
            var inicioDivContainer = '<div class="container">';
            var finDivContainer = '</div>';
            var diasdelaSemana = '<div class="main-modal__calendar--days_of_week">\n                <span class="week_item">Lun</span>\n                <span class="week_item">Mar</span>\n                <span class="week_item">Mie</span>\n                <span class="week_item">Jue</span>\n                <span class="week_item">Vie</span>\n                <span class="week_item">Sab</span>\n                <span class="week_item">Dom</span>                \n            </div>';
            var layoutWeek = '<div class="main-modal__calendar--days_by_week"></div>';

            var botontxt = '<div class="btn__blue__solid" data-dismiss="modal">Entendido</div>';

            var fechaIni = data.fechaCalendar.fechaInicio.split("/");
            var fechaFin = data.fechaCalendar.fechaFin.split("/");

            fechaIni = {
                day: parseInt(fechaIni[0]),
                month: parseInt(fechaIni[1]) - 1,
                year: fechaIni[2],
                monthTxt: data.fechaCorta.fechaInicio.match(/([a-zA-Z]+)/)[0]
            };
            fechaFin = {
                day: parseInt(fechaFin[0]),
                month: parseInt(fechaFin[1]) - 1,
                year: fechaFin[2],
                monthTxt: data.fechaCorta.fechaFin.match(/([a-zA-Z]+)/)[0]
            };

            var monthToDraw = [];

            monthToDraw.push(fechaIni);
            if (fechaIni.month != fechaFin.month) {
                monthToDraw.push(fechaFin);
            }
            var containerModal = document.querySelector(".main-modal__calendar2");
            var fromDate = new Date(fechaIni.year, fechaIni.month, fechaIni.day);
            var toDate = new Date(fechaFin.year, fechaFin.month, fechaFin.day);
            var today = new Date();
            //console.log("today"+today)
            today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            //console.log("todayAjus"+today)
            var toDate = new Date(fechaFin.year, fechaFin.month, fechaFin.day);

            monthToDraw.forEach(function (item) {
                var tittle = apuntador.htmlToElement(layoutMes.replace("{{month}}", item.monthTxt));
                var daysObj = apuntador.htmlToElement(diasdelaSemana);

                //let htmlInicioDivContainer = apuntador.htmlToElement(inicioDivContainer);
                //let htmlFinDivContainer = apuntador.htmlToElement(finDivContainer);

                containerModal.append(tittle);
                //containerModal.append(htmlInicioDivContainer)
                containerModal.append(daysObj);

                var diasDelmes = apuntador.getDaysInMonth(item.month, item.year);

                var diaInicial = new Date(item.year, item.month, 1).getDay();
                var semanaObj = undefined;
                //dibujar la semana 1


                var diaSemana = diaInicial;
                for (var cd = 1; cd <= diasDelmes; cd++) {
                    var tipoDia = apuntador.getTypeDayToDraw(fromDate, toDate, today, new Date(item.year, item.month, cd));
                    if (cd == 1) {
                        semanaObj = apuntador.htmlToElement(layoutWeek);
                        if (diaSemana > 1) {
                            for (var leftDay = 1; leftDay < diaInicial; leftDay++) {
                                var objDia = apuntador.getDayDomObj("", 0);
                                semanaObj.append(objDia);
                            }
                        }
                        semanaObj.append(apuntador.getDayDomObj(cd, tipoDia));
                    } else {
                        semanaObj.append(apuntador.getDayDomObj(cd, tipoDia));
                        if (diaSemana == 0) {
                            containerModal.append(semanaObj);
                            semanaObj = apuntador.htmlToElement(layoutWeek);
                        }
                    }
                    if (cd == diasDelmes) {
                        containerModal.append(semanaObj);
                    }

                    diaSemana++;
                    if (diaSemana == 7) {
                        diaSemana = 0;
                    }
                }
            });
            //containerModal.append(apuntador.htmlToElement(botontxt));
            //containerModal.append(htmlFinDivContainer);

        }
    }, {
        key: 'getTypeDayToDraw',
        value: function getTypeDayToDraw(from, to, today, check) {
            var tipo = 0;
            if (today.getTime() == check.getTime()) return 4;
            if (check >= from && check <= to) {
                tipo = 1;
                if (check.getTime() == from.getTime()) {
                    tipo = 2;
                }
                if (check.getTime() == to.getTime()) {
                    tipo = 3;
                }
            }
            return tipo;
        }
    }, {
        key: 'getDayDomObj',
        value: function getDayDomObj(txt, type) {
            var layoutDia = '<span class="week_item"></span>';
            var dayObj = this.htmlToElement(layoutDia);
            dayObj.innerHTML = txt;

            if (type == 1) {
                dayObj.classList.add("active");
            }
            if (type == 2) {
                dayObj.classList.add("active");
                dayObj.classList.add("inicio");
            }
            if (type == 3) {
                dayObj.classList.add("active");
                dayObj.classList.add("fin");
            }

            if (type == 4) {
                dayObj.classList.add("today");
            }

            return dayObj;
        }
    }, {
        key: 'getDaysInMonth',
        value: function getDaysInMonth(month, year) {
            return new Date(year, month + 1, 0).getDate();
        }
    }, {
        key: 'htmlToElement',
        value: function htmlToElement(html) {
            var template = document.createElement('template');
            html = html.trim();
            template.innerHTML = html;
            return template.content.firstChild;
        }
    }]);

    return GenCalendar;
}();

},{}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HomePrepago = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _ModalMng = require("../../utils/ModalMng");

var _ValidacionesGral = require("../../utils/ValidacionesGral");

var val = _interopRequireWildcard(_ValidacionesGral);

var _GenCalendar = require("./GenCalendar");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HomePrepago = exports.HomePrepago = function () {
    function HomePrepago() {
        _classCallCheck(this, HomePrepago);

        this.ch = new _CookieHelper.CookieHelper();
        this.init();
    }

    _createClass(HomePrepago, [{
        key: "init",
        value: function init() {
            this.pintaRecargaPrepago();
        }
    }, {
        key: "pintaRecargaPrepago",
        value: function pintaRecargaPrepago() {
            var apuntador = this;
            $('#spinnersSaldo').show();
            var tipoCliente = this.ch.props.tipocliente;

            var divPrepago = document.getElementById("divPrepago");
            var pagaredocuenta = document.getElementById("pagaredocuenta");
            var hacerRecarga = document.getElementById("hacerRecarga");

            if (tipoCliente == 1) {
                divPrepago.style.display = "block";
                pagaredocuenta.style.display = "none";
                hacerRecarga.style.display = "flex";
            } else {
                if (pagaredocuenta != null) pagaredocuenta.style.display = "block";
            }
            apuntador.recargaActual();
        }
    }, {
        key: "recargaActual",
        value: function recargaActual() {
            var apunta = this;

            var url = CONSTANTES.endpoints.getRecargaActual;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var payload = {
                method: "POST",
                headers: cabeceraMC
            };

            fetch(url, payload).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {

                $('#spinnersSaldo').hide();
                try {
                    if (respuesta.status == 0) {
                        if (respuesta.bean != undefined) {
                            if (respuesta.bean.fechaCorta != undefined) {
                                //if (respuesta.bean.status === "1") {
                                $("#leyendaPrepago").html("Tu recarga vence el");
                                $("#fechaPrepago").html(respuesta.bean.fechaCorta.fechaFin);
                                $("#diasRestantes").html(val.prettifyDate(respuesta.bean.tiempoRestante));
                                $("#btnCalendario").css("display", "flex");
                                var gc = new _GenCalendar.GenCalendar();
                                gc.generaCalendario(respuesta.bean);
                            }
                        }

                        /*if (respuesta.bean.status === "3") {
                            $("#leyendaPrepago").html("Tu servicio est&aacute;");
                            $("#fechaPrepago").html("Vencido");
                            $("#diasRestantes").html("Realiza un pago para continuar con tu servicio");
                            $("#btnCalendario").css("display","none");                                
                        }*/
                    } else {
                        $("#leyendaPrepago").html("Tu recarga est&aacute;");
                        $("#fechaPrepago").html("Vencida");
                        $("#linkrecarga").html("Realizar una recarga");
                        $("#btnCalendario").css("display", "none");
                    }
                } catch (e) {
                    $("#leyendaPrepago").html("Sin informaci&oacute;n");
                    $("#fechaPrepago").html("Sin informaci&oacute;n");
                }
            }).catch(function (err) {

                $('#spinnersSaldo').hide();
                $("#leyendaPrepago").html("Sin informaci&oacute;n");
                $("#fechaPrepago").html("Sin informaci&oacute;n");

                console.log("Informacion no Disponible");
                console.log("err=>" + err);
            });
        }
    }]);

    return HomePrepago;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49,"../../utils/ModalMng":50,"../../utils/ValidacionesGral":52,"./GenCalendar":27}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InfoPagos = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _ModalMng = require("../../utils/ModalMng");

var _Prepago = require("./Prepago");

var prepago = _interopRequireWildcard(_Prepago);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InfoPagos = exports.InfoPagos = function () {
    function InfoPagos() {
        _classCallCheck(this, InfoPagos);

        this.props = {
            datosBINGT: {
                nombreBanco: '', idBanco: '', proveedorBanco: '', cargosAutomaticos: ''
            },
            saldoPrepago: 0,
            banderaBINGT: '',
            icnCorrecto: '',
            icnError: '',
            icnAlerta: '',
            referencias: '',
            tarjetaseleccionadapago: '',
            todaslastarjetas: '',
            montoapagar: '',
            contador: '',
            mes: '',
            anio: ''
        };
        this.ch = new _CookieHelper.CookieHelper();
    }

    _createClass(InfoPagos, [{
        key: "init",
        value: function init(opcion) {
            var apuntadorClase = this;
            var modalManager = new _ModalMng.ModalMng();
            modalManager.createModal(CONSTANTES.modals.recomendados).then(function (status) {
                //confirmacion creacion del Primer modal
                apuntadorClase.setListeners(opcion);
                apuntadorClase.banderaBINGT = false;
                apuntadorClase.icnCorrecto = 'far fa-check-circle';
                apuntadorClase.icnError = 'fas fa-times';
                apuntadorClase.icnAlerta = 'fas fa-exclamation-circle';
                apuntadorClase.referencias = [];
            }).catch(function (err) {
                console.error("el error es" + err);
            });
            this.pintaPrepago();
        }
    }, {
        key: "pintaPrepago",
        value: function pintaPrepago() {
            var tipoCliente = this.ch.props.tipocliente;
            var cookie = this.ch.obtenerCookieWeb();
            var apuntador = this;
            var datosPrepago = document.getElementById("datosPrepago");
            var divSpei = document.getElementById("divSpei");
            var pathname = window.location.pathname;

            if (tipoCliente == 1) {
                datosPrepago.style.display = "flex";
                divSpei.style.display = "none";
                prepago.obtenerSaldo(apuntador, cookie);
                var x = window.matchMedia("(min-width: 768px) and (max-width: 1700px)");
                if (pathname.includes("Formas")) {
                    apuntador.funcionQuery(x);
                    x.addListener(apuntador.funcionQuery);
                }
            }
        }
    }, {
        key: "funcionQuery",
        value: function funcionQuery(x) {
            var element = document.getElementById("ofertaRecargas");
            if (x.matches) {
                // If media query matches
                $("#ofertaRecargas").css("padding-inline-start", "20px");
            }
        }
    }, {
        key: "loadGetEdoCta",
        value: function loadGetEdoCta(opt, refresh) {
            $('#spinnersSaldo').show();

            var apunta = this;

            var url = CONSTANTES.endpoints.saldo;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var payload = {
                method: "POST",
                headers: cabeceraMC
            };

            if (refresh != undefined && refresh) {
                payload.body = '{"refresh":"refresh"}';
            }

            fetch(url, payload).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {

                try {

                    if (respuesta.status == 0) {

                        $('#spinnersSaldo').hide();
                        $('#divSaldo').show();

                        if (respuesta.bean != undefined) {
                            var saldoActCmp = parseFloat(respuesta.bean.saldoActual.replace("$", "").replace(",", ""));

                            if (respuesta.bean.statusCuenta == "sinsaldo") {
                                $("#statuspago").html("Sin saldo pendiente");
                                $("#cantSaldo").html(respuesta.bean.saldoActual);
                                apunta.props.montoapagar = respuesta.bean.saldoActual;
                                $("#fechaLim").html("<i style='text-transform: none;'>Usted no cuenta con adeudo pendiente</i>");
                            }

                            var ppp = parseFloat(respuesta.bean.totalPagoDesc.replace("$", "").replace(",", ""));
                            var ppl = parseFloat(respuesta.bean.totalPago.replace("$", "").replace(",", ""));

                            if (respuesta.bean.statusCuenta == "prontopago") {
                                $("#statuspago").html("Saldo pendiente");
                                $("#fechaLim").html(respuesta.bean.fechaLimDesc);

                                if (saldoActCmp != ppl) {
                                    saldoActCmp = ppp - (ppl - saldoActCmp);

                                    $("#cantSaldo").html('$' + saldoActCmp);
                                    apunta.props.montoapagar = '$' + saldoActCmp;
                                } else {
                                    $("#cantSaldo").html(respuesta.bean.totalPagoDesc);
                                    apunta.props.montoapagar = respuesta.bean.totalPagoDesc;
                                }
                            }

                            if (respuesta.bean.statusCuenta == "limitepago") {
                                $("#statuspago").html("Saldo pendiente");
                                $("#fechaLim").html('Pagando ' + respuesta.bean.fechaLim);
                                if (saldoActCmp != ppl) {
                                    $("#cantSaldo").html("$" + saldoActCmp);
                                    apunta.props.montoapagar = "$" + saldoActCmp;
                                } else {
                                    $("#cantSaldo").html(respuesta.bean.totalPago);
                                    apunta.props.montoapagar = respuesta.bean.totalPago;
                                }
                            }

                            if (respuesta.bean.statusCuenta == "moroso") {
                                $("#statuspago").html("Saldo pendiente");
                                //<br> SIN SERVICIO
                                $("#cantSaldo").html(respuesta.bean.saldoActual);
                                //$("#fechaLim").html("Tu servicio ha sido suspendido<br>por un adeudo pendiente.<br><i>Realiza tu Pago y se reactivar&aacute; tu servicio en 48 hrs.</i>");
                                $("#fechaLim").html("Usted cuenta con adeudo pendiente");
                                apunta.props.montoapagar = respuesta.bean.saldoActual;
                            }

                            $("#periodo").html(respuesta.bean.periodo);
                            $("#estadoCuentaAnt").html(respuesta.bean.estadoCuentaAnt);
                            $(".packageN").html(localStorage.getItem("pn"));
                            $("#rentas").html(respuesta.bean.rentas);
                            $("#fechaLimDesc").html(respuesta.bean.fechaLimDesc);
                            $("#totalPagoDesc").html(respuesta.bean.totalPagoDesc);
                            $("#fechaLista").html(respuesta.bean.fechaLim);
                            $("#totalPago").html(respuesta.bean.totalPago);

                            if (opt == 1) {
                                $('#montofinal').html(apunta.props.montoapagar);
                            }

                            if (opt == 2) {
                                apunta.referencias = respuesta.bean.listaReferencias;
                                apunta.loadReferencias(apunta.referencias);

                                try {
                                    $('#form1').val(apunta.props.montoapagar);
                                    $('#montofinal').html(apunta.props.montoapagar);
                                } catch (error) {
                                    console.error(error);
                                }
                            }

                            try {
                                if (!apunta.props.montoapagar.includes("$0") && !apunta.props.montoapagar.includes("-")) {
                                    $('#btnPayCard').show();
                                    $('#btnPayCard').removeAttr('disabled');
                                    $('#linkEditarPago').show();
                                    $('#linkFormasPago').show();
                                    $("#montoPagar").html(respuesta.bean.saldoActual);
                                    //if(refresh == undefined || !refresh){
                                    var montoPaypal = parseFloat(apunta.props.montoapagar.replace("$", "").replace(",", "")).toFixed(2);
                                    apunta.cargarPaypal(montoPaypal);
                                    apunta.cargarPayPalRecurrente('1');
                                    //}
                                }
                                var params = window.location.search;
                                console.log("Params respuesta: ", params);
                                if (params != undefined && params != null && params != '') {
                                    apunta.creaAgreementPayPal(params);
                                }
                            } catch (err) {
                                console.error(err);
                            }
                        } else {
                            $("#statuspago").html("Sin informaci&oacute;n");
                            $("#fechaLim").html("Sin informaci&oacute;n");
                        }
                    } else {
                        console.log("No se cargo bien la info");
                        $('#spinnersSaldo').hide();
                    }
                } catch (e) {
                    console.error(e);
                    throw "Error al traer la informacion";
                    $('#spinnersSaldo').hide();
                }
            }).catch(function (err) {
                console.log("Informacion no Disponible");
                console.log("err=>" + err);
                $('#spinnersSaldo').hide();
            });
        }
    }, {
        key: "loadGetServicioBin",
        value: function loadGetServicioBin(URL2LOAD, params, contador) {

            if (contador == 1) {
                var _apuntador = this;

                var cabeceraMC = new Headers();
                cabeceraMC.append("Content-type", "application/json;charset=utf-8");
                cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

                var data = null;
                var formdata = undefined;

                if (params != undefined) {
                    if (params.data != undefined) {
                        formdata = new URLSearchParams();

                        Object.keys(params.data).forEach(function (key) {
                            formdata.append(key, params.data[key]);
                        });
                    }
                }

                var maquetas = undefined;
                if (params != undefined) {
                    if (params.maquetas != undefined) {
                        maquetas = maquetas;
                    }
                }

                fetch(URL2LOAD, {
                    method: 'POST',
                    body: JSON.stringify(params),
                    headers: cabeceraMC
                }).then(function (data) {
                    if (data.ok) {
                        return data.json();
                    } else {
                        throw "Error en la llamada Ajax fetch con parametros " + URL2LOAD;
                    }
                }).then(function (texto) {

                    try {
                        var respuesta = texto;
                        if (parseInt(respuesta.status) === 0) {

                            var existeDato = false;
                            try {
                                var idBanco = respuesta.bean.bin.idBanco;
                                if (idBanco != '') {
                                    existeDato = true;
                                }
                            } catch (Exception) {
                                console.error(Exception);
                            }

                            var validacionServicio = parseInt(respuesta.bean.response.code);
                            if (validacionServicio == 0 && existeDato) {
                                _apuntador.pintarIcn(_apuntador.icnCorrecto);
                                $('#inpNumeroTarjetaRT').addClass('is-valid');

                                _apuntador.props.datosBINGT.nombreBanco = respuesta.bean.bin.nombreBanco;
                                _apuntador.props.datosBINGT.idBanco = respuesta.bean.bin.idMarca;
                                _apuntador.props.datosBINGT.proveedorBanco = respuesta.bean.bin.nombreMarca;
                                _apuntador.props.datosBINGT.cargosAutomaticos = respuesta.bean.bin.cargosAutomaticos;

                                try {
                                    $('#tipCard').attr('src', _apuntador.getSrcTarjeta(respuesta.bean.bin.nombreMarca));
                                    $('#tipCard').css('display', 'inline');
                                } catch (error) {
                                    console.log("no pude traer el tipo de tarjeta" + error);
                                }

                                _apuntador.banderaBINGT = true;
                            } else {
                                _apuntador.pintarIcn(_apuntador.icnAlerta);
                                $('#inpNumeroTarjetaRT').addClass('is-invalid');
                                $('#vldNumeroTarjetaRT').html('Valida tu n&uacute;mero de tarjeta');
                                $('#vldNumeroTarjetaRT').show();
                                _apuntador.banderaBINGT = false;
                                throw "Fallo tarjeta 1";
                            }
                        } else {
                            _apuntador.pintarIcn(apuntado.icnError);
                            $('#inpNumeroTarjetaRT').addClass('is-invalid');
                            $('#vldNumeroTarjetaRT').html('Valida tu n&uacute;mero de tarjeta');
                            $('#vldNumeroTarjetaRT').show();
                            _apuntador.banderaBINGT = false;
                            throw "Fallo tarjeta 2";
                        }
                    } catch (e) {
                        console.log("c a t c h");
                        _apuntador.banderaBINGT = false;
                        _apuntador.pintarIcn(_apuntador.icnError);
                        $('#inpNumeroTarjetaRT').addClass('is-invalid');
                        $('#vldNumeroTarjetaRT').html('Valida tu n&uacute;mero de tarjeta');
                        $('#vldNumeroTarjetaRT').show();
                        throw "Error al traer la informacion " + e;
                    }
                }).catch(function (err) {
                    _apuntador.banderaBINGT = false;
                    _apuntador.pintarIcn(_apuntador.icnError);
                    $('#inpNumeroTarjetaRT').addClass('is-invalid');
                    $('#vldNumeroTarjetaRT').html('Valida tu n&uacute;mero de tarjeta');
                    $('#vldNumeroTarjetaRT').show();
                    console.log("err=>" + err);
                }); //fin fetch
                _apuntador.props.contador++;
            }
        }
    }, {
        key: "loadAddCard",
        value: function loadAddCard(URL2LOAD, params) {
            var apuntador = this;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var data = null;
            var formdata = undefined;

            if (params != undefined) {
                if (params.data != undefined) {
                    formdata = new URLSearchParams();

                    Object.keys(params.data).forEach(function (key) {
                        formdata.append(key, params.data[key]);
                    });
                }
            }

            var maquetas = undefined;
            if (params != undefined) {
                if (params.maquetas != undefined) {
                    maquetas = maquetas;
                }
            }

            fetch(URL2LOAD, {
                method: 'POST',
                body: JSON.stringify(params),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax fetch con parametros " + URL2LOAD;
                }
            }).then(function (texto) {

                try {
                    var respuesta = texto;
                    $('#modalLoad').modal('hide');
                    $('#agregar-tarjeta').modal('hide');
                    $('#direccionmodal').modal('hide');
                    apuntador.limpiarDatos();
                    var str = JSON.stringify(respuesta, null, 2);
                    if (parseInt(respuesta.status) === 0) {
                        $("#msjTitle").html("\xC9xito");
                        $('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
                        $('#msjrespuesta').html('Tu tarjeta  se ha registrado exitosamente.');
                        $('#modalrespuesta').modal('show');
                    } else if (parseInt(respuesta.status) === 1) {
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html("Tu tarjeta ya se encuentra registrada.");
                        $('#modalrespuesta').modal('show');
                    } else {

                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                    }
                } catch (e) {
                    console.log("c a t c h");
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');

                    throw "Error al traer la informacion " + e;
                }
            }).catch(function (err) {
                console.log("err=>" + err);
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            }).finally(function () {
                apuntador.loadFirstCard({ first: "refresh" }, 1);
            }); //fin fetch
        }
    }, {
        key: "loadReferencias",
        value: function loadReferencias(referencias) {
            var apunta = this;
            var obj = referencias;

            var tipoCliente = apunta.ch.props.tipocliente;
            $("#edo-referencias").empty();
            if (tipoCliente != 1) {
                obj.forEach(function (item) {
                    if (item.Banco == "spei") {

                        var spei = item.REF;
                        spei = spei.match(/([\d]+)/);
                        if (spei != null && spei != "null") {
                            $('#edo-referencia-pago-spei').html(spei[0]);
                        }
                    } else {
                        var refEleC = "";
                        var division = item.REF.split("Ref");

                        if (item.Banco == "banamex") {
                            refEleC += '<div class="col-md-6 col-12 mt-2 pl-0 pr-1 order-last">';
                        } else {
                            refEleC += '<div class="col-md-6 col-12 mt-2 pl-0 pr-1">';
                        }

                        refEleC += '<div class="cont-lugares p-2">' + '<div class="bancos ' + item.Banco + '"></div>' + '<p class="mt-1">' + division[0] + '</p>'; //convenio
                        if (division[1] != undefined) {
                            refEleC += '<p class="mt-1">Ref' + division[1] + '</p>';
                        }
                        refEleC += '<p>&nbsp;</p>' + '</div>' + '</div>';

                        if (item.Banco == "bancoazteca") {
                            $("#edo-referencias").prepend(refEleC);
                            var bazref = item.REF.substring(5, item.REF.length);
                            $("#edo-referencia-pago").html(bazref);
                            apunta.barCodeGenLoad(bazref);
                            $("#spinnersRef").hide();
                            $("#spinnersBar").hide();
                        } else {
                            $("#edo-referencias").append(refEleC);
                        }
                    }
                });
            } else {
                obj.forEach(function (item) {
                    var refEleC = "";
                    var division = item.REF.split("Ref");
                    if (item.Banco == "bancoazteca") {
                        refEleC += '<div class="col-md-12 col-12 mt-2 pl-0 pr-1">';
                        refEleC += '<div class="cont-lugares p-2">' + '<div class="bancos ' + item.Banco + '"></div>' + '<p>&nbsp;</p>' + '<p class="mt-1">' + division[0] + '</p>'; //convenio
                        if (division[1] != undefined) {
                            refEleC += '<p class="mt-1">Ref' + division[1] + '</p>';
                        }
                        refEleC += '<p>&nbsp;</p>' + '</div>' + '</div>';

                        //$("#edo-referencias").prepend(refEleC); 
                        var bazref = item.REF.substring(5, item.REF.length);
                        $("#edo-referencia-pago").html(bazref);
                        apunta.barCodeGenLoad(bazref);
                        $("#edo-referencias").append(refEleC);
                        $("#spinnersRef").hide();
                        $("#spinnersBar").hide();
                    }
                });
            }
        }
    }, {
        key: "barCodeGenLoad",
        value: function barCodeGenLoad(codigo) {
            var flagCodigo = false;
            var apunta = this;

            if (window.JsBarcode == undefined) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = "assets/vendor/barCode/JsBarcode.code128.min.js";
                script.onload = function () {
                    console.log("tuveQueCargar el barcode");
                    apunta.barCodeGen(codigo);
                };
                document.body.appendChild(script);
            } else {
                console.log("ya existe el barcode");
                apunta.barCodeGen(referencia);
            }
        }
    }, {
        key: "barCodeGen",
        value: function barCodeGen(codigobarra) {
            var apuntador = this;
            var typeSO = apuntador.getMobileOperatingSystem();
            var anchura = 2;

            if (typeSO == "Android" || typeSO == "iOS") {
                anchura = 1;
            }

            JsBarcode("#barcode", codigobarra, {
                width: anchura,
                height: 30,
                font: "montserrat",
                fontSize: 10

            });
        }
    }, {
        key: "getIconoTarjeta",
        value: function getIconoTarjeta(proveedor) {
            var iconoTarjeta = '<i class="far fa-credit-card fa-lg"></i>';
            if (proveedor == "V") {
                iconoTarjeta = '<img src="assets/images/icons/visa.svg" style="margin-top:-3px;" class="icnNT tarjetaD icnNT-tarjetaD mx-2" height="30" width="40">';
            }
            if (proveedor == "M") {
                iconoTarjeta = '<img src="assets/images/icons/mastercard.svg" style="margin-top:-3px;" class="icnNT tarjetaD icnNT-tarjetaD mx-2" height="30" width="40">';
            }
            if (proveedor == "A") {
                iconoTarjeta = '<img src="assets/images/icons/amex.svg" style="margin-top:-3px;" class="icnNT tarjetaD icnNT-tarjetaD mx-2" height="30" width="40">';
            }

            return iconoTarjeta;
        }
    }, {
        key: "getSrcTarjeta",
        value: function getSrcTarjeta(proveedor) {
            var iconoTarjeta = "";

            if (proveedor == "VISA") {
                iconoTarjeta = "assets/images/icons/visa.svg";
            }
            if (proveedor == "MASTERCARD") {
                iconoTarjeta = "assets/images/icons/mastercard.svg";
            }
            if (proveedor == "AMEX") {
                iconoTarjeta = "assets/images/icons/amex.svg";
            }

            return iconoTarjeta;
        }
    }, {
        key: "getleyendatarjeta",
        value: function getleyendatarjeta(proveedor) {
            var arrayleyenda = [];
            if (proveedor == "A") {
                arrayleyenda = { "imagen": '<img src="assets/images/ayuda-amex.png">',
                    "texto": "4 d&iacute;gitos al frente de tu tarjeta" };
            } else {
                arrayleyenda = { "imagen": '<img src="assets/images/ayuda-visa-mastercard.png">',
                    "texto": "3 d&iacute;gitos al reverso de tu tarjeta" };
            }

            return arrayleyenda;
        }
    }, {
        key: "loadFirstCard",
        value: function loadFirstCard(params, bandera) {
            var idTarjetaSeleccion = '';
            var nombreBancoInicial = '';
            var terminacionTarjetaInicial = '';
            var apuntadorClase = this;
            apuntadorClase.props.tarjetaseleccionadapago = [];
            var url = CONSTANTES.endpoints.tarjetas;
            var data = null;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                body: JSON.stringify(params),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                try {

                    if (respuesta.status == 0) {
                        //ok
                        if (respuesta.bean != undefined && respuesta.bean.ltb_tarjetas.length > 0) {
                            var iconRecurrente = '';

                            idTarjetaSeleccion = respuesta.bean.ltb_tarjetas[0].cb_idCard;
                            nombreBancoInicial = respuesta.bean.ltb_tarjetas[0].cb_bankname;
                            var finTarjeta = respuesta.bean.ltb_tarjetas[0].cb_endingCardNumber;
                            terminacionTarjetaInicial = "* " + finTarjeta.substr(finTarjeta.length - 4);

                            var iconoTarjeta = apuntadorClase.getIconoTarjeta(respuesta.bean.ltb_tarjetas[0].cb_provider);

                            var splitBanco = "";
                            if (nombreBancoInicial.length > 13) {
                                splitBanco = nombreBancoInicial.substring(0, 13);
                                splitBanco += '...';
                            } else {
                                splitBanco = nombreBancoInicial;
                            }

                            var htmlBoton = '<div class="row" >' + '<span class="col-sm-9 pagar-con-home mx-auto">Pagar con </span>' + '<button class="boton boton-azul" style="margin-top:10px;" id="btnPagarHome">' + iconoTarjeta + ' &nbsp; ' + splitBanco + ' <span> ' + terminacionTarjetaInicial + ' </span></button>' + '</div>';
                            var objPagar = apuntadorClase.htmlToElement(htmlBoton);
                            $("#lstCard").html(objPagar);
                            apuntadorClase.setListenersHome();

                            //Pone todas las tarjetas en la seccion pagos.html
                            var listaTarjetasAdmin = "";
                            var listaTarjetasSeleccion = "";
                            apuntadorClase.props.todaslastarjetas = respuesta.bean.ltb_tarjetas;
                            if (bandera == 2) {
                                apuntadorClase.props.tarjetaseleccionadapago = respuesta.bean.ltb_tarjetas[0];
                                apuntadorClase.pintatarjetaseleccionada();
                            }

                            $.each(respuesta.bean.ltb_tarjetas, function (key, object) {
                                iconoTarjeta = apuntadorClase.getIconoTarjeta(object.cb_provider);

                                var esSeleccion = "";
                                if (parseInt(idTarjetaSeleccion) == parseInt(object.cb_idCard)) {
                                    esSeleccion = "tarjetaSeleccionada";
                                }
                                var finTarjeta = object.cb_endingCardNumber;
                                var ultimosDigitos = finTarjeta.substr(finTarjeta.length - 4);

                                if (object.cb_current != null && object.cb_current != undefined && object.cb_current == "T") {
                                    if (bandera == 1) {
                                        iconRecurrente = '<img class="" src="assets/images/ic-domiciliado.svg">';
                                    } else {
                                        iconRecurrente = '<img class="" src="assets/images/icon-star.svg">';
                                    }
                                } else {
                                    iconRecurrente = '';
                                }
                                var nombretar = object.cb_firstName.toLowerCase().replace(/\b[a-z]/g, function (match) {
                                    return match.toUpperCase();
                                });

                                if (bandera == 1) {

                                    listaTarjetasAdmin += '<div class="col-11 col-md-6 cont-tarjeta-pagos cont-tarjeta-rmv">' + '<div class="tarjeta">' + '<div class="row">' + '<div class="col-md-8 icono-tarjeta">' + iconoTarjeta + iconRecurrente + '<span class="">' + object.cb_bankname + "</span>" + '</div>' + '<div class="col-md-4 text-right ">' + '<a id="' + object.cb_idCard + '" class="editar-metodo">Editar' + '<i class="fa fa-pen"></i></a>' + '</div>' + '<div class="col-md-12 mt-30 mb-30 text-right">' + '<span class="notarjeta">**** **** **** ' + ultimosDigitos + "</span>" + "</div>" + "<div class='col-md-12'>" + "<span class='nomcliente'>" + nombretar + "</span>" + "</div>" + "</div>" + "</div>" + "</div>";
                                    $('#montoPNT').hide();
                                } else {

                                    listaTarjetasAdmin += '<div class="col-md-6 col-12 mt-2 cont-tarjeta tarjeta-edocta" id="' + object.cb_idCard + '">' + '<div class="tarjetas">' + '<div class="d-flex icono-tarjeta">' + iconoTarjeta + '<p class="no-tarjeta">' + object.cb_bankname + ' **** **** **** ' + ultimosDigitos + '</p>' + iconRecurrente + '</div>' + '</div>' + '</div>';
                                }
                            });

                            $('.cont-tarjeta-rmv').remove();
                            $('.tarjeta-edocta').remove();
                            $("#listaTarjetasAdmin").prepend(listaTarjetasAdmin);

                            apuntadorClase.seleccionartarjetas();
                            apuntadorClase.formasdepagofunciones();
                        } else {

                            console.log("no hay datos");
                            $('.cont-tarjeta-rmv').remove();

                            $('#btnPayCard').hide();
                            $('#btnPayCard').addClass('disabled');
                        }
                    }
                } catch (e) {
                    console.error(e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                console.log("err=>" + err);
            });
        }
    }, {
        key: "seleccionartarjetas",
        value: function seleccionartarjetas() {
            var apuntadorClase = this;
            $('.cont-tarjeta').on("click", function () {
                var idsel = this.id;
                if (idsel == "") {} else {
                    apuntadorClase.props.todaslastarjetas.forEach(function (elem) {

                        if (idsel == elem.cb_idCard) {
                            console.log("elemento seleccionado");
                            apuntadorClase.props.tarjetaseleccionadapago = elem;
                            apuntadorClase.pintatarjetaseleccionada();

                            $('#formas-pago').modal('hide');
                            $('#pagar').modal('show');
                        }
                    });
                }
            });
        }
    }, {
        key: "pintatarjetaseleccionada",
        value: function pintatarjetaseleccionada() {
            var apuntadorClase = this;
            var tarjetafirst = apuntadorClase.props.tarjetaseleccionadapago;
            var idTarjetaSel = tarjetafirst.cb_idCard;
            var nombreBancoSel = tarjetafirst.cb_bankname;
            var finTarjetaSel = tarjetafirst.cb_endingCardNumber;
            var iconoTarjetaSel = apuntadorClase.getIconoTarjeta(tarjetafirst.cb_provider);
            var nombreTarjetaSel = tarjetafirst.cb_firstName;

            $(".tarjeta").html('<div class="d-flex">' + iconoTarjetaSel + '<p class="text-left">' + nombreBancoSel + '</p>' + '</div>' + '<p class="text-dark text-right w-100 mt-4 mb-3 fs-20"> **** **** ***' + finTarjetaSel + '</p>' + '<p class="text-left w-100 pt-3">' + nombreTarjetaSel + '</p>'
            //+'<p class="text-left w-100 fs-14"> Vigencia '+
            //vigenciaTarjetaSel+
            //'</p>'
            );
            console.log("pintar tarjeta");
            if (tarjetafirst.cb_provider == "A") {
                //$('#cvv4').show();
                if ($('#cvv4').val() == undefined) {
                    $('#cvv').append('<div class="col" id="colcvv4">' + '<input id="cvv4" type="password" class="form-control" placeholder="*" maxlength="1"' + ' oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*)\\./g, \'1\'); " >' + '</div>');
                }
                $('#cvv3').on('keyup', function () {
                    var valor = this.value;
                    if (valor.length == 1) $('#cvv4').focus();
                });
            } else {
                $("#colcvv4").remove();
            }
            var arrleyenda = apuntadorClase.getleyendatarjeta(tarjetafirst.cb_provider);
            $("#imagenayuda").html(arrleyenda.imagen);
            $("#leyendaayuda").html(arrleyenda.texto);

            // boton editar monto
            $("#tarjetapagar").html(" " + nombreBancoSel + " *" + finTarjetaSel);
        }
    }, {
        key: "pintarIcn",
        value: function pintarIcn(icnClase) {
            $("#ldrBinRT").removeAttr('class');
            $("#ldrBinRT").attr('class', '');
            $("#ldrBinRT").addClass(icnClase);
        }
    }, {
        key: "inicializarCampoRT",
        value: function inicializarCampoRT() {
            $("#inpNumeroTarjetaRT").removeClass('is-valid');
            $("#inpNumeroTarjetaRT").removeClass('is-invalid');
            $("#inpNumeroTarjetaRT").removeClass('is-warning');
        }
    }, {
        key: "validarCamposRegistroTarjeta",
        value: function validarCamposRegistroTarjeta() {
            $('.invalid-feedback').hide();
            var cont = 1;

            var inputCampos = ['inpNombreRT', 'inpApellidoPRT', 'inpNumeroTarjetaRT', 'inpMesVRT', 'inpAnioVRT', 'inpCVVRT', 'inpDircom'];

            var labelValidacion = ['vldNombreRT', 'vldApellidoPRT', 'vldNumeroTarjetaRT', 'vldMesVRT', 'vldAnioVRT', 'vldCVVRT'];

            var camposChicos = ['vldMesVRT', 'vldAnioVRT', 'vldCVVRT'];
            var validacion = true;
            console.log("Paso " + cont++ + "  Validacion=> " + validacion);

            $.each(inputCampos, function (i, idCampo) {
                var valor = $('#' + idCampo).val().trim();

                if (valor === '') {
                    validacion = false;
                    var texto = '* El campo es requerido';
                    if (camposChicos.indexOf(labelValidacion[i]) >= 0) {
                        texto = '* Requerido';
                    }
                    $('#' + labelValidacion[i]).html(texto);
                    $('#' + labelValidacion[i]).show();
                    if (idCampo == "inpDircom") {
                        var valor1 = $('#' + idCampo).text();
                        if (valor1.includes("Agregar dirección de tarjeta")) {
                            $('#vldDireccion').show();
                            $('#vldDireccion').html("*Dirección requerida");
                        } else {
                            validacion = true;
                        }
                    }
                } else {
                    if (idCampo == 'inpNumeroTarjetaRT') {
                        var digito = $('#inpNumeroTarjetaRT').val().substring(0, 1);
                        if (digito == '3') {
                            if (valor.length != 15) {
                                pintarIcn(apuntador.icnAlerta);
                                $('#vldNumeroTarjetaRT').html('Debe ser de 15 digitos');
                                $('#vldNumeroTarjetaRT').show();
                                validacion = false;
                            }
                        } else {
                            if (valor.length != 16) {
                                pintarIcn(apuntador.icnAlerta);
                                $('#vldNumeroTarjetaRT').html('Debe ser de 16 digitos');
                                $('#vldNumeroTarjetaRT').show();
                                validacion = false;
                            }
                        }

                        if (digito == '3') {
                            if ($('#inpCVVRT').val().length != 4) {
                                $('#vldCVVRT').html('Requiere 4 digitos');
                                $('#vldCVVRT').show();
                                validacion = false;
                            }
                        } else {
                            if ($('#inpCVVRT').val().length != 3) {
                                $('#vldCVVRT').html('Requiere 3 digitos');
                                $('#vldCVVRT').show();
                                validacion = false;
                            }
                        }
                    }
                    if (idCampo == 'inpCVVRT') {
                        if (valor.length < 3) {
                            $('#vldCVVRT').html('Minimo son 3 digitos');
                            $('#vldCVVRT').show();
                            validacion = false;
                        }
                    }
                }
            });

            var anioActual = parseInt(new Date().getFullYear().toString().substr(-2));
            var mesActual = parseInt(new Date().getMonth());

            if (parseInt($('#inpAnioVRT').val()) == parseInt(anioActual)) {
                if (parseInt($('#inpMesVRT').val()) < parseInt(mesActual)) {
                    $('#vldMesVRT').html('Invalido');
                    $('#vldMesVRT').show();
                    validacion = false;
                }
            }

            return validacion;
        }
    }, {
        key: "enviarGuardadoTarjeta",
        value: function enviarGuardadoTarjeta() {
            $('#agregar-tarjeta').modal('hide');
            $('#icnMensajeRT').attr('class', '');
            $('#btnCorrectoRT').hide();
            $('#btnRevisarRT').hide();
            $('#modalLoad').modal('show');

            var objetoTarjeta = {
                primerNombre: $('#inpNombreRT').val(),
                segundoNombre: $('#inpApellidoPRT').val(),
                numeroTarjeta: $('#inpNumeroTarjetaRT').val(),
                mesVencimiento: $('#inpMesVRT').val(),
                anioVencimiento: $('#inpAnioVRT').val(),
                cvv: $('#inpCVVRT').val(),
                nombreBanco: this.props.datosBINGT.nombreBanco,
                idBanco: this.props.datosBINGT.idBanco,
                proveedorBanco: this.props.datosBINGT.proveedorBanco,
                idProveedorBanco: ""
            };

            var informacionEncriptada = otpyrc2(JSON.stringify(objetoTarjeta));
            var informacion = {
                "informacionEncriptada": informacionEncriptada
            };

            this.loadAddCard(CONSTANTES.endpoints.guardartarjeta, informacion);
        }
    }, {
        key: "limpiarDatos",
        value: function limpiarDatos() {
            this.banderaBINGT = false;
            this.datosBINGT = {
                nombreBanco: '', idBanco: '', proveedorBanco: '', cargosAutomaticos: ''
            };

            $('#inpAnioVNT').val('');

            $('#inpCVVCP').val('');

            $('.invalid-feedback').hide();
        }
    }, {
        key: "limpiarnuevatarjeta",
        value: function limpiarnuevatarjeta() {

            $('.invalid-feedback').hide();

            var inputCampos = ['inpNombreRT', 'inpApellidoPRT', 'inpNumeroTarjetaRT', 'inpMesVRT', 'inpAnioVRT', 'inpCVVRT', 'inpDirCalleRT', 'inpDirColoniaRT', 'inpDirCPRT', 'inpDirMunicipioRT', 'inpDirEstadoRT'];
            $.each(inputCampos, function (i, idCampo) {
                $('#' + idCampo).val('');
            });
            $("#inpDircom").html('Agregar direcci&oacute;n de tarjeta');
        }
    }, {
        key: "disablePagoBotonTarjeta",
        value: function disablePagoBotonTarjeta() {
            var _this = this;

            this.esperasaldo().then(function () {
                if (_this.props.montoapagar.startsWith("$0") || _this.props.montoapagar.startsWith("-$")) {

                    $("#linkTarjeta").hide();
                    $("#linkEdocta").show();
                } else {
                    $("#linkTarjeta").show();
                    $("#linkEdocta").hide();
                }
            }).catch(function (e) {
                console.log("catch " + e);
                $("#linkTarjeta").hide();
            });
        }
    }, {
        key: "esperasaldo",
        value: function esperasaldo() {
            var apuntador = this;
            return new Promise(function (resolve, reject) {
                var contador = 0;
                var interval = setInterval(function () {
                    if (apuntador.props.montoapagar != '') {

                        clearInterval(interval);

                        resolve("FOUND_SALDO");
                    }
                }, 300);
            });
        }
    }, {
        key: "setListenersHome",
        value: function setListenersHome() {
            var apuntador = this;
            this.disablePagoBotonTarjeta();

            $('#btnPagarHome').on("click", function () {
                $('#pagar').modal('show');
            });

            $('#btnFinalizarPago').unbind("click");

            $('#btnFinalizarPago').on('click', function () {
                var cvv4valor = "";
                if ($("#cvv4").val() != undefined) {
                    cvv4valor = $("#cvv4").val();
                }
                var cvvformado = $("#cvv1").val() + $("#cvv2").val() + $("#cvv3").val() + cvv4valor;
                console.log(cvvformado);
                var montoapagar = $("#montofinal").text();
                if (cvvformado == "") {
                    $("#errorcvv").html("*Campo Requerido");
                } else {
                    if (apuntador.validacvv(apuntador.props.tarjetaseleccionadapago.cb_provider, cvvformado)) {
                        apuntador.enviarPagoTarjetaExistente(cvvformado, montoapagar);
                    } else {
                        $("#errorcvv").html("Campo no v&aacute;lido");
                    }
                }
            });
        }
    }, {
        key: "setListeners",
        value: function setListeners(opcion) {
            var apuntador = this;

            var strAnioActual = new Date().getFullYear().toString().substr(-2);
            var intAnioActual = parseInt(strAnioActual);
            var strOptionSelect = '<option value="">A&ntilde;o</option><option value="' + intAnioActual + '">' + intAnioActual + '</option>';
            for (var i = 1; i <= 10; i++) {
                intAnioActual++;
                strOptionSelect += '<option value="' + intAnioActual + '">' + intAnioActual + '</option>';
            }

            $('#inpAnioVNT').html(strOptionSelect);
            $('#inpAnioVED').html(strOptionSelect);
            $('#inpAnioVCP').html(strOptionSelect);
            $('#inpAnioVRT').html(strOptionSelect);

            $('#anadirNueva').on('click', function () {
                console.log("limpiar datos..");
                apuntador.limpiarnuevatarjeta();
                $('#agregar-tarjeta').modal('show');
                //$('#modalNuevaTarjeta').modal('show');
            });
            $('#anadirPagoNueva').on('click', function () {
                console.log("es  nueva tarjeta---");

                apuntador.esperasaldo().then(function () {
                    var montoPNT = parseFloat(apuntador.props.montoapagar.replace("$", "").replace(",", "")).toFixed(2);
                    $('#montoPNT').html("$ " + montoPNT);
                    $('#montoPNT').show();
                    $('#tituloparaPNT').html("Agregar y pagar tarjeta");
                    $('#btnRegistraTarjeta').html("Pagar");
                });
                $('#formas-pago').modal('hide');
                $('#agregar-tarjeta').modal('show');
            });

            $(document).on('keyup', '.inpValida', function () {
                var campoVld = $(this).attr('data-vld');
                //$(this).val($(this).val().toUpperCase());
                var valor = $(this).val();

                try {
                    valor.trim();
                    var exp = /(\s\s)$/g;
                    if (exp.test(valor)) {

                        $('#' + campoVld).html('No permitido');
                        $('#' + campoVld).show();
                        $('#btnAceptaDir').removeAttr('disabled');
                        $('#btnRegistraTarjeta').removeAttr('disabled');
                    } else {
                        var letras = /^[a-zA-Z0-9ÑñáéíóúÁÉÍÓÚ\s]+$/g;
                        if (!letras.test(valor)) {

                            $('#' + campoVld).html('No permitido');
                            $('#' + campoVld).show();
                            $('#btnAceptaDir').attr('disabled', 'true');
                            $('#btnRegistraTarjeta').attr('disabled', 'true');
                        } else {
                            $('#' + campoVld).html('');
                            $('#' + campoVld).hide();
                            $('#btnAceptaDir').removeAttr('disabled');
                            $('#btnRegistraTarjeta').removeAttr('disabled');
                        }
                    }
                } catch (e) {
                    console.error(e);
                    $('#' + campoVld).html('No permitido');
                    $('#' + campoVld).show();
                }
            });

            $("#btnAceptaDir").on("click", function (e) {
                e.preventDefault();
                var apuntador = this;
                $('.invalid-feedback').hide();

                var inputCampos = ['inpDirCalleRT', 'inpDirColoniaRT', 'inpDirCPRT', 'inpDirMunicipioRT', 'inpDirEstadoRT'];

                var labelValidacion = ['vldDirCalleRT', 'vldDirColoniaR', 'vldDirCPRT', 'vldDirMunicipioRT', 'vldDirEstadoRT'];
                var validacion = true;

                $.each(inputCampos, function (i, idCampo) {
                    var valor = $('#' + idCampo).val().trim();

                    if (valor === '') {
                        validacion = false;
                        var texto = '* El campo es requerido';
                        $('#' + labelValidacion[i]).html(texto);
                        $('#' + labelValidacion[i]).show();
                    }
                });

                if (validacion) {
                    var direccionCom = {
                        called: $('#inpDirCalleRT').val(),
                        coloniad: $('#inpDirColoniaRT').val(),
                        cpd: $('#inpDirCPRT').val(),
                        municipiod: $('#inpDirMunicipioRT').val(),
                        estadod: $('#inpDirEstadoRT option:selected').text(),
                        concatena: function concatena() {
                            return this.cpd + ", " + this.estadod + ", " + this.municipiod + ", " + this.coloniad + ", " + this.called;
                        }
                    };
                    var direccioncompleta = direccionCom.concatena(); //cpd+", "+estadod+", "+municipiod+", "+coloniad+", "+called;
                    $("#inpDircom").text(direccioncompleta);
                    $("#direccionmodal").modal("hide");
                    $("#agregar-tarjeta").modal("show");
                    $('#vldDireccion').hide();
                }
            });

            $(document).on('keyup', '#inpNumeroTarjetaRT', function () {
                var numeroTarjeta = $('#inpNumeroTarjetaRT').val();
                var digito = numeroTarjeta.substring(0, 1);
                $('#inpCVVRT').val('');

                $('.icnNT_R').removeClass('tarjetaD');
                if (digito === '3') {
                    $('#icnAmexNT_R').addClass('tarjetaD');
                    $('#inpCVVRT').attr('maxlength', '4');
                }
                if (digito === '4') {
                    $('#icnVisaNT_R').addClass('tarjetaD');
                    $('#inpCVVRT').attr('maxlength', '3');
                }
                if (digito === '5' || digito === '2') {
                    $('#icnMasterNT_R').addClass('tarjetaD');
                    $('#inpCVVRT').attr('maxlength', '3');
                }
            });

            $(document).on('blur', '#inpNumeroTarjetaRT', function () {

                apuntador.inicializarCampoRT();
                apuntador.props.datosBINGT = {
                    nombreBanco: '', idBanco: '', proveedorBanco: ''
                };
                $('#vldNumeroTarjetaRT').html('');

                var numeroTarjeta = $('#inpNumeroTarjetaRT').val();

                if (numeroTarjeta.length >= 6) {
                    var bin = numeroTarjeta.substring(0, 6);

                    var objetoTarjeta = {
                        inicioTarjeta: bin
                    };

                    var informacionEncriptada = otpyrc2(JSON.stringify(objetoTarjeta));
                    var informacion = {
                        "informacionEncriptada": informacionEncriptada
                    };

                    apuntador.pintarIcn("fas fa-sync fa-spin");
                    $('#ldrBinRT').show();

                    //apuntador.loadGetServicioBin(apuntador.props.apis.getserviciobin,informacion);
                    apuntador.props.contador = 1;
                    apuntador.loadGetServicioBin(CONSTANTES.endpoints.getserviciobin, informacion, apuntador.props.contador);
                } else {
                    apuntador.banderaBINGT = false;
                    apuntador.pintarIcn(apuntador.icnAlerta);
                    $('#inpNumeroTarjetaRT').addClass('is-invalid');
                    $('#vldNumeroTarjetaRT').html('Valida tu n&uacute;mero de tarjeta');
                    $('#vldNumeroTarjetaRT').show();
                }
            });

            $('#btnRegistraTarjeta').on('click', function (e) {
                e.preventDefault();
                console.log("validacion campos " + apuntador.validarCamposRegistroTarjeta());
                console.log("Estatus BEAN " + apuntador.banderaBINGT);
                if (apuntador.validarCamposRegistroTarjeta() && apuntador.banderaBINGT) {
                    if (opcion == 1) {
                        apuntador.enviarGuardadoTarjeta();
                    } else {
                        apuntador.enviarPagoNuevaTarjeta();
                    }
                }
            });

            $('#btnSpei').on('click', function () {
                $('#spei').modal('show');
                $('#formas-pago').modal('hide');
            });

            $('#btnRefBanco').on('click', function () {
                $('#referencias').modal('show');
                $('#formas-pago').modal('hide');
            });

            $('#btnRefEfe').on('click', function () {
                $('#lugares-pago').modal('show');
                $('#formas-pago').modal('hide');
            });

            $('#linkpaymentforms').on('click', function () {
                $('#formas-pago').modal('show');
            });

            $(".estado-cuenta").on('shown.bs.modal', '.modal', '#formas-pago', function () {
                console.log('holis');
                apuntador.loadFirstCard({ first: "false" }, 2);
            });

            $('#btnPayCard').on("click", function () {
                $('#pagar').modal('show');
            });

            $('#pagar').on('hidden.bs.modal', function () {

                apuntador.limpiacvv(apuntador.props.tarjetaseleccionadapago);
            });

            $("#botonpagoeditado").on('click', function (e) {
                e.preventDefault();
                var nuevovalor = $('#form1').val();

                var montototal = apuntador.props.montoapagar.replace("$", "").replace(",", "");
                nuevovalor = nuevovalor.replace("$", "").replace(",", "");

                if (nuevovalor != "") {
                    nuevovalor = parseFloat(nuevovalor);
                } else {
                    nuevovalor = 0.00;
                }

                if (montototal != "") {
                    montototal = parseFloat(montototal);
                } else {
                    montototal = 0.00;
                }

                if (nuevovalor > 0) {
                    console.log(montototal.constructor);
                    console.log(nuevovalor.constructor);
                    console.log(nuevovalor <= montototal);
                    if (nuevovalor <= montototal) {
                        $('#montofinal').html("$ " + nuevovalor.toFixed(2));
                        $('#pagar').modal('show');
                        $('#editar-pago').modal('hide');
                        $('#errorMontoEdicion').html("");
                    } else {
                        $('#errorMontoEdicion').html("El monto a pagar debe ser menor o igual al monto establecido");
                    }
                } else {
                    $('#errorMontoEdicion').html("El monto a pagar debe ser mayor a 0");
                }
            });

            var $pop = $('.pop-ayuda');

            $(document).mouseup(function (e) {
                if (!$pop.is(e.target) && $pop.has(e.target).length === 0) {
                    $pop.fadeOut();
                }
            });

            $('.icon-ayuda').on('click', function () {
                $pop.fadeIn();
            });

            // Mostrar icono tarjeta

            var $tarjeta = $('.tarjeta-icono');

            $('.no-cuenta').on('click', function () {
                $tarjeta.fadeIn();
            });

            $('#divBtnDir').on('click', function () {
                console.log("abrire modal de direccion");
                $('#agregar-tarjeta').modal('hide');
                $('#direccionmodal').modal('show');
            });
            /*---------editar y  elimiar--------------------*/
            $("#bntIrEliminar").on("click", function () {
                $('#editar-tarjeta').modal('hide');
                var idsel = $("#inpIdED").text();
                apuntador.props.todaslastarjetas.forEach(function (elem) {
                    if (idsel == elem.cb_idCard) {
                        console.log("voy a eliminar" + idsel);
                        var nombreBancoSel = elem.cb_bankname;
                        var finTarjetaSel = elem.cb_endingCardNumber;
                        var iconoTarjetaSel = apuntador.getIconoTarjeta(elem.cb_provider);
                        var nombreTarjetaSel = elem.cb_firstName;
                        $("#tarjetaeliminar").html('<div class="d-flex">' + iconoTarjetaSel + '<p class="text-left">' + nombreBancoSel + '</p>' + '</div>' + '<p class="text-dark text-right my-4 fs-20"> **** **** ***' + finTarjetaSel + '</p>' + '<p class="text-left mt-5">' + nombreTarjetaSel + '</p>' +
                        //'<p class="text-left mt-3 fs-14"> Vigencia '+
                        //vigenciaTarjetaSel+
                        //'</p>'+
                        '<span id="inpIdEL" class="inpIdEL">' + elem.cb_idCard + '</span>');

                        $('#eliminar-tarjeta').modal('show');
                    }
                });
            });

            $("#bntEliminarTarjeta").on("click", function () {
                console.log("eliminar....");
                apuntador.enviarEliminaTarjeta();
            });

            $("#btnEditarTarjeta").on('click', function () {
                if (apuntador.validarCamposEditaTarjeta()) {
                    apuntador.enviarEditaTarjeta();
                }
            });

            $("#btnAtrasDireccion").on('click', function () {
                $("#direccionmodal").modal('hide');
                $('#agregar-tarjeta').modal('show');
            });

            $("#btnPPtotal").on('click', function () {
                var montototal = apuntador.props.montoapagar.replace("$", "").replace(",", "");
                console.log("montototal", montototal);
                $("#formas-pago").modal('hide');
                $('#ctnPayPalRec').hide();
                $("#cargos_automaticos").prop("checked", false);
                if (montototal > 0) {
                    $('#btnPaypal').show();
                    $("#modalPayPal").modal('show');
                } else {
                    $("#modalNOPayPal").modal('show');
                }
            });

            $("#cargos_automaticos").on('click', function () {
                var isChecked = this.checked;
                console.log("Es seleccionado: ", isChecked);
                if (isChecked) {
                    $('#btnPaypal').hide();
                    $('#ctnPayPalRec').show();
                } else {
                    $('#btnPaypal').show();
                    $('#ctnPayPalRec').hide();
                }
            });
        }
    }, {
        key: "validacvv",
        value: function validacvv(provider, cvv) {
            var bandera = false;
            if (provider == "A") {
                if (cvv.length == 4) bandera = true;
            } else {
                if (cvv.length == 3) bandera = true;
            }
            return bandera;
        }
    }, {
        key: "limpiacvv",
        value: function limpiacvv(provider) {
            $('#cvv1').val("");
            $('#cvv2').val("");
            $('#cvv3').val("");
            if (provider == "A") {
                $('#cvv4').val("");
            }
        }
    }, {
        key: "enviarPagoTarjetaExistente",
        value: function enviarPagoTarjetaExistente(cvvformado, montoapagar) {
            $('#modalLoad').modal('show');
            console.log("envio monto" + montoapagar);
            var montoPago = $("#montofinal").text().replace("$", "").replace(",", "");
            var apuntador = this;
            var objetoTarjeta = {
                idTarjeta: apuntador.props.tarjetaseleccionadapago.cb_idCard,
                tarjetaFin: apuntador.props.tarjetaseleccionadapago.cb_endingCardNumber,
                primerNombre: apuntador.props.tarjetaseleccionadapago.cb_firstName,
                segundoNombre: apuntador.props.tarjetaseleccionadapago.cb_lastName,
                nombreBanco: apuntador.props.tarjetaseleccionadapago.cb_bankname,
                cvv: cvvformado,
                monto: parseFloat(montoPago).toFixed(2),
                ipCliente: "", numeroCuenta: "", cargosAutomaticos: "No"

            };

            var informacionEncriptada = otpyrc2(JSON.stringify(objetoTarjeta));
            var informacion = {
                "secdata": informacionEncriptada
            };

            var urlser = CONSTANTES.endpoints.pagotarjetaexistente;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(urlser, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                try {

                    $('#modalLoad').modal('hide');
                    $('#pagar').modal('hide');

                    if (respuesta.status == 0) {

                        if (respuesta.bean != undefined) {

                            if (respuesta.bean.codigoAutoriza !== null && respuesta.bean.codigoAutoriza !== '') {

                                $("#msjTitle").html("\xC9xito");
                                $("#msjrespuesta").html('Tu pago ha sido aprobado.' + '<p>C&oacute;digo de autorizaci&oacute;n:' + '<br><strong class="">' + respuesta.bean.codigoAutoriza + '</strong></p>' + '<p class="p-3"><small>Se ha enviado un correo electr&oacute;nico con la informaci&oacute;n de tu pago</small>' + '</p>');
                                $('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
                                $('#modalrespuesta').modal('show');

                                apuntador.loadGetEdoCta(1, true);
                            }
                        }
                    } else {

                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                    }
                } catch (e) {

                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    console.error(e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                $('#modalLoad').modal('hide');
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');

                console.log("Informacion no Disponible");
                console.log("err=>" + err);
            }).finally(function () {
                $('#modalLoad').modal('hide');
            });
        }
    }, {
        key: "enviarPagoNuevaTarjeta",
        value: function enviarPagoNuevaTarjeta() {
            var apuntador = this;
            $('#icnMensajeRT').attr('class', '');
            $('#btnCorrectoRT').hide();
            $('#btnRevisarRT').hide();
            $('#modalLoad').modal('show');
            var montoPago = $("#montoPNT").text().replace("$", "").replace(",", "");

            var objetoTarjeta = {
                primerNombre: $('#inpNombreRT').val(),
                segundoNombre: $('#inpApellidoPRT').val(),
                numeroTarjeta: $('#inpNumeroTarjetaRT').val(),
                mesVencimiento: $('#inpMesVRT').val(),
                anioVencimiento: $('#inpAnioVRT').val(),
                cvv: $('#inpCVVRT').val(),
                domicilioCalle: $('#inpDirCalleRT').val(),
                domicilioColonia: $('#inpDirColoniaRT').val(),
                domicilioCodigoPostal: $('#inpDirCPRT').val(),
                domicilioDelegacionMunicipio: $('#inpDirMunicipioRT').val(),
                domicilioEstado: $('#inpDirEstadoRT').val(),
                domicilioPais: 'Mexico',
                nombreBanco: this.props.datosBINGT.nombreBanco,
                idBanco: this.props.datosBINGT.idBanco,
                proveedorBanco: this.props.datosBINGT.proveedorBanco,
                cargosAutomaticos: this.props.datosBINGT.cargosAutomaticos,
                numeroCuenta: "",
                ipCliente: "",
                idProveedorBanco: "",
                montoPago: parseFloat(montoPago).toFixed(2)

            };
            console.log("objeto nueva tarjeta --- ");
            var informacionEncriptada = otpyrc2(JSON.stringify(objetoTarjeta));
            var informacion = {
                "strEnco": informacionEncriptada
            };

            var urlser = CONSTANTES.endpoints.pagonuevatarjeta;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(urlser, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                try {

                    $('#modalLoad').modal('hide');
                    $('#agregar-tarjeta').modal('hide');

                    if (respuesta.status == 0) {

                        if (respuesta.bean != undefined) {

                            if (respuesta.bean.codigoAutoriza !== null && respuesta.bean.codigoAutoriza !== '') {

                                $("#msjTitle").html("\xC9xito");
                                $("#msjrespuesta").html('Tu pago ha sido aprobado.' + '<p>C&oacute;digo de autorizaci&oacute;n:' + '<br><strong class="">' + respuesta.bean.codigoAutoriza + '</strong></p>' + '<p class="p-3"><small>Se ha enviado un correo electr&oacute;nico con la informaci&oacute;n de tu pago</small>' + '</p>');
                                $('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
                                $('#modalrespuesta').modal('show');

                                apuntador.loadGetEdoCta(1, true);
                                apuntador.loadFirstCard({ first: "refresh" }, 2);
                            }
                        }
                    } else {
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                    }
                } catch (e) {
                    $('#modalLoad').modal('hide');
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    console.error(e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                $('#modalLoad').modal('hide');
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');

                console.log("Informacion no Disponible");
                console.log("err=>" + err);
            });
        }
    }, {
        key: "getMobileOperatingSystem",
        value: function getMobileOperatingSystem() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if (/windows phone/i.test(userAgent)) {
                return "Windows Phone";
            }

            if (/android/i.test(userAgent)) {
                return "Android";
            }

            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iOS";
            }

            if (/Win32|Win64|Windows|WinCE/.test(userAgent)) {
                return "Desktop Windows";
            }

            if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
                return "Desktop Macintosh";
            }

            return "desconocido";
        }
    }, {
        key: "llenaFecha",
        value: function llenaFecha(fecha) {
            var apuntador = this;
            var arrayDate = fecha.split(" ");

            apuntador.props.anio = arrayDate[1];

            if (arrayDate[0] == "Ene") {

                apuntador.props.mes = "01";
            } else if (arrayDate[0] == "Feb") {

                apuntador.props.mes = "02";
            } else if (arrayDate[0] == "Mar") {

                apuntador.props.mes = "03";
            } else if (arrayDate[0] == "Abr") {

                apuntador.props.mes = "04";
            } else if (arrayDate[0] == "May") {

                apuntador.props.mes = "05";
            } else if (arrayDate[0] == "Jun") {

                apuntador.props.mes = "06";
            } else if (arrayDate[0] == "Jul") {

                apuntador.props.mes = "07";
            } else if (arrayDate[0] == "Ago") {

                apuntador.props.mes = "08";
            } else if (arrayDate[0] == "Sep") {

                apuntador.props.mes = "09";
            } else if (arrayDate[0] == "Oct") {

                apuntador.props.mes = "10";
            } else if (arrayDate[0] == "Nov") {

                apuntador.props.mes = "11";
            } else if (arrayDate[0] == "Dic") {

                apuntador.props.mes = "12";
            }
        }
    }, {
        key: "htmlToElement",
        value: function htmlToElement(html) {
            var template = document.createElement('template');
            html = html.trim();
            template.innerHTML = html;
            return template.content.firstChild;
        }

        /* ===== edicion tarjeta ==============*/

    }, {
        key: "formasdepagofunciones",
        value: function formasdepagofunciones() {

            var apuntador = this;
            $('.editar-metodo').on('click', function () {
                var idsel = this.id;
                console.log("editar " + idsel);
                apuntador.props.todaslastarjetas.forEach(function (elem) {
                    if (idsel == elem.cb_idCard) {
                        var idtarjetade = elem.cb_idCard;
                        var fintarjetaed = elem.cb_endingCardNumber;
                        var nombreed = elem.cb_firstName;
                        $("#inpIdED").html(idtarjetade);
                        $("#inpNombreED").val(nombreed);
                        $("#inpNumeroTarjetaED").val("**** **** **** ***" + fintarjetaed);
                        if (elem.cb_current != null && elem.cb_current != undefined && elem.cb_current == "T") {
                            $("#bntIrEliminar").hide();
                        } else {

                            $("#bntIrEliminar").show();
                        }
                    }
                });

                $('#editar-tarjeta').modal('show');
            });
        }
    }, {
        key: "validarCamposEditaTarjeta",
        value: function validarCamposEditaTarjeta() {
            $('.invalid-feedback').hide();
            var inputCampos = ['inpNumeroTarjetaED', 'inpMesVED', 'inpAnioVED', 'inpCVVED'];

            var labelValidacion = ['vldNumeroTarjetaED', 'vldMesVED', 'vldAnioVED', 'vldCVVED'];

            var validacion = true;

            $.each(inputCampos, function (i, idCampo) {
                var valor = $('#' + idCampo).val().trim();
                if (valor === '') {
                    validacion = false;
                    var texto = '* El campo es requerido';
                    $('#' + labelValidacion[i]).html(texto);
                    $('#' + labelValidacion[i]).show();
                }
                if (idCampo == 'inpCVVED') {
                    if (valor.length < 3) {
                        $('#vldCVVED').html('Minimo son 3 digitos');
                        $('#vldCVVED').show();
                        validacion = false;
                    }
                }
            });
            var anioActual = parseInt(new Date().getFullYear().toString().substr(-2));
            var mesActual = parseInt(new Date().getMonth());

            if (parseInt($('#inpAnioVED').val()) == parseInt(anioActual)) {
                if (parseInt($('#inpMesVED').val()) < parseInt(mesActual)) {
                    $('#vldMesVED').html('Invalido');
                    $('#vldMesVED').show();
                    validacion = false;
                }
            }

            return validacion;
        }
    }, {
        key: "enviarEditaTarjeta",
        value: function enviarEditaTarjeta() {

            $('#editar-tarjeta').modal('hide');
            $('#modalLoad').modal('show');
            var apuntador = this;

            var objetoTarjeta = {
                idcar: $('#inpIdED').text(),
                mesVencimiento: $('#inpMesVED').val(),
                anioVencimiento: $('#inpAnioVED').val(),
                recurrente: "N"
            };
            var informacionEncriptada = otpyrc2(JSON.stringify(objetoTarjeta));
            var informacion = {
                "secdata": informacionEncriptada
            };

            var urlser = CONSTANTES.endpoints.editatarjeta;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(urlser, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                try {
                    $('#modalLoad').modal('hide');
                    if (respuesta.status == 0) {
                        $("#msjTitle").html("\xC9xito");
                        $("#msjrespuesta").html('Los datos de tu tarjeta se actualizaron correctamente.');
                        $('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
                        $('#modalrespuesta').modal('show');
                        apuntador.loadFirstCard({ first: "refresh" }, 1);
                    } else {
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                    }
                } catch (e) {

                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    console.error(e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');

                console.log("Informacion no Disponible");
                console.log("err=>" + err);
            }).finally(function () {
                $('#modalLoad').modal('hide');
            });
        }
    }, {
        key: "enviarEliminaTarjeta",
        value: function enviarEliminaTarjeta() {
            $('#eliminar-tarjeta').modal('hide');
            $('#modalLoad').modal('show');
            var apuntador = this;

            var objetoTarjeta = {
                eliminar: $('#inpIdEL').text()
            };

            var informacionEncriptada = otpyrc2(JSON.stringify(objetoTarjeta));
            var informacion = {
                "secdata": informacionEncriptada
            };;

            var urlser = CONSTANTES.endpoints.eliminatarjeta;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(urlser, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                try {
                    $('#modalLoad').modal('hide');
                    if (respuesta.status == 0) {
                        $("#msjTitle").html("\xC9xito");
                        $("#msjrespuesta").html('Tu tarjeta se ha eliminado correctamente.');
                        $('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
                        $('#modalrespuesta').modal('show');
                        apuntador.loadFirstCard({ first: "refresh" }, 1);
                    } else {
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                    }
                } catch (e) {

                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    console.error(e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');

                console.log("Informacion no Disponible");
                console.log("err=>" + err);
            }).finally(function () {
                $('#modalLoad').modal('hide');
            });
        }
    }, {
        key: "cargarPaypal",
        value: function cargarPaypal(montoapagar) {

            var apuntador = this;
            var InfoCuenta = localStorage.getItem('dashboardData');
            var objBean = JSON.parse(InfoCuenta);
            var cuenta = objBean.bean.cuenta;

            var donde = window.location.pathname;
            if ((donde.includes("EstadoCuenta") || donde.includes("FormasPago")) && montoapagar > 0) {
                var cabeceraMC = new Headers();
                cabeceraMC.append("Content-type", "application/json;charset=utf-8");
                cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

                var FUNDING_SOURCES = [paypal.FUNDING.PAYPAL];

                FUNDING_SOURCES.forEach(function (fundingSource) {
                    var button = paypal.Buttons({
                        fundingSource: fundingSource,
                        style: {
                            color: 'gold',
                            shape: 'rect',
                            label: 'paypal'
                        },
                        createOrder: function createOrder(data, actions) {
                            console.log("creando orden...");
                            $("#modalPayPal").modal("hide");
                            return actions.order.create({
                                purchase_units: [{
                                    amount: { value: montoapagar },
                                    description: "Pago Paypal - Único - MTP",
                                    custom_id: cuenta
                                }]
                            });
                        },
                        onApprove: function onApprove(data) {
                            apuntador.guardarPaypalBrm(data.orderID).then(function (respuesta) {
                                console.log("onApprove", respuesta);
                                if (respuesta.result == 0) {
                                    $('#modalLoad').modal('hide');
                                    $("#msjTitle").html("\xC9xito");
                                    $("#msjrespuesta").html("Tu pago ha sido aprobado.\n                                                            <p><strong class=\"\">" + respuesta.bean + "</strong></p>");
                                    $('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
                                    $('#modalrespuesta').modal('show');
                                    apuntador.loadGetEdoCta(1, true);
                                } else {
                                    $('#modalLoad').modal('hide');
                                    $("#msjTitle").html("Atenci&oacute;n");
                                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                                    $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                                    $('#modalrespuesta').modal('show');
                                }
                            }).catch(function (err) {
                                $('#modalLoad').modal('hide');
                                $("#msjTitle").html("Atenci&oacute;n");
                                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                                $('#modalrespuesta').modal('show');
                                console.error(e);
                            });
                        },
                        onError: function onError(err) {
                            $('#modalLoad').modal('hide');
                            $("#msjTitle").html("Atenci&oacute;n");
                            $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                            $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                            $('#modalrespuesta').modal('show');

                            console.log("error", err);
                        }
                    });

                    if (button.isEligible()) {
                        button.render('#btnPaypal');
                    }
                });
            }
        }
    }, {
        key: "cargarPayPalRecurrente",
        value: function cargarPayPalRecurrente(process, ba_id) {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                // $('#modalLoad').modal('show');
                var cabeceraMC = new Headers();
                cabeceraMC.append("Content-type", "application/json;charset=utf-8");
                cabeceraMC.append("totalplay", _this2.ch.obtenerCookieWeb());

                var servicio = CONSTANTES.endpoints.obtieneUrlAcuerdoPayPal;
                var param = { "process": process };
                if (process == '2' && ba_id != undefined) {
                    param.ba_id = ba_id;
                }
                console.log("servicio......", servicio);
                console.log("Params PayPal agreement: ", JSON.stringify(param));
                var params = { "secdata": cifraTP(JSON.stringify(param)) };
                fetch(servicio, {
                    method: "POST",
                    headers: cabeceraMC,
                    body: JSON.stringify(params)
                }).then(function (data) {
                    if (data.ok) {
                        return data.json();
                    } else {
                        //throw "Error en la llamada Ajax";
                        reject("error");
                    }
                }).then(function (respuesta) {
                    var resp = JSON.parse(descifraTP(respuesta));
                    // console.log("REspuesta: ",resp);
                    if (resp.status == 0) {
                        $('#ctnPayPalRec').show();
                        switch (process) {
                            case '1':
                                $('#btnPaypalR').on('click', function () {
                                    localStorage.setItem('openModal', '#modalrespuesta');
                                    window.location.href = resp.bean;
                                });break;
                            case '2':
                                resolve(resp);break;
                            default:
                                break;
                        }
                    } else {
                        $('#ctnPayPalRec').hide();
                    }
                }).catch(function (err) {
                    console.log(err);
                    reject(err);
                });
            });
        }
    }, {
        key: "creaAgreementPayPal",
        value: function creaAgreementPayPal(params) {
            $('#modalLoad').modal('show');
            var apunta = this;
            var action = /action=([^&]+)/.exec(params)[1];
            var ba_id = /ba_token=([^&]+)/.exec(params)[1];
            if (action.includes("success")) {
                console.log("Billing Agreement ID: ", ba_id);

                apunta.cargarPayPalRecurrente('2', ba_id).then(function (resp) {
                    console.log("Respuesta: ", resp);
                    $('#modalLoad').modal('hide');
                    if (resp != null && resp != undefined && resp.status == 0) {
                        var montoPaypal = parseFloat(apunta.props.montoapagar.replace("$", "").replace(",", "")).toFixed(2);
                        apunta.procesaPagoRecPayPal(resp.bean, montoPaypal);
                    } else {
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html('Ocurrió un problema durante el proceso de aceptación de acuerdo de pago recuerrente con PayPal');
                        $('#modalrespuesta').modal('show');
                    }
                });
            } else if (action.includes('cancel')) {
                $('#modalLoad').modal('hide');
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $('#msjrespuesta').html('Debes aceptar el acuerdo de pago domiciliado PayPal');
                $("#modalrespuesta").modal('show');
            }
            window.history.pushState({}, document.title, window.location.href.replace(params, ''));
        }
    }, {
        key: "procesaPagoRecPayPal",
        value: function procesaPagoRecPayPal(b_id, monto) {
            $('#modalLoad').modal('show');
            var apuntador = this;

            var info = {
                b_id: b_id,
                monto: monto
            };

            var informacionEncriptada = cifraTP(JSON.stringify(info));
            var informacion = {
                "secdata": informacionEncriptada
            };

            var urlser = CONSTANTES.endpoints.procesaPagoPayPalF2;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(urlser, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                try {
                    $('#modalLoad').modal('hide');
                    console.log("Respuesta pago: ", respuesta);
                    var modalId = localStorage.getItem('openModal');
                    if (respuesta.status == 0) {
                        if (modalId != null) {
                            $("#msjTitle").html("\xC9xito");
                            $('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
                            $('#msjrespuesta').html("Tu pago con PayPal ha sido aprobado.</br></br>\n                                                Referencia:</br></br>\n                                                <p><strong>" + respuesta.bean + "</strong></p></br>\n                                                Y ha quedado registrado como pago domiciliado de forma exitosa.");
                            $(modalId).modal('show');
                            localStorage.removeItem('openModal');
                            apuntador.loadGetEdoCta(1, true);
                        }
                    } else {
                        if (modalId != null) {
                            $("#msjTitle").html("Atenci&oacute;n");
                            $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                            $('#msjrespuesta').html('Ocurrió un problema durante el proceso de activación de cargo domiciliado PayPal, inténtalo más tarde.');
                            $(modalId).modal('show');
                            localStorage.removeItem('openModal');
                        }
                    }
                } catch (e) {

                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    console.error(e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
                console.log("Informacion no Disponible");
                console.log("err=>" + err);
            }).finally(function () {
                $('#modalLoad').modal('hide');
            });
        }
    }, {
        key: "guardarPaypalBrm",
        value: function guardarPaypalBrm(orden) {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                $('#modalLoad').modal('show');
                var cabeceraMC = new Headers();
                cabeceraMC.append("Content-type", "application/json;charset=utf-8");
                cabeceraMC.append("totalplay", _this3.ch.obtenerCookieWeb());
                var obj = { orderID: orden };

                var servicio = CONSTANTES.endpoints.guardarpaypal;
                console.log("servicio......", servicio);
                fetch(servicio, {
                    method: "POST",
                    headers: cabeceraMC,
                    body: JSON.stringify(obj)
                }).then(function (data) {
                    if (data.ok) {
                        return data.json();
                    } else {
                        //throw "Error en la llamada Ajax";
                        reject("error");
                    }
                }).then(function (respuesta) {
                    resolve(respuesta);
                }).catch(function (err) {
                    reject(err);
                });
            });
        }
    }]);

    return InfoPagos;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49,"../../utils/ModalMng":50,"./Prepago":30}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Pagos = undefined;
exports.obtenerSaldo = obtenerSaldo;

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _CookieHelper = require("../../utils/CookieHelper");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Pagos = exports.Pagos = function Pagos() {
    _classCallCheck(this, Pagos);

    this.ch = new _CookieHelper.CookieHelper();
};

async function obtenerSaldo(apuntador, cookie, params) {
    var url = CONSTANTES.endpoints.saldoprepago;
    var cabeceraMC = new Headers();
    cabeceraMC.append("Content-type", "application/json;charset=utf-8");
    cabeceraMC.append("totalplay", cookie);

    var data = null;
    var formdata = undefined;

    if (params != undefined) {
        if (params.data != undefined) {
            formdata = new URLSearchParams();

            Object.keys(params.data).forEach(function (key) {
                formdata.append(key, params.data[key]);
            });
        }
    }
    try {
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(params),
            headers: cabeceraMC
        }).then(function (data) {
            if (data.ok) {
                return data.json();
            } else {
                throw "Error en la llamada Ajax fetch con parametros " + url;
            }
        }).then(function (texto) {
            try {
                var respuesta = texto;
                var saldoPrepago = document.getElementById("saldoPrepago");
                if (respuesta.status == 0) {
                    if (respuesta.bean != undefined) {
                        var saldoPre = respuesta.bean.Saldo;
                        if (saldoPre.includes("-")) {
                            var saldoFavor = saldoPre.split("-");
                            saldoPrepago.innerHTML = "- $" + saldoFavor[1];;
                            apuntador.props.saldoPrepago = "- $" + saldoFavor[1];;
                        } else {
                            saldoPrepago.innerHTML = "$" + respuesta.bean.Saldo;
                            apuntador.props.saldoPrepago = respuesta.bean.Saldo;
                        }
                    }
                } else {
                    saldoPrepago.innerHTML = "-";
                    console.log(e);
                }
            } catch (e) {
                console.error(e);
                throw "Error al traer la informacion";
            }
        }).catch(function (err) {
            console.log(err);
        }); //fin fetch*/
    } catch (e) {
        console.error(e);
    }
}

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InfoGral = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InfoGral = exports.InfoGral = function () {
    function InfoGral() {
        _classCallCheck(this, InfoGral);

        this.ch = new _CookieHelper.CookieHelper();
        this.init();
    }

    _createClass(InfoGral, [{
        key: "init",
        value: function init() {
            console.log("info general 23");
            //this.verificarestatuscontrato();
        }
    }, {
        key: "verificarestatuscontrato",
        value: function verificarestatuscontrato() {
            var arrayenviar = { tipo: "obtener" };
            console.log(arrayenviar);
            var objencrp = { "secdata": otpyrc2(JSON.stringify(arrayenviar)) };
            console.log(JSON.stringify(objencrp));

            var url = CONSTANTES.endpoints.getcontrato;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: 'POST',
                body: JSON.stringify(objencrp),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {

                try {
                    console.log(respuesta);
                    if (respuesta.status == 0) {
                        var nombrepdf = respuesta.bean.nombre + ".pdf";
                        $("#contratolink").html('<a href="data:application/pdf;base64,' + respuesta.bean.documento + '" download="' + nombrepdf + '">Descargar contrato</a>');
                    } else {
                        $("#contratolink").hide();
                    }
                } catch (e) {
                    console.error(e);
                    throw "Error al traer la informaci0n";
                }
            }).catch(function (err) {
                console.error(err);
            });
        }
    }]);

    return InfoGral;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Login = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _ModalMng = require("../../utils/ModalMng");

var _JwtBO = require("../../servicios/bo/JwtBO/JwtBO");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Login = exports.Login = function () {
	function Login() {
		_classCallCheck(this, Login);

		this.jwtBO = new _JwtBO.JwtBO();
		this.props = {
			lstLblMsgUsr: {
				"lblCampoVacio": "*Campo obligatorio",
				"lblFormatoDif": "*Campo no valido"
			},
			keys_arr: [8, 9, 35, 36, 37, 39],
			tokCap: ""

		};

		this.ch = new _CookieHelper.CookieHelper();
		this.init();
	}

	_createClass(Login, [{
		key: "init",
		value: function init() {
			var _this = this;

			console.log("se inicializa captcha");
			//$("#modalWelcome").show();
			this.ch.crearCookie();
			if (!window.location.host.includes("avisopago.totalplay.com.mx")) {
				this.cargaCaptha();
			}

			var modalManager = new _ModalMng.ModalMng();
			modalManager.createModal(CONSTANTES.modals.modalRegistroCuenta).then(function (status) {
				//confirmacion creacion del Primer modal
				return modalManager.createModal(CONSTANTES.modals.modalPassRecovery);
			}).then(function (status) {
				//confirmacion creacion del segundo modal
				return modalManager.createModal(CONSTANTES.modals.logMdlMsjToUser);
			}).then(function (status) {
				//confirmacion de creacion del tercer modal
				_this.setListeners();
				_this.setListenersInputs();
			}).catch(function (err) {
				console.error("el error es" + err);
			});

			this.ojito();
			//this.querysLogin();
			//this.multipleSessions();
		}
	}, {
		key: "limpiaAlerts",
		value: function limpiaAlerts() {
			$("#log-msj-err").css("display", "none");
			$("#log-msj-err-md-1").css("display", "none");
			$("#log-msj-suc-md-1").css("display", "none");
			$("#log-msj-err-md-2").css("display", "none");
			$("#log-msj-suc-md-2").css("display", "none");
		}
	}, {
		key: "setListeners",
		value: function setListeners() {
			$("body").removeClass("oculto");
			$("body").addClass("refresh");
			var clase = this;
			try {

				document.querySelector("#log-but-inises").addEventListener("click", function () {
					clase.limpiaAlerts();
					clase.iniciaSesion();
				});
				document.querySelector("#log-btn-crecue").addEventListener("click", function () {
					clase.limpiaAlerts();
					clase.creaCuenta();
				});
				document.querySelector("#log-btn-recpas").addEventListener("click", function () {
					clase.limpiaAlerts();
					clase.recuperaPass();
				});
			} catch (e) {
				console.error("element not found" + e);
			}

			document.querySelector('#inputUserNwAcc').addEventListener('keydown', function () {
				var newpass = $("#inputUserNwAcc").val();
				if (newpass != "") {
					//document.querySelector('#log-btn-crecue').disabled = false;
				}
			});

			document.querySelector('#inputPassRecoverys').addEventListener('keydown', function () {
				var newpass = $("#inputPassRecoverys").val();
				if (newpass != "") {
					//document.querySelector('#log-btn-recpas').disabled = false;
				}
			});
		}
	}, {
		key: "setListenersInputs",
		value: function setListenersInputs() {
			document.getElementById("log-user");
			document.getElementById("log-pass");

			var clase = this;
			$("#log-user").on("keyup", function () {
				$("#err-log-1").css("display", "none");
				$("#log-msj-err").css("display", "none");
			});

			$("#log-pass").on("keyup", function (e) {
				var keycode = e.keyCode ? e.keyCode : event.which;
				if (keycode === "13" || keycode === 13) {
					clase.iniciaSesion();
				} else {
					$("#err-log-2").css("display", "none");
					$("#log-msj-err").css("display", "none");
				}
			});

			$("#inputUserNwAcc, #inputPassRecoverys").on("keyup", function (e) {

				var value = $(this).val().trim();
				$(this).val(value);
				var valorTexto = this.value;
				var idBotonActual = $(this).attr('id');
				clase.validaCampoNumerico(valorTexto, idBotonActual);
			}).on("paste", function (e) {
				var content = "";

				if (clase.isIE()) {
					content = window.clipboardData.getData('text');
				} else {
					content = e.originalEvent.clipboardData.getData('text/plain');
				}

				var value = $(this).val().trim();
				$(this).val(value);

				var valorTexto = this.value;
				var idBotonActual = $(this).attr('id');

				clase.validaCampoNumerico(valorTexto, idBotonActual);
			});
		}
	}, {
		key: "cargaCaptha",
		value: function cargaCaptha() {
			var scriptChallenge = document.createElement("script");
			scriptChallenge.type = "text/javascript";
			scriptChallenge.src = "https://www.google.com/recaptcha/api.js?render=" + CONSTANTES.captcha.valor;
			document.body.appendChild(scriptChallenge);
		}
	}, {
		key: "ojito",
		value: function ojito() {

			$("#iconEye").on("click", function () {
				if ($("#log-pass").attr("type") == "text") {
					$("#iconEye").removeClass("clicked");
					$("#log-pass").attr("type", "password");
				} else if ($("#log-pass").attr("type") == "password") {
					$("#log-pass").attr("type", "text");
					$("#iconEye").addClass("clicked");
				}
			});

			var tooltip = document.querySelector('#tooltip-index');

			document.querySelector('.ico-question').addEventListener('click', function () {
				if (tooltip.classList.contains('visible')) {
					tooltip.classList.remove('visible');
				} else {
					tooltip.classList.add('visible');
					setTimeout(function () {
						tooltip.classList.remove('visible');
					}, 6000);
				}
			});
		}
	}, {
		key: "querysLogin",
		value: function querysLogin() {
			var clase = this;
			var x = window.matchMedia("(max-width: 792px)");
			this.funcionQuery(x);
			x.addListener(this.funcionQuery);
		}
	}, {
		key: "funcionQuery",
		value: function funcionQuery(x) {
			var element = document.getElementById("img-login");
			if (x.matches) {
				// If media query matches
				$("#img-login").css("display", "none");
			} else {
				$("#img-login").css("display", "block");
			}
		}
	}, {
		key: "creaCuenta",
		value: function creaCuenta() {
			//Obtener datos formulario
			try {
				var isNulo = false;
				var noCuenta = $.trim($("#inputUserNwAcc").val());
				if (noCuenta.length === 0) {
					isNulo = true;
					$("#err-log-md-1").html(this.props.lstLblMsgUsr.lblCampoVacio);
					$("#err-log-md-1").css("display", "block");
				} else {
					$("#err-log-md-1").css("display", "none");
				}

				if (!isNulo) {

					var isValid = this.validaDataUser(noCuenta);

					if (isValid) {
						//Encripta
						var jsonNwAcc = { "noCuenta": noCuenta };
						var cadenc = otpyrc2(JSON.stringify(jsonNwAcc));
						var objsen = { "secdata": cadenc };
						this.loadData(CONSTANTES.endpoints.crearcuenta, objsen, 2);
						jsonNwAcc = null;
						cadenc = null;
						objsen = null;
					} else {
						//this.showModal("Dato inv&aacute;lido","El n&uacute;mero de cuenta/tel&eacute;fono no tiene formato v&aacute;lido");
						$("#err-log-md-1").css("display", "block");
						$("#err-log-md-1").html(this.props.lstLblMsgUsr.lblFormatoDif);
					}
				}
			} catch (e) {
				console.log("Exception creaCuenta");
				console.log(e);
			}
		}
		/***** CREA CUENTA END *****/

		/***** RECUPERA CONTRASEnA START *****/

	}, {
		key: "recuperaPass",
		value: function recuperaPass() {
			//Obtener datos formulario

			try {
				var isNulo = false;
				var noCuenta = $.trim($("#inputPassRecoverys").val());

				if (noCuenta.length === 0) {
					isNulo = true;
					$("#err-log-md-2").css("display", "block");
					$("#err-log-md-2").html(this.props.lstLblMsgUsr.lblCampoVacio);
				} else {
					$("#err-log-md-2").css("display", "none");
				}
				console.log(noCuenta);

				if (!isNulo) {

					//Validar si es numero de cuenta o telefono
					var isValid = this.validaDataUser(noCuenta);

					if (isValid) {
						//Encripta
						var jsonRecPas = { "noCuenta": noCuenta, "origen": "" };
						var cadenc = otpyrc2(JSON.stringify(jsonRecPas));
						var objsen = { "secdata": cadenc };

						this.loadData(CONSTANTES.endpoints.recuperacontrasenia, objsen, 3);
						jsonRecPas = null;
						cadenc = null;
						objsen = null;
					} else {
						$("#err-log-md-2").css("display", "block");
						$("#err-log-md-2").html(this.props.lstLblMsgUsr.lblFormatoDif);
					}
				}
			} catch (e) {
				console.log("Exception recuperaContrasenia");
				console.log(e);
			}
		}
		/***** VALIDACIONES START *****/

	}, {
		key: "validaDataUser",
		value: function validaDataUser(user) {
			console.log("entroooooooooooo");
			var isValid = false;
			try {
				if (this.validaTel(user)) {
					isValid = true;
					console.log("entroooooooooooo tel");
				} else if (this.validaEmail(user)) {
					console.log("entroooooooooooo email");

					isValid = true;
				} else if (this.validaCuenta(user)) {
					console.log("entroooooooooooo cuenta");

					isValid = true;
				}
			} catch (e) {
				console.log(e);
			}

			return isValid;
		}
	}, {
		key: "validaEmail",
		value: function validaEmail(email) {
			var response = false;
			var reEmail = /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/; // regular expression defining email address
			if (email.length > 0) {
				if (email.match(reEmail)) {
					console.log("Valido por Email");
					response = true;
				}
			}

			return response;
		}
	}, {
		key: "validaTel",
		value: function validaTel(telefono) {
			var response = false;
			var reTelefono = /^\d{9,10}$/; //regular expression defining a 10 digit number

			if (telefono.length > 0) {
				if (telefono.match(reTelefono)) {
					//console.log("Valido por Telefono o NumCuenta");
					response = true;
				}
			}

			return response;
		}
	}, {
		key: "validaCuenta",
		value: function validaCuenta(cuenta) {
			var response = false;
			var reCuenta = /^\d{1}[.]\d{7}$/; //regular expression defining a 5 digit number

			if (cuenta.length > 0) {
				if (cuenta.match(reCuenta)) {
					//console.log("Valido por cuenta");
					response = true;
				}
			}
			return response;
		}
		/***** VALIDACIONES END *****/

		/***** MODAL START *****/

	}, {
		key: "showModal",
		value: function showModal(title, msg, icon) {
			$("#mdlTitToUser").html(title);
			$("#mdlBodyToUser").html(msg);
			$("#iconrespuesta").html(icon);
			$("#logMdlMsjToUser").modal("show");
		}

		//seccion de inicon de session

	}, {
		key: "iniciaSesion",
		value: function iniciaSesion() {
			var _this2 = this;

			try {
				var resuf = $.trim($("#log-user").val());
				var ssapf = $.trim($("#log-pass").val());

				var isNulo = false;
				var cadRes = "";

				if (resuf.length === 0) {
					isNulo = true;
					cadRes += "No ingreso su usuario";
					$("#err-log-1").css("display", "block");
					$("#err-log-1").html(this.props.lstLblMsgUsr.lblCampoVacio);
				}

				if (ssapf.length === 0) {
					isNulo = true;
					cadRes += " y/o no ingreso su contraseña. ";
					$("#err-log-2").css("display", "block");
					$("#err-log-2").html(this.props.lstLblMsgUsr.lblCampoVacio);
				}

				if (!isNulo) {
					//Validar user valido
					var isValid = this.validaDataUser(resuf);

					if (isValid) {
						this.ch.clearStorage().then(function () {
							return _this2.getTokenCaptcha();
						}).then(function () {
							_this2.creaObjLogin(resuf, ssapf, _this2.props.tokCap);
						});
					} else {
						$("#err-log-1").css("display", "block");
						$("#err-log-1").html(this.props.lstLblMsgUsr.lblFormatoDif);
					}
				}
			} catch (e) {
				console.log(e);
				$("#log-msj-err").html("Error al procesar la petici&oacute;n");
				$("#log-msj-err").css("display", "block");
			}
		}
	}, {
		key: "creaObjLogin",
		value: function creaObjLogin(resuf, ssapf, token) {
			var apuntador = this;
			var obtenerorigen = "";
			//var obtenerorigen=window.location.href;
			//console.log("origen................."+obtenerorigen);
			if (window.location.host.includes("avisopago.totalplay.com.mx")) {
				obtenerorigen = "morosos";
			}

			var jsonlogin = { resu: resuf, ssap: ssapf, captcha: token, origen: obtenerorigen };
			var cadenc = otpyrc2(JSON.stringify(jsonlogin));
			var data = apuntador.ch.obtenerCookieWebN("intentos");
			console.log("data: ", data);
			var cuantosintentos = 0;
			if (data != "" && data != null) {
				cuantosintentos = parseInt(data);
			}
			console.log("cuantosintentos", cuantosintentos);
			if (cuantosintentos < 3) {
				this.loadData(CONSTANTES.endpoints.login, { datosEncriptados: cadenc }, 1);
			} else {
				$("#log-msj-err").html("Se ha excedido el número de intentos para iniciar sesión.");
				$("#log-msj-err").css("display", "block");
				console.log("favor de intentar en 10 minutos...");
			}
		}
	}, {
		key: "isIE",
		value: function isIE() {
			var ua = window.navigator.userAgent;
			return ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0;
		}
	}, {
		key: "acceptKey",
		value: function acceptKey(eventk) {
			var keynum = window.event ? window.event.keyCode : eventk.which;

			//Validar Teclas especiales
			// Shift End
			if (eventk.shiftKey && keynum === 35) {
				return true;
			}

			// Shift Start
			if (eventk.shiftKey && keynum === 36) {
				return true;
			}
			// Ctrl+C or Cmd+C pressed?
			if ((event.ctrlKey || event.metaKey) && keynum === 67) {
				return true;
			}
			// Ctrl+V or Cmd+V pressed?
			if ((eventk.ctrlKey || eventk.metaKey) && keynum === 86) {
				return true;
			}
			// Ctrl+X or Cmd+X pressed?
			if ((eventk.ctrlKey || eventk.metaKey) && keynum === 88) {
				return true;
			}

			//Validar teclas aceptadas
			if (this.props.keys_arr.indexOf(parseInt(keynum)) > -1) {
				return true;
			}

			if (keynum === 190) {
				return true;
			}

			if (keynum > 95 && keynum < 106) {
				return true;
			}

			if (keynum < 48 || keynum > 57) {
				return false;
			} else {
				return true;
			}
		}
	}, {
		key: "generaNewCaptcha",
		value: function generaNewCaptcha() {
			return new Promise(function (resolve, reject) {
				grecaptcha.ready(function () {
					grecaptcha.execute(CONSTANTES.captcha.valor, { action: 'login' }).then(function (token) {
						if (token.length > 0) {
							resolve(token);
						} else {
							reject("");
						}
					});
				});
			});
		}
	}, {
		key: "getTokenCaptcha",
		value: async function getTokenCaptcha() {
			if (!window.location.host.includes("avisopago.totalplay.com.mx")) {
				var token = await this.generaNewCaptcha();
				this.props.tokCap = token;
				return token;
			} else {
				return "";
			}
		}
	}, {
		key: "fakeresponse",
		value: function fakeresponse() {

			return new Promise(function (resolve, rej) {
				resolve({
					"status": 0
				});
			});
		}
	}, {
		key: "solicitarJWT",
		value: function solicitarJWT() {
			var _this3 = this;

			this.jwtBO.solicitaSesionTotalShop().then(function (res) {
				localStorage.setItem("sesionTTSHP", JSON.stringify(res));
				localStorage.setItem("sesionTTSHP_Estatus", "0");

				var redireccion = _this3.jwtBO.redireccionar(null);
				if (redireccion == false) {
					window.location.replace(CONSTANTES.sitioBase + "dashboard.html");
				} else {
					/** requiere redireccionamiento pero primero validar el usuario filtrado */
					if (_this3.jwtBO.usuarioValido()) {
						_this3.jwtBO.getInfoRedirect(redireccion);
					} else {
						window.location.replace(CONSTANTES.sitioBase + "dashboard.html");
					}
				}
			}, function (err) {
				console.log(err);
			}).finally(function (final) {});
		}
	}, {
		key: "loadData",
		value: function loadData(url, params, opt) {
			var _this4 = this;

			var apuntador = this;
			$('#modalLoad').modal('show');

			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");

			if (opt === 1) {
				cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());
			}

			fetch(url, {
				method: 'POST',
				body: JSON.stringify(params),
				headers: cabeceraMC
			}).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax Fetch " + url;
				}
			})
			//apuntador.fakeresponse()

			.then(function (respuesta) {
				try {

					if (parseInt(opt) === 1) {
						//Es login
						console.log(respuesta);
						if (respuesta.status === 0) {
							console.log("iniciando bean ........", respuesta.bean);
							var storeprepago = CONSTANTES.storedKeys.storeprepago;
							apuntador.storedata(respuesta.bean, storeprepago);

							apuntador.controlasessiones(respuesta.bean.tipocliente);
						} else {

							$('#modalLoad').modal('hide');
							if (parseInt(respuesta.status) === 3) {
								$("#log-msj-err").html("Hubo un error al conectar con nuestro servidor, favor de intentar m&aacute;s tarde.");
								$("#log-msj-err").css("display", "block");
								$(".art").height(479);
							} else if (parseInt(respuesta.status) === 10) {
								$("#log-msj-err").html("Error al validar captcha");
								$("#log-msj-err").css("display", "block");
							} else if (parseInt(respuesta.status) === 7) {
								$("#log-msj-err").html(respuesta.descripcion);
								$("#log-msj-err").css("display", "block");
							} else if (parseInt(respuesta.status) === 202) {
								$("#log-msj-err").html("El correo tiene varias cuentas asociadas,ingrese con su n&uacute;ro de cuenta.");
								$("#log-msj-err").css("display", "block");
							} else {
								//guardar cookiie
								apuntador.ch.cookieIntentos();

								$("#log-msj-err").html("Verifique sus datos y vuelva a intentar.");
								$("#log-msj-err").css("display", "block");
								$(".art").height(479);
							}
						}
					}

					if (parseInt(opt) === 2) {
						$('#modalLoad').modal('hide');
						//Crea cuenta
						if (respuesta.status === 0) {
							$("#inputUserNwAcc").val("");
							$('#logMdlNewAcc').modal('hide');
							_this4.showModal("Usuario creado", "<p>Se ha creado la cuenta, se ha enviado una contrase&ntilde;a temporal a su correo registrado.</p>", "<i class='far fa-check-circle fa-3x text-success'></i>");
						} else {
							if (respuesta.status === 2) {
								$("#log-msj-err-md-1").css("display", "block");
								$("#log-msj-err-md-1").html(respuesta.descripcion);
							} else {
								$("#log-msj-err-md-1").css("display", "block");
								$("#log-msj-err-md-1").html("No se cre&oacute; la cuenta,intente nuevamente.");
							}
						}
					}

					if (parseInt(opt) === 3) {
						$('#modalLoad').modal('hide');
						//Restablece pass
						if (respuesta.status === 0) {
							$('#logMdlRecPas').modal('hide');
							$("#inputPassRecoverys").val("");
							$("#logMdlMsjToUser").modal("hide");
							_this4.showModal("Contrase&ntilde;a reestablecida", "Se reestableci&oacute; su contrase&ntilde;a, se env&iacute;o una contrase&ntilde;a temporal al correo registrado.", "<i class='far fa-check-circle fa-3x text-success'></i>");
						} else {
							$("#log-msj-err-md-2").css("display", "block");
							$("#log-msj-err-md-2").html("No se pudo reestablecer su contrase&ntilde;a, vuelva a intentar.");
						}
					}
				} catch (e) {
					$('#modalLoad').modal('hide');
					if (parseInt(opt) === 1) {
						$("#log-msj-err").css("display", "block");
						$("#log-msj-err").html("Ocurri&oacute; un error al establecer comunicaci&oacute;n con nuestro servidor. Intente nuevamente.");
					}
					if (parseInt(opt) === 2) {
						$("#log-msj-err-md-1").css("display", "block");
						$("#log-msj-err-md-1").html("No se cre&oacute; la cuenta,intente nuevamente");
					}
					if (parseInt(opt) === 3) {
						$("#log-msj-err-md-2").css("display", "block");
						$("#log-msj-err-md-2").html("No pudo restablecerse su contrase&ntilde;a.");
					}
				}
			}).catch(function (err) {
				$('#modalLoad').modal('hide');
				console.log("err=>" + url + " / " + err);
			});
		}
	}, {
		key: "controlasessiones",
		value: function controlasessiones(tipocliente) {
			console.log("tipocliente", tipocliente);
			var apuntador = this;
			$('#modalLoad').modal('show');
			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");
			cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());
			var url = CONSTANTES.endpoints.revisarSesiones;
			console.log("nueva url.....", url);

			fetch(url, {
				method: 'POST',
				headers: cabeceraMC
			}).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax Fetch " + url;
				}
			}).then(function (respuesta) {
				console.log("respuesta,,,,,", respuesta);
				if (respuesta.codigo == 0) {

					if (tipocliente === 2) {
						window.location.replace(CONSTANTES.sitioBase + "EstadoCuenta.html");
					} else if (tipocliente === 3) {
						window.location.replace(CONSTANTES.sitioBase + "Mispagos.html");
					} else {
						window.location.replace(CONSTANTES.sitioBase + "dashboard.html");
						//apuntador.solicitarJWT();
					}
				} else {

					$('#modalLoad').modal('hide');
					$("#contenedorLogin").hide();
					$("#contenedorSessiones").show();
					var htmlsessiones = "";
					respuesta.bean.forEach(function (item) {
						console.log(item);
						var obj = {};
						if (item != null) obj = JSON.parse(item);
						htmlsessiones += "<div class=\"session\">\n                            <div class=\"device desktop\"></div>\n                            <div class=\"desc col\">" + obj.navegador + "<br><strong>Activo ahora</strong></div>\n                        </div>";
					});
					$("#mostrarSessiones").html(htmlsessiones);
					apuntador.multipleSessions();
				}
			}).catch(function (error) {
				console.log("error al procesar las sessiones", error);
			});
		}
	}, {
		key: "multipleSessions",
		value: function multipleSessions() {
			var apuntador = this;

			$('.out_all').click(function () {
				$('#allSession').modal('show');
			});

			$(".btn-primary").click(function () {
				$('#allSession').modal('hide');
				apuntador.cerrarsessiones();
			});

			$('#btnRegresarLogin').click(function () {
				window.location.replace(CONSTANTES.sitioBase);
			});
		}
	}, {
		key: "cerrarsessiones",
		value: function cerrarsessiones() {

			var apuntador = this;
			$('#modalLoad').modal('show');

			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");
			cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());
			var url = CONSTANTES.endpoints.cerrarSesiones;

			fetch(url, {
				method: 'POST',
				headers: cabeceraMC
			}).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax Fetch " + url;
				}
			}).then(function (respuesta) {
				console.log("respuesta,,,,,", respuesta);
				$('#modalLoad').modal('hide');
				if (respuesta.codigo == 0) {
					$("#textoSessiones").html("Las sesiones se eliminaron correctamente.");
					$('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
					$('#exitoCS').modal('show');
				} else {

					$("#textoSessiones").html("Ocurrio un error.");
					$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
					$('#exitoCS').modal('show');
				}
			}).catch(function (error) {
				$('#modalLoad').modal('hide');
				$("#textoSessiones").html("Ocurrio un error.");
				$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
				$('#exitoCS').modal('show');
				console.log("error cerrar session ", error);
			});
		}
	}, {
		key: "storedata",
		value: function storedata(respuesta, key) {
			if (localStorage != null && localStorage != undefined) localStorage.setItem(key, JSON.stringify(respuesta));
		}
	}, {
		key: "validaCampoNumerico",
		value: function validaCampoNumerico(valorTexto, idBotonActual) {
			var idMensajeError = '#err-log-md-1';
			var idBotonAccion = '#log-btn-crecue';

			if (idBotonActual === 'inputPassRecoverys') {
				idMensajeError = '#err-log-md-2';
				idBotonAccion = '#log-btn-recpas';
			}

			var expresionNumerica = new RegExp('^[0-9]+$');
			var validacion = expresionNumerica.test(valorTexto);

			var expressionEnlace = /^\d{1}[.]\d{7}$/;
			var validacionEnlace = valorTexto.match(expressionEnlace);

			var bandera = false;

			if (validacion || valorTexto.match(expressionEnlace)) {
				if (validacion && valorTexto.length == 10 || validacionEnlace && valorTexto.length == 9) {
					bandera = true;
					$(idMensajeError).html('');
					$(idMensajeError).css("display", "none");
					$(idBotonAccion).removeAttr('disabled');
				} else {
					$(idMensajeError).html('No es una cuenta v&aacute;lida');
					$(idMensajeError).css("display", "block");
					$(idBotonAccion).attr('disabled', '');
				}
			} else {
				$(idMensajeError).html('Captura una cuenta v&aacute;lida');
				$(idMensajeError).css("display", "block");
				$(idBotonAccion).attr('disabled', '');
			}

			return bandera;
		}
	}]);

	return Login;
}();

},{"../../servicios/bo/JwtBO/JwtBO":46,"../../utils/Constantes":48,"../../utils/CookieHelper":49,"../../utils/ModalMng":50}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MiPlan = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MiPlan = exports.MiPlan = function () {
    function MiPlan(tipo) {
        _classCallCheck(this, MiPlan);

        this.ch = new _CookieHelper.CookieHelper();

        this.init(tipo);
    }

    _createClass(MiPlan, [{
        key: "init",
        value: function init(tipo) {
            this.loadPlan(tipo);
        }
    }, {
        key: "loadPlan",
        value: function loadPlan(tipo) {
            $('#spinnersMiPlan').show();

            var url = CONSTANTES.endpoints.urlPlan;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());
            var obj = { "refresh": tipo };
            console.log("refresa plan", obj);

            fetch(url, {
                method: 'POST',
                body: JSON.stringify(obj),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                try {

                    console.log("status : ", respuesta);

                    if (respuesta.status == 0) {
                        $('#packageName').html(respuesta.bean.nombrePaquete.toLowerCase());
                        localStorage.setItem('pn', respuesta.bean.nombrePaquete);

                        var servicios = respuesta.bean.listaServicios;
                        var htmlservicios = "";
                        var htmlserviciosPaq = "";
                        servicios.forEach(function (element) {
                            htmlservicios += "<li class=\"text-capitalize\">" + element.nombre.toLowerCase() + "</li>";
                            htmlserviciosPaq += "<div class=\"row\">\n                                            <div class=\"col-12 contenido-paquetes py-3\">\n                                                <div class=\"padre text-capitalize\">" + element.padre.toLowerCase() + "</div>\n                                                <div class=\"detalle text-capitalize\">" + element.nombre.toLowerCase() + "</div>\n                                            </div>\n                                        </div>";
                        });
                        if (htmlservicios == "") htmlservicios = "<li>No se encontró información</li>";
                        $("#listServicios").html(htmlservicios);
                        $("#serviciosPaquete").html(htmlserviciosPaq);

                        var adicionales = respuesta.bean.listaAdicionales;
                        var htmladdons = "";
                        var htmladdonsPaq = "";
                        adicionales.forEach(function (element) {
                            htmladdons += "<li class=\"text-capitalize\">" + element.nombre.toLowerCase() + "</li>";
                            htmladdonsPaq += "<div class=\"row\">\n                                            <div class=\"col-12 contenido-paquetes py-3\">\n                                                <div class=\"detalle text-capitalize\">" + element.nombre.toLowerCase() + "</div>\n                                            </div>\n                                        </div>";
                        });
                        if (htmladdons == "") htmladdons = "<li>No se encontró información</li>";
                        $("#listAdicionales").html(htmladdons);
                        $("#adicionalesPaquete").html(htmladdonsPaq);
                        if (htmladdonsPaq != "") $("#contenedorAdicionales").show();

                        $('#spinnersMiPlan').hide();
                        $('#divMiPlan').show();
                    }
                } catch (e) {
                    $('#spinnersMiPlan').hide();
                    $('#divMiPlan').show();

                    console.error(e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                $('#spinnersMiPlan').hide();
                $('#divMiPlan').show();

                console.log("Informacion no Disponible");
                console.log("err=>" + err);
            });
        }
    }]);

    return MiPlan;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MiPlanPrepago = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MiPlanPrepago = exports.MiPlanPrepago = function () {
    function MiPlanPrepago() {
        _classCallCheck(this, MiPlanPrepago);

        this.ch = new _CookieHelper.CookieHelper();
        this.init();
    }

    _createClass(MiPlanPrepago, [{
        key: "init",
        value: function init() {
            this.cargarPlan();
        }
    }, {
        key: "cargarPlan",
        value: function cargarPlan() {
            var _this = this;

            $("#loaderStatusNetflix").hide();
            $('#spinnersMiPlan').show();
            var apuntador = this;
            var url = CONSTANTES.endpoints.planprepago;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());
            fetch(url, {
                method: 'POST',
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0) {
                        $('#packageName').html(respuesta.bean.nombrepaquete.toLowerCase());
                        localStorage.setItem('pn', respuesta.bean.nombrepaquete.toLowerCase());
                        var objProd = respuesta.bean.productos;
                        var html = "",
                            htmlAddon = "";var muestraTV = false;
                        var re = /mb/g;
                        objProd.forEach(function (item) {
                            var desc = item.descripcionparse.toLowerCase().replace(re, "MB");
                            html += '<li class="text-left capitalize">' + desc + '</li>';
                            if (item.tipo == "Television") {
                                muestraTV = true;
                            }
                        });
                        if (html != "") {
                            $('#listServicios').append(html);
                            if (muestraTV) {
                                $("#idAgregaTV").show();
                            }
                        } else {
                            $('#listServicios').html('<li class="text-left ">No hay información que mostrar</li>');
                        }

                        var objAddon = respuesta.bean.adicionales;
                        objAddon.forEach(function (item) {
                            var desc = item.descripcion.toLowerCase().replace(re, "MB");
                            htmlAddon += '<li class="text-left">' + desc + ' Tv(s) Adicional(es)</li>';
                        });

                        if (htmlAddon != "") {
                            $('#listAdicionales').html(htmlAddon);
                        } else {
                            $('#listAdicionales').html('<li class="text-left ">No cuenta con adicionales</li>');
                        }

                        apuntador.agregaTV();
                    }

                    $('#spinnersMiPlan').hide();
                    $('#divMiPlan').show();
                } catch (e) {
                    $('#spinnersMiPlan').hide();
                    $('#divMiPlan').show();
                    console.error(e);
                    throw "Error al traer la informacion";
                }
                _this.agregaTV();
            }).catch(function (err) {
                $('#spinnersMiPlan').hide();
                $('#divMiPlan').show();
                console.log("Error al consultar plan=>" + err);
            });
        }
    }, {
        key: "agregaTV",
        value: function agregaTV() {
            $("#idAgregaTV").on("click", function () {
                $('#modalAgregaTV').modal('show');
            });

            $("#btnirChatAgregaTV").on("click", function () {
                window.open("https://www.totalplay.online/totalplayatencion/chatbeacon/content/windows/chat.html?accountid=1&siteid=1&queueid=1&theme=blue&popout=true", "cbchat", "left=20,top=20,width=315,height=570,resizable=0");
                $("#modalAgregaTV").modal("hide");
            });
        }
    }]);

    return MiPlanPrepago;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49}],35:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Pagos = undefined;
exports.BINGT = BINGT;
exports.enviarPagoNuevaTarjeta = enviarPagoNuevaTarjeta;
exports.recargaPlan = recargaPlan;
exports.consultarBitacora = consultarBitacora;
exports.enviarPagoTarjetaExistente = enviarPagoTarjetaExistente;

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _CookieHelper = require("../../utils/CookieHelper");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Pagos = exports.Pagos = function Pagos() {
    _classCallCheck(this, Pagos);

    this.ch = new _CookieHelper.CookieHelper();
};

function BINGT(params, cookie) {
    var URL2LOAD = CONSTANTES.endpoints.getserviciobin;
    var cabeceraMC = new Headers();
    cabeceraMC.append("Content-type", "application/json;charset=utf-8");
    cabeceraMC.append("totalplay", cookie);

    var response = void 0;
    try {
        response = fetch(URL2LOAD, {
            method: 'POST',
            body: JSON.stringify(params),
            headers: cabeceraMC
        });
    } catch (e) {
        console.error("Error al consultar BINGT" + e);
    }

    return response;
}

function enviarPagoNuevaTarjeta(datosBINGT, cookie) {
    var apuntador = this;
    $('#icnMensajeRT').attr('class', '');
    $('#btnCorrectoRT').hide();
    $('#btnRevisarRT').hide();
    var montoPago = $("#montoPNT").text().replace("$", "").replace(",", "");

    var objetoTarjeta = {
        primerNombre: $('#inpNombreRT').val(),
        segundoNombre: $('#inpApellidoPRT').val(),
        numeroTarjeta: $('#inpNumeroTarjetaRT').val(),
        mesVencimiento: $('#inpMesVRT').val(),
        anioVencimiento: $('#inpAnioVRT').val(),
        cvv: $('#inpCVVRT').val(),
        domicilioCalle: $('#inpDirCalleRT').val(),
        domicilioColonia: $('#inpDirColoniaRT').val(),
        domicilioCodigoPostal: $('#inpDirCPRT').val(),
        domicilioDelegacionMunicipio: $('#inpDirMunicipioRT').val(),
        domicilioEstado: $('#inpDirEstadoRT').val(),
        domicilioPais: 'Mexico',
        nombreBanco: datosBINGT.nombreBanco,
        idBanco: datosBINGT.idBanco,
        proveedorBanco: datosBINGT.proveedorBanco,
        cargosAutomaticos: datosBINGT.cargosAutomaticos,
        numeroCuenta: "",
        ipCliente: "",
        idProveedorBanco: "",
        //montoPago: 1.0
        montoPago: parseFloat(montoPago).toFixed(2)

    };
    console.log("objeto nueva tarjeta --- ");
    console.log(objetoTarjeta);
    var informacion = { "strEnco": otpyrc2(JSON.stringify(objetoTarjeta)) };

    var urlser = CONSTANTES.endpoints.pagonuevatarjeta;
    var cabeceraMC = new Headers();
    cabeceraMC.append("Content-type", "application/json;charset=utf-8");
    cabeceraMC.append("totalplay", cookie);

    var response = void 0;
    try {
        response = fetch(urlser, {
            method: "POST",
            body: JSON.stringify(informacion),
            headers: cabeceraMC
        });
    } catch (e) {
        console.error("Error pago nueva tarjeta: " + e);
    }

    return response;
}

function recargaPlan(recargabean, teles, cookie) {

    $("#oferta").modal('hide');
    $("#modalLoad").modal('show');

    var obj = {
        idPlan: recargabean.idSfPlan,
        noTV: teles.numeroTv,
        codificacionTK: recargabean.codificacion,
        descPlan: recargabean.descSf
    };
    console.log(obj);
    var informacion = { "secdata": otpyrc2(JSON.stringify(obj)) };
    console.log(informacion);

    var urlser = CONSTANTES.endpoints.comprarecarga;
    var cabeceraMC = new Headers();
    cabeceraMC.append("Content-type", "application/json;charset=utf-8");
    cabeceraMC.append("totalplay", cookie);

    var response = void 0;
    try {
        response = fetch(urlser, {
            method: "POST",
            body: JSON.stringify(informacion),
            headers: cabeceraMC
        });
    } catch (e) {
        console.error("recarga:" + e);
    }

    return response;
}

function consultarBitacora(idBitacora, cookie) {

    var obj = { idBitacora: idBitacora };
    console.log(obj);
    var informacion = { "secdata": otpyrc2(JSON.stringify(obj)) };
    console.log(informacion);

    var urlser = CONSTANTES.endpoints.obtenerbitacora;
    var cabeceraMC = new Headers();
    cabeceraMC.append("Content-type", "application/json;charset=utf-8");
    cabeceraMC.append("totalplay", cookie);

    var response = void 0;
    try {
        response = fetch(urlser, {
            method: "POST",
            body: JSON.stringify(informacion),
            headers: cabeceraMC
        });
    } catch (e) {
        console.error("consultar bitacora:" + e);
    }

    return response;
}

function enviarPagoTarjetaExistente(cvvformado, montoapagar, apuntador) {
    $('#modalLoad').modal('show');
    $('#pagar').modal('hide');
    console.log("envio monto" + montoapagar);
    var montoPago = $("#montofinal").text().replace("$", "").replace(",", "");
    console.log(montoPago);
    console.log(parseFloat(montoPago).toFixed(2));
    var objetoTarjeta = {
        idTarjeta: apuntador.props.tarjetaseleccionadapago.cb_idCard,
        tarjetaFin: apuntador.props.tarjetaseleccionadapago.cb_endingCardNumber,
        primerNombre: apuntador.props.tarjetaseleccionadapago.cb_firstName,
        segundoNombre: apuntador.props.tarjetaseleccionadapago.cb_lastName,
        nombreBanco: apuntador.props.tarjetaseleccionadapago.cb_bankname,
        cvv: cvvformado,
        monto: parseFloat(montoPago).toFixed(2),
        //monto: 1.0,
        ipCliente: "", numeroCuenta: "", cargosAutomaticos: "No"

    };
    console.log(objetoTarjeta);

    var informacionEncriptada = otpyrc2(JSON.stringify(objetoTarjeta));
    console.log("informacionEncriptada ", informacionEncriptada);
    var informacion = {
        "secdata": informacionEncriptada
    };
    console.log("objetoTarjeta ", informacion);

    var urlser = CONSTANTES.endpoints.pagotarjetaexistente;
    var cabeceraMC = new Headers();
    cabeceraMC.append("Content-type", "application/json;charset=utf-8");
    cabeceraMC.append("totalplay", apuntador.ch.obtenerCookieWeb());

    var response = void 0;
    try {
        response = fetch(urlser, {
            method: "POST",
            body: JSON.stringify(informacion),
            headers: cabeceraMC
        });
    } catch (e) {
        console.error("error pago tarjeta existente:" + e);
    }

    return response;
}

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49}],36:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Recargas = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _ModalMng = require("../../utils/ModalMng");

var _Validaciones = require("./Validaciones");

var val = _interopRequireWildcard(_Validaciones);

var _Pagos = require("./Pagos");

var pagos = _interopRequireWildcard(_Pagos);

var _HomePrepago = require("./../home/HomePrepago");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Recargas = exports.Recargas = function () {
    function Recargas() {
        _classCallCheck(this, Recargas);

        this.props = {
            containerList: [].concat(_toConsumableArray(document.querySelectorAll('.main-payment__payments--payment-container'))),
            container: document.querySelector('.main-payment__payments--payment-container'),
            listOfItems: [].concat(_toConsumableArray(document.querySelectorAll('.payments-options__item'))),
            arrayHistorico: [],
            arrayRecargas: [],
            teles: [],
            saldocliente: 0,
            botontarjeta: '',
            arrayTarjetas: [],
            tarjetaSeleccionada: '',
            tarjetaseleccionadapago: '',
            precioSeleccionado: null,
            arrayBin: null,
            recargaSelec: null
        };
        this.ch = new _CookieHelper.CookieHelper();
    }

    _createClass(Recargas, [{
        key: "init",
        value: async function init() {
            var modalManager = new _ModalMng.ModalMng();
            modalManager.createModal(CONSTANTES.modals.recomendados);

            this.nombrepaquete();

            var pathname = window.location.pathname;

            try {
                if (pathname.includes("pagos")) {
                    this.cargarHistorial();
                }

                var x1 = await this.cargarSaldo();
                this.cargarOferta();
                this.obtenerTarjetas({ first: "false" });
                var x2 = await this.cargarListeners();
                if (x2 == "FOUND_LISTENERS") {
                    this.listeners();
                }
            } catch (e) {
                console.log("promise init recargas " + e);
            }
        }
    }, {
        key: "nombrepaquete",
        value: function nombrepaquete() {
            var paquete = localStorage.getItem("pn");
            $("#paquetePP").html(paquete);
        }
    }, {
        key: "cargarSaldo",
        value: function cargarSaldo() {
            var apuntador = this;
            var urlser = CONSTANTES.endpoints.saldoprepago;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var response = fetch(urlser, {
                method: "POST",
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros para cargar saldo";
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0) {
                        if (respuesta.bean != undefined) {

                            var valor = parseFloat(respuesta.bean.Saldo);
                            if (Math.sign(valor) == -1) {
                                var nvoValor = valor * -1;
                                apuntador.props.saldocliente = parseFloat(valor.toFixed(2));

                                document.getElementById("saldocliente").innerHTML = "- $" + nvoValor.toFixed(2);
                            } else {
                                apuntador.props.saldocliente = parseFloat(valor.toFixed(2));
                                document.getElementById("saldocliente").innerHTML = "$" + valor.toFixed(2);
                            }
                        }
                    }
                } catch (e) {
                    console.error(e);
                    throw "Error al traer la informacion en consulta saldo";
                }
            }).catch(function (err) {
                console.error("Error en consulta saldo=>" + err);
            });

            return response;
        }
    }, {
        key: "cargarOferta",
        value: function cargarOferta() {
            var apuntador = this;
            var urlser = CONSTANTES.endpoints.obteneroferta;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var response = fetch(urlser, {
                method: "POST",
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros consulta oferta";
                }
            }).then(function (respuesta) {
                try {
                    $("#spinnersOferta").hide();
                    var noinfo = "<span>No hay información que mostrar.</span>";
                    var pathname = window.location.pathname;
                    if (respuesta.status == 0) {
                        if (respuesta.bean != undefined) {
                            if (respuesta.bean.arrayRecargas.length > 0) {

                                apuntador.props.arrayRecargas = respuesta.bean.arrayRecargas;
                                apuntador.props.teles = respuesta.bean.numeroTeles;
                                var htmloferta = "";
                                apuntador.props.arrayRecargas.forEach(function (elem) {
                                    if (elem.desc == '1 D&iacute;as') {
                                        elem.desc = '1 D&iacute;a';
                                    }
                                    htmloferta += "<li class=\"payments-options__item\" id=\"" + elem.idSfPlan + "\">\n                                    <span class=\"payments-options__item--days\">" + elem.desc + "</span>\n                                    <span class=\"payments-options__item--price\">$ " + elem.monto + "</span>\n                                </li>";
                                });
                                document.getElementById("ofertaRecargas").innerHTML = htmloferta;
                            } else {
                                document.getElementById("ofertaRecargas").innerHTML = noinfo;
                                if (pathname.includes("Formas")) {
                                    document.getElementById("noInfoTarifa").css.display = "block";
                                }
                            }
                        } else {
                            document.getElementById("ofertaRecargas").innerHTML = noinfo;
                            if (pathname.includes("Formas")) {
                                document.getElementById("noInfoTarifa").css.display = "block";
                            }
                        }
                    }
                } catch (e) {

                    document.getElementById("ofertaRecargas").innerHTML = "<span>No hay información que mostrar.</span>";
                    console.error("Excepcion al consultar oferta: " + e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                document.getElementById("ofertaRecargas").innerHTML = "<span>No hay información que mostrar.</span>";
                console.error("Error consulta oferta => " + err);
            });

            return response;
        }
    }, {
        key: "cargarListeners",
        value: function cargarListeners() {
            var apuntador = this;
            return new Promise(function (resolve, reject) {
                var contador = 0;
                var interval = setInterval(function () {
                    if (apuntador.props.saldocliente != null && apuntador.props.arrayRecargas.length > 0) {
                        clearInterval(interval);
                        resolve("FOUND_LISTENERS");
                    }
                }, 300);
            });
        }
    }, {
        key: "listeners",
        value: function listeners() {
            var apuntador = this;

            var _container = document.querySelector('.main-modal__payment-topup--payments-container');
            var elemcontainer = _container.querySelectorAll(".payments-options__item");
            elemcontainer.forEach(function (item) {
                item.addEventListener('click', function (e) {
                    elemcontainer.forEach(function (elem) {
                        elem.classList.remove('active');
                    });
                    item.classList.add('active');
                    apuntador.pagarOactivar(item.id);
                });
            });

            var cookie = this.ch.obtenerCookieWeb();
            $("#anadirPagoNuevaP").on("click", function () {
                $("#modal-tarjetas").modal('hide');
                $("#montoPNT").show();
                var total = encodeURIComponent($("#totalapagar").html());
                $("#montoPNT").text(decodeURIComponent(total));
                $("#tituloparaPNT").html("Pagar y agregar tarjeta");
                $("#btnRegistraTarjeta").html("Pagar");
                val.llenarAnio();
                $("#agregar-tarjeta").modal('show');
            });

            $("#btnAtrasDireccion").on("click", function () {
                $("#direccionmodal").modal('hide');
                $("#agregar-tarjeta").modal('show');
            });

            $("#divBtnDir").on("click", function () {
                $("#agregar-tarjeta").modal('hide');
                $("#direccionmodal").modal('show');
            });

            //eventos agregar tarjeta
            var $pop = $('.pop-ayuda');

            $(document).mouseup(function (e) {
                if (!$pop.is(e.target) && $pop.has(e.target).length === 0) {
                    $pop.fadeOut();
                }
            });

            $('.icon-ayuda').on('click', function () {
                $pop.fadeIn();
            });

            // Mostrar icono tarjeta

            var $tarjeta = $('.tarjeta-icono');

            $('.no-cuenta').on('click', function () {
                $tarjeta.fadeIn();
            });

            $(document).on('blur', '#inpNumeroTarjetaRT', function () {

                val.inicializarCampoRT();

                $('#vldNumeroTarjetaRT').html('');
                var numeroTarjeta = $('#inpNumeroTarjetaRT').val();
                if (numeroTarjeta.length >= 6) {
                    var bin = numeroTarjeta.substring(0, 6);

                    var objetoTarjeta = { inicioTarjeta: bin };
                    var informacion = { "informacionEncriptada": otpyrc2(JSON.stringify(objetoTarjeta)) };

                    var contador = 1;
                    if (contador == 1) {
                        pagos.BINGT(informacion, cookie).then(function (dataresponse) {
                            if (dataresponse.ok) {
                                return dataresponse.json();
                            } else {
                                throw "Error en la llamada Ajax fetch BIN ";
                            }
                        }).then(function (json) {
                            var binbean = json.bean.bin;
                            var existeDato = false;
                            try {
                                var idBanco = json.bean.bin.idBanco;
                                if (idBanco != '') {
                                    existeDato = true;
                                }
                            } catch (Exception) {
                                console.error(Exception);
                            }

                            var validacionServicio = parseInt(json.bean.response.code);
                            if (validacionServicio == 0 && existeDato) {

                                apuntador.props.arrayBin = {
                                    nombreBanco: binbean.nombreBanco,
                                    idBanco: binbean.idMarca,
                                    proveedorBanco: binbean.nombreMarca,
                                    cargosAutomaticos: binbean.cargosAutomaticos
                                };
                                $('#inpNumeroTarjetaRT').addClass('is-valid');

                                try {
                                    $('#tipCard').attr('src', val.getSrcTarjeta(json.bean.bin.nombreMarca));
                                    $('#tipCard').css('display', 'inline');
                                } catch (error) {
                                    console.erro("no pude traer el tipo de tarjeta" + error);
                                }
                            } else {
                                $('#inpNumeroTarjetaRT').addClass('is-invalid');
                                $('#vldNumeroTarjetaRT').html('Valida tu n&uacute;mero de tarjeta');
                                $('#vldNumeroTarjetaRT').show();
                            }
                            contador++;
                        });
                    }
                } else {
                    val.pintarIcn("fas fa-exclamation-circle");
                    $('#inpNumeroTarjetaRT').addClass('is-invalid');
                    $('#vldNumeroTarjetaRT').html('Valida tu n&uacute;mero de tarjeta');
                    $('#vldNumeroTarjetaRT').show();
                }
            });

            $("#btnAceptaDir").on("click", function (e) {
                e.preventDefault();
                var validacion = val.validarCamposDireccion();

                if (validacion) {
                    var direccionCom = {
                        called: $('#inpDirCalleRT').val(),
                        coloniad: $('#inpDirColoniaRT').val(),
                        cpd: $('#inpDirCPRT').val(),
                        municipiod: $('#inpDirMunicipioRT').val(),
                        estadod: $('#inpDirEstadoRT option:selected').text(),
                        concatena: function concatena() {
                            return this.cpd + ", " + this.estadod + ", " + this.municipiod + ", " + this.coloniad + ", " + this.called;
                        }
                    };
                    var direccioncompleta = direccionCom.concatena(); //cpd+", "+estadod+", "+municipiod+", "+coloniad+", "+called;
                    $("#inpDircom").text(direccioncompleta);
                    $("#direccionmodal").modal("hide");
                    $("#agregar-tarjeta").modal("show");
                    $('#vldDireccion').hide();
                }
            });

            $('#btnRegistraTarjeta').on('click', function (e) {
                e.preventDefault();

                var validacion = val.validarCamposRegistroTarjeta();
                if (validacion && apuntador.props.arrayBin != null) {
                    apuntador.recargaConNuevaTarjeta();
                }
            });

            $('#btnFinalizarPago').on('click', function () {
                apuntador.recargaConTarjetaExistente();
            });

            $('.sendInterfac').on('click', function () {
                apuntador.enviarInterfactura();
            });
        }
    }, {
        key: "pagarOactivar",
        value: function pagarOactivar(_index) {
            var apuntador = this;
            apuntador.props.arrayRecargas.forEach(function (obj) {
                if (obj.idSfPlan == _index) {
                    apuntador.props.recargaSelec = obj;
                    var montoplan = parseFloat(obj.monto);
                    var totalapagar = montoplan + apuntador.props.saldocliente;
                    apuntador.props.precioSeleccionado = "$" + totalapagar.toFixed(2);
                    document.getElementById("recargasel").innerHTML = obj.desc;
                    document.getElementById("pricesel").innerHTML = "$" + montoplan.toFixed(2);
                    if (totalapagar <= 0) {
                        if (Math.sign(totalapagar) == -1) {
                            totalapagar = totalapagar * -1;
                            document.getElementById("saldofavor").innerHTML = "- $" + totalapagar.toFixed(2);
                        } else {
                            document.getElementById("saldofavor").innerHTML = "$" + totalapagar.toFixed(2);
                        }
                        document.getElementById("resumeafavor").style.display = "flex";
                        document.getElementById("totalapagar").innerHTML = "$ 0";
                        document.getElementById("pagaroactivar").innerHTML = "<span class=\"btn__blue__solid\" id=\"btnActivarPlan\">Activar plan</span>";
                    } else {
                        document.getElementById("resumeafavor").style.display = "none";
                        document.getElementById("totalapagar").innerHTML = "$" + totalapagar.toFixed(2);

                        if (apuntador.props.arrayTarjetas.length > 0) {
                            apuntador.primeratarjeta();
                        } else {
                            document.getElementById("pagaroactivar").innerHTML = "<span class=\"btn__blue__solid\" id=\"btnIrPagarNuevaTarjeta\">Agregar tarjeta</span>";
                        }
                    }
                }
            });
            apuntador.listenerbotonedinamicos();
        }
    }, {
        key: "primeratarjeta",
        value: function primeratarjeta() {
            var apuntador = this;
            var primeratarjeta = apuntador.props.arrayTarjetas[0];
            apuntador.props.tarjetaSeleccionada = primeratarjeta;
            var nombreBancoInicial = primeratarjeta.cb_bankname;
            var finTarjeta = primeratarjeta.cb_endingCardNumber;
            var terminacionTarjetaInicial = "* " + finTarjeta.substr(finTarjeta.length - 4);
            var splitBanco = "";
            if (nombreBancoInicial.length > 13) {
                splitBanco = nombreBancoInicial.substring(0, 13);
                splitBanco += '...';
            } else {
                splitBanco = nombreBancoInicial;
            }
            var tarjetapago = splitBanco + terminacionTarjetaInicial;
            document.getElementById("pagaroactivar").innerHTML = "<span class=\"btn__blue__solid\" id=\"btnPagarPrepago\">" + tarjetapago + "</span>\n              <span class=\"btn__opaque__blue\" id=\"btnOtrasTarjetasP\">Otras tarjetas</span>";
        }
    }, {
        key: "listenerbotonedinamicos",
        value: function listenerbotonedinamicos() {
            var apuntador = this;
            $("#btnActivarPlan").on("click", function () {
                apuntador.activarPrepago();
            });
            $("#btnIrPagarNuevaTarjeta").on("click", function () {
                $("#oferta").modal('hide');
                $("#montoPNT").show();
                var total = encodeURIComponent($("#totalapagar").html());
                $("#montoPNT").text(decodeURIComponent(total));
                $("#tituloparaPNT").html("Pagar y agregar tarjeta");
                $("#btnRegistraTarjeta").html("Pagar");
                val.llenarAnio();
                $("#agregar-tarjeta").modal('show');
            });

            $("#btnPagarPrepago").on("click", function () {
                $("#oferta").modal('hide');
                var pintaTarjeta = val.pintatarjetaseleccionada(apuntador);
                $("#pagar").modal('show');
            });
            $("#btnOtrasTarjetasP").on("click", function () {
                $("#oferta").modal('hide');
                $("#modal-tarjetas").modal('show');
            });
        }
    }, {
        key: "recargaConNuevaTarjeta",
        value: function recargaConNuevaTarjeta() {
            var apuntadorClase = this;
            var cookie = this.ch.obtenerCookieWeb();
            $('#agregar-tarjeta').modal('hide');
            $('#modalLoad').modal('show');

            pagos.enviarPagoNuevaTarjeta(apuntadorClase.props.arrayBin, cookie).then(function (dataresponse) {
                if (dataresponse.ok) {
                    return dataresponse.json();
                } else {
                    throw "Error en la llamada Ajax fetch nuevatarjeta ";
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0) {
                        if (respuesta.bean != undefined) {
                            if (respuesta.bean.codigoAutoriza !== null && respuesta.bean.codigoAutoriza !== '') {

                                $('#modalLoad').css("z-index", "999");
                                $("#msjTitle").html("\xC9xito");
                                $("#msjrespuesta").html('Tu pago ha sido aprobado.' + '<p>C&oacute;digo de autorizaci&oacute;n:' + '<br>' + respuesta.bean.codigoAutoriza + '</p>' + '<p class="p-3"> Tu recarga esta en proceso ' + '</p>');
                                $('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
                                $('#modalrespuesta').modal('show');
                                apuntadorClase.activarPrepago();
                            }
                        }
                    } else {

                        $('#modalLoad').modal('hide');
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                    }
                } catch (e) {

                    $('#modalLoad').modal('hide');
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    console.error("Excepcion en pago nueva tarjeta " + e);
                }
            }).catch(function (err) {
                $('#modalLoad').modal('hide');
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
                console.error("Error pago nueva tarjeta =>" + err);
            });
        }
    }, {
        key: "recargaConTarjetaExistente",
        value: function recargaConTarjetaExistente() {
            var apuntadorClase = this;
            //valida cvv
            var cvv4valor = "";
            if ($("#cvv4").val() != undefined) {
                cvv4valor = $("#cvv4").val();
            }
            var cvvformado = $("#cvv1").val() + $("#cvv2").val() + $("#cvv3").val() + cvv4valor;
            var montoapagar = $("#montofinal").text();
            if (cvvformado == "") {
                $("#errorcvv").html("*Campo Requerido");
            } else {
                if (val.validacvv(apuntadorClase.props.tarjetaSeleccionada.cb_provider, cvvformado)) {
                    $('#pagar').modal('hide');
                    $('#modalLoad').modal('show');
                    pagos.enviarPagoTarjetaExistente(cvvformado, montoapagar, apuntadorClase).then(function (dataresponse) {
                        if (dataresponse.ok) {
                            return dataresponse.json();
                        } else {
                            throw "Error en la llamada Ajax fetch nuevatarjeta ";
                        }
                    }).then(function (respuesta) {
                        try {
                            if (respuesta.status == 0) {
                                if (respuesta.bean != undefined) {
                                    if (respuesta.bean.codigoAutoriza !== null && respuesta.bean.codigoAutoriza !== '') {
                                        $('#modalLoad').css("z-index", "999");
                                        $("#msjTitle").html("\xC9xito");
                                        $("#msjrespuesta").html('Tu pago ha sido aprobado.' + '<p>C&oacute;digo de autorizaci&oacute;n:' + '<br>' + respuesta.bean.codigoAutoriza + '</p>' + '<p class="p-3"> Tu recarga esta en proceso ' + '</p>');
                                        $('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
                                        $('#modalrespuesta').modal('show');
                                        apuntadorClase.activarPrepago();
                                    }
                                }
                            } else {

                                $('#modalLoad').modal('hide');
                                $("#msjTitle").html("Atenci&oacute;n");
                                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                                $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                                $('#modalrespuesta').modal('show');
                            }
                        } catch (e) {

                            $('#modalLoad').modal('hide');
                            $("#msjTitle").html("Atenci&oacute;n");
                            $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                            $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                            $('#modalrespuesta').modal('show');
                            console.error("Excepcion en pago tajeta existente " + e);
                        }
                    }).catch(function (err) {
                        $('#modalLoad').modal('hide');
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                        $('#modalrespuesta').modal('show');
                        console.error("Error en pago tajeta existente => " + err);
                    });
                } else {
                    $("#errorcvv").html("Campo no v&aacute;lido");
                }
            }
        }
    }, {
        key: "activarPrepago",
        value: function activarPrepago() {
            var apuntador = this;
            var cookie = this.ch.obtenerCookieWeb();
            var recargabean = apuntador.props.recargaSelec;
            var noteles = apuntador.props.teles;
            if (recargabean != null) {
                pagos.recargaPlan(recargabean, noteles, cookie).then(function (dataresponse1) {
                    if (dataresponse1.ok) {
                        return dataresponse1.json();
                    } else {
                        throw "Error en la llamada Ajax fetch comprar recarga ";
                    }
                }).then(function (respuesta) {
                    try {
                        if (respuesta.status == 0) {
                            var idbitacora = respuesta.bean.idBitacora;
                            setTimeout(function () {
                                console.log("esperando 15 segundos");
                                apuntador.revisarBitacora(idbitacora);
                            }, 20000);
                        } else {
                            $('#modalLoad').modal('hide');
                            $("#msjTitle").html("Atenci&oacute;n");
                            $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                            $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                            $('#modalrespuesta').modal('show');
                        }
                    } catch (e) {
                        $('#modalLoad').modal('hide');
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                        $('#modalrespuesta').modal('show');
                        console.error("Excepcion en comprar recarga " + e);
                    }
                }).catch(function (err) {
                    $('#modalLoad').modal('hide');
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    console.error("Error en comprar recarga =>" + err);
                });
            } else {
                console.error("comprar recarga bean null");
            }
        }
    }, {
        key: "revisarBitacora",
        value: function revisarBitacora(idBitacora) {
            var _this = this;

            var apuntador = this;
            var cookie = this.ch.obtenerCookieWeb();

            pagos.consultarBitacora(idBitacora, cookie).then(function (dataresponse1) {
                if (dataresponse1.ok) {
                    return dataresponse1.json();
                } else {
                    throw "Error en la llamada Ajax fetch comprar recarga ";
                }
            }).then(function (respuesta) {
                $('#modalLoad').modal('hide');
                console.log(respuesta);
                if (respuesta.status == 0) {
                    $("#msjTitle").html("\xC9xito");
                    $('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
                    $('#msjrespuesta').html('Tu recarga se registro exitosamente.');
                    $('#modalrespuesta').modal('show');
                } else {
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html("Su servicio quedará restaurado en un minuto, si existe algún inconveniente, comunícate a nuestro centro de Atención a clientes.");
                    $('#modalrespuesta').modal('show');
                }
            }).catch(function (err) {
                $('#modalLoad').modal('hide');
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
                console.error("Error en comprar recarga =>" + err);
            }).finally(function () {
                //apuntador.obtenerTarjetas({ first: "refresh" });
                var pathname = window.location.pathname;
                apuntador.cargarSaldo();
                apuntador.limpiarModalOferta();
                if (pathname.includes("pagos")) {
                    _this.cargarHistorial();
                }
                if (pathname.includes("home")) {
                    var hp = new _HomePrepago.HomePrepago();
                }
            });
        }
    }, {
        key: "cargarHistorial",
        value: function cargarHistorial() {
            var apuntador = this;
            var urlser = CONSTANTES.endpoints.obtenerhistorial;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(urlser, {
                method: "POST",
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros cargar historial";
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0) {
                        if (respuesta.bean != undefined) {

                            if (respuesta.bean.facturaActual != undefined) {
                                $("#urlFacturaPrepago").attr("href", respuesta.bean.facturaActual);
                            }
                            if (respuesta.bean.listHistoricoBean.length > 0) {
                                $('#spinnersRecargas').hide();
                                var plantillahis = '<span class="main-payment__payments--title">Pagos realizados:</span>';
                                respuesta.bean.listHistoricoBean.forEach(function (item) {
                                    var diasrecargas = val.prettifyDate(item.numeroDias);
                                    plantillahis += " <ul class=\"main-payment__payments--payment-container\">\n            \n                                            <li class=\"main-payment__payments--payment-container__payment-title\">\n                                                <span class=\"payment-days\">" + diasrecargas + "</span>\n                                                <span class=\"payment-date\">" + item.fechaCorta.fechaInicio + " - " + item.fechaCorta.fechaFin + "</span>\n                                                <div class=\"open-close-resume\"></div>\n                                            </li>\n\n                                            <li class=\"main-payment__payments--payment-container__payment-description\">\n                                                <div class=\"description-item\">\n                                                    <span class=\"description-item__title\">Vigencia</span>\n                                                    <div class=\"description-item__info\">\n                                                        <span class=\"info-title\">Fecha incio</span>\n                                                        <span class=\"info-date\">" + item.fechaDetalle.fechaInicio + "</span>\n                                                    </div>\n                                                    <div class=\"description-item__info\">\n                                                        <span class=\"info-title\">Fecha fin</span>\n                                                        <span class=\"info-date\">" + item.fechaDetalle.fechaFin + "</span>\n                                                    </div>\n                                                </div>\n                                            </li>\n                                        </ul>";
                                });
                                $("#recargasRealizadasP").html(plantillahis);
                                apuntador.inciaestiloshistorial();
                            } else {
                                $('#spinnersRecargas').hide();
                                $("#recargasRealizadasP").html("<span class=\"main-payment__payments--title\">Pagos realizados:</span>\n                                                             <span class=\"text-center\"> No hay informaci\xF3n que mostrar</span>");
                            }
                        }
                    }
                } catch (e) {
                    $('#spinnersRecargas').hide();
                    console.error("Excepcion cargar historial " + e);
                }
            }).catch(function (err) {
                $('#spinnersRecargas').hide();
                console.error("Error cargar historial =>" + err);
            });
        }
    }, {
        key: "limpiarModalOferta",
        value: function limpiarModalOferta() {
            document.getElementById("recargasel").innerHTML = "Selecciona tu recarga";
            document.getElementById("pricesel").innerHTML = "";
            document.getElementById("resumeafavor").style.display = "none";
            document.getElementById("totalapagar").innerHTML = "$ 0";
            document.getElementById("pagaroactivar").innerHTML = "";
            var _container = document.querySelector('.main-modal__payment-topup--payments-container');
            var elemcontainer = _container.querySelectorAll(".payments-options__item");
            elemcontainer.forEach(function (item) {
                elemcontainer.forEach(function (elem) {
                    elem.classList.remove('active');
                });
            });
        }
    }, {
        key: "inciaestiloshistorial",
        value: function inciaestiloshistorial() {
            this.props.container = document.querySelector('.main-payment__payments--payment-container');
            this.props.containerList = [].concat(_toConsumableArray(document.querySelectorAll('.main-payment__payments--payment-container')));

            //Obtine el alto del primer elemento de la lista 
            var titleHeight = this.props.container.firstElementChild.offsetHeight;
            this.props.containerList.forEach(function (item) {
                setTimeout(function () {
                    //item.style.cssText = `height: ${titleHeight}px; overflow: hidden;`; 
                    item.style.cssText = "height: 56px; overflow: hidden;";
                }, 100);
            });

            this.userEvents();
        }
    }, {
        key: "userEvents",
        value: function userEvents() {
            var _this2 = this;

            //Obtiene la lista de los indicadores (flechas)
            var closeOpenList = [].concat(_toConsumableArray(document.querySelectorAll('.open-close-resume')));
            //Obtiene el contenedor del titulo, para agregar/quitar clase 'active'
            var titleList = [].concat(_toConsumableArray(document.querySelectorAll('.main-payment__payments--payment-container__payment-title')));

            //Recorre la lista de los contenedores principales

            var _loop = function _loop(x) {
                //Agrega listener a cada (ul) contenedor de la lista
                closeOpenList[x].addEventListener('click', function (e) {

                    var itemsList = _this2.props.containerList[x].children;
                    var sizeItemList = 0;

                    //para hacer la sumatoria de los altos de cada elemento del contenedor
                    for (var y = 0; y < itemsList.length; y++) {
                        sizeItemList += itemsList[y].offsetHeight;
                    }

                    if (!titleList[x].classList.contains('active')) {
                        titleList[x].classList.add('active');
                        closeOpenList[x].classList.add('active');
                        _this2.props.containerList[x].style.cssText = "height: " + (window.innerWidth < 712 ? sizeItemList + 48 : sizeItemList) + "px;";
                    } else {
                        titleList[x].classList.remove('active');
                        closeOpenList[x].classList.remove('active');
                        _this2.props.containerList[x].style.cssText = 'height: 56px; overflow-y: hidden;';
                    }
                });
            };

            for (var x = 0; x < closeOpenList.length; x++) {
                _loop(x);
            }
        }
    }, {
        key: "obtenerTarjetas",
        value: function obtenerTarjetas(params) {
            var apuntadorClase = this;
            var url = CONSTANTES.endpoints.tarjetas;
            var data = null;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                body: JSON.stringify(params),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax obtener tarjetas";
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0) {
                        if (respuesta.bean != undefined && respuesta.bean.ltb_tarjetas.length > 0) {
                            apuntadorClase.props.arrayTarjetas = respuesta.bean.ltb_tarjetas;
                            apuntadorClase.pintartodastarjetas();
                        }
                    }
                } catch (e) {
                    console.error("Excepcion en obtener tarjetas" + e);
                }
            }).catch(function (err) {
                console.error("Error en obetner tarjetas =>" + err);
            });
        }
    }, {
        key: "pintartodastarjetas",
        value: function pintartodastarjetas() {
            var apuntador = this;
            var todastarjetas = apuntador.props.arrayTarjetas;

            var listaTarjetasAdmin = "";
            todastarjetas.forEach(function (object) {

                var finTarjeta = object.cb_endingCardNumber;
                var ultimosDigitos = finTarjeta.substr(finTarjeta.length - 4);
                var iconoTarjeta = val.getIconoTarjeta(object.cb_provider);
                var iconRecurrente = "";
                if (object.cb_current != null && object.cb_current != undefined && object.cb_current == "T") {
                    iconRecurrente = '<img class="" src="assets/images/ic-domiciliado.svg">';
                }
                listaTarjetasAdmin += '<div class="col-md-6 col-12 mt-2 cont-tarjeta-prepago" id="' + object.cb_idCard + '">' + '<div class="tarjetas">' + '<div class="d-flex icono-tarjeta">' + iconoTarjeta + '<p class="no-tarjeta">' + object.cb_bankname + ' **** **** **** ' + ultimosDigitos + '</p>' + iconRecurrente + '</div>' + '</div>' + '</div>';
            });

            //$('.cont-tarjeta-rmv').remove();
            $("#todastajetas").prepend(listaTarjetasAdmin);
            apuntador.eventoTarjetas();
        }
    }, {
        key: "eventoTarjetas",
        value: function eventoTarjetas() {
            var apuntador = this;
            $(".cont-tarjeta-prepago").on("click", function () {
                var index = this.id;
                apuntador.props.arrayTarjetas.forEach(function (obj) {
                    if (index == obj.cb_idCard) {
                        apuntador.props.tarjetaSeleccionada = obj;
                    }
                });

                $("#modal-tarjetas").modal("hide");
                val.pintatarjetaseleccionada(apuntador);
                $("#pagar").modal("show");
            });
        }
    }, {
        key: "enviarInterfactura",
        value: function enviarInterfactura() {
            $('#alertSending').removeAttr('style');

            var apuntador = this;
            var url = CONSTANTES.endpoints.sendinterfact;
            var fecha = new Date();
            console.log("anio" + fecha.getFullYear());
            console.log("anio" + (fecha.getMonth() + 1));
            var params = JSON.stringify({ "mes": "06", "anio": "2020" });
            console.log(params);

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                body: JSON.stringify(params),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                $('#alertSending').attr('style', 'display:none !important;');
                try {
                    if (respuesta.status == 0) {

                        $('#alertSendSuccessfuly').removeAttr('style');
                        setTimeout(function () {
                            $('#alertSendSuccessfuly').attr('style', 'display:none !important;');
                        }, 3000);
                    } else {

                        $('#alertSendWrong').removeAttr('style');
                        setTimeout(function () {
                            $('#alertSendWrong').attr('style', 'display:none !important;');
                        }, 3000);
                    }
                } catch (e) {
                    $('#alertSending').attr('style', 'display:none !important;');
                    $('#alertSendWrong').removeAttr('style');
                    setTimeout(function () {
                        $('#alertSendWrong').attr('style', 'display:none !important;');
                    }, 3000);

                    console.error(e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                $('#alertSending').attr('style', 'display:none !important;');
                $('#alertSendWrong').removeAttr('style');
                setTimeout(function () {
                    $('#alertSendWrong').attr('style', 'display:none !important;');
                }, 3000);
                console.error("err=>" + err);
            });
        }
    }]);

    return Recargas;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49,"../../utils/ModalMng":50,"./../home/HomePrepago":28,"./Pagos":35,"./Validaciones":37}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSrcTarjeta = getSrcTarjeta;
exports.getIconoTarjeta = getIconoTarjeta;
exports.pintarIcn = pintarIcn;
exports.llenarAnio = llenarAnio;
exports.inicializarCampoRT = inicializarCampoRT;
exports.validarCamposDireccion = validarCamposDireccion;
exports.validarCamposRegistroTarjeta = validarCamposRegistroTarjeta;
exports.pintatarjetaseleccionada = pintatarjetaseleccionada;
exports.validacvv = validacvv;
var prettifyDate = exports.prettifyDate = function prettifyDate(date) {
    var responseDate = "";
    var cant = "";
    if (date.includes("D")) {
        cant = date.replace("D", "");
        responseDate = cant + " D&iacute;a";
        if (cant != "1") responseDate = responseDate + "s";
    }
    if (date.includes("H")) {
        cant = date.replace("H", "");
        responseDate = cant + " Hora";
        if (cant != "1") responseDate = responseDate + "s";
    }
    if (date.includes("M")) {
        cant = date.replace("M", "");
        responseDate = cant + " Minuto";
        if (cant != "1") responseDate = responseDate + "s";
    }
    return responseDate;
};
function getSrcTarjeta(proveedor) {
    var iconoTarjeta = "";

    if (proveedor == "VISA") {
        iconoTarjeta = "assets/images/icons/visa.svg";
    }
    if (proveedor == "MASTERCARD") {
        iconoTarjeta = "assets/images/icons/mastercard.svg";
    }
    if (proveedor == "AMEX") {
        iconoTarjeta = "assets/images/icons/amex.svg";
    }

    return iconoTarjeta;
}

function getIconoTarjeta(proveedor) {
    var iconoTarjeta = '<i class="far fa-credit-card fa-lg"></i>';
    if (proveedor == "V") {
        iconoTarjeta = '<img src="assets/images/icons/visa.svg" style="margin-top:-3px;" class="icnNT tarjetaD icnNT-tarjetaD mx-2" height="30" width="40">';
    }
    if (proveedor == "M") {
        iconoTarjeta = '<img src="assets/images/icons/mastercard.svg" style="margin-top:-3px;" class="icnNT tarjetaD icnNT-tarjetaD mx-2" height="30" width="40">';
    }
    if (proveedor == "A") {
        iconoTarjeta = '<img src="assets/images/icons/amex.svg" style="margin-top:-3px;" class="icnNT tarjetaD icnNT-tarjetaD mx-2" height="30" width="40">';
    }

    return iconoTarjeta;
}

function pintarIcn(icnClase) {
    $("#ldrBinRT").removeAttr('class');
    $("#ldrBinRT").attr('class', '');
    $("#ldrBinRT").addClass(icnClase);
}

function llenarAnio() {
    var strAnioActual = new Date().getFullYear().toString().substr(-2);
    var intAnioActual = parseInt(strAnioActual);
    var strOptionSelect = '<option value="">A&ntilde;o</option><option value="' + intAnioActual + '">' + intAnioActual + '</option>';
    for (var i = 1; i <= 10; i++) {
        intAnioActual++;
        strOptionSelect += '<option value="' + intAnioActual + '">' + intAnioActual + '</option>';
    }
    $('#inpAnioVRT').html(strOptionSelect);
}
function inicializarCampoRT() {
    $("#inpNumeroTarjetaRT").removeClass('is-valid');
    $("#inpNumeroTarjetaRT").removeClass('is-invalid');
    $("#inpNumeroTarjetaRT").removeClass('is-warning');
}
function validarCamposDireccion() {
    $('.invalid-feedback').hide();

    var inputCampos = ['inpDirCalleRT', 'inpDirColoniaRT', 'inpDirCPRT', 'inpDirMunicipioRT', 'inpDirEstadoRT'];

    var labelValidacion = ['vldDirCalleRT', 'vldDirColoniaR', 'vldDirCPRT', 'vldDirMunicipioRT', 'vldDirEstadoRT'];
    var validacion = true;

    $.each(inputCampos, function (i, idCampo) {
        var valor = $('#' + idCampo).val().trim();

        if (valor === '') {
            validacion = false;
            var texto = '* El campo es requerido';
            $('#' + labelValidacion[i]).html(texto);
            $('#' + labelValidacion[i]).show();
        }
    });

    return validacion;
}
function validarCamposRegistroTarjeta() {
    $('.invalid-feedback').hide();
    var cont = 1;

    var inputCampos = ['inpNombreRT', 'inpApellidoPRT', 'inpNumeroTarjetaRT', 'inpMesVRT', 'inpAnioVRT', 'inpCVVRT', 'inpDircom'];

    var labelValidacion = ['vldNombreRT', 'vldApellidoPRT', 'vldNumeroTarjetaRT', 'vldMesVRT', 'vldAnioVRT', 'vldCVVRT'];

    var camposChicos = ['vldMesVRT', 'vldAnioVRT', 'vldCVVRT'];
    var validacion = true;
    console.log("Paso " + cont++ + "  Validacion=> " + validacion);

    $.each(inputCampos, function (i, idCampo) {
        var valor = $('#' + idCampo).val().trim();

        if (valor === '') {
            validacion = false;
            var texto = '* El campo es requerido';
            if (camposChicos.indexOf(labelValidacion[i]) >= 0) {
                texto = '* Requerido';
            }
            $('#' + labelValidacion[i]).html(texto);
            $('#' + labelValidacion[i]).show();
            if (idCampo == "inpDircom") {
                var valor1 = $('#' + idCampo).text();
                if (valor1.includes("Agregar dirección de tarjeta")) {
                    $('#vldDireccion').show();
                    $('#vldDireccion').html("*Dirección requerida");
                } else {
                    validacion = true;
                }
            }
        } else {
            if (idCampo == 'inpNumeroTarjetaRT') {
                var digito = $('#inpNumeroTarjetaRT').val().substring(0, 1);
                if (digito == '3') {
                    if (valor.length != 15) {
                        //pintarIcn(apuntador.icnAlerta);
                        $('#vldNumeroTarjetaRT').html('Debe ser de 15 digitos');
                        $('#vldNumeroTarjetaRT').show();
                        validacion = false;
                    }
                } else {
                    if (valor.length != 16) {
                        pintarIcn(apuntador.icnAlerta);
                        $('#vldNumeroTarjetaRT').html('Debe ser de 16 digitos');
                        $('#vldNumeroTarjetaRT').show();
                        validacion = false;
                    }
                }

                if (digito == '3') {
                    if ($('#inpCVVRT').val().length != 4) {
                        $('#vldCVVRT').html('Requiere 4 digitos');
                        $('#vldCVVRT').show();
                        validacion = false;
                    }
                } else {
                    if ($('#inpCVVRT').val().length != 3) {
                        $('#vldCVVRT').html('Requiere 3 digitos');
                        $('#vldCVVRT').show();
                        validacion = false;
                    }
                }
            }
            if (idCampo == 'inpCVVRT') {
                if (valor.length < 3) {
                    $('#vldCVVRT').html('Minimo son 3 digitos');
                    $('#vldCVVRT').show();
                    validacion = false;
                }
            }
        }
    });

    var anioActual = parseInt(new Date().getFullYear().toString().substr(-2));
    var mesActual = parseInt(new Date().getMonth());

    if (parseInt($('#inpAnioVRT').val()) == parseInt(anioActual)) {
        if (parseInt($('#inpMesVRT').val()) < parseInt(mesActual)) {
            $('#vldMesVRT').html('Invalido');
            $('#vldMesVRT').show();
            validacion = false;
        }
    }

    return validacion;
}

function pintatarjetaseleccionada(apuntadorClase) {
    console.log("++++++++++++++++++++++++++++");
    $('#montofinal').html(apuntadorClase.props.precioSeleccionado);
    console.log(apuntadorClase.props.tarjetaSeleccionada);
    var tarjetafirst = apuntadorClase.props.tarjetaSeleccionada;
    apuntadorClase.props.tarjetaseleccionadapago = tarjetafirst;
    var idTarjetaSel = tarjetafirst.cb_idCard;
    var nombreBancoSel = tarjetafirst.cb_bankname;
    var finTarjetaSel = tarjetafirst.cb_endingCardNumber;
    var iconoTarjetaSel = getIconoTarjeta(tarjetafirst.cb_provider);
    var nombreTarjetaSel = tarjetafirst.cb_firstName;

    $(".tarjeta").html('<div class="d-flex">' + iconoTarjetaSel + '<p class="text-left">' + nombreBancoSel + '</p>' + '</div>' + '<p class="text-dark text-right w-100 mt-4 mb-3 fs-20"> **** **** ***' + finTarjetaSel + '</p>' + '<p class="text-left w-100 pt-3">' + nombreTarjetaSel + '</p>'
    //+
    //'<p class="text-left w-100 fs-14"> Vigencia '+
    //vigenciaTarjetaSel+
    //'</p>'
    );
    console.log("pintar tarjeta");
    if (tarjetafirst.cb_provider == "A") {
        //$('#cvv4').show();
        if ($('#cvv4').val() == undefined) {
            $('#cvv').append('<div class="col" id="colcvv4">' + '<input id="cvv4" type="password" class="form-control" placeholder="*" maxlength="1"' + ' oninput="this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\..*)\\./g, \'1\'); " >' + '</div>');
        }
        $('#cvv3').on('keyup', function () {
            var valor = this.value;
            if (valor.length == 1) $('#cvv4').focus();
        });
    } else {
        $("#colcvv4").remove();
    }
    var arrleyenda = getleyendatarjeta(tarjetafirst.cb_provider);
    $("#imagenayuda").html(arrleyenda.imagen);
    $("#leyendaayuda").html(arrleyenda.texto);

    // boton editar monto
    $("#tarjetapagar").html(" " + nombreBancoSel + " *" + finTarjetaSel);
}

function getIconoTarjeta(proveedor) {
    var iconoTarjeta = '<i class="far fa-credit-card fa-lg"></i>';
    if (proveedor == "V") {
        iconoTarjeta = '<img src="assets/images/icons/visa.svg" style="margin-top:-3px;" class="icnNT tarjetaD icnNT-tarjetaD mx-2" height="30" width="40">';
    }
    if (proveedor == "M") {
        iconoTarjeta = '<img src="assets/images/icons/mastercard.svg" style="margin-top:-3px;" class="icnNT tarjetaD icnNT-tarjetaD mx-2" height="30" width="40">';
    }
    if (proveedor == "A") {
        iconoTarjeta = '<img src="assets/images/icons/amex.svg" style="margin-top:-3px;" class="icnNT tarjetaD icnNT-tarjetaD mx-2" height="30" width="40">';
    }

    return iconoTarjeta;
}

function getleyendatarjeta(proveedor) {
    var arrayleyenda = [];
    if (proveedor == "A") {
        arrayleyenda = { "imagen": '<img src="assets/images/ayuda-amex.png">',
            "texto": "4 d&iacute;gitos al frente de tu tarjeta" };
    } else {
        arrayleyenda = { "imagen": '<img src="assets/images/ayuda-visa-mastercard.png">',
            "texto": "3 d&iacute;gitos al reverso de tu tarjeta" };
    }

    return arrayleyenda;
}

function validacvv(provider, cvv) {
    var bandera = false;
    if (provider == "A") {
        if (cvv.length == 4) bandera = true;
    } else {
        if (cvv.length == 3) bandera = true;
    }
    return bandera;
}

},{}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Paquetes = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _ModalMng = require("../../utils/ModalMng");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Paquetes = exports.Paquetes = function () {
    function Paquetes() {
        _classCallCheck(this, Paquetes);

        this.ch = new _CookieHelper.CookieHelper();
        this.props = {
            arraydetallenetflix: []
        };
        this.init();
    }

    _createClass(Paquetes, [{
        key: "init",
        value: function init() {
            console.log("estoy en paquetes.................");
            this.verificarBundle();
            this.setlisteners();
            var modalManager = new _ModalMng.ModalMng();
            modalManager.createModal(CONSTANTES.modals.recomendados);
        }
    }, {
        key: "validarnetflix2",
        value: function validarnetflix2() {
            var url = CONSTANTES.endpoints.validarnetflix;
            var apuntador = this;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());
            var storenet1 = CONSTANTES.storedKeys.storenet1;
            this.getDashBoardData(storenet1).then(function (bean) {

                if (bean.stored) {
                    return bean;
                } else {
                    return fetch(url, {
                        method: "POST",
                        headers: cabeceraMC
                    });
                }
            }).then(function (data) {
                if (data.constructor == {}.constructor) {
                    return data;
                } else {
                    if (data.ok) {
                        return data.json();
                    } else {
                        throw "Error en la llamada Ajax a Dashboard";
                    }
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0) {
                        if (respuesta.bean.isbundle == "SI" || respuesta.bean.isaddon == "SI") {
                            apuntador.revisarestatus2();
                        } else {
                            $("#loaderStatusNetflix").hide();
                        }
                    }
                } catch (e) {
                    console.error(e);
                    throw "Error al traer la informaci0n";
                }
            }).catch(function (err) {
                console.error(err);
            });
        }
    }, {
        key: "verificarBundle",
        value: function verificarBundle() {
            var apuntador = this;
            var url = CONSTANTES.endpoints.obtenerbundle;
            var data = null;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var storenet2 = CONSTANTES.storedKeys.storebundle;
            this.getDashBoardData(storenet2).then(function (bean) {

                if (bean.stored) {
                    return bean;
                } else {
                    return fetch(url, {
                        method: "POST",
                        headers: cabeceraMC
                    });
                }
            }).then(function (data) {
                if (data.constructor == {}.constructor) {
                    return data;
                } else {
                    if (data.ok) {
                        return data.json();
                    } else {
                        throw "Error en la llamada Ajax a Dashboard";
                    }
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0) {
                        if (respuesta.bean.tipoBundle == "Netflix") {
                            apuntador.revisarPaqueteNetflix();
                        } else if (respuesta.bean.tipoBundle == "Amazon") {
                            apuntador.revisarPaqueteAmazon();
                        } else {
                            $("#loaderStatusNetflix").hide();
                        }
                    } else {
                        $("#loaderStatusNetflix").hide();
                    }
                } catch (e) {
                    console.error(e);
                    $("#loaderStatusNetflix").hide();
                }
            }).catch(function (err) {
                console.error(err);
                $("#loaderStatusNetflix").hide();
            });
        }
    }, {
        key: "revisarPaqueteAmazon",
        value: function revisarPaqueteAmazon() {
            var apuntador = this;
            var htmlbundle = "<div class=\"col-10\">\n                            <div class=\"font-weight-regular txt-reg-16 mt-3\" >Membres\xCDa</div>\n                            <div class=\"font-weight-regular txt-reg-18\" >Amazon Prime</div>\n                        </div>\n                        <div class=\"col-2 mx-auto text-right\" id=\"btnInformacionBundle\" >\n                            <img src=\"assets/images/arrow-forward-ios-24-px.png\">\n                        </div>";

            $("#paquetenetflix").html(htmlbundle);

            apuntador.accionesBundle();
        }
    }, {
        key: "accionesBundle",
        value: function accionesBundle() {
            $("#btnInformacionBundle").on("click", function () {
                $("#paquetes").hide();
                $("#detalleBundle").show();
            });

            $(".mas-bundle").on("click", function () {
                var num = $('.mas-bundle').index(this) + 1;
                $("#descBundle" + num).show();

                if ($(this).hasClass('menos-bundle')) {
                    $("#descBundle" + num).css("display", "none");
                    $(this).removeClass('menos-bundle');
                } else {
                    $(this).addClass('menos-bundle');
                }
            });
        }
    }, {
        key: "revisarPaqueteNetflix",
        value: function revisarPaqueteNetflix() {
            var apuntador = this;
            var url = CONSTANTES.endpoints.verificarnetflix;
            var data = null;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var storenet2 = CONSTANTES.storedKeys.storenet2;
            this.getDashBoardData(storenet2).then(function (bean) {

                if (bean.stored) {
                    return bean;
                } else {
                    return fetch(url, {
                        method: "POST",
                        headers: cabeceraMC
                    });
                }
            }).then(function (data) {
                if (data.constructor == {}.constructor) {
                    return data;
                } else {
                    if (data.ok) {
                        return data.json();
                    } else {
                        throw "Error en la llamada Ajax a Dashboard";
                    }
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0) {
                        apuntador.loadaddonsnet(respuesta.bean.isActive);
                    } else {
                        $("#loaderStatusNetflix").hide();
                    }
                } catch (e) {
                    console.error(e);
                    $("#loaderStatusNetflix").hide();
                    throw "Error al traer la informaci0n";
                }
            }).catch(function (err) {
                console.error(err);
            });
        }
    }, {
        key: "storedata",
        value: function storedata(respuesta, key) {
            if (localStorage != null && localStorage != undefined) localStorage.setItem(key, JSON.stringify(respuesta));
        }
    }, {
        key: "getDashBoardData",
        value: function getDashBoardData(key) {
            var bean = null;
            return new Promise(function (resolve, reject) {
                if (localStorage != null && localStorage != undefined) {
                    var _bean = localStorage.getItem(key);
                    if (_bean != null && _bean != undefined) {
                        _bean = JSON.parse(_bean);
                        _bean.stored = true;
                        resolve(_bean);
                    } else {
                        _bean = { "stored": false };
                        resolve(_bean);
                    }
                } else {
                    bean = { "stored": false };
                    resolve(bean);
                }
            });
        }
    }, {
        key: "loadaddonsnet",
        value: function loadaddonsnet(valor) {
            var _this = this;

            var apuntador = this;
            var url = CONSTANTES.endpoints.getaddonsnetflix;
            var data = null;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                try {

                    if (respuesta.status == 0) {
                        if (respuesta.bean != undefined && respuesta.bean.listaproductos.length > 0) {
                            $("#netflixpreguntasfrec").show();
                            _this.props.arraydetallenetflix = respuesta.bean.listaproductos.sort(function (a, b) {
                                return b.plan - a.plan;
                            });
                            var htmladdon = "";var idcontratado = "";
                            _this.props.arraydetallenetflix.forEach(function (elem) {
                                if (elem.tipo == "contratado") {
                                    idcontratado = elem.idbrm;
                                }
                            });

                            _this.props.arraydetallenetflix.forEach(function (elem) {

                                if (elem.tipo == "incluido") {
                                    var htmlnetflix = "<div class=\"col-10 pb-3\">\n                                                    <div class=\"font-weight-regular txt-reg-16 mt-3\" >" + elem.caracteristica + "</div>\n                                                    <div class=\"font-weight-regular txt-reg-18\" >" + elem.nopantallas + "</div>\n                                                </div>";
                                    if (valor == "N") {
                                        htmlnetflix += "<div class=\"col-2 mx-auto text-right\" id=\"div-paq-actv\">\n                                                        <span class=\"link_\" id=\"ligaNetflix\">Activa tu cuenta</span>\n                                                    </div>";
                                    } else {
                                        htmlnetflix += "<div class=\"col-2 mx-auto text-right\" id=\"div-paq-arrow\" >\n                                                        <img src=\"assets/images/arrow-forward-ios-24-px.png\">\n                                                    </div>";
                                    }
                                    htmlnetflix = htmlnetflix + '</div></div>';
                                    $("#detallenetflix").html(htmlnetflix);
                                    $("#paquetenetflix").show();
                                }

                                //console.log(elem);
                                var planactual = "";
                                if (elem.tipo == "contratado") {
                                    planactual = '<div class="plan-actual">Tu plan actual</div>';
                                }
                                if (elem.tipo == "incluido" && idcontratado == "") {
                                    planactual = '<div class="plan-actual">Tu plan actual</div>';
                                }

                                var accion = "acc";
                                if (elem.tipo == "incluido" && idcontratado != "") {
                                    accion = "acc1_" + elem.idbrm;
                                }

                                if (elem.tipo == "addon" && idcontratado != "") {
                                    accion = "acc3_" + elem.idbrm;
                                }
                                if (elem.tipo == "addon" && idcontratado == "") {
                                    accion = "acc2_" + elem.idbrm;
                                }

                                var order = "";
                                var imgultra = "";
                                if (elem.plan.includes("sico")) order = "order-first ";
                                if (elem.plan.includes("andar")) {
                                    imgultra = '<img src="assets/images/hd-net.svg">';
                                }
                                if (elem.plan.includes("miu")) {
                                    imgultra = '<img src="assets/images/uhd-net.svg">';
                                    order = "order-last ";
                                }

                                var precio = "Sin costo adicional";
                                if (elem.precio != "incluido") {
                                    precio = "$" + elem.precio + " al mes";
                                }

                                htmladdon = htmladdon + '<div class="col-11 mx-auto ' + order + ' contenido-paquetes-netflix ' + elem.plan + '" style="margin-top: 8px">' + '<div class="row py-3">' + '<div class="col-6 col-md-3 my-2" style="text-align: center">' + planactual + '<div class="txt-bold-18" style="line-height: 1.5">' + elem.plan + '</div>' + imgultra + '</div>' + '<div class="col-12 col-md-6 my-4 order-detalle-paq">' + '<div class="txt-reg-16 upper-case paq-desc">' + elem.caracteristica + '</div>' + '</div>' + '<div class="col-6 col-md-3 my-4">' + '<a href="#" class="link_ paq-precio" id="' + accion + '" >' + precio + '</a>' + '</div>' + '</div>' + '</div>';
                            });

                            $("#addonspaquetenetflixweb").html(htmladdon);
                            apuntador.acciones(idcontratado);
                        }
                    }
                } catch (e) {
                    console.error(e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                console.error("err=>" + err);
            });
        }
    }, {
        key: "setlisteners",
        value: function setlisteners() {
            var apuntador = this;

            $("#btnirnetflix").on("click", function () {
                //apuntador.iranetflix();
                $("#modalNetflix").modal("hide");
            });

            $("#ligaNetflix").on("click", function () {
                apuntador.iranetflix();
            });

            $("#forgotten_pass_netflix").on("click", function () {
                apuntador.iranetflix();
            });

            $("#btnregresarpaq").on("click", function () {
                var div = document.getElementById('paquetes');
                div.style.display = 'block';
                var divweb = document.getElementById('paqNetflixWeb');
                divweb.style.display = 'none';
            });

            $("#regresarPaqueteBundle").on("click", function () {
                $("#paquetes").show();
                $("#detalleBundle").hide();
            });

            $("#btnconfirmar").on("click", function () {
                var idpaquete = $("#montopagar").attr("idpaquete");
                var idpaquetec = $("#montopagar").attr("idpaquetec");

                var accion = "acc2";
                if (idpaquetec != "" && idpaquetec != "undefined") {
                    accion = "acc3";
                }
                var obj = { idpaquete: idpaquete, idpaquetec: idpaquetec, accion: accion };
                apuntador.compraraddons(obj);
            });
            $("#btnconfirmarcancela").on("click", function () {
                var idpaquete = $("#montopagarc").attr("idpaquete");
                var idservicio = $("#montopagarc").attr("idservicio");
                var obj = { idpaquete: idpaquete, idservicio: idservicio, accion: "acc1" };
                apuntador.compraraddons(obj);
            });
        }
    }, {
        key: "iranetflix",
        value: function iranetflix() {
            $('#modalLoad').modal('show');
            var apunta = this;
            var url = CONSTANTES.endpoints.generartok;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");

            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var payload = {
                method: "POST",
                headers: cabeceraMC
            };
            fetch(url, payload).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {

                try {
                    if (respuesta.status == 0 && respuesta.bean.Token != undefined && respuesta.bean.Token != null && respuesta.bean.Token != "") {
                        $("#linkNetflix").attr("href", CONSTANTES.EndpointNetflix + respuesta.bean.Token);
                        $('#modalLoad').modal('hide');
                        $("#modalNetflix").modal("show");
                    } else {
                        $("#modalNetflix").modal("hide");
                        $('#modalLoad').modal('hide');

                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                    }
                } catch (e) {
                    console.error(e);
                    $("#modalNetflix").modal("hide");
                    $('#modalLoad').modal('hide');

                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                console.error("err=>" + err);
                $("#modalNetflix").modal("hide");
                $('#modalLoad').modal('hide');

                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "acciones",
        value: function acciones(idcontratado) {

            $("#div-paq-arrow").on("click", function () {

                var div2 = document.getElementById('paquetes');
                div2.style.display = 'none';
                var _show = window.innerWidth;
                console.log(_show);
                var div = document.getElementById('paqNetflixWeb');
                div.style.display = 'block';
            });
            var apunta = this;
            $(".link_").on("click", function () {

                var valor = this.id;
                var idagregar = valor.split("_")[1];
                var accion = valor.split("_")[0];
                var obj = [];
                var objcontratado = [];
                apunta.props.arraydetallenetflix.forEach(function (elem) {
                    if (idagregar == elem.idbrm) {

                        obj = elem;
                    }
                    if (idcontratado != "" && idcontratado == elem.idbrm) {
                        objcontratado = elem;
                    }
                });
                console.log(objcontratado);
                console.log(obj);
                if (accion == "acc1") {
                    apunta.accion1(objcontratado, obj);
                }
                if (accion == "acc2") {
                    apunta.accion2(obj);
                }
                if (accion == "acc3") {
                    apunta.accion3(obj, idcontratado);
                }
            });
        }
    }, {
        key: "accion1",
        value: function accion1(obj, obj1) {
            $("#montopagarc").html("$" + obj.precio);
            $("#montopagarc").attr("idpaquete", obj.idbrm);
            $("#montopagarc").attr("idservicio", obj.idservicio);
            //$("#planseleccionado").html(obj.plan);
            $("#nopantallasc").html(obj1.nopantallas);
            //$("#pantallasc").html(obj1.nopantallas);
            $("#modalCancelaN").modal("show");
        }
    }, {
        key: "accion2",
        value: function accion2(obj) {
            $("#montopagar").html("$" + obj.precio);
            $("#montopagar").attr("idpaquete", obj.idbrm);
            $("#montopagar").attr("idpaquetec", "");
            $("#planseleccionado").html(obj.plan);
            $("#nopantallas").html(obj.nopantallas);
            $("#pantallas").html(obj.nopantallas);
            $("#modalCompraN").modal("show");
        }
    }, {
        key: "accion3",
        value: function accion3(obj, id2) {
            $("#montopagar").html("$" + obj.precio);
            $("#montopagar").attr("idpaquete", obj.idbrm);
            $("#montopagar").attr("idpaquetec", id2);
            $("#nopantallas").html(obj.nopantallas);
            $("#planseleccionado").html(obj.plan);
            $("#modalCompraN").modal("show");
        }
    }, {
        key: "compraraddons",
        value: function compraraddons(obj) {
            var apunta = this;
            var objobten = [];
            var objcontratado = [];
            var arrayenviar = [];
            apunta.props.arraydetallenetflix.forEach(function (elem) {
                if (obj.idpaquete == elem.idbrm) {
                    objobten = elem;
                }
                if (obj.idpaquetec == elem.idbrm) {
                    objcontratado = elem;
                }
            });

            if (obj.accion == "acc1") {
                console.log("solo eliminar");
                arrayenviar = { poid: "", costo: "0", descripcion: "", poidproduct: obj.idpaquete, poidservice: obj.idservicio, accion: obj.accion };
            }

            if (obj.accion == "acc2") {

                console.log("solo agregar");
                arrayenviar = { poid: objobten.idbrm, costo: objobten.precio, descripcion: objobten.caracteristica,
                    poidproduct: "-", poidservice: "-", accion: obj.accion };
            }

            if (obj.accion == "acc3") {
                arrayenviar = { poid: objobten.idbrm, costo: objobten.precio, descripcion: objobten.caracteristica,
                    poidproduct: obj.idpaquetec, poidservice: objcontratado.idservicio, accion: obj.accion };
            }
            console.log(arrayenviar);
            var objencrp = { "secdata": otpyrc2(JSON.stringify(arrayenviar)) };
            console.log(JSON.stringify(objencrp));

            var url = CONSTANTES.endpoints.compraraddonsnetflix;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());
            $('#modalLoad').modal('show');

            fetch(url, {
                method: 'POST',
                body: JSON.stringify(objencrp),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {

                try {
                    console.log(respuesta);
                    if (respuesta.status == 0) {

                        $('#modalCancelaN').modal('hide');
                        $('#modalCompraN').modal('hide');
                        $('#modalLoad').modal('hide');

                        $("#msjTitle").html("\xC9xito");
                        $('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
                        $('#msjrespuesta').html('Su transacci&oacute;n se ha registrado exitosamente.');
                        $('#modalrespuesta').modal('show');
                        $("#aceptarespuesta").on("click", function () {
                            location.reload();
                        });
                    } else {
                        $('#modalCancelaN').modal('hide');
                        $('#modalCompraN').modal('hide');
                        $('#modalLoad').modal('hide');

                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        //$("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $("#msjrespuesta").html("Hubo un error en tu solicitud.<br>Int&eacute;ntalo m&aacute;s tarde.");
                        $("#aceptarespuesta").on("click", function () {
                            location.reload();
                        });
                        $('#modalrespuesta').modal('show');
                    }
                } catch (e) {
                    console.error(e);
                    $('#modalCancelaN').modal('hide');
                    $('#modalCompraN').modal('hide');
                    $('#modalLoad').modal('hide');
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');

                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                console.error("err=>" + err);
                $('#modalCancelaN').modal('hide');
                $('#modalCompraN').modal('hide');
                $('#modalLoad').modal('hide');

                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }]);

    return Paquetes;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49,"../../utils/ModalMng":50}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Portabilidad = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _ModalMng = require("../../utils/ModalMng");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Portabilidad = exports.Portabilidad = function () {
    function Portabilidad() {
        _classCallCheck(this, Portabilidad);

        this.props = {
            lstLsbMsgUsr: {
                "lblCampoVacio": "*Campo obligatorio",
                "lblFormatoDif": "*Campo no válido",
                "lblExtDif": "*Formato inválido"
            }
        };

        this.ch = new _CookieHelper.CookieHelper();

        this.init();
        this.setKeyupFiles();
        this.setChangeFileAction();
        this.soloNumeros();

        var modalManager = new _ModalMng.ModalMng();
        modalManager.createModal(CONSTANTES.modals.recomendados).then(function (status) {
            console.log(status);
        }).catch(function (err) {
            console.log(err);
        });
    }

    _createClass(Portabilidad, [{
        key: "init",
        value: function init() {
            this.hideAll();
            $("#porta-step-0").css("display", "block");
            this.loadPortabilidad();
            this.step0();
        }

        /* Flujo Portabilidad Start */
        // Step 0 Inicia Flujo portabilidad

    }, {
        key: "step0",
        value: function step0() {
            this.listenerInitPorta();
            this.step1();
            this.step2();
            this.step21();
            //Buttons
            this.btnEnviaPortaFisica();
            this.btnDownloadFormato();
            this.btnEnviaPortaFisicaCancel();
            this.btnEnviaPortaMoral();

            //PFC
            this.fileIdeOfiPFC();
            this.fileCarCanPFC();
            this.fileForPorPFC();

            //PM
            this.fileIdeOfiPM();
            this.fileActConPM();
            this.fileForPorPM();
        }
    }, {
        key: "listenerInitPorta",
        value: function listenerInitPorta() {
            var clase = this;
            document.getElementById("btnIniciaPorta").addEventListener("click", function () {
                clase.initPorta();
            });
        }

        //Step 1 Selección Tipo Persona (Física | Moral)

    }, {
        key: "step1",
        value: function step1() {
            this.listenerPersonaFisica();
            this.listenerPersonaMoral();
            this.changeStep1();
            this.cancelStep1();
        }
    }, {
        key: "listenerPersonaFisica",
        value: function listenerPersonaFisica() {
            var clase = this;
            document.getElementById("btnPersonaFisicaPorta").addEventListener("click", function () {
                $("#porta-span-tipper").html("Persona Física");
                clase.esPersonaFisica();
            });
        }
    }, {
        key: "listenerPersonaMoral",
        value: function listenerPersonaMoral() {
            var clase = this;
            document.getElementById("btnPersonaMoralPorta").addEventListener("click", function () {
                $("#porta-span-tipper").html("Persona Moral");
                clase.esPersonaMoral();
            });
        }
    }, {
        key: "cancelStep1",
        value: function cancelStep1() {
            var clase = this;
            document.getElementById("porta-st1-cancel").addEventListener("click", function () {
                clase.init();
            });
        }
    }, {
        key: "changeStep1",
        value: function changeStep1() {
            var clase = this;
            document.getElementById("porta-st1-change").addEventListener("click", function () {
                clase.changeTipoPersona();
            });
        }

        //Step 2 Persona Fisica - Estatus Linea

    }, {
        key: "step2",
        value: function step2() {
            this.listenerLineaActivaSiPorta();
            this.listenerLineaActivaNoPorta();
            this.changeStep2();
        }
    }, {
        key: "listenerLineaActivaSiPorta",
        value: function listenerLineaActivaSiPorta() {
            var clase = this;
            document.getElementById("btnLineaSiActivaPorta").addEventListener("click", function () {
                $("#porta-span-estlin").html("Linea Cancelada");
                clase.esLineaCancelada();
            });
        }
    }, {
        key: "listenerLineaActivaNoPorta",
        value: function listenerLineaActivaNoPorta() {
            var clase = this;
            document.getElementById("btnLineaNoActivaPorta").addEventListener("click", function () {
                $("#porta-span-estlin").html("Linea Activa");
                clase.esLineaActiva();
            });
        }
    }, {
        key: "changeStep2",
        value: function changeStep2() {
            var clase = this;
            document.getElementById("porta-st2-change").addEventListener("click", function () {
                clase.changeEstatusLinea();
            });
        }

        //Step 2.1 Persona Fisica - Fecha cancelación

    }, {
        key: "step21",
        value: function step21() {
            this.listenerSiDiasPorta();
            this.listenerNoDiasPorta();
            this.changeStep21();
        }
    }, {
        key: "listenerSiDiasPorta",
        value: function listenerSiDiasPorta() {
            var clase = this;
            document.getElementById("btnLineaSiDiasPorta").addEventListener("click", function () {
                clase.esLineaCanceladaPorDias();
            });
        }
    }, {
        key: "listenerNoDiasPorta",
        value: function listenerNoDiasPorta() {
            var clase = this;
            document.getElementById("btnLineaNoDiasPorta").addEventListener("click", function () {
                clase.esLineaCanceladaPf();
            });
        }
    }, {
        key: "changeStep21",
        value: function changeStep21() {
            var clase = this;
            document.getElementById("porta-st21-change").addEventListener("click", function () {
                clase.changeDiasCancelacion();
            });
        }
        /* Flujo Portabilidad End */

        /* Set Flujo Portabilidad Start */

    }, {
        key: "initPorta",
        value: function initPorta() {
            this.hideAll();
            $("#porta-step-1").css("display", "block");
            $("#porta-cf-tipopersona-sel").css("display", "block");
        }

        //Step 1 - Seleccionar Tipo Persona Fisica | Moral

    }, {
        key: "esPersonaFisica",
        value: function esPersonaFisica() {
            this.hideAll();
            $("#porta-step-1").css("display", "block");
            $("#porta-cf-tipopersona").css("display", "block");
            $("#porta-span-tipper").html("Persona F&iacute;sica");
            $("#porta-st1-change").css("display", "inline-block");

            //Step 2 - Persona Fisica Estatus Linea
            $("#porta-step-2").css("display", "block");
            $("#porta-cf-estatuslinea-sel").css("display", "block");
        }
    }, {
        key: "esPersonaMoral",
        value: function esPersonaMoral() {
            this.hideAll();
            $("#porta-step-1").css("display", "block");
            $("#porta-cf-tipopersona").css("display", "block");
            $("#porta-span-tipper").html("Persona Moral");
            $("#porta-st1-change").css("display", "inline-block");

            //Step 3 - Persona Moral
            $("#porta-step-3-pm").css("display", "block");
        }
    }, {
        key: "changeTipoPersona",
        value: function changeTipoPersona() {
            this.hideAll();
            $("#porta-step-1").css("display", "block");
            $("#porta-cf-tipopersona-sel").css("display", "block");
        }

        //Step 2 - Persona Fisica Estatus Linea

    }, {
        key: "esLineaActiva",
        value: function esLineaActiva() {
            $("#porta-cf-estatuslinea-sel").css("display", "none");
            $("#porta-cf-estatuslinea").css("display", "block");
            $("#porta-st2-change").css("display", "block");

            $("#porta-step-3-pf").css("display", "block");
        }
    }, {
        key: "esLineaCancelada",
        value: function esLineaCancelada() {
            $("#porta-cf-estatuslinea-sel").css("display", "none");
            $("#porta-cf-estatuslinea").css("display", "block");
            $("#porta-st2-change").css("display", "block");

            $("#porta-step-21").css("display", "block");
            $("#porta-cf-estatuslineadias-sel").css("display", "block");
        }
    }, {
        key: "changeEstatusLinea",
        value: function changeEstatusLinea() {
            $("#porta-cf-estatuslinea-sel").css("display", "block");
            $("#porta-cf-estatuslinea").css("display", "none");
            $("#porta-span-estlin").html("");

            $("#porta-step-21").css("display", "none");
            $("#porta-cf-estatuslineadias").css("display", "none");
            $("#pporta-span-estlindias").html("");
            $("#porta-step-3-pf").css("display", "none");
            $("#porta-step-3-pfc").css("display", "none");
            $("#porta-step-3-pm").css("display", "none");
        }

        //Step 2.1 - Dias Cancelada Linea

    }, {
        key: "esLineaCanceladaPorDias",
        value: function esLineaCanceladaPorDias() {
            $("#porta-cf-estatuslineadias-sel").css("display", "none");
            $("#porta-cf-estatuslineadias").css("display", "none");
            $("#porta-st21-change").css("display", "block");

            $("#porta-cf-estatuslineadias").css("display", "block");
            $("#porta-span-estlindias").html("Estimado cliente, no es posible realizar tu tr&aacute;mite de portabilidad debido a que tu cancelaci&oacute;n tiene m&aacute;s de 40 dias.");
        }
    }, {
        key: "esLineaCanceladaPf",
        value: function esLineaCanceladaPf() {
            $("#porta-cf-estatuslineadias-sel").css("display", "none");
            $("#porta-cf-estatuslineadias").css("display", "none");
            $("#porta-st21-change").css("display", "block");

            $("#porta-cf-estatuslineadias").css("display", "block");
            $("#porta-span-estlindias").html("Puede realizar portabilidad");

            $("#porta-step-3-pfc").css("display", "block");
        }
    }, {
        key: "changeDiasCancelacion",
        value: function changeDiasCancelacion() {
            $("#porta-st21-change").css("display", "none");
            $("#porta-cf-estatuslineadias-sel").css("display", "block");
            $("#porta-cf-estatuslineadias").css("display", "none");
            $("#porta-span-estlindias").html("");
            $("#porta-step-3-pf").css("display", "none");
            $("#porta-step-3-pfc").css("display", "none");
            $("#porta-step-3-pm").css("display", "none");
        }
        /* Set Flujo Portabilidad End */

        /* Envio Formularios Portabilidad Start */

        //Persona Fisica

    }, {
        key: "btnEnviaPortaFisica",
        value: function btnEnviaPortaFisica() {
            var _this = this;

            var btnSndPersonaFisica = document.getElementById("btnEnviaPortaFisica");
            btnSndPersonaFisica.addEventListener("click", function () {
                $("#modalLoad").show();
                _this.enableButton(1, true);
                _this.makePersonaFisica();
            });
        }
    }, {
        key: "makePersonaFisica",
        value: function makePersonaFisica() {
            var procesa = true;
            var clase = this;

            //Validacion  de campos formulario
            var nippor = $.trim($("#por-inp-pf-nip").val());
            var telpor = $.trim($("#por-inp-pf-telpor").val());
            var telcon = $.trim($("#por-inp-pf-telcon").val());

            if (this.esVacio(nippor)) {
                $("#err-pf-1").css("display", "block");
                $("#err-pf-1").html("*Campo obligatorio");
                procesa = false;
            }

            if (this.esVacio(telpor)) {
                $("#err-pf-2").css("display", "block");
                $("#err-pf-2").html("*Campo obligatorio");
                procesa = false;
            } else {
                if (!this.validaTelefono(telpor)) {
                    $("#err-pf-2").css("display", "block");
                    $("#err-pf-2").html("*Campo no v&aacute;lido");
                    procesa = false;
                }
            }

            if (this.esVacio(telcon)) {
                $("#err-pf-3").css("display", "block");
                $("#err-pf-3").html("*Campo obligatorio");
                procesa = false;
            } else {
                if (!this.validaTelefono(telcon)) {
                    $("#err-pf-3").css("display", "block");
                    $("#err-pf-3").html("*Campo no v&aacute;lido");
                    procesa = false;
                }
            }

            if (procesa) {
                var jsonparams = {
                    "nip": nippor,
                    "noTelefonoPorta": telpor,
                    "noTelefonoConta": telcon
                };

                var json = {
                    "opt": 1,
                    "params": otpyrc2(JSON.stringify(jsonparams))

                    /*var data = {
                        "headers":{
                            "X-Forwarded-For":"187.188.25.218",
                            "totalplay": clase.ch.obtenerCookieWeb() //obtenerCookieWeb('Y29va2lldHAyMDE5')
                        },
                        "method":"POST",
                        "body":JSON.stringify(json)
                    };*/
                };var data = JSON.stringify(json);

                clase.sendObjToSave(data);
                clase.enableButton(1, false);
            } else {
                console.log("Persona Fisica procesa false");
                $("#modalLoad").hide();
                clase.enableButton(1, false);
            }
        }

        //Persona Fisica Cancel

    }, {
        key: "btnDownloadFormato",
        value: function btnDownloadFormato() {
            $(".por-ico-down").on("click", function () {
                var link = document.createElement("a");
                link.download = "portabilidad-formato";
                link.href = 'https://mitotalplay.com.mx/legales/portabilidad-formato.pdf';
                link.target = '_blank';
                link.click();
            });
        }
    }, {
        key: "btnEnviaPortaFisicaCancel",
        value: function btnEnviaPortaFisicaCancel() {
            var _this2 = this;

            var btnSndPersonaFisicaCance = document.getElementById("btnEnviaPortaFisicaCancel");
            btnSndPersonaFisicaCance.addEventListener("click", function () {
                $("#modalLoad").show();
                _this2.enableButton(2, true);
                _this2.makePersonaFisicaCancel();
            });
        }
    }, {
        key: "fileIdeOfiPFC",
        value: function fileIdeOfiPFC() {
            var itmfileIdeOfiPFC = document.getElementById("por-div-act-pfc-ideofi");
            itmfileIdeOfiPFC.addEventListener("click", function () {
                $("#por-inp-pfc-fil-ideofi").click();
            });
        }
    }, {
        key: "fileCarCanPFC",
        value: function fileCarCanPFC() {
            var itmfileCarCanPFC = document.getElementById("por-div-act-pfc-carcan");
            itmfileCarCanPFC.addEventListener("click", function () {
                $("#por-inp-pfc-fil-carcan").click();
            });
        }
    }, {
        key: "fileForPorPFC",
        value: function fileForPorPFC() {
            var itmfileForPorPFC = document.getElementById("por-div-act-pfc-forpor");
            itmfileForPorPFC.addEventListener("click", function () {
                $("#por-inp-pfc-fil-forpor").click();
            });
        }
    }, {
        key: "makePersonaFisicaCancel",
        value: function makePersonaFisicaCancel() {
            var procesa = true;
            var clase = this;

            var numpor = $.trim($("#por-inp-pfc-telpor").val());
            var numcon = $.trim($("#por-inp-pfc-telcon").val());
            var filIdeOfi = document.getElementById("por-inp-pfc-fil-ideofi") != null ? document.getElementById("por-inp-pfc-fil-ideofi").files[0] : "";
            var b64filIdeOfi = "";
            var filCarCan = document.getElementById("por-inp-pfc-fil-carcan") != null ? document.getElementById("por-inp-pfc-fil-carcan").files[0] : "";
            var b64filCarCan = "";
            var filForPor = document.getElementById("por-inp-pfc-fil-forpor") != null ? document.getElementById("por-inp-pfc-fil-forpor").files[0] : "";
            var b64filForPor = "";

            if (this.esVacio(numpor)) {
                $("#err-pfc-1").css("display", "block");
                $("#err-pfc-1").html("*Campo obligatorio");
                procesa = false;
            } else {
                if (!this.validaTelefono(numpor)) {
                    $("#err-pfc-1").css("display", "block");
                    $("#err-pfc-1").html("*Campo no v&aacute;lido");
                    procesa = false;
                }
            }

            if (this.esVacio(numcon)) {
                $("#err-pfc-2").css("display", "block");
                $("#err-pfc-2").html("*Campo obligatorio");
                procesa = false;
            } else {
                if (!this.validaTelefono(numcon)) {
                    $("#err-pfc-2").css("display", "block");
                    $("#err-pfc-2").html("*Campo no v&aacute;lido");
                    procesa = false;
                }
            }

            var arrayPromesas = [];

            if (this.esVacio(filIdeOfi)) {
                $("#err-pfc-3").css("display", "block");
                $("#err-pfc-3").html("*Campo obligatorio.");
                procesa = false;
            } else {
                arrayPromesas.push(this.getFileB64(filIdeOfi, "filIdeOfi"));
            }

            if (this.esVacio(filCarCan)) {
                $("#err-pfc-4").css("display", "block");
                $("#err-pfc-4").html("*Campo obligatorio");
                procesa = false;
            } else {
                arrayPromesas.push(this.getFileB64(filCarCan, "filCarCan"));
            }

            if (this.esVacio(filForPor)) {
                $("#err-pfc-5").css("display", "block");
                $("#err-pfc-5").html("*Campo obligatorio");
                procesa = false;
            } else {
                arrayPromesas.push(this.getFileB64(filForPor, "filForPor"));
            }

            if (procesa) {
                Promise.all(arrayPromesas).then(function (result) {
                    if (procesa) {
                        var jsonparams = {
                            "noTelefonoPorta": numpor,
                            "noTelefonoConta": numcon,
                            "namideofi": $("#por-inp-pfc-ideofi").val(),
                            "ideofi": result[0].b64,
                            "namcarcan": $("#por-inp-pfc-carcan").val(),
                            "carcan": result[1].b64,
                            "namforpor": $("#por-inp-pfc-forpor").val(),
                            "forpor": result[2].b64
                        };

                        var json = {
                            "opt": 2,
                            "params": otpyrc2(JSON.stringify(jsonparams))

                            /*var data = {
                                "headers":{
                                    "X-Forwarded-For":"187.188.25.218",
                                    "totalplay":clase.ch.obtenerCookieWeb() //obtenerCookieWeb('Y29va2lldHAyMDE5')
                                },
                                "method":"POST",
                                "body":JSON.stringify(json)
                            };*/
                        };var data = JSON.stringify(json);

                        clase.sendObjToSave(data);
                        clase.enableButton(2, false);
                    } else {
                        console.log("Persona Fisica Cancel procesa false");
                        clase.enableButton(2, false);
                    }
                }).catch(function (err) {
                    console.error("Error:" + err);
                    clase.enableButton(2, false);
                });
            } else {
                console.log("Persona Fisica Cancel procesa false");
                $("#modalLoad").hide();
                clase.enableButton(2, false);
            }
        }

        //Persona Moral

    }, {
        key: "btnEnviaPortaMoral",
        value: function btnEnviaPortaMoral() {
            var _this3 = this;

            var btnEnvPortaMoral = document.getElementById("btnEnviaPortaMoral");
            btnEnvPortaMoral.addEventListener("click", function () {
                $("#modalLoad").show();
                _this3.enableButton(3, true);
                _this3.makePersonaMoral();
            });
        }
    }, {
        key: "fileIdeOfiPM",
        value: function fileIdeOfiPM() {
            var itmfileIdeOfiPM = document.getElementById("por-div-act-ideofi");
            itmfileIdeOfiPM.addEventListener("click", function () {
                $("#por-inp-pm-fil-ideofi").click();
            });
        }
    }, {
        key: "fileActConPM",
        value: function fileActConPM() {
            var itmfileActConPM = document.getElementById("por-div-act-actcon");
            itmfileActConPM.addEventListener("click", function () {
                $("#por-inp-pm-fil-actcon").click();
            });
        }
    }, {
        key: "fileForPorPM",
        value: function fileForPorPM() {
            var itmfileForPorPM = document.getElementById("por-div-act-forpor");
            itmfileForPorPM.addEventListener("click", function () {
                $("#por-inp-pm-fil-forpor").click();
            });
        }
    }, {
        key: "makePersonaMoral",
        value: function makePersonaMoral() {
            var apuntador = this;
            var procesa = true;

            var numpor = $.trim($("#por-inp-pm-telpor").val());
            var numcon = $.trim($("#por-inp-pm-telcon").val());
            var filIdeOfi = document.getElementById("por-inp-pm-fil-ideofi") != null ? document.getElementById("por-inp-pm-fil-ideofi").files[0] : "";
            var b64filIdeOfi = "";
            var filActCon = document.getElementById("por-inp-pm-fil-actcon") != null ? document.getElementById("por-inp-pm-fil-actcon").files[0] : "";
            var b64filActCon = "";
            var filForPor = document.getElementById("por-inp-pm-fil-forpor") != null ? document.getElementById("por-inp-pm-fil-forpor").files[0] : "";
            var b64filForPor = "";

            if (this.esVacio(numpor)) {
                $("#err-pm-1").css("display", "block");
                $("#err-pm-1").html("*Campo obligatorio");
                procesa = false;
            } else {
                if (!this.validaTelefono(numpor)) {
                    $("#err-pm-1").css("display", "block");
                    $("#err-pm-1").html("*Campo no v&aacute;lido");
                    procesa = false;
                }
            }

            if (this.esVacio(numcon)) {
                $("#err-pm-2").css("display", "block");
                $("#err-pm-2").html("*Campo obligatorio");
                procesa = false;
            } else {
                if (!this.validaTelefono(numcon)) {
                    $("#err-pm-2").css("display", "block");
                    $("#err-pm-2").html("*Campo no v&aacute;lido");
                    procesa = false;
                }
            }

            var arrayPromesas = [];
            if (this.esVacio(filIdeOfi)) {
                $("#err-pm-3").css("display", "block");
                $("#err-pm-3").html("*Campo obligatorio");
                procesa = false;
            } else {
                //Validar extension            
                arrayPromesas.push(this.getFileB64(filIdeOfi, "filIdeOfi"));
            }

            if (this.esVacio(filActCon)) {
                $("#err-pm-4").css("display", "block");
                $("#err-pm-4").html("*Campo obligatorio");
                procesa = false;
            } else {
                //Validar extension
                arrayPromesas.push(this.getFileB64(filActCon, "filActCon"));
            }

            if (this.esVacio(filForPor)) {
                $("#err-pm-5").css("display", "block");
                $("#err-pm-5").html("*Campo obligatorio");
                procesa = false;
            } else {
                //Validar extension
                arrayPromesas.push(this.getFileB64(filForPor, "filForPor"));
            }

            var clase = this;

            if (procesa) {
                Promise.all(arrayPromesas).then(function (result) {
                    if (procesa) {
                        var jsonparams = {
                            "noTelefonoPorta": numpor,
                            "noTelefonoConta": numcon,
                            "namideofi": $("#por-inp-pm-ideofi").val(),
                            "ideofi": result[0].b64,
                            "namactcon": $("#por-inp-pm-actcon").val(),
                            "actcon": result[1].b64,
                            "namforpor": $("#por-inp-pm-forpor").val(),
                            "forpor": result[2].b64
                        };

                        var json = {
                            "opt": 3,
                            "params": otpyrc2(JSON.stringify(jsonparams))

                            /*var data = {
                                "headers":{
                                    "X-Forwarded-For":"187.188.25.218",
                                    "totalplay":clase.ch.obtenerCookieWeb() //obtenerCookieWeb('Y29va2lldHAyMDE5')
                                },
                                "method":"POST",
                                "body":JSON.stringify(json)
                            };*/
                        };var data = JSON.stringify(json);

                        clase.sendObjToSave(data);
                        clase.enableButton(3, false);
                    } else {
                        console.log("Persona Moral procesa false");
                        clase.enableButton(3, false);
                    }
                }).catch(function (err) {
                    console.error("Error:" + err);
                    clase.enableButton(3, false);
                });
            } else {
                console.log("Persona Moral procesa false");
                $("#modalLoad").hide();
                clase.enableButton(3, false);
            }
        }
    }, {
        key: "sendObjToSave",
        value: function sendObjToSave(strSend) {
            var clase = this;
            if (strSend != 'undefined' && strSend != null) {
                var endpoint = CONSTANTES.endpoints.guardaportabilidad;

                clase.getData(endpoint, strSend).then(function (respuesta) {
                    $("#modalLoad").hide();

                    if (respuesta.status === 0) {
                        var title = "Éxito";
                        var msg = respuesta.descripcion;
                        var icon = '<i class="far fa-check-circle fa-3x text-success"></i>';
                        clase.showModalIcon(title, msg, icon);

                        setTimeout(function () {
                            clase.reload();
                        }, 2500);
                    } else if (respuesta.status === 2) {
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html("El proceso no pudo completarse, adjunta un archivo en formato JPG o PDF para continuar con el proceso.");
                        $('#modalrespuesta').modal('show');
                    } else {
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                        /* let title="Error";
                         let msg = "";
                         let icon = '<i class="fas fa-times fa-3x text-danger"></i>';
                         
                           if(oper===3){
                             msg = respuesta.descripcion;
                         }else{
                             msg= "No fue posible guardar el registro de portabilidad. Intente nuevamente";
                         }
                           clase.showModalIcon(title,msg,icon);*/
                    }
                }).catch(function (err) {
                    console.error("Error al guardar portabilidad:" + err);
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    //this.showModalPorta("Error","<h3>No fue posible guardar el registro de portabilidad. Intente nuevamente.</h3>");
                    //let title="Error";
                    //let msg = "No fue posible guardar el registro de portabilidad. Intente nuevamente.";
                    //let icon = '<i class="fas fa-times fa-3x text-danger"></i>';
                    //clase.showModalIcon(title,msg,icon);


                    $("#modalLoad").hide();
                });
            } else {
                $("#modalLoad").hide();
                console.log("Error en el objeto a guardar");
            }
        }

        /* Envio Formularios Portabilidad End */

        /* Carga de datos Portabilidad End */

    }, {
        key: "loadPortabilidad",
        value: function loadPortabilidad() {
            $("#spinnersPorta").show();

            var clase = this;

            var data = {};

            var params = {
                "headers": {
                    "X-Forwarded-For": "187.188.25.218",
                    "totalplay": clase.ch.obtenerCookieWeb()
                },
                "method": "POST",
                "body": {
                    "secdata": data
                }
            };

            clase.getData(CONSTANTES.endpoints.getportabilidad, params).then(function (response) {
                if (parseInt(response.status) === 0) {
                    var lstPortabilidad = response.bean;
                    clase.pintaHTML(lstPortabilidad);
                    $("#spinnersPorta").hide();
                } else {
                    if (parseInt(response.status) === 3) {
                        alert("Format de archivo inválido");
                    } else {
                        var html = '<div class="mt-5 mb-5">';
                        html += '<p class="nodatos sz-24"> No tienes ninguna portabilidad <\/p>';
                        html += '<p class="nodatos sz-18"> Para cualquier aclaración llama al <span>800 510 0510<\/span> <\/p>';
                        html += '<\/div>';
                        $("#c-porta-status").html(html);
                    }
                    $("#spinnersPorta").hide();
                }
            }).catch(function (err) {
                console.error("Exception [GetPorta]:" + err);
                var html = '<div class="mt-5 mb-5">';
                html += '<p class="nodatos sz-24"> No tienes ninguna portabilidad <\/p>';
                html += '<p class="nodatos sz-18"> Para cualquier aclaración llama al <span>800 510 0510<\/span> <\/p>';

                html += '<\/div>';
                $("#c-porta-status").html(html);
                $("#spinnersPorta").hide();
            });
        }
    }, {
        key: "pintaHTML",
        value: function pintaHTML(lstPortabilidad) {
            var clase = this;
            if (lstPortabilidad.length > 0) {
                $("#c-porta-status").html("");

                lstPortabilidad.forEach(function (item, i) {
                    var fecsol = item.fechaSolicitud;
                    var fecpor = item.fechaProgramacion;

                    var fechaSolic = "--";
                    var fechaPorta = "--";
                    var portacomen = "--";

                    if (fecsol != 'undefined' && fecsol != null && fecsol.trim().length > 0) {
                        fechaSolic = clase.formatFecha(fecsol);
                    }

                    if (fecpor != 'undefined' && fecpor != null && fecpor.trim().length > 0) {
                        fechaPorta = clase.formatFecha(fecpor);
                    }

                    try {
                        portacomen = decodeURIComponent(escape(item.comentario));
                    } catch (e) {
                        portacomen = item.comentario;
                    }

                    var html = '<div class="card mx-auto my-4 por-sty-card por-sz-card">';
                    html += '<div class="row por-borlef-card">';
                    html += '    <div class="col-12 col-md-7">';
                    html += '        <div class="row pl-2 py-1">';
                    html += '            <div class="col-12 col-md-6 text-left">';
                    html += '                <div class="row">';
                    html += '                    <div class="col-12 clr-gray sz-12">';
                    html += '                        No. telef&oacute;nico a portar';
                    html += '                    </div>';
                    html += '                </div>';
                    html += '                <div class="row">';
                    html += '                    <div class="col-12 sz-18 stfnde">';
                    html += '                        <span id="por-lbl-noporta">' + item.portado + '</span>';
                    html += '                    </div>';
                    html += '                </div>';
                    html += '            </div>';
                    html += '            <div class="col-12 col-md-6 text-left">';
                    html += '                <div class="row">';
                    html += '                    <div class="col-12 clr-gray sz-12">';
                    html += '                        Fecha solicitud';
                    html += '                    </div>';
                    html += '                </div>';
                    html += '                <div class="row">';
                    html += '                    <div class="col-12 sz-18 stfnde">';
                    html += '                        <span id="por-lbl-fecsol">' + fechaSolic + '</span>';
                    html += '                    </div>';
                    html += '                </div>';
                    html += '            </div>';
                    html += '        </div>';
                    html += '        <div class="row pl-2 py-1">';
                    html += '            <div class="col-12 text-left">';
                    html += '                <div class="row">';
                    html += '                    <div class="col-12 clr-gray sz-12">';
                    html += '                        Observaciones';
                    html += '                    </div>';
                    html += '                    <div class="col-12 sz-18 stfnde text-justify">';
                    html += '                        <span id="por-lbl-observacion">' + portacomen + '</span>';
                    html += '                    </div>';
                    html += '                </div>';
                    html += '            </div>';
                    html += '        </div>';
                    html += '    </div>';
                    html += '    <div class="col-12 col-md-1 text-center">';
                    html += '        <div class="row">';
                    html += '            <div class="col-4 d-none d-md-block">';
                    html += '                |||||||||||||||';
                    html += '            </div>';
                    html += '            <div class="col-12 d-block d-sm-block d-md-none por-sty-line">';
                    html += '                --------------';
                    html += '            </div>';
                    html += '        </div>';
                    html += '    </div>';
                    html += '    <div class="col-12 col-md-4 text-left">';
                    html += '        <div class="row pl-2 py-3">';
                    html += '            <div class="col-12 clr-gray sz-12">';
                    html += '                Folio';
                    html += '            </div>';
                    html += '            <div class="col-12 sz-18 stfnde">';
                    html += '                <span id="por-lbl-folio">' + item.folio + '</span>';
                    html += '            </div>';
                    html += '        </div>';
                    html += '        <div class="row pl-2 py-3 mt-2">';
                    html += '            <div class="col-12 clr-gray sz-12">';
                    html += '                Fecha de portabilidad';
                    html += '            </div>';
                    html += '            <div class="col-12 sz-18 stfnde">';
                    html += '                <span id="por-lbl-fecpor">' + fechaPorta + '</span>';
                    html += '            </div>';
                    html += '        </div>';
                    html += '        <div class="row pl-2 py-3 mt-2">';
                    html += '            <div class="col-12 clr-gray sz-12">';
                    html += '                Estatus';
                    html += '            </div>';
                    html += '            <div class="col-12 sz-18 stfnde">';
                    html += '                <span id="por-lbl-estatus">' + item.estatus + '</span>';
                    html += '            </div>';
                    html += '        </div>';
                    html += '    </div>';
                    html += '</div>';
                    html += '</div>';

                    $("#c-porta-status").append(html);
                });
            } else {
                var html = '<div class="mt-5 mb-5">';
                html += '<h3> No cuenta con registros de portabilidad <\/h3>';
                html += '<\/div>';
                $("#c-porta-status").html(html);
            }
        }
        /*Carga de datos Portabilidad End */

        /* Funciones generales Start */

    }, {
        key: "formatFecha",
        value: function formatFecha(strFecha) {
            var fecha = new Date(strFecha);

            var dia = ('0' + fecha.getDate()).slice(-2);
            var mes = ('0' + fecha.getMonth()).slice(-2);
            var anio = fecha.getFullYear();

            var dateFmt = new Date(anio, mes, dia);
            mes = dateFmt.toLocaleString("mx", { month: 'short' });
            mes = mes.charAt(0).toUpperCase() + mes.slice(1);

            var strFmt = dia + " " + mes.slice(0, -1) + " " + anio;

            return strFmt;
        }
    }, {
        key: "getData",
        value: function getData(url, params) {
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            return new Promise(function (resolve, reject) {
                fetch(url, {
                    method: "POST",
                    body: JSON.stringify(params),
                    headers: cabeceraMC
                }).then(function (data) {
                    if (data.ok) {
                        return data.json();
                    } else {
                        throw "Error en la llamada Ajax Fetch " + url;
                    }
                }).then(function (respuesta) {
                    resolve(respuesta);
                }).catch(function (err) {
                    console.log("err=>" + url + "/" + err);
                    reject(Error(err));
                });
            });
        }
    }, {
        key: "hideAll",
        value: function hideAll() {
            $("#porta-step-0").css("display", "none");
            $("#porta-step-1").css("display", "none");
            $("#porta-st1-change").css("display", "none");
            $("#porta-cf-tipopersona-sel").css("display", "none");
            $("#porta-cf-tipopersona").css("display", "none");
            $("#porta-step-2").css("display", "none");
            $("#porta-st2-change").css("display", "none");
            $("#porta-cf-estatuslinea-sel").css("display", "none");
            $("#porta-cf-estatuslinea").css("display", "none");
            $("#porta-step-21").css("display", "none");
            $("#porta-st21-change").css("display", "none");
            $("#porta-cf-estatuslineadias-sel").css("display", "none");
            $("#porta-cf-estatuslineadias").css("display", "none");
            $("#porta-step-3-pf").css("display", "none");
            $("#porta-step-3-pfc").css("display", "none");
            $("#porta-step-3-pm").css("display", "none");
            this.limpiaDataPf();
            this.hideErrorPf();
            this.limpiaDataPfc();
            this.hideErrorPfc();
            this.limpiaDataPm();
            this.hideErrorPm();
        }
    }, {
        key: "limpiaDataPf",
        value: function limpiaDataPf() {
            $("#por-inp-pf-nip").val("");
            $("#por-inp-pf-telpor").val("");
            $("#por-inp-pf-telcon").val("");
        }
    }, {
        key: "hideErrorPf",
        value: function hideErrorPf() {
            $("#err-pf-1").css("display", "none");
            $("#err-pf-2").css("display", "none");
            $("#err-pf-3").css("display", "none");
        }
    }, {
        key: "limpiaDataPfc",
        value: function limpiaDataPfc() {
            $("#por-inp-pfc-telpor").val("");
            $("#por-inp-pfc-telcon").val("");

            $("#por-inp-pfc-ideofi").val("");
            $("#por-inp-pfc-fil-ideofi").val("");

            $("#por-inp-pfc-carcan").val("");
            $("#por-inp-pfc-fil-carcan").val("");

            $("#por-inp-pfc-forpor").val("");
            $("#por-inp-pfc-fil-forpor").val("");
        }
    }, {
        key: "hideErrorPfc",
        value: function hideErrorPfc() {
            $("#err-pfc-1").css("display", "none");
            $("#err-pfc-2").css("display", "none");
            $("#err-pfc-3").css("display", "none");
            $("#err-pfc-4").css("display", "none");
            $("#err-pfc-5").css("display", "none");
        }
    }, {
        key: "limpiaDataPm",
        value: function limpiaDataPm() {
            $("#por-inp-pm-telpor").val("");
            $("#por-inp-pm-telcon").val("");

            $("#por-inp-pm-ideofi").val("");
            $("#por-inp-pm-fil-ideofi").val("");

            $("#por-inp-pm-actcon").val("");
            $("#por-inp-pm-fil-actcon").val("");

            $("#por-inp-pm-forpor").val("");
            $("#por-inp-pm-fil-forpor").val("");
        }
    }, {
        key: "hideErrorPm",
        value: function hideErrorPm() {
            $("#err-pm-1").css("display", "none");
            $("#err-pm-2").css("display", "none");
            $("#err-pm-3").css("display", "none");
            $("#err-pm-4").css("display", "none");
            $("#err-pm-5").css("display", "none");
        }
    }, {
        key: "setKeyupFiles",
        value: function setKeyupFiles() {
            //Inputs PF
            $('#por-inp-pf-nip').on("keyup", function () {
                $("#err-pf-1").css("display", "none");
            });
            $('#por-inp-pf-telpor').on("keyup", function () {
                $("#err-pf-2").css("display", "none");
            });
            $('#por-inp-pf-telcon').on("keyup", function () {
                $("#err-pf-3").css("display", "none");
            });

            //Input PFC
            $("#por-inp-pfc-telpor").on("keyup", function () {
                $("#err-pfc-1").css("display", "none");
            });
            $("#por-inp-pfc-telcon").on("keyup", function () {
                $("#err-pfc-2").css("display", "none");
            });

            //Input PM
            $("#por-inp-pm-telpor").on("keyup", function () {
                $("#err-pm-1").css("display", "none");
            });
            $("#por-inp-pm-telcon").on("keyup", function () {
                $("#err-pm-2").css("display", "none");
            });
        }
    }, {
        key: "setChangeFileAction",
        value: function setChangeFileAction() {
            var clase = this;
            $('input[type="file"]').change(function (e) {
                var idsel = e.currentTarget.id;
                var fileName = e.target.files[0].name;

                //PFC
                if (idsel === 'por-inp-pfc-fil-ideofi') {
                    if (clase.validaExtensionFile(fileName)) {
                        $("#err-pfc-3").css("display", "none");
                        $("#por-inp-pfc-ideofi").val(fileName);
                    } else {
                        $("#err-pfc-3").css("display", "block");
                        $("#err-pfc-3").html(clase.props.lstLsbMsgUsr.lblExtDif);
                        $("#por-inp-pfc-ideofi").val("");
                        $("#" + idsel).val("");
                    }
                }
                if (idsel === 'por-inp-pfc-fil-carcan') {
                    if (clase.validaExtensionFile(fileName)) {
                        $("#err-pfc-4").css("display", "none");
                        $("#por-inp-pfc-carcan").val(fileName);
                    } else {
                        $("#err-pfc-4").css("display", "block");
                        $("#err-pfc-4").html(clase.props.lstLsbMsgUsr.lblExtDif);
                        $("#por-inp-pfc-carcan").val("");
                        $("#" + idsel).val("");
                    }
                }
                if (idsel === 'por-inp-pfc-fil-forpor') {
                    if (clase.validaExtensionFile(fileName)) {
                        $("#err-pfc-5").css("display", "none");
                        $("#por-inp-pfc-forpor").val(fileName);
                    } else {
                        $("#err-pfc-5").css("display", "block");
                        $("#err-pfc-5").html(clase.props.lstLsbMsgUsr.lblExtDif);
                        $("#por-inp-pfc-forpor").val("");
                        $("#" + idsel).val("");
                    }
                }

                //PM
                if (idsel === 'por-inp-pm-fil-ideofi') {
                    if (clase.validaExtensionFile(fileName)) {
                        $("#err-pm-3").css("display", "none");
                        $("#por-inp-pm-ideofi").val(fileName);
                    } else {
                        $("#err-pm-3").css("display", "block");
                        $("#err-pm-3").html(clase.props.lstLsbMsgUsr.lblExtDif);
                        $("#por-inp-pm-ideofi").val("");
                        $("#" + idsel).val("");
                    }
                }

                if (idsel === 'por-inp-pm-fil-actcon') {
                    if (clase.validaExtensionFile(fileName)) {
                        $("#err-pm-4").css("display", "none");
                        $("#por-inp-pm-actcon").val(fileName);
                    } else {
                        $("#err-pm-4").css("display", "block");
                        $("#err-pm-4").html(clase.props.lstLsbMsgUsr.lblExtDif);
                        $("#por-inp-pm-actcon").val("");
                        $("#" + idsel).val("");
                    }
                }

                if (idsel === 'por-inp-pm-fil-forpor') {
                    if (clase.validaExtensionFile(fileName)) {
                        $("#err-pm-5").css("display", "none");
                        $("#por-inp-pm-forpor").val(fileName);
                    } else {
                        $("#err-pm-5").css("display", "block");
                        $("#err-pm-5").html(clase.props.lstLsbMsgUsr.lblExtDif);
                        $("#por-inp-pm-forpor").val("");
                        $("#" + idsel).val("");
                    }
                }
            });
        }
    }, {
        key: "validaExtensionFile",
        value: function validaExtensionFile(fileName) {
            var arrExtAccepted = ['jpg', 'jpeg', 'pdf'];
            try {
                if (fileName != null && fileName.trim().length > 0) {
                    var extFile;

                    //Validar extension
                    extFile = fileName.split('.').pop();
                    extFile = extFile.toLowerCase();
                    var a = arrExtAccepted.indexOf(extFile);
                    if (a != -1) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } catch (e) {
                console.error("Error al validar extensión de archivo:" + e);
                return false;
            }
        }
    }, {
        key: "soloNumeros",
        value: function soloNumeros() {
            $('.solo-numeros').keydown(function (e) {
                if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 || e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true) || e.keyCode >= 35 && e.keyCode <= 40) {
                    return;
                }
                if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
                    e.preventDefault();
                }
            });
        }
    }, {
        key: "esVacio",
        value: function esVacio(valor) {
            try {
                if (valor != 'undefined' && valor != null) {
                    var value = $.trim(valor);

                    if (value === null || value.length === 0) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            } catch (e) {
                return true;
            }
        }
    }, {
        key: "validaTelefono",
        value: function validaTelefono(telefono) {
            var response = false;
            var reTelefono = /^\d{10}$/; //regular expression defining a 10 digit number

            if (telefono.length > 0) {
                if (telefono.match(reTelefono)) {
                    response = true;
                }
            }
            return response;
        }
    }, {
        key: "enableButton",
        value: function enableButton(opt, enable) {
            var name = "";
            try {
                if (parseInt(opt) === 1) {
                    name = "btnEnviaPortaFisica";
                } else if (parseInt(opt) === 2) {
                    name = "btnEnviaPortaFisicaCancel";
                } else if (parseInt(opt) === 3) {
                    name = "btnEnviaPortaMoral";
                }

                document.getElementById(name).disabled = enable;
            } catch (e) {}
        }
    }, {
        key: "getFileB64",
        value: function getFileB64(file, type) {
            return new Promise(function (resolve, reject) {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    var result = reader.result;
                    var xplode = result.split("base64,");

                    var json = { "file": type, "b64": xplode[1] };
                    resolve(json);
                };
                reader.onerror = function (error) {
                    return reject(error);
                };
            });
        }
    }, {
        key: "showModal",
        value: function showModal(title, msg) {
            $("#mdlTitToUser").html(title);
            $("#mdlBodyToUser").html(msg);
            $("#logMdlMsjToUser").modal("show");
        }
    }, {
        key: "showModalIcon",
        value: function showModalIcon(title, msg, icon) {
            $('#iconrespuesta').html(icon);
            $("#msjTitle").html(title);
            $("#msjrespuesta").html(msg);

            $("#modalrespuesta").modal("show");
        }
    }, {
        key: "reload",
        value: function reload() {
            window.location.reload();
        }
        /* Funciones generales End */

    }]);

    return Portabilidad;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49,"../../utils/ModalMng":50}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Visita = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _ModalMng = require("../../utils/ModalMng");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Visita = exports.Visita = function () {
    function Visita() {
        var _this = this;

        _classCallCheck(this, Visita);

        this.props = {
            plantilla_card: '<div class="col-lg-6 py-3">' + '<div class="card div-border w-100 si-sm">' + '<div class="card-header text-center b-blue f-white f-w600 sz-18">' + '<i class="icon-lla-2"><\/i> <span>Folio: <\/span><span id="no_folio"><\/span>' + '<\/div>' + '<div class="card-body">' + '<div class="row p-2" style="border-bottom: dashed 1px rgba(29, 29, 38, 0.3);">' + '<div class="col-10" style="text-align: left">' + '<p id="estatus" class="sz-16 my-2" style="color:#75787;margin-bottom:5px;"><\/p> ' + '<p id="horario" class="sz-16 my-3" style="color:#75787;margin-bottom:5px;"> <\/p> ' + '<\/div><div class="col-1"><\/div>' + '<\/div>' + '<div class="row p-3"><div class="col-3" id="imagenins">' + '<\/div><div class="col-9"><\/div><\/div><\/div>' + '<\/div><\/div><\/div>',
            plantilla_porcalificar: '<div class="col-lg-6 py-3">' + '<div class="card div-border w-100 si-sm">' + '<div class="card-body">' + '<div class="row p-2" >' + '<div class="col-3"><br><img src="/assets/images/seguimiento/instalacion/build-24-px2.svg"><\/div>' + '<div class="col-9" style="text-align: left">' + '<p id="fecha" class="f-bold sz-14 mb-3">12/07/2019<\/p>' + '<p id="ley1" class="f-bold sz-14 mb-3">Solicitud de instalaci&oacute;n<\/p>' + '<p id="folio" class="sz-14 mb-3">123456<\/p>  ' + '<\/div><\/div>' + '<div class="row p-3" style="border-bottom: dashed 1px rgba(29, 29, 38, 0.3);">' + ' <div class="col-3" id="imagenins1"><\/div>' + ' <div class="col-9 text-left">' + '<p class="sz-13 mb-3">T&eacute;cnico a cargo<\/p>' + '<p class="f-blue sz-14 mb-3" style="text-transform:capitalize !important;min-height:30px !important;">Nombre.....<\/p>' + '<\/div>' + '<\/div>' + ' <div class="row p-3 text-center" >' + '<div class="col-12 f-blue p-3 sz-13"><\/div>' + '<\/div><\/div><\/div><\/div>',
            plantilla_respuesta_ots: "<br><div class='col-8 offset-2 col-md-12 offset-md-0'><p class='sz-24 f-w500 clr-gray-3 monreg spalet'>No tienes ninguna solicitud de visita<\/p>" + "<p class='sz-18 monreg clr-gray-3 spalet mt-2'>Para cualquier aclaraci&oacute;n llama al <span class='azul sz-18 spalets'> <a href='tel:8005100510' class='azul'>800 510 0510</a><\/span><\/p><\/div>",
            plantilla_respuesta_fail: "<br><div class='col-8 offset-2 col-md-12 offset-md-0'><p class='sz-24 f-w500 clr-gray-3 monreg spalet'>Por el momento no se pudo obtener la información. Intente más tarde.<\/p>" + "<p class='sz-18 monreg clr-gray-3 spalet mt-2'>Para cualquier aclaraci&oacute;n llama al <span class='azul sz-18 spalet'> <a href='tel:8005100510' class='azul'>800 510 0510</a> <\/span><\/p><\/div>",
            plantilla_respuesta_calificar: "<br><div class='col-8 offset-2 col-md-12 offset-md-0'><p class='sz-24 f-w500 clr-gray-3 monreg spalet'>No tienes ninguna solicitud por calificar<\/p>" + "<p class='sz-18 monreg clr-gray-3 spalet mt-2'>Para cualquier aclaraci&oacute;n llama al <span class='azul sz-18 spalet'> <a href='tel:8005100510' class='azul'>800 510 0510</a> <\/span><\/p><\/div>",
            plantilla_pregunta: '<div class="col-12 pt-3"><p class="text-center"><\/p><\/div>',
            plantilla_caritas: '<div id="pregunta" class="row col-11 offset-1 col-md-12 offset-md-0 py-3">' + '<div class="col-12 col-md-2">' + '<span class="{idPre} muymalo carita" id="1_{idPre}"><\/span>Muy malo' + '<\/div>' + '<div class="col-12 col-md-2" >' + '<span class="{idPre} malo carita" id="2_{idPre}"><\/span>Malo' + '<\/div>' + '<div class="col-12 col-md-2">' + '<span class="{idPre} carita regular" id="3_{idPre}"><\/span>Regular' + '<\/div>' + '<div class="col-12 col-md-2">' + '<span class="{idPre} carita bueno" id="4_{idPre}"><\/span>Bueno' + '<\/div>' + '<div class="col-12 col-md-2">' + '<span class="{idPre} carita muybueno" id="5_{idPre}"><\/span>Muy bueno' + '<\/div>' + '<div class="col-6 col-md-2 mx-auto">' + '<button type="button" class="btn btn-primary w-80 btncomentario" id="{idPre}">+ comentario<\/button>' + '<\/div>' + '<\/div>',
            plantilla_comentarios: '<div class="col-12 pt-3 comentarios" id="comentarios{idPre}">' + '<textarea style="width:100%;" rows="4" name="text" placeholder="Escribe un comentario" onkeypress="validacaracteres(event)"><\/textarea>' + '<\/div>',
            epgral: "https://7wx6n5y7xg.execute-api.us-east-1.amazonaws.com/MI_CUENTA_TP",
            arrayencuesta: [],
            arrayrespuestas: []
        };
        this.ch = new _CookieHelper.CookieHelper();

        /* Cargar funciones generales */
        this.inicializar();

        this.ir();
        this.hideAll();
        this.showOption();
        this.recordarMasTarde();
        this.btnEncuesta();
        this.irEncuesta();
        this.volver();
        this.btnSiguiente();
        this.btnSiguiente2();
        this.btnEnviarEnc();
        var modalManager = new _ModalMng.ModalMng();
        modalManager.createModal(CONSTANTES.modals.recomendados).then(function (status) {
            //confirmacion creacion del Primer modal
            _this.showModal();
            _this.hideModal();
            _this.showModalGeneric();
            _this.aceptaRespuesta();
        }).catch(function (err) {
            console.error("el error es" + err);
        });

        // Carga inicial
        this.init();
    }

    _createClass(Visita, [{
        key: "init",
        value: function init() {
            console.log("Seguimiento Visita Script");
            this.obtenerEstatusOT();
        }
    }, {
        key: "inicializar",
        value: function inicializar() {
            $('#carseg').carousel();

            $('#carseg').carousel({
                pause: true,
                interval: false
            });

            $('#carseg').on('slide.bs.carousel', function () {
                $('.carousel').carousel('pause');
            });

            //$(function(){
            $('#selector2').removeClass('selector');
            $("#nav1").addClass("tablinkAct");

            $('#nav1').on('click', function () {
                $('#calificar').addClass('ocultar');
                $('#progresso').removeClass('ocultar');

                $("#nav1").addClass("tablinkAct");
                $("#selector1").addClass("selector");
                $("#selector2").removeClass("selector");
                $("#nav2").removeClass("tablinkAct");
            });

            $('#nav2').on('click', function () {
                $('#progresso').addClass('ocultar');
                $('#calificar').removeClass('ocultar');
                $("#nav2").addClass("tablinkAct");
                $("#selector1").removeClass("selector");
                $("#selector2").addClass("selector");
                $("#nav1").removeClass("tablinkAct");
            });
            //});
        }
    }, {
        key: "obtenerEstatusOT",
        value: function obtenerEstatusOT() {
            var clase = this;
            var url = CONSTANTES.endpoints.obtenerEstatusOt;
            var strData = "{}";
            var params = { "strEnco": strData };
            var sendData = clase.getParamsString(params);

            $("#spinnerVisita").show();

            clase.getData(url, sendData).then(function (response) {
                console.log("****** Response Estatus OT ******");
                try {
                    //response = JSON.parse(datarsp);
                    console.log(response);
                    if (response.status === 0 || response.result === "0") {
                        $("#spinnerVisita").hide();
                        var arrayactivas = response.bean.listaactivas;
                        /*var arrayactivas= [
                            {"idOT":6173827,"fecha":"10 de junio","estado":"1","fotoTecnico":null,"os":null,"ticket":null,"estatus":null,"turno":"Matutino","idTecnico":1,"nombreTecnico":"prueba"},
                            {"idOT":6192356,"fecha":"30 de octubre","estado":"2","fotoTecnico":null,"os":null,"ticket":null,"estatus":null,"turno":"Mixto","idTecnico":141,"nombreTecnico":"prueba tecn"},
                            //{"idOT":3,"fecha":"30 de octubre","estado":"2","fotoTecnico":null,"os":null,"ticket":null,"estatus":null,"turno":"Mixto","idTecnico":null,"nombreTecnico":"prueba tecnico"}
                        ];*/

                        if (arrayactivas.length > 0) {
                            var bandera = false;

                            $.each(arrayactivas, function (ind, elem) {
                                if (elem.idOT != null) {
                                    bandera = true;

                                    var html = $.parseHTML(clase.props.plantilla_card);
                                    html[0].children[0].children[0].children[2].innerHTML = elem.idOT;
                                    html[0].children[0].children[1].children[0].children[0].children[0].innerHTML = 'Estatus<br><span style="font-size:1.6rem !important;font-weight: 600;color: #3b4559;">' + elem.estado + '</span>';
                                    html[0].children[0].children[1].children[0].children[0].children[1].innerHTML = 'Horario<br><span style="font-size:1.6rem !important;font-weight: 600;color: #3b4559;">' + elem.fecha + ', turno ' + elem.turno + '</span>';

                                    html[0].children[0].children[1].children[0].children[1].innerHTML = '<br><img class="ira" onclick="$.ir(' + elem.idOT + ')" src="/assets/images/seguimiento/instalacion/arrow-forward.png">';

                                    var tecnico = "Por asignar";

                                    if (elem.idTecnico != null) {
                                        tecnico = elem.nombreTecnico;

                                        html[0].children[0].children[1].children[1].children[0].innerHTML = '<div id="imgpros' + ind + "_" + elem.idOT + '"><\/div>';
                                        clase.getFotografia(elem.fotoTecnico, 'imgpros' + ind + "_" + elem.idOT);
                                        html[0].children[0].children[1].children[1].children[1].innerHTML = '<p class="sz-16 my-2">T&eacute;cnico a cargo<\/p><p><a class="ira pt-3" ><span class="azul sz-16 my-1">' + tecnico + '<\/span><\/a><\/p>';
                                    } else {
                                        html[0].children[0].children[1].children[1].children[0].innerHTML = '<img class="imagen-instaladorsr" src="/assets/images/seguimiento/instalacion/icon-person.jpg" width="100%">';
                                        html[0].children[0].children[1].children[1].children[1].innerHTML = '<p class="sz-16 my-2">T&eacute;cnico a cargo<\/p><p class="sz-16 my-1"><span>"' + tecnico + '"<\/span><\/p>';
                                    }
                                    $('#ots').append(html);
                                }
                            });

                            if (!bandera) {
                                $("#ots").html(clase.props.plantilla_respuesta_ots);
                            }
                        } else {
                            $("#ots").html(clase.props.plantilla_respuesta_ots);
                        }

                        //Ots por calificar
                        var arrayxcalificar = response.bean.listacalificar;
                        console.log(arrayxcalificar);
                        if (arrayxcalificar.length > 0) {
                            var bandera1 = false;

                            $.each(arrayxcalificar, function (index, ele) {
                                if (ele.idOT != null) {
                                    bandera1 = true;
                                    var html = $.parseHTML(clase.props.plantilla_porcalificar);

                                    html[0].children[0].children[0].children[0].children[1].children[0].innerHTML = ele.fechaEnd;
                                    html[0].children[0].children[0].children[0].children[1].children[2].innerHTML = ele.idOT;

                                    html[0].children[0].children[0].children[1].children[1].children[1].innerHTML = ele.nombreTecnico;
                                    //console.log(ele.fotoTecnico);
                                    if (ele.fotoTecnico != null) {
                                        html[0].children[0].children[0].children[1].children[0].innerHTML = '<div id="imgxc' + ele.idOT + '"><\/div>';
                                        //$.getfotografia(ele.fotoTecnico,'imgxc'+ele.idOT);
                                        clase.getFotografia(ele.fotoTecnico, 'imgxc' + ele.idOT);
                                    }

                                    html[0].children[0].children[0].children[2].children[0].innerHTML = 'Calificar Instalaci&oacute;n<img  ' + 'onclick="$.irencuesta(' + ele.idOT + ')" ' + 'src="/assets/images/seguimiento/chevron-right-24-px.svg">';

                                    $("#porcalificar").append(html);
                                }
                            });

                            if (!bandera1) {
                                $("#porcalificar").html(clase.props.plantilla_respuesta_calificar);
                            }

                            $("#spinnerVisita").hide();
                        } else {
                            $("#porcalificar").html(clase.props.plantilla_respuesta_calificar);
                            $("#spinnerVisita").hide();
                        }
                    } else {
                        $("#spinnerVisita").hide();
                        $("#ots").html(clase.props.plantilla_respuesta_ots);
                        $("#porcalificar").html(clase.props.plantilla_respuesta_calificar);
                    }
                } catch (e) {
                    console.log(e);
                    $("#spinnerVisita").hide();
                    $("#ots").html(clase.props.plantilla_respuesta_ots);
                    $("#porcalificar").html(clase.props.plantilla_respuesta_calificar);

                    /*if(textStatus === 'timeout'){
                        console.log("timeout"); 
                    }else{
                        console.log(err);
                    }*/
                }
                console.log("***** Response Estatus OT ******");
            }).catch(function (err) {
                console.log(err);
                $("#spinnerVisita").hide();
                $("#ots").html(clase.props.plantilla_respuesta_fail);
                $("#porcalificar").html(clase.props.plantilla_respuesta_fail);
            });
        }
    }, {
        key: "getFotografia",
        value: function getFotografia(img, id) {
            console.log("Get fotografia");
            try {
                var clase = this;
                var url = CONSTANTES.endpoints.getFotografia;

                var params = { fotografia: img };
                var secdata = otpyrc2(JSON.stringify(params));
                //var secdata = "3mBs1qENd4S4tZoUJlwGYNPDPikDN3Bp3mDd0CpHe5sB+TBTKEm1UvLSoXuAV25Dstgz4QApITIZOmWO+9oXMQ=="; // -> Test
                params = { "strEnco": secdata }; //secdata

                //var sendData = clase.getParamsString(params);

                clase.getData(url, params).then(function (response) {
                    console.log(response);
                    try {
                        if (response.status === 0) {
                            $("#" + id).append('<img class="imagen-instaladorv" src="data:image/png;base64,' + response.bean + '" />');
                        } else {
                            $("#" + id).append('<img class="imagen-instaladorsr" src="/assets/images/seguimiento/instalacion/icon-person.jpg" width="100%">');
                        }
                    } catch (e) {
                        console.log("Catch Get fotografia:" + e);
                        $("#" + id).append('<img class="imagen-instaladorsr" src="/assets/images/seguimiento/instalacion/icon-person.jpg" width="100%">');
                    }
                }).catch(function (err) {
                    console.log(err);
                });
            } catch (e) {
                console.log(e);
                $("#" + id).append('<img class="imagen-instaladorsr" src="/assets/images/seguimiento/instalacion/icon-person.jpg" width="100%">');
            }
        }
    }, {
        key: "getInfoPaquete",
        value: function getInfoPaquete(idOt) {
            console.log("Get Info Paquete:" + idOt);

            try {
                var clase = this;
                var url = CONSTANTES.endpoints.getInfoPaquete;

                var params = { "idOt": idOt };

                var secdataSignature = "secdata";
                var objSend = params;

                var cadenc = otpyrc2(JSON.stringify(objSend));

                var objt = {};
                objt[secdataSignature] = cadenc;

                var sendData = objt;

                clase.getData(url, sendData).then(function (response) {
                    console.log(response);
                    try {
                        if (response.status === 0) {
                            var paquete = response.bean;

                            var seguimiento = $("#secc-step");
                            var paquetenom = "No hay informaci&oacute;n";
                            var paquetedes = "No hay informaci&oacute;n";
                            try {
                                if (paquete.nombrePaquete != "null") {
                                    paquetenom = paquete.nombrePaquete;
                                }
                            } catch (error) {
                                console.log(error);
                            }
                            try {
                                if (paquete.descripcionPaquete != "null") {
                                    paquetedes = paquete.descripcionPaquete;
                                }
                            } catch (error) {
                                console.log(error);
                            }
                            seguimiento.find("#paquete").html(paquetenom);
                            seguimiento.find("#nom_paq_inst").html(paquetenom);
                            seguimiento.find("#desc-inst").html(paquetedes);
                        } else {
                            console.log("Info paquete OT code != 0");
                        }
                    } catch (e) {
                        console.log("Exception promise getData getInfoPaquete:" + e);
                    }
                }).catch(function (err) {
                    console.log(err);
                });
            } catch (e) {
                console.log("Exception getInfoPaquete:" + e);
            }
        }
    }, {
        key: "getEstatusOt",
        value: function getEstatusOt(idOt) {
            $("#secc-step #spinnerVisita").show();
            console.log("Get Estatus Ot:" + idOt);
            localStorage.setItem("idot", idOt);
            try {
                var clase = this;
                var url = CONSTANTES.endpoints.getEstatusOt;

                var secdataSignature = "secdata";

                var cabeceraMC = new Headers();
                cabeceraMC.append("Content-type", "application/json;charset=utf-8");
                cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

                var objSend = idOt;

                var cadenc = otpyrc2(JSON.stringify(objSend));

                var objt = {};
                objt[secdataSignature] = cadenc;

                var sendData = objt;

                clase.getData(url, sendData).then(function (response) {
                    console.log(response);
                    var data = response;

                    try {
                        if (data.status === 0) {
                            //var ot=JSON.parse(data.bean.ot);
                            var ot = data.bean.ot;

                            clase.getInfoPaquete(ot.IdOT);

                            var seguimiento = $("#secc-step");

                            //ot.IdEstado = 14;

                            if (ot.IdEstado == "7" || ot.IdEstado == "9") {
                                console.log("Id Estado 7 o 9");
                                seguimiento.find("#diainstalacion").html(ot.FechaInstalacion);
                                seguimiento.find("#des-tur").html(ot.TurnoOrden);
                                seguimiento.find("#no_folio1").html(ot.IdOT);
                                $.hideAll();
                                $.showOption(1);
                                $("#secc-step #spinnerVisita").hide();
                            } else if (ot.IdEstado == "10") {
                                console.log("Id Estado 10");
                                seguimiento.find("#no_folio2").html(ot.IdOT);
                                seguimiento.find("#nom-ins").html(ot.NombreTecnico);
                                seguimiento.find("#turno").html(ot.TurnoOrden);
                                var vehiculo = data.bean.ubicate;
                                console.log(vehiculo);

                                seguimiento.find("#mrc-car").html(vehiculo.MarcaVehiculo + " " + vehiculo.ModeloVehiculo);
                                seguimiento.find("#num-pla").html(vehiculo.PlacasVehiculo);

                                if (vehiculo.FotografiaTecnico != null && vehiculo.FotografiaTecnico != "") {
                                    clase.getFotografiav1(vehiculo.FotografiaTecnico.trim());
                                }

                                //var ubicacion=JSON.parse(data.bean.ubicacionOT);
                                var ubicacion = data.bean.ubicaot;
                                var ubicaciones = [];
                                if (ot.IdTecnico != null) {
                                    clase.getDatosEmpleado(ot.IdTecnico, ot.IdOT);

                                    ubicaciones = [[parseFloat(vehiculo.Latitud), parseFloat(vehiculo.Longitud)], [parseFloat(ubicacion.LatitudOT), parseFloat(ubicacion.LongitudOT)]];

                                    clase.loadMapsAPI();
                                    clase.myMap();
                                    setTimeout(function () {
                                        $.myMap(ubicaciones);
                                    }, 3000);
                                }

                                $.hideAll();
                                $.showOption(2);
                                $("#secc-step #spinnerVisita").hide();
                            } else if (ot.IdEstado == "11") {
                                console.log("Id Estado 11");
                                seguimiento.find("#no_folio3").html(ot.IdOT);
                                if (ot.hrEstado != null) {
                                    seguimiento.find("#prep-hora-ini").html(ot.hrEstado);
                                }

                                $.hideAll();
                                $.showOption(3);
                                $("#secc-step #spinnerVisita").hide();
                            } else if (ot.IdEstado == "14") {
                                console.log("Id Estado 14");
                                seguimiento.find("#no_folio4").html(" " + ot.IdOT);

                                var fechaarray = ot.FechaInstalacion.split('/');
                                var meses = new Array("Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre");
                                var diasSemana = new Array("Domingo", "Lunes", "Martes", "Mi&eacute;rcoles", "Jueves", "Viernes", "S&aacute;bado");
                                var f = new Date(fechaarray[1] + '/' + fechaarray[0] + '/' + fechaarray[2]);
                                var dia = diasSemana[f.getDay()];
                                var mes = meses[f.getMonth()];

                                var fechatermina = dia + ", " + fechaarray[0] + " de " + mes;
                                if (ot.hrEstado != null) {
                                    fechatermina = fechatermina + " a las " + ot.hrEstado;
                                }
                                seguimiento.find("#fin-desc-inst").html(fechatermina);

                                if (ot.banderaEncuesta != null) {
                                    if (ot.banderaEncuesta == 1 || ot.banderaEncuesta == "1") {
                                        $("#banderaencuesta").hide();
                                    }
                                    if (ot.banderaEncuesta == 0 || ot.banderaEncuesta == "0") {
                                        $("#banderaencuesta").show();
                                    }
                                } else {
                                    $("#banderaencuesta").show();
                                }
                                $.hideAll();
                                $.showOption(4);
                                $("#secc-step #spinnerVisita").hide();
                            } else {
                                seguimiento.find("#no_folio5").html(ot.IdOT);
                                $("#estatus").html("Estatus: " + ot.DescripcionEstado);
                                $.hideAll();
                                $.showOption(5);
                                $("#secc-step #spinnerVisita").hide();
                            }
                        } else {
                            $("#secc-step #spinnerVisita").hide();
                        }
                    } catch (e) {
                        console.log("Exception getEstatusOt:" + e);
                        $("#secc-step #spinnerVisita").hide();
                    }
                }).catch(function (err) {
                    console.log(err);
                    $("#secc-step #spinnerVisita").hide();
                });
            } catch (e) {
                console.log(e);
                $("#secc-step #spinnerVisita").hide();
            }
        }
    }, {
        key: "getFotografiav1",
        value: function getFotografiav1(img) {
            console.log("Get fotografia V1");
            console.log(img);
            try {
                var clase = this;
                var url = CONSTANTES.endpoints.getFotografia;

                //var params = {fotografia:img};
                //var secdata = otpyrc2(JSON.stringify(params));
                //secdata = "3mBs1qENd4S4tZoUJlwGYNPDPikDN3Bp3mDd0CpHe5sB+TBTKEm1UvLSoXuAV25Dstgz4QApITIZOmWO+9oXMQ=="; // -> Test
                //params = {"strEnco":secdata};

                //var sendData = clase.getParamsString(params);

                var secdataSignature = "strEnco";

                var cabeceraMC = new Headers();
                cabeceraMC.append("Content-type", "application/json;charset=utf-8");
                cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

                var objSend = img;
                var cadenc = cadenc = JSON.stringify(objSend);

                var objt = {};
                objt[secdataSignature] = cadenc;

                clase.getData(url, objt).then(function (response) {
                    console.log(response);
                    try {
                        if (response.status === 0) {
                            $("#img-inst").html('<img class="imagen-instalador" src="data:image/png;base64,' + response.bean + '" />');
                        } else {
                            $("#img-inst").html('<img class="imagen-instalador" src="/assets/images/seguimiento/instalacion/icon-person.jpg" width="100%">');
                        }
                    } catch (e) {
                        console.log("Catch Get fotografia v1:" + e);
                        $("#img-inst").html('<img class="imagen-instalador" src="/assets/images/seguimiento/instalacion/icon-person.jpg" width="100%">');
                    }
                }).catch(function (err) {
                    console.log(err);
                });
            } catch (e) {
                console.log(e);
                $("#img-inst").html('<img class="imagen-instaladorsr" src="/assets/images/seguimiento/instalacion/icon-person.jpg" width="100%">');
            }
        }
    }, {
        key: "getDatosEmpleado",
        value: function getDatosEmpleado(idTecnico, idOt) {
            console.log("Get Datos Cliente");
            try {
                var clase = this;
                var url = CONSTANTES.endpoints.getDatosEmpleado;

                /*var params = {"IdEmpleado": idTecnico,"idOt":idOt};
                var secdata = otpyrc2(JSON.stringify(params));
                params = {"secdata":secdata};
                  var sendData = clase.getParamsString(params);*/
                console.log(idTecnico);
                var params = { "idempleado": idTecnico };

                var secdataSignature = "secdata";

                var cabeceraMC = new Headers();
                cabeceraMC.append("Content-type", "application/json;charset=utf-8");
                cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

                var cadenc = otpyrc2(JSON.stringify(params));

                var objt = {};
                objt[secdataSignature] = cadenc;

                var sendData = objt;

                clase.getData(url, sendData).then(function (response) {
                    console.log(response);

                    var data = response;

                    try {
                        var califica = 0;

                        if (data.codigo == 0) {
                            var operador = JSON.parse(data.bean.Operador);
                            if (operador.Calificacion != "" && operador.Calificacion != " ") {
                                califica = operador.Calificacion;
                            }
                        }
                        $("#val-puntaje").html(califica);
                    } catch (e) {
                        console.log("Catch1 getDatosEmpleado:" + e);
                    }
                }).catch(function (err) {
                    console.log(err);
                });
            } catch (e) {
                console.log("Catch2 getDatosEmpleado:" + e);
            }
        }
    }, {
        key: "getEncuesta",
        value: function getEncuesta() {
            var _this2 = this;

            console.log("Get Encuesta");
            $("#loaeje #spinnerVisita").show();
            var clase = this;
            try {

                var url = CONSTANTES.endpoints.getEncuesta;

                var strData = "{}";
                var params = { "strEnco": strData };
                var sendData = clase.getParamsString(params);

                clase.getData(url, sendData).then(function (response) {
                    console.log(response);
                    try {
                        var data = response;
                        $("#loaeje #spinnerVisita").hide();
                        if (data.status == 0) {
                            var arraypreguntas = data.bean.listapreg;
                            _this2.props.arrayencuesta = data.bean.listapreg;

                            $("#encuestaejecutivo").html("");
                            $("#encuestainstalador").html("");
                            $("#encuestatotal").html("");

                            arraypreguntas.forEach(function (elem, index) {
                                var plantilla1 = $(clase.props.plantilla_pregunta, "p").html(index + 1 + " . " + elem.pregunta);
                                var plantilla2 = clase.props.plantilla_caritas.replace(/{idPre}/g, elem.idPregunta);
                                var plantilla3 = clase.props.plantilla_comentarios.replace(/{idPre}/g, elem.idPregunta);

                                if (elem.tipo == 1) {
                                    $("#encuestaejecutivo").append(plantilla1);
                                    $("#encuestaejecutivo").append(plantilla2);
                                    $("#encuestaejecutivo").append(plantilla3);
                                }

                                if (elem.tipo == 2) {
                                    $("#encuestainstalador").append(plantilla1);
                                    $("#encuestainstalador").append(plantilla2);
                                    $("#encuestainstalador").append(plantilla3);
                                }

                                if (elem.tipo == 3) {
                                    $("#encuestatotal").append(plantilla1);
                                    $("#encuestatotal").append(plantilla2);
                                    $("#encuestatotal").append(plantilla3);
                                }
                            });

                            $('.carita').on('click', function () {
                                var valor = this.id;
                                var valores = valor.split('_');
                                if ($(this).hasClass('activo')) {} else {
                                    $('.' + valores[1]).removeClass('activo');
                                    $(this).addClass('activo');
                                }
                            });

                            $('.btncomentario').on('click', function () {
                                var valor1 = this.id;
                                if ($("#comentarios" + valor1).css('display') == 'none') {
                                    $("#comentarios" + valor1).show();
                                } else {
                                    $("#comentarios" + valor1).hide();
                                }
                            });
                        } else {

                            $("#loaeje #spinnerVisita").hide();
                            var html = '<div class="col-12 text-center mt-2 mb-2">Por el momento no se pudo obtener la información. Intente más tarde.</div>';

                            $("#encuestatotal").html(html);
                            $("#encuestainstalador").html(html);
                            $("#encuestaejecutivo").html(html);
                        }
                    } catch (e) {
                        console.log("Error");
                        console.log(e);
                        $("#loaeje #spinnerVisita").hide();
                        $("#encuestatotal").html(clase.props.plantilla_respuesta_fail);
                        $("#encuestainstalador").html(clase.props.plantilla_respuesta_fail);
                        $("#encuestaejecutivo").html(clase.props.plantilla_respuesta_fail);
                    }
                }).catch(function (err) {
                    console.log(err);
                    $("#loaeje #spinnerVisita").hide();
                    $("#encuestatotal").html(clase.props.plantilla_respuesta_fail);
                    $("#encuestainstalador").html(clase.props.plantilla_respuesta_fail);
                    $("#encuestaejecutivo").html(clase.props.plantilla_respuesta_fail);
                });
            } catch (e) {
                console.log("Exception get Encuesta:" + e);
                $("#loaeje #spinnerVisita").hide();
                $("#encuestatotal").html(clase.props.plantilla_respuesta_fail);
                $("#encuestainstalador").html(clase.props.plantilla_respuesta_fail);
                $("#encuestaejecutivo").html(clase.props.plantilla_respuesta_fail);
            }
        }
    }, {
        key: "guardarEncuesta",
        value: function guardarEncuesta() {
            console.log("Guardar Encuesta");
            try {
                var clase = this;
                var url = CONSTANTES.endpoints.saveEncuesta;

                var arrayrespuestas = clase.props.arrayrespuestas;
                var recogerot = localStorage.getItem("idot");

                var cabeceraMC = new Headers();
                cabeceraMC.append("Content-type", "application/json;charset=utf-8");
                cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

                var strData = { "idOt": recogerot, "lista": arrayrespuestas };
                var secdata = otpyrc2(JSON.stringify(strData));

                var params = { "secdata": secdata };

                //var sendData = clase.getParamsString(params);

                clase.getData(url, params).then(function (response) {
                    console.log(response);
                    try {
                        var data = response;

                        if (data.status === 0) {
                            $.showModal("La encuesta se env&iacute;o <br\/> exitosamente.", "exito");
                        }
                    } catch (e) {
                        console.log("Encuesta guardada");
                    }
                }).catch(function (err) {
                    console.log(err);
                });
            } catch (e) {
                console.log(e);
            }
        }

        /***** Funciones generales Start *****/

    }, {
        key: "getParamsString",
        value: function getParamsString(strData) {
            var data = {
                "headers": {
                    "X-Forwarded-For": "187.188.25.218",
                    "totalplay": this.ch.obtenerCookieWeb() // obtenerCookieWeb('Y29va2lldHAyMDE5')
                },
                "method": "POST",
                "body": strData
            };

            return data;
        }
    }, {
        key: "getData",
        value: function getData(url, params) {
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb()); //obtenerCookieWeb('Y29va2lldHAyMDE5'));

            return new Promise(function (resolve, reject) {
                fetch(url, {
                    method: "POST",
                    body: JSON.stringify(params),
                    headers: cabeceraMC
                }).then(function (data) {
                    if (data.ok) {
                        return data.json();
                    } else {
                        throw "Error en la llamada Ajax Fetch " + url;
                    }
                }).then(function (respuesta) {
                    resolve(respuesta);
                }).catch(function (err) {
                    console.log("err=>" + url + "/" + err);
                    reject(Error(err));
                });
            });
        }
    }, {
        key: "addScript",
        value: function addScript() {
            $.addScript = function (url, callback) {
                var script = document.createElement('script');
                if (callback) script.onload = callback;
                script.type = 'text/javascript';
                script.src = url;
                document.body.appendChild(script);
            };
        }
    }, {
        key: "loadMapsAPI",
        value: function loadMapsAPI() {
            this.addScript();

            $.addScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyCQRUUriBBogazg3Izb2IbR1z-Mf4wvl7A&components=country:mx&libraries=geometry');
        }
    }, {
        key: "myMap",
        value: function myMap() {
            $.myMap = function (arrayubicaciones) {
                var map;
                //$("#mapa").html(spinner_html);
                var ubicax = arrayubicaciones[0];
                var ubicay = arrayubicaciones[1];

                var mapProp = {
                    center: new google.maps.LatLng(ubicax[0], ubicax[1]),
                    zoom: 10,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    mapTypeControl: false,
                    zoomControl: false,
                    /*zoomControlOptions: {
                        position: google.maps.ControlPosition.TOP_RIGHT
                    },*/
                    gestureHandling: 'none',
                    scaleControl: false,
                    streetViewControl: false,
                    fullscreenControl: false
                };
                map = new google.maps.Map(document.getElementById("mapa"), mapProp);

                function makeMarker(position, icon, title, mapita) {
                    new google.maps.Marker({
                        position: position,
                        map: mapita,
                        icon: icon,
                        title: title
                    });
                }

                var origenICO = "https://www.mitotalplay.com.mx/mi_instalacion/assets/img/tecnicoMapa.png";
                var destinoICO = "https://www.mitotalplay.com.mx/mi_instalacion/assets/img/casita2.png";

                var icons = {
                    start: new google.maps.MarkerImage(origenICO),
                    end: new google.maps.MarkerImage(destinoICO)
                };

                var directionsService = new google.maps.DirectionsService();
                var directionsDisplay = new google.maps.DirectionsRenderer();
                directionsDisplay.setMap(map);

                directionsService.route({
                    origin: { lat: ubicax[0], lng: ubicax[1] },
                    destination: { lat: ubicay[0], lng: ubicay[1] },
                    travelMode: 'DRIVING'
                }, function (response, status) {
                    if (status === 'OK') {
                        new google.maps.DirectionsRenderer({
                            map: map,
                            directions: response,
                            suppressMarkers: true
                        });
                        var leg = response.routes[0].legs[0];
                        makeMarker(leg.start_location, icons.start, "title", map);
                        makeMarker(leg.end_location, icons.end, 'title', map);

                        //directionsDisplay.setDirections(response);
                        //alert("Duration:" + leg.duration.text);

                        var result = leg.duration.text;
                        if (result) {
                            $("#durationlbl").html(result);
                        }
                    } else {
                        window.alert('Directions request failed due to ' + status);
                    }
                });
            };
        }
    }, {
        key: "validacaracteres",
        value: function validacaracteres(evt) {
            if (evt.key.match(/[a-z0-9\u00C1\u00E1\u00C9\u00E9\u00CD\u00ED\u00DE\u00F3\u00DA\u00FA\u00DC\u00FC\u00D1\u00F1.,\s]/i) === null) {
                evt.preventDefault();
            }
        }
    }, {
        key: "ir",
        value: function ir() {
            var clase = this;
            $.ir = function (idot) {
                $('#carseg').carousel(1);
                clase.getEstatusOt(idot);
            };
        }
    }, {
        key: "hideAll",
        value: function hideAll() {
            $.hideAll = function () {
                var items = document.getElementById("secc-step");
                var ti = items.childElementCount;

                for (var i = 0; i < ti; i++) {
                    $("#step" + i).removeClass("show1");
                    $("#step" + i).addClass("hide1");
                }
            };
        }
    }, {
        key: "showOption",
        value: function showOption() {
            $.showOption = function (opt) {
                $("#step" + opt).removeClass("hide1");
                $("#step" + opt).addClass("show1");
            };
        }
    }, {
        key: "recordarMasTarde",
        value: function recordarMasTarde() {
            $("#btnrecordarmastarde").click(function () {
                $('#carseg').carousel(0);
            });
        }
    }, {
        key: "btnEncuesta",
        value: function btnEncuesta() {
            var clase = this;
            $("#btnencuesta").click(function () {
                $('#carseg').carousel(2);
                clase.getEncuesta();
            });
        }
    }, {
        key: "irEncuesta",
        value: function irEncuesta() {
            var clase = this;
            $.irencuesta = function (idot) {
                localStorage.setItem("idot", idot);
                $('#carseg').carousel(2);
                clase.getEncuesta();
            };
        }
    }, {
        key: "volver",
        value: function volver() {
            $(".volver").click(function () {
                $('#carseg').carousel(0);
            });
        }
    }, {
        key: "btnSiguiente",
        value: function btnSiguiente() {
            var clase = this;
            $("#btnSiguiente").click(function () {
                var arrayrespuestas = clase.props.arrayrespuestas;
                var arrayencuesta = clase.props.arrayencuesta;

                var cuantaspreguntas = $("#encuestaejecutivo #pregunta").length;
                var cuantasrespuestas = $("#encuestaejecutivo .activo").length;
                if (cuantaspreguntas === cuantasrespuestas) {
                    $("#encuestaejecutivo .activo").each(function (index) {
                        var arrayx = this.id.split("_");
                        arrayencuesta.forEach(function (elem) {
                            if (elem.idPregunta == arrayx[1]) {
                                var comenta = $("#comentarios" + arrayx[1]).find("textarea").val();
                                var respuesta = { idPregunta: elem.idPregunta, Pregunta: elem.pregunta, idRespuesta: arrayx[0], Observaciones: comenta, tipo: elem.tipo };
                                arrayrespuestas.push(respuesta);
                            }
                        });
                    });
                    clase.props.arrayrespuestas = arrayrespuestas;
                    console.log(arrayrespuestas);
                    $('#carseg').carousel(3);
                } else {
                    $.showModal("Verifique que ha respondido todas las preguntas.", "error");
                }
            });
        }
    }, {
        key: "btnSiguiente2",
        value: function btnSiguiente2() {
            var clase = this;
            $("#btnSiguiente2").click(function () {
                var arrayrespuestas = clase.props.arrayrespuestas;
                var arrayencuesta = clase.props.arrayencuesta;

                var cuantaspreguntas = $("#encuestainstalador #pregunta").length;
                var cuantasrespuestas = $("#encuestainstalador .activo").length;
                if (cuantaspreguntas === cuantasrespuestas) {
                    $("#encuestainstalador .activo").each(function (index) {
                        var arrayx = this.id.split("_");
                        arrayencuesta.forEach(function (elem) {
                            if (elem.idPregunta == arrayx[1]) {
                                var comenta = $("#comentarios" + arrayx[1]).find("textarea").val();
                                var respuesta = { idPregunta: elem.idPregunta, Pregunta: elem.pregunta, idRespuesta: arrayx[0], Observaciones: comenta, tipo: elem.tipo };
                                arrayrespuestas.push(respuesta);
                            }
                        });
                    });
                    console.log(arrayrespuestas);
                    clase.props.arrayrespuestas = arrayrespuestas;
                    $('#carseg').carousel(4);
                } else {
                    $.showModal("Verifique que ha respondido todas las preguntas.", "error");
                }
            });
        }
    }, {
        key: "btnEnviarEnc",
        value: function btnEnviarEnc() {
            var clase = this;
            $('#btnEnviarEnc').on('click', function () {
                var arrayrespuestas = clase.props.arrayrespuestas;
                var arrayencuesta = clase.props.arrayencuesta;

                var cuantaspreguntas = $("#encuestatotal #pregunta").length;
                var cuantasrespuestas = $("#encuestatotal .activo").length;
                if (cuantaspreguntas == cuantasrespuestas) {
                    $("#loaderseguimiento").show();
                    $("#encuestatotal .activo").each(function (index) {
                        var arrayx = this.id.split("_");
                        arrayencuesta.forEach(function (elem) {
                            if (elem.idPregunta == arrayx[1]) {
                                var comenta = $("#comentarios" + arrayx[1]).find("textarea").val();
                                var respuesta = { idPregunta: elem.idPregunta, Pregunta: elem.pregunta, idRespuesta: arrayx[0], Observaciones: comenta, tipo: elem.tipo };
                                arrayrespuestas.push(respuesta);
                            }
                        });
                    });
                    console.log(arrayrespuestas);
                    clase.props.arrayrespuestas = arrayrespuestas;
                    console.log("Guardar encuesta");
                    //guardaencuesta();
                    clase.guardarEncuesta();
                } else {
                    $.showModal("Verifique que ha respondido todas las preguntas.", "error");
                }
            });
        }
    }, {
        key: "showModal",
        value: function showModal() {
            $.showModal = function (msg, tipo) {
                $("#modalrespuesta #msjrespuesta").html(msg);
                var otra = "";
                if (tipo == "exito") {
                    otra = "error";
                }
                if (tipo == "error") {
                    otra = "exito";
                }
                $('#iconrespuesta').removeClass(otra);
                $("#iconrespuesta").addClass(tipo);
                $("#modalrespuesta").modal("show");
            };
        }
    }, {
        key: "hideModal",
        value: function hideModal() {
            $.hideModal = function (idModal) {
                $("#" + idModal).modal("hide");
            };
        }
    }, {
        key: "showModalGeneric",
        value: function showModalGeneric() {
            $.showModalGeneric = function (idModal) {
                $("#" + idModal).modal("show");
            };
        }
    }, {
        key: "aceptaRespuesta",
        value: function aceptaRespuesta() {
            $("#aceptarespuesta").on("click", function () {
                $('#modalrespuesta').modal('hide');
            });
        }
        /***** Funciones generales Start *****/

    }]);

    return Visita;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49,"../../utils/ModalMng":50}],41:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CambioPass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _ModalMng = require("../../utils/ModalMng");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CambioPass = exports.CambioPass = function () {
    function CambioPass() {
        _classCallCheck(this, CambioPass);

        this.ch = new _CookieHelper.CookieHelper();
        this.init();
    }

    _createClass(CambioPass, [{
        key: "init",
        value: function init() {

            var apuntadorClase = this;
            var modalManager = new _ModalMng.ModalMng();
            modalManager.createModal(CONSTANTES.modals.recomendados).then(function (status) {
                //confirmacion creacion del Primer modal
                return modalManager.createModal(CONSTANTES.modals.seguridad);
            }).then(function () {
                apuntadorClase.setListeners();
            }).catch(function (err) {
                console.error("el error es" + err);
            });
        }
    }, {
        key: "setListeners",
        value: function setListeners() {

            var apuntador = this;
            var datal = localStorage.getItem("dashboardData");
            datal = JSON.parse(datal);
            $('#divPassword').hide();

            $(".enviar1").hide();
            $(".enviarbody1").hide();
            $(".celularEnviar").html("** ** ** *" + datal.bean.celular.substr(7));
            $(".mailSend").html("*******" + datal.bean.correo.substr(-13));
            $(".infoenviar").html("** ** ** *" + datal.bean.celular.substr(7));

            $("#codigoU4").on("keyup", function () {
                var valor = $("#codigoU1").val() + $("#codigoU2").val() + $("#codigoU3").val() + $("#codigoU4").val();

                if (valor != "" && valor.length == 4) {
                    apuntador.confirmartoken(valor);
                }
            });

            $('.visibility').click(function () {
                var cambio = $('#log-pass-new')[0];
                if (cambio.type == "password") {
                    cambio.type = "text";
                    $('.iconEyeBlue').removeClass('fa fa-eye-slash').addClass('fa fa-eye');
                } else {
                    cambio.type = "password";
                    $('.iconEyeBlue').removeClass('fa fa-eye').addClass('fa fa-eye-slash');
                }
            });

            $('#cambiaPass').on("click", function () {
                apuntador.sendToken("C");
            });

            $('#okRedirect').on("click", function () {
                location.reload();
            });

            $('#actualizarbutton').on("click", function () {
                var psw = $("#log-pass-new").val();
                apuntador.actualizarPassword(psw);
            });

            $('.buttonNext').on("click", function () {
                if ($('input:radio[name=selectOption]:checked').val() == 1) {
                    apuntador.sendToken("E");
                } else {
                    apuntador.sendToken("C");
                }
                $(".enviar1").hide();
                $(".enviarbody1").hide();

                $(".verificar1").show();
                $(".verificarbody1").show();
            });

            $("#passnew").keydown(function () {
                var passnew = $(this).val();
                var score = 0;
                if (passnew.length > 8) score++;
                if (passnew.match(/[a-z]/) && passnew.match(/[A-Z]/)) score++;
                if (passnew.match(/\d+/)) score++;
                if (passnew.match(/[0-9]/)) score++;
                if (passnew.match(/.-,.,$,\@]/)) score++;
                if (passnew.length > 8) score++;
                if (passnew.length < 4) score = 0;
                var nivel = 'baja';
                if (score < 2) {
                    nivel = 'baja';
                } else {
                    if (score < 5) nivel = 'media';
                    if (score > 4) nivel = 'alta';
                }
                $("#nivel").removeClass().addClass("progress-bar " + nivel);
                $("#niveltxt").html(nivel);
            });

            $(".close").on("click", function () {
                apuntador.limpiardatos();
            });

            $(".iconoleftreturn").on("click", function () {
                $('#divPassword').hide();
                $('#divSeguridad').show();
            });

            document.getElementById("passconf").addEventListener('keyup', function (e) {
                //console.log('keyup');
                var passnew = document.getElementById("passnew").value;
                var passconf = document.getElementById("passconf").value;

                if (passnew.length > 3) {
                    if (passnew == passconf) {
                        $("#errorconf").html("");
                    } else {
                        $("#errorconf").html("La contrase&ntilde;a no coincide");
                    }
                }
            });

            document.getElementById("log-pass-new").addEventListener('keyup', function (e) {
                var pass = document.getElementById("log-pass-new").value;
                var validMayuscula = false;
                var validEspecial = false;
                var validLongitud = false;
                var mayusculas = "ABCDEFGHIJKLMNÑOPQRSTUVWXYZ";
                var especiales = "!#$%/+-_<>@|.€÷^*";

                console.log(pass);
                if (pass.length >= 8) {
                    $(".validation1").addClass("text-success");
                    $(".iconsuccess1").addClass("iconsuccessActive");
                    validLongitud = true;
                } else {
                    $(".validation1").removeClass("text-success");
                    $(".iconsuccess1").removeClass("iconsuccessActive");
                }

                for (var index = 0; index < mayusculas.length; index++) {
                    for (var i = 0; i < pass.length; i++) {
                        if (mayusculas[index].includes(pass[i])) {
                            validMayuscula = true;
                        }
                    }
                }

                for (var _index = 0; _index < especiales.length; _index++) {
                    for (var _i = 0; _i < pass.length; _i++) {
                        if (especiales[_index].includes(pass[_i])) {
                            validEspecial = true;
                        }
                    }
                }

                if (validMayuscula) {
                    $(".validation2").addClass("text-success");
                    $(".iconsuccess2").addClass("iconsuccessActive");
                } else {
                    $(".validation2").removeClass("text-success");
                    $(".iconsuccess2").removeClass("iconsuccessActive");
                }

                if (validEspecial) {
                    $(".validation3").addClass("text-success");
                    $(".iconsuccess3").addClass("iconsuccessActive");
                } else {
                    $(".validation3").removeClass("text-success");
                    $(".iconsuccess3").removeClass("iconsuccessActive");
                }

                if (validMayuscula && validEspecial && validLongitud) {
                    $('#actualizarbutton').prop('disabled', false);
                } else {
                    $('#actualizarbutton').prop('disabled', true);
                }
            });
            document.getElementById('btnAceptar').onclick = function () {

                $("#erroraviso").html("");
                $("#errorpass").html("");
                $("#errorconf").html("");

                if (apuntador.validacampos()) {
                    $('#modalLoad').modal({ backdrop: 'static', keyboard: false });
                    $('#modalLoad').modal('show');
                    $('#modalcambiacontrasenia').modal('hide');
                    var newpass = document.getElementById("passnew").value;
                    var cadenaenc = otpyrc2(newpass);
                    apuntador.loadDataUpdatePass({ "strEnco": cadenaenc });
                }
            };

            $("#passconf").keydown(function () {
                var newpass = $("#passnew").val();
                console.log("pas");
                if (newpass != "") {
                    document.querySelector('#btnAceptar').disabled = false;
                }
            });

            document.getElementById('otrasFormasEnvio').onclick = function () {
                $(".enviar1").show();
                $(".enviarbody1").show();

                $(".verificar1").hide();
                $(".verificarbody1").hide();
            };

            $('.divRadio').on("click", function () {
                $(".divRadio").removeClass("divRadioActive");
                $(this).addClass("divRadioActive");
                $(this).find("input").prop('checked', true);
            });
        }
    }, {
        key: "validacampos",
        value: function validacampos() {
            var bandera2 = true;
            if ($("#passnew").val() == "") {
                $("#errorpass").html("*La contrase&ntilde;a es requerida");
                bandera2 = false;
                return false;
            }
            if ($("#passconf").val() == "") {
                $("#errorconf").html("*La confirmaci&oacute;n de la contrase&ntilde;a es requerida");
                bandera2 = false;
                return false;
            }

            if ($("#passnew").val().length < 8) {
                $("#errorpass").html("Contrase&ntilde;a incorrecta");
                bandera2 = false;
                return false;
            }

            if ($("#passnew").val().match(/[\‘,\’,\‚,\“,\”,\„,\†,\‡,\‰,\‹,\›,\?,\',\",\™,\!,\“,\#,\%,\&,\‘,\(,\),\*,\+,\,,\/,\:,\;,\<,\=,\>,\?,\[,\\,\],\],\_,\`,\{,\|,\},\~,\–,\—,\¡,\¢,\£,\¤,\¥,\¦,\§,\¨,\©,\ª,\«,\¬,\­,\®,\¯,\°,\±,\²,\³,\´,\µ,\¶,\·,\¸,\¹,\º,\»,\¼,\½,\¾,\¿,\À,\Á,\Â,\Ã,\Ä,\Å,\Æ,\Ç,\È,\É,\Ê,\Ë,\Ì,\Í,\Î,\Ï,\Ð,\Ñ,\Ò,\Ó,\Ô,\Õ,\Ö,\×,\Ø,\Ù,\Ú,\Û,\Ü,\Ý,\Þ,\ß,\à,\á,\â,\ã,\ä,\å,\æ,\ç,\è,\é,\ê,\ë,\ì,\í,\î,\ï,\ð,\ñ,\ò,\ó,\ô,\õ,\ö,\÷,\ø,\ù,\ú,\û,\ü,\ý,\þ,\ÿ]/)) {
                $("#errorpass").html("La contrase&ntilde;a tiene caracteres no autorizados");
                bandera2 = false;
                return false;
            }
            if ($("#passnew").val() != $("#passconf").val()) {
                $("#errorconf").html("La contrase&ntilde;a no coincide");
                bandera2 = false;

                return false;
            }

            return bandera2;
        }
    }, {
        key: "limpiardatos",
        value: function limpiardatos() {
            $("#passnew").val("");
            $("#passconf").val("");
            $("#passequ").html("");
            $("#nivel").removeClass().addClass("progress-bar");
            $("#niveltxt").html("");
            $("#errorpass").html("");
            $("#erroraviso").html("");
            $("#errorconf").html("");
            $("#errorenvio").html("");
        }
    }, {
        key: "sendToken",
        value: function sendToken(type) {
            var apuntador = this;

            $('#modalLoad').modal('show');

            var datal = localStorage.getItem("dashboardData");
            datal = JSON.parse(datal);
            var typeParams = "";
            if (type == "C") {
                typeParams = "S";
                $(".infoenviar").html("** ** ** *" + datal.bean.celular.substr(7));
            } else {
                typeParams = "C";
                $(".infoenviar").html("*******" + datal.bean.correo.substr(-13));
            }

            var url = CONSTANTES.endpoints.dobleautenticacion;

            var objeto = { proceso: '1', type: typeParams, codapp: 'TPR_MC_002' };

            console.log("Info a enviar token: " + JSON.stringify(objeto));
            var informacionEncriptada = cifraTP(JSON.stringify(objeto));
            var informacion = {
                "secdata": informacionEncriptada
            };

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            $("#codigoU1").val("");$("#codigoU2").val("");$("#codigoU3").val("");$("#codigoU4").val("");

            fetch(url, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                $("#modalLoad").modal('hide');
                console.log("Respuesta envio token: ", respuesta);
                if (respuesta.codigo == 0) {
                    $('#addonSmsCode').modal({ backdrop: 'static', keyboard: false });
                } else {
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                    $('#modalrespuesta').modal('show');
                }
            }).catch(function (err) {
                console.error(err);
                $("#modalLoad").modal("hide");

                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "ojito",
        value: function ojito() {
            $("#iconEye").on("click", function () {
                if ($("#log-pass").attr("type") == "text") {
                    $("#iconEye").removeClass("clicked");
                    $("#log-pass-new").attr("type", "password");
                } else if ($("#log-pass-new").attr("type") == "password") {
                    $("#log-pass").attr("type", "text");
                    $("#iconEye").addClass("clicked");
                }
            });

            var tooltip = document.querySelector('#tooltip-index');

            document.querySelector('.ico-question').addEventListener('click', function () {
                if (tooltip.classList.contains('visible')) {
                    tooltip.classList.remove('visible');
                } else {
                    tooltip.classList.add('visible');
                    setTimeout(function () {
                        tooltip.classList.remove('visible');
                    }, 6000);
                }
            });
        }
    }, {
        key: "loadDataUpdatePass",
        value: function loadDataUpdatePass(params) {
            var apuntador = this;
            var urlser = CONSTANTES.endpoints.changepass;
            var data = null;
            var formdata = undefined;
            if (params != undefined) {
                if (params.data != undefined) {
                    formdata = new URLSearchParams();

                    Object.keys(params.data).forEach(function (key) {
                        formdata.append(key, params.data[key]);
                    });
                }
            }
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(urlser, {
                method: 'POST',
                body: JSON.stringify(params),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0) {
                        $('#modalLoad').modal('hide');
                        apuntador.limpiardatos();

                        $("#msjTitle").html("\xC9xito");
                        $("#msjrespuesta").html("Tu contrase&ntilde;a se actualizo exitosamente");
                        $('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
                        $('#aceptarespuesta').html('Aceptar');
                        $('#modalrespuesta').modal('show');
                    } else {
                        $('#modalLoad').modal('hide');
                        //console.log("Intenta nuevamente");
                        //$("#errorenvio").html("Hubo un error al cambiar la contrase&ntilde;a.</br> Por favor, intente m&aacute;s tarde.");
                        //$('#modalcambiacontrasenia').modal('show');

                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');

                        throw "no data avaliable";
                    }
                } catch (e) {
                    console.error(e);
                    $('#modalLoad').modal('hide');
                    //$("#errorenvio").html("Hubo un error al cambiar la contrase&ntilde;a.</br> Por favor, intente m&aacute;s tarde.");
                    //$('#modalcambiacontrasenia').modal('show');


                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                console.error("err=>" + err);
                $('#modalLoad').modal('hide');

                //$("#errorenvio").html("Ocurri&oacute; un error. </br> Por favor, intente m&aacute; tarde.");
                //$('#modalcambiacontrasenia').modal('show');

                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }, {
        key: "confirmartoken",
        value: function confirmartoken(token) {
            $('#modalLoad').modal('show');
            var apuntador = this;

            var objeto = { proceso: '2', code: token, codapp: 'TPR_MC_002' };
            console.log("Info a enviar token: " + JSON.stringify(objeto));
            var informacionEncriptada = cifraTP(JSON.stringify(objeto));
            var informacion = {
                "secdata": informacionEncriptada
            };

            var url = CONSTANTES.endpoints.dobleautenticacion;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                $("#modalLoad").modal('hide');
                console.log("Respuesta envio token: ", respuesta);
                if (respuesta.status == 0) {
                    $('#modalLoad').modal('hide');
                    $('#addonSmsCode').modal('hide');
                    $('#divPassword').show();
                    $('#divSeguridad').hide();
                } else if (respuesta.status == -1) {
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html('El código ingresado no es correcto, intenta nuevamente');
                    $('#modalrespuesta').modal('show');
                } else if (respuesta.status == -2) {
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html('El código ingresado ha caducado');
                    $('#modalrespuesta').modal('show');
                } else if (respuesta.status == -3) {
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html('El código ingresado ha sido utilizado anteriormente');
                    $('#modalrespuesta').modal('show');
                } else {
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                    $('#modalrespuesta').modal('show');
                }
            }).catch(function (err) {
                console.error(err);
                $("#modalLoad").modal("hide");

                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });

            // $('#modalLoad').modal('show');
            // var urlReset =  CONSTANTES.endpoints.enviarValidarToken;

            // var cabeceraMC = new Headers();
            // cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            // cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            // var params = {
            //     "proceso":"1",
            //     "code" : token
            // } 
            // var cadenc = otpyrc2(JSON.stringify(params));
            // var objsen = { "secdata": cadenc };

            //     fetch(urlReset, {
            //         method: 'POST',
            //         body: JSON.stringify(objsen),
            //         headers: cabeceraMC
            //     }).then((data) => {
            //         if (data.ok) {
            //             return data.json()
            //         } else {
            //             throw "Error en la llamada Ajax load sin parametros";
            //         }
            //     }).then((respuesta) => {
            //         try {
            //             if (respuesta.estatus == 0) {
            //                 $('#modalLoad').modal('hide');
            //                 $('#addonSmsCode').modal('hide');
            //                 $('#divPassword').show();
            //                 $('#divSeguridad').hide();
            //             } else {
            //                 $('#modalLoad').modal('hide');
            //                 $("#msjTitle").html("Atenci&oacute;n");
            //                 $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
            //                 $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
            //                 $('#modalrespuesta').modal('show');
            //                 throw "no data avaliable"
            //             }
            //         } catch (e) {
            //             console.error(e);
            //             $('#modalLoad').modal('hide');
            //             $("#msjTitle").html("Atenci&oacute;n");
            //             $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
            //             $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
            //             $('#modalrespuesta').modal('show');
            //             throw "Error al traer la informacion";
            //         }

            //     }).catch((err) => {
            //         console.error("err=>" + err);
            //         $('#modalLoad').modal('hide');
            //         $("#msjTitle").html("Atenci&oacute;n");
            //         $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
            //         $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
            //         $('#modalrespuesta').modal('show');
            //     });                  
        }
    }, {
        key: "actualizarPassword",
        value: function actualizarPassword(pass) {
            var apuntador = this;

            $('#modalLoad').modal('show');
            var urlReset = CONSTANTES.endpoints.actualizarPassword;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var params = {
                "pass": pass
            };

            var cadenc = otpyrc2(JSON.stringify(params));
            var objsen = { "secdata": cadenc };

            fetch(urlReset, {
                method: 'POST',
                body: JSON.stringify(objsen),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                try {
                    if (respuesta.status == 0) {
                        $('#modalLoad').modal('hide');
                        $('#successResetearPassword').modal({ backdrop: 'static', keyboard: false });
                        $('#successResetearPassword').modal('show');
                    } else if (respuesta.status == 5) {
                        $('#modalLoad').modal('hide');
                        $('#infoRepeatPassword').modal({ backdrop: 'static', keyboard: false });
                        $('#infoRepeatPassword').modal('show');
                    } else {
                        $('#modalLoad').modal('hide');
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                        throw "no data avaliable";
                    }
                } catch (e) {
                    console.error(e);
                    $('#modalLoad').modal('hide');
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                console.error("err=>" + err);
                $('#modalLoad').modal('hide');
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }]);

    return CambioPass;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49,"../../utils/ModalMng":50}],42:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tarjetaTp = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var tarjetaTp = exports.tarjetaTp = function () {
    function tarjetaTp() {
        _classCallCheck(this, tarjetaTp);

        this.props = {
            datosBINGT: {},
            banderaBINGT: false,
            datosTarjeta: null,
            datosTarjetaE: null,
            arrayTarjetasExistentes: [],
            tipoPago: 0
        };
        this.ch = new _CookieHelper.CookieHelper();
        this.init();
    }

    _createClass(tarjetaTp, [{
        key: "init",
        value: function init() {

            this.validNip();
            this.modals();
            this.customSelect();
        }
    }, {
        key: "validNip",
        value: function validNip() {
            var apuntador = this;
            var lblinvalid = $('.nipinvalid');
            lblinvalid.hide();
            $('.visibility').click(function () {
                var cambio = $('#txtNip')[0];
                if (cambio.type == "password") {
                    cambio.type = "text";
                    $('.icon').removeClass('fa fa-eye-slash').addClass('fa fa-eye');
                } else {
                    cambio.type = "password";
                    $('.icon').removeClass('fa fa-eye').addClass('fa fa-eye-slash');
                }
            });
            $("#btnNip").click(function () {
                var nip = $('#txtNip').val().trim();
                if (apuntador.validaCampoNip(nip)) apuntador.obtieneNIP(nip);else lblinvalid.show();
            });
        }
    }, {
        key: "obtieneNIP",
        value: function obtieneNIP(nip) {
            var apuntador = this;
            var lblinvalid = $('.nipinvalid');
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var url = CONSTANTES.endpoints.creditoNIP;
            var informacionEncriptada = otpyrc2(JSON.stringify({ "nip": parseInt(nip) }));
            var informacion = JSON.stringify({ "secdata": informacionEncriptada });

            $('#modalLoad').modal('show');
            fetch(url, {
                method: 'POST',
                body: informacion,
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax fetch con parametros " + url;
                }
            }).then(function (respuesta) {

                $('#modalLoad').modal('hide');
                if (respuesta.status == 0) {
                    if (respuesta.bean.validNip == 0) {
                        lblinvalid.hide();
                        $("#contenedorNIP").hide();
                        $("#contenedorTC").show();

                        apuntador.referencias();
                        var fecha = new Date();
                        var periodoActual = fecha.getFullYear() + '-' + (fecha.getMonth() + 1);
                        apuntador.movimientos(periodoActual);
                    } else {
                        lblinvalid.html("*NIP incorrecto, por favor intenta de nuevo");
                        lblinvalid.show();
                    }
                } else {
                    lblinvalid.html("Ocurrió un problema");
                }
            });
        }
    }, {
        key: "referencias",
        value: function referencias() {
            var apuntador = this;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var url = CONSTANTES.endpoints.creditoReferencias;

            fetch(url, {
                method: 'POST',
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax fetch con parametros " + url;
                }
            }).then(function (respuesta) {
                //console.log("referencias: ",respuesta);
                if (respuesta.status == 0) {
                    var hmtltarjetas = "";
                    apuntador.props.arrayTarjetasExistentes = respuesta.bean.tarjetas;
                    respuesta.bean.tarjetas.forEach(function (tar) {
                        hmtltarjetas += "<div class=\"row border-bottom py-4\">\n                    <div class=\"col-1\">\n                        <input type=\"radio\" name=\"existentes\" id=\"" + tar.id + "\">\n                    </div>\n                    <div class=\"col\">\n                        <p class=\"card_name " + tar.aliasprovider.toLowerCase() + "\">" + tar.aliasprovider + " *" + tar.cardnumber + "</p>\n                    </div>\n                </div>";
                    });
                    $("#tajetasCredito").html(hmtltarjetas);

                    if (respuesta.bean.spei != null) $("#spei").html(respuesta.bean.spei);

                    var referhtml = "";
                    respuesta.bean.referencias.forEach(function (refer) {
                        referhtml += "<img src=\"" + refer + "\">";
                    });
                    $("#brands").html(referhtml);

                    apuntador.eventosTarjetas();
                }
            });
        }
    }, {
        key: "eventosTarjetas",
        value: function eventosTarjetas() {
            var apuntador = this;
            var addCardBtn = $('.select_card .add_card'),
                newCardForm = $('.select_card .new_card');

            addCardBtn.on('click', function () {
                $("input:radio[name='existentes']").prop("checked", false);
                apuntador.props.datosTarjetaE = null;
                newCardForm.show(300);
                $(this).hide();
                apuntador.limpiardatostarjeta();
            });

            $('.select_card .cancel').on('click', function () {
                newCardForm.hide(300);
                addCardBtn.show(300);

                apuntador.limpiardatostarjeta();
            });

            $("input:radio[name='existentes']").change(function () {
                newCardForm.hide(300);
                addCardBtn.show(300);
                var valor = this.id;
                apuntador.props.arrayTarjetasExistentes.forEach(function (tar) {
                    if (tar.id == valor) apuntador.props.datosTarjetaE = tar;
                });
            });
        }
    }, {
        key: "movimientos",
        value: function movimientos(periodo) {
            var apuntador = this;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var url = CONSTANTES.endpoints.creditoMovimientos;
            console.log("url: ", url);
            var entrada = JSON.stringify({ "periodo": periodo });
            $('#modalLoad').modal('show');

            fetch(url, {
                method: 'POST',
                body: entrada,
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax fetch con parametros " + url;
                }
            }).then(function (respuesta) {
                $('#modalLoad').modal('hide');
                if (respuesta.status == 0) {
                    var currencyFormat = Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' });
                    $("#cargosM").html(currencyFormat.format(parseFloat(respuesta.bean.cargos).toFixed(2)));
                    $("#abonosM").html(currencyFormat.format(parseFloat(respuesta.bean.abonos).toFixed(2)));
                    $("#fechacorteM").html(respuesta.bean.corte);

                    var htmlmov = "";
                    if (respuesta.bean.movimientos.length > 0) {
                        respuesta.bean.movimientos.forEach(function (mov) {
                            var descp = "Ninguno";
                            if (mov.desc != null && mov.desc != "") descp = mov.desc;
                            var clase = "";
                            if (mov.tipo == "Abono") clase = "green";
                            var montoMov = currencyFormat.format(parseFloat(mov.monto).toFixed(2));
                            htmlmov += "<div class=\"row mov " + clase + "\">\n                                    <div class=\"col-9\">\n                                        <p class=\"concept\"><strong>" + descp + "</strong></p>\n                                        <p class=\"text-gray\">" + mov.fecha + "</p>\n                                    </div>\n                                    <div class=\"col-3 text-right\">\n                                        <strong>" + montoMov + "</strong>\n                                    </div>\n                                </div>";
                        });
                        $("#movimientosCredito").html(htmlmov);
                    } else {
                        $("#movimientosCredito").html('No hay movimientos para consultar en el periodo seleccionado');
                    }

                    //Pinta periodos para consulta de estados de cuenta
                    var htmlPeriodos = '';
                    var meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
                    var fecha = new Date();
                    var periodoActual = fecha.getFullYear() + '-' + meses[fecha.getMonth()];
                    var htmlSelectPeriodos = "<span class=\"label\"  id=\"s-" + periodoActual + "\">Periodo actual</span>";
                    if (respuesta.bean.periodos.length == 0) {
                        $('#errorEdoCta').html('No existen periodos para consultar');
                        $('.btnEnviaEdoCta').hide();
                    } else {
                        respuesta.bean.periodos.forEach(function (periodo) {
                            var fechaFormat = periodo.split('-');
                            htmlPeriodos += " <li class=\"nav-item\">\n                                        <a class=\"nav-link\" id=\"" + periodo + "\"\n                                            data-toggle=\"pill\" href=\"#pills-nov-21\" \n                                            role=\"tab\" aria-controls=\"pills-nov-21\" \n                                            aria-selected=\"true\">" + fechaFormat[1] + " " + fechaFormat[0] + "</a>\n                                    </li>";
                            htmlSelectPeriodos += "<span id=\"s-" + periodo + "\">" + fechaFormat[1] + " " + fechaFormat[0] + "</span>";
                        });
                        $('.navPeriodos').html(htmlPeriodos);
                        $('#selPeriodoMovs').html(htmlSelectPeriodos);
                        $('#lblFiltroMovs').html('Filtrar por');

                        $(".navPeriodos li a").click(function () {
                            var periodoSel = $(this)[0].id.trim();
                            var anioMes = periodoSel.split('-');
                            var mes = meses.indexOf(anioMes[1]) + 1;
                            var anio = parseInt(anioMes[0]);
                            apuntador.obtieneEstadoC(mes, anio);
                        });

                        $("#selPeriodoMovs span").click(function () {
                            var periodoSel = $(this)[0].id.trim();
                            var anioMes = periodoSel.split('-');
                            var mes = meses.indexOf(anioMes[2]) + 1;
                            var perFormat = anioMes[1] + '-' + mes;
                            $('#lblPeriodoMovs').html(anioMes[2] + ' ' + anioMes[1]);
                            console.log("Periodo a consultar: " + perFormat);
                            $('#selPeriodoMovs').removeClass('visible');
                            apuntador.movimientos(perFormat);
                        });

                        $("#selFiltroMovs span").click(function () {
                            console.log($(this)[0].id);
                            var opcionF = $(this)[0].id;
                            htmlmov = "";
                            $("#movimientosCredito").html(htmlmov);
                            var movsFilter = respuesta.bean.movimientos;
                            if (opcionF != 'opTodos') movsFilter = respuesta.bean.movimientos.filter(function (mov) {
                                return mov.tipo == opcionF;
                            });
                            movsFilter.forEach(function (mov) {
                                var descp = "Ninguno";
                                if (mov.desc != null && mov.desc != "") descp = mov.desc;
                                var clase = "";
                                if (mov.tipo == "Abono") clase = "green";
                                var montoMov = currencyFormat.format(parseFloat(mov.monto).toFixed(2));
                                htmlmov += "<div class=\"row mov " + clase + "\">\n                                        <div class=\"col-9\">\n                                            <p class=\"concept\"><strong>" + descp + "</strong></p>\n                                            <p class=\"text-gray\">" + mov.fecha + "</p>\n                                        </div>\n                                        <div class=\"col-3 text-right\">\n                                            <strong>" + montoMov + "</strong>\n                                        </div>\n                                    </div>";
                            });
                            $('#selFiltroMovs').removeClass('visible');
                            $("#movimientosCredito").html(htmlmov);
                        });
                    }
                }
            }).catch(function (error) {});
        }
    }, {
        key: "obtieneEstadoC",
        value: function obtieneEstadoC(mes, anio) {
            var apuntador = this;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());
            var url = CONSTANTES.endpoints.creditoObtenerEstadoCuenta;

            var informacion = JSON.stringify({
                "mes": mes,
                "anio": anio
            });

            //console.log("url: ",url);
            //console.log("Encrip NIP: "+informacionEncriptada);
            //$('#modalLoad').modal('show');

            fetch(url, {
                method: 'POST',
                body: informacion,
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax fetch con parametros " + url;
                }
            }).then(function (respuesta) {
                if (respuesta.status == 0) {
                    $('.visorEstadoCuenta').show();
                    $("#errorEdoCta").html("");

                    $('.visorEstadoCuenta').attr('src', respuesta.bean.urlEstadoCuenta);
                    $('.btnEnviaEdoCta').show();
                    $('.btnEnviaEdoCta').click(function () {
                        apuntador.enviaEdoCtaCorreo(informacion);
                    });
                } else {
                    $('.visorEstadoCuenta').hide();
                    $('#errorEdoCta').html("No hay información que mostrar.");
                    $('.btnEnviaEdoCta').hide();
                }
            }).catch(function (error) {
                $('.visorEstadoCuenta').hide();
                $('#errorEdoCta').html("Ocurrió un problema al consultar estado de cuenta");
                $('.btnEnviaEdoCta').hide();
            });
        }
    }, {
        key: "enviaEdoCtaCorreo",
        value: function enviaEdoCtaCorreo(entrada) {
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var url = CONSTANTES.endpoints.creditoEnviarEstadoCuenta;

            $('#modalLoad').modal('show');
            fetch(url, {
                method: 'POST',
                body: entrada,
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax fetch con parametros " + url;
                }
            }).then(function (respuesta) {
                console.log("Enviar Estado de cuenta : ", respuesta);
                $('#modalLoad').modal('hide');
                if (respuesta.status == 0) {
                    $('#iconrespuesta').html('<i class=" fas  fa-check-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html("Enviado con éxito");
                    $('#modalrespuesta').modal('show');
                } else {
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                    $("#msjrespuesta").html("Ocurrió un error, intente más tarde");
                    $('#modalrespuesta').modal('show');
                }
            });
        }
    }, {
        key: "obtenformatoperiodo",
        value: function obtenformatoperiodo(respuesta) {
            var result = "";
            var date = respuesta;
            var data = date.substr(5);
            var year = date.substr(0, 4);
            var meses = new Array("Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre");
            var i = 0;
            for (var _i = 0; _i < meses.length; _i++) {
                if (meses[_i] == data) {
                    result = year + " - " + (_i + 1);
                }
            }

            return result;
        }
    }, {
        key: "modals",
        value: function modals() {
            var apuntador = this;

            var strAnioActual = new Date().getFullYear().toString().substr(-2);
            var intAnioActual = parseInt(strAnioActual);
            var strOptionSelect = '<option value="">A&ntilde;o</option><option value="' + intAnioActual + '">' + intAnioActual + '</option>';
            for (var i = 1; i <= 10; i++) {
                intAnioActual++;
                strOptionSelect += '<option value="' + intAnioActual + '">' + intAnioActual + '</option>';
            }
            $('#inpAnioVRT').html(strOptionSelect);

            $(document).on('blur', '#inpNumeroTarjetaRT', function () {
                $("#inpNumeroTarjetaRT").removeClass('is-valid');
                $("#inpNumeroTarjetaRT").removeClass('is-invalid');

                var numeroTarjeta = $('#inpNumeroTarjetaRT').val();
                console.log(isNaN(numeroTarjeta));
                if (isNaN(numeroTarjeta)) {
                    $("#inpNumeroTarjetaRT").addClass('is-invalid');
                    $('#vldNumeroTarjetaRT').html('Tu número de tarjeta sólo debe contener dígitos');
                    $('#vldNumeroTarjetaRT').show();
                } else {
                    $('#vldNumeroTarjetaRT').hide();
                    if (numeroTarjeta.length >= 6 && !apuntador.banderaBINGT) {
                        var bin = numeroTarjeta.substring(0, 6);
                        if (numeroTarjeta.length != 16) {
                            $("#inpNumeroTarjetaRT").addClass('is-invalid');
                            $('#vldNumeroTarjetaRT').html('Tu número de tarjeta debe contener 16 dígitos');
                            $('#vldNumeroTarjetaRT').show();
                        } else {
                            $('#vldNumeroTarjetaRT').hide();
                        }
                        var objetoTarjeta = { inicioTarjeta: bin };
                        var informacionEncriptada = otpyrc2(JSON.stringify(objetoTarjeta));
                        var informacion = { "informacionEncriptada": informacionEncriptada };
                        apuntador.loadGetServicioBin(informacion);
                    }
                }
            });

            $("#btnContinuarPCredito").click(function () {
                if (apuntador.props.datosTarjetaE != null) {
                    apuntador.props.tipoPago = 1;
                    var clase = apuntador.props.datosTarjetaE.aliasprovider.toLowerCase();
                    $("#tarjetaPagoE").removeClass("mastercard visa").addClass(clase);
                    $("#tarjetaPagoE").html(apuntador.props.datosTarjetaE.aliasprovider + " *" + apuntador.props.datosTarjetaE.cardnumber);
                    $("#select_card").modal("hide");
                    $("#quantity").modal("show");
                } else {
                    //console.log(`validacion campos ${apuntador.validarCamposRegistroTarjeta()}`);
                    //console.log(`Estatus BEAN ${apuntador.props.banderaBINGT}`);
                    //console.log(" apuntador.props.datosBINGT", apuntador.props.datosBINGT);

                    if (apuntador.validarCamposRegistroTarjeta() && apuntador.props.banderaBINGT) {
                        apuntador.props.tipoPago = 2;

                        apuntador.props.datosTarjeta = {
                            primerNombre: $('#inpNombreRT').val(),
                            segundoNombre: "",
                            numeroTarjeta: $('#inpNumeroTarjetaRT').val(),
                            mesVencimiento: $('#inpMesVRT').val(),
                            anioVencimiento: $('#inpAnioVRT').val(),
                            nombreBanco: apuntador.props.datosBINGT.nombreBanco,
                            idBanco: apuntador.props.datosBINGT.idBanco,
                            proveedorBanco: apuntador.props.datosBINGT.proveedorBanco
                        };

                        var longitud1 = apuntador.props.datosTarjeta.numeroTarjeta.length;
                        var tarjeta = apuntador.props.datosTarjeta.numeroTarjeta.substring(longitud1 - 4, longitud1);

                        var tarjetaparapagar = "<img class=\"w-17\"\n                    alt=\"\" src=\"" + apuntador.getSrcTarjeta(apuntador.props.datosBINGT.proveedorBanco) + "\" > \n                     **** **** **** " + tarjeta;

                        $(".tarjetaPagoE").html(tarjetaparapagar);

                        $("#select_card").modal("hide");
                        $("#quantity").modal("show");
                    }
                }
            });

            $("#btnSiguientePC").click(function () {
                console.log("Se seleccionó monto: ", $('input[name=montoPago]').is(':checked'));
                if ($('input[name=montoPago]').is(':checked')) {
                    $('#vldMontoPagoTC').hide();
                    var valor = $('input[name=montoPago]:checked').val();
                    var montofinal = 0;

                    if (valor == "minimo") {
                        var monto = $(".pagominimo").html().replace("$", "").replace(",", "");
                        montofinal = parseInt(monto);
                    }
                    if (valor == "sinintereses") {
                        var monto = $(".pagonogenerarintereses").html().replace("$", "").replace(",", "");
                        montofinal = parseInt(monto);
                    }
                    if (valor == "total") {
                        var monto = $(".cantSaldoCredito").html().replace("$", "").replace(",", "");
                        montofinal = parseInt(monto);
                    }

                    if (valor == "otra") {
                        montofinal = $("#otracantidad").val();
                    }

                    console.log("validando montofinal", montofinal, "valor", valor);
                    if (montofinal != '' && montofinal != undefined) {
                        if (!isNaN(montofinal)) {
                            if (montofinal > 0) {

                                montofinal = parseFloat(montofinal).toFixed(2);
                                if (apuntador.props.tipoPago == 1) apuntador.props.datosTarjetaE.monto = montofinal;
                                if (apuntador.props.tipoPago == 2) apuntador.props.datosTarjeta.montoPago = montofinal;

                                var montofinalFormato = Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(montofinal);
                                $(".montofinalPC").html(montofinalFormato);
                                $('#quantity').modal('hide');
                                $('#pay_confirm').modal('show');
                            } else {
                                $('#vldMontoPagoTC').html("Monto a pagar debe ser mayor a cero.");
                                $('#vldMontoPagoTC').show();
                            }
                        } else {
                            $('#vldMontoPagoTC').html("Monto a pagar debe ser un valor numérico.");
                            $('#vldMontoPagoTC').show();
                        }
                    } else {
                        $('#vldMontoPagoTC').html("Debe ingresar un monto a pagar.");
                        $('#vldMontoPagoTC').show();
                    }
                } else {
                    $('#vldMontoPagoTC').html("Debe seleccionar una cantidad a pagar.");
                    $('#vldMontoPagoTC').show();
                }
            });

            $('#pagarahoraC').click(function () {
                var valor1 = $("#cvv1").val();
                var valor2 = $("#cvv2").val();
                var valor3 = $("#cvv3").val();
                if (valor1 != "" && valor2 != "" && valor3 != "") {
                    console.log("apuntador.props.tipoPago ", apuntador.props.tipoPago);
                    if (apuntador.props.tipoPago == 1) {
                        apuntador.props.datosTarjetaE.cvv = valor1 + valor2 + valor3;
                        var objetoTarjeta = apuntador.props.datosTarjetaE;
                        console.log("datostarjeta", objetoTarjeta);
                        apuntador.enviarPagoTarjetaExistente(objetoTarjeta);
                    }
                    if (apuntador.props.tipoPago == 2) {
                        apuntador.props.datosTarjeta.cvv = valor1 + valor2 + valor3;
                        var _objetoTarjeta = apuntador.props.datosTarjeta;
                        console.log("datostarjeta", _objetoTarjeta);
                        apuntador.enviarPagoNuevaTarjeta(_objetoTarjeta);
                    }
                    $('#pay_confirm').modal('hide');
                    $('#modalLoad').modal('show');
                } else {
                    console.log("cvv incorrecto");
                }
            });

            $("#id_demo").on('change', function () {
                var tipo = "";
                if ($(this).is(':checked')) {
                    tipo = "bloquear";
                } else {
                    tipo = "desbloquear";
                }

                apuntador.bloquearTarjeta(tipo);
            });

            $('.lista > .row .col:nth-child(2) img').click(function () {
                $('#verEstado').modal('show');
            });

            $('[data-modal]').click(function () {
                var toOpen = '.' + $(this).data('modal'),
                    modals = $('.modal');

                toOpen = modals.filter(toOpen);

                if (toOpen.length) {
                    modals.modal('hide');
                    toOpen.modal('show');
                }
            });

            $('.close_resume').click(function () {
                $('.modal.resume').modal('hide');
            });

            $('.modal .dismiss, .modal .custom_close').click(function () {
                var modal = $(this).closest('.modal');

                modal.modal('hide');
            });
        }
    }, {
        key: "validarCamposRegistroTarjeta",
        value: function validarCamposRegistroTarjeta() {
            var inputCampos = ['inpNombreRT', 'inpNumeroTarjetaRT', 'inpMesVRT', 'inpAnioVRT'];

            var labelValidacion = ['vldNombreRT', 'vldNumeroTarjetaRT', 'vldMesVRT', 'vldAnioVRT'];

            var camposChicos = ['vldMesVRT', 'vldAnioVRT'];
            var validacion = true;
            $.each(inputCampos, function (i, idCampo) {
                var valor = $('#' + idCampo).val().trim();
                if (valor === '') {
                    validacion = false;
                    var texto = 'Loa campos con * son requeridos';
                    if (camposChicos.indexOf(labelValidacion[i]) >= 0) {
                        texto = '* Requerido';
                    }
                    $('#' + labelValidacion[i]).html(texto);
                    $('#' + labelValidacion[i]).show();
                }
            });

            var anioActual = parseInt(new Date().getFullYear().toString().substr(-2));
            var mesActual = parseInt(new Date().getMonth());

            if (parseInt($('#inpAnioVRT').val()) == parseInt(anioActual)) {
                if (parseInt($('#inpMesVRT').val()) < parseInt(mesActual)) {
                    $('#vldMesVRT').html('Invalido');
                    $('#vldMesVRT').show();
                    validacion = false;
                }
            }

            return validacion;
        }
    }, {
        key: "limpiardatostarjeta",
        value: function limpiardatostarjeta() {
            $('#inpNombreRT').val("");
            $('#inpNumeroTarjetaRT').val("");

            $('#inpMesVRT').val("");
            $('#inpAnioVRT').val("");

            $('#vldNumeroTarjetaRT').html("");

            $('#vldMontoPagoTC').html("");
            $("#otracantidad").val("");

            $("#cvv1").val("");
            $("#cvv2").val("");
            $("#cvv3").val("");

            var apuntador = this;
            apuntador.props.datosBINGT = {};
            apuntador.props.banderaBINGT = false;
            apuntador.props.datosTarjeta = null;
            apuntador.props.datosTarjetaE = null;
            apuntador.props.tipoPago = 0;
        }
    }, {
        key: "loadGetServicioBin",
        value: function loadGetServicioBin(params) {

            var apuntador = this;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            var URL2LOAD = CONSTANTES.endpoints.getserviciobin;

            fetch(URL2LOAD, {
                method: 'POST',
                body: JSON.stringify(params),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax fetch con parametros " + URL2LOAD;
                }
            }).then(function (respuesta) {
                console.log("respuesta", respuesta);
                if (respuesta.status == 0) {
                    if (respuesta.bean.bin != null && respuesta.bean.bin.idBanco != "") {
                        console.log("tipo", respuesta.bean.bin.tipoTarjeta.toUpperCase());
                        if (respuesta.bean.bin.tipoTarjeta.toUpperCase().includes("DEBITO")) {
                            apuntador.props.banderaBINGT = true;
                            $('#inpNumeroTarjetaRT').addClass('is-valid');
                            apuntador.props.datosBINGT.nombreBanco = respuesta.bean.bin.nombreBanco;
                            apuntador.props.datosBINGT.idBanco = respuesta.bean.bin.idMarca;
                            apuntador.props.datosBINGT.proveedorBanco = respuesta.bean.bin.nombreMarca;
                            apuntador.props.datosBINGT.cargosAutomaticos = respuesta.bean.bin.cargosAutomaticos;
                        } else {
                            console.log("no es tarjeta debito");
                            $('#inpNumeroTarjetaRT').addClass('is-invalid');
                            $('#vldNumeroTarjetaRT').html('Solo tarjetas debito');
                            $('#vldNumeroTarjetaRT').show();
                            apuntador.props.banderaBINGT = false;
                        }
                    } else {
                        $('#inpNumeroTarjetaRT').addClass('is-invalid');
                        $('#vldNumeroTarjetaRT').html('Valida tu n&uacute;mero de tarjeta');
                        $('#vldNumeroTarjetaRT').show();

                        apuntador.props.banderaBINGT = false;
                    }
                } else {
                    $('#inpNumeroTarjetaRT').addClass('is-invalid');
                    $('#vldNumeroTarjetaRT').html('Valida tu n&uacute;mero de tarjeta');
                    $('#vldNumeroTarjetaRT').show();
                    apuntador.props.banderaBINGT = false;
                }
            }).catch(function (err) {
                console.log("err", err);

                apuntador.props.banderaBINGT = false;
                $('#inpNumeroTarjetaRT').addClass('is-invalid');
                $('#vldNumeroTarjetaRT').html('Valida tu n&uacute;mero de tarjeta');
                $('#vldNumeroTarjetaRT').show();
            }); //fin fetch

        }
    }, {
        key: "getSrcTarjeta",
        value: function getSrcTarjeta(proveedor) {
            var iconoTarjeta = "";

            if (proveedor == "VISA") {
                iconoTarjeta = "assets/images/icons/visa.svg";
            }
            if (proveedor == "MASTERCARD") {
                iconoTarjeta = "assets/images/icons/mastercard.svg";
            }
            if (proveedor == "AMEX") {
                iconoTarjeta = "assets/images/icons/amex.svg";
            }

            return iconoTarjeta;
        }
    }, {
        key: "enviarPagoNuevaTarjeta",
        value: function enviarPagoNuevaTarjeta(objetoTarjeta) {

            console.log("VAMOS A PAGAR ....objeto nueva tarjeta --- ", objetoTarjeta);
            var informacionEncriptada = otpyrc2(JSON.stringify(objetoTarjeta));
            var informacion = { "secdata": informacionEncriptada };

            var urlser = CONSTANTES.endpoints.creditoPago;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(urlser, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                console.log(respuesta);
                try {

                    $('#modalLoad').modal('hide');

                    if (respuesta.codigo == 0) {

                        if (respuesta.bean != undefined && respuesta.bean !== null && respuesta.bean !== '') {

                            $("#msjTitle").html("\xC9xito");
                            $("#msjrespuesta").html('Tu pago ha sido aprobado.' + '<p>C&oacute;digo de autorizaci&oacute;n:' + '<br><strong class="">' + respuesta.bean + '</strong></p>');
                            $('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
                            $('#modalrespuesta').modal('show');
                        }
                    } else {
                        $('#modalLoad').modal('hide');
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                    }
                } catch (e) {
                    $('#modalLoad').modal('hide');
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    console.error(e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                $('#modalLoad').modal('hide');
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
                console.log("err=>", err);
            }).finally(function () {
                apuntador.limpiardatostarjeta();
            });
        }
    }, {
        key: "enviarPagoTarjetaExistente",
        value: function enviarPagoTarjetaExistente(objetoTarjeta) {

            console.log("VAMOS A PAGAR ....objeto tarjeta existente --- ", objetoTarjeta);
            var informacionEncriptada = otpyrc2(JSON.stringify(objetoTarjeta));
            var informacion = { "secdata": informacionEncriptada };

            var urlser = CONSTANTES.endpoints.creditoPagoTE;
            console.log(urlser);

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(urlser, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                console.log(respuesta);
                try {

                    $('#modalLoad').modal('hide');

                    if (respuesta.codigo == 0) {

                        if (respuesta.bean != undefined && respuesta.bean !== null && respuesta.bean !== '') {

                            $("#msjTitle").html("\xC9xito");
                            $("#msjrespuesta").html('Tu pago ha sido aprobado.' + '<p>C&oacute;digo de autorizaci&oacute;n:' + '<br><strong class="">' + respuesta.bean + '</strong></p>');
                            $('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
                            $('#modalrespuesta').modal('show');
                        }
                    } else {
                        $('#modalLoad').modal('hide');
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                    }
                } catch (e) {
                    $('#modalLoad').modal('hide');
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                    console.error(e);
                    throw "Error al traer la informacion";
                }
            }).catch(function (err) {
                $('#modalLoad').modal('hide');
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');

                console.log("Informacion no Disponible");
                console.log("err=>", err);
            }).finally(function () {
                apuntador.limpiardatostarjeta();
            });
        }
    }, {
        key: "bloquearTarjeta",
        value: function bloquearTarjeta(tipo) {

            var urlser = CONSTANTES.endpoints.creditoBloqueoTarjeta;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(urlser, {
                method: "POST",
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                console.log("resouesta ..", respuesta);
            }).catch(function (error) {});
        }
    }, {
        key: "customSelect",
        value: function customSelect() {
            var select = $('#movements .custom_select'),
                options = select.next('.options'),
                list = options.children();

            select.click(function (e) {
                $(this).removeClass('current');
                $(this).next('.options').addClass('visible');
                e.stopPropagation();
            });

            $(options, options.find('*')).click(function (e) {
                e.stopPropagation();
            });

            list.filter('.label').click(function (e) {
                $(this).toggleClass('up');
                select.toggleClass('up');

                console.log("aca -----");
            });

            list.filter(':not(.label)').click(function (e) {
                var caption = $(this).text(),
                    disSel = $(this).parent().siblings('.custom_select'),
                    disLab = $(this).siblings('.label');

                disSel.text(caption).addClass('current');
                disLab.filter('.label').text(caption);
            });

            $(window).click(function () {
                var isVisible = options.hasClass('visible');

                if (isVisible) {
                    options.removeClass('visible');
                }
            });
        }
    }, {
        key: "validaCampoNip",
        value: function validaCampoNip(nip) {
            var lblinvalid = $('.nipinvalid');
            var isValid;
            var mensaje = '';
            if (nip.length != 0) {
                isValid = true;
                if (nip.length == 4) {
                    isValid = true;
                    if (!isNaN(nip)) {
                        isValid = true;
                    } else {
                        mensaje = '* NIP debe ser un valor numérico';
                        isValid = false;
                    }
                } else {
                    mensaje = '* NIP debe contener 4 digitos';
                    isValid = false;
                }
            } else {
                mensaje = "* NIP requerido";
                isValid = false;
            }
            lblinvalid.html(mensaje);
            lblinvalid.show();
            return isValid;
        }
    }]);

    return tarjetaTp;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49}],43:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Adicionales = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _ModalMng = require("../../utils/ModalMng");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Adicionales = exports.Adicionales = function () {
    function Adicionales() {
        _classCallCheck(this, Adicionales);

        this.ch = new _CookieHelper.CookieHelper();
        this.props = {
            canales: [],
            equipos: [],
            streamings: [],
            costos: [],
            cantidadFinal: 1

        };
        this.init();
    }

    _createClass(Adicionales, [{
        key: "init",
        value: function init() {
            var apuntador = this;
            //apuntador.obtenerAdicionales();
            apuntador.validarMigracion();
        }
    }, {
        key: "validarMigracion",
        value: function validarMigracion() {
            var apuntador = this;
            var url = CONSTANTES.endpoints.obtenerEstatusMigracion;

            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                console.log("respuesta migracion ....", respuesta);
                var promocionesDineyT = null;

                if (respuesta.status == 0) {
                    promocionesDineyT = respuesta.bean;
                    /*if(respuesta.bean.promocion==0)banderaPromocionDisney=false;
                    if(respuesta.bean.promocion==1)banderaPromocionDisney=true;
                    if(respuesta.bean.migracion==0)banderaMigracionStar=false;
                    if(respuesta.bean.migracion==1)banderaMigracionStar=true;*/
                }

                apuntador.obtenerAdicionales(promocionesDineyT);
            }).catch(function (err) {
                console.error(err);
                apuntador.revisarSegmentacion();
            });
        }
    }, {
        key: "obtenerAdicionales",
        value: function obtenerAdicionales(promocionesDineyT) {
            //let params={promocion:promoDisney, migracion:migracion};
            //console.log("params",params);

            localStorage.removeItem("canales");
            localStorage.removeItem("equipos");
            localStorage.removeItem("streamings");
            localStorage.removeItem("adicionales");
            localStorage.removeItem("costos");
            localStorage.removeItem("tipoProductos");

            var apuntadorClase = this;
            var url = CONSTANTES.endpoints.obteneraddons;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            fetch(url, {
                method: "POST",
                body: JSON.stringify(promocionesDineyT),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                console.log("**************************", respuesta);
                if (respuesta.codigo == 0) {
                    var arrayaddons = respuesta.bean;
                    var htmladdons = "",
                        htmlcanales = "",
                        htmlsteamings = "";
                    arrayaddons.forEach(function (item) {
                        //console.log(item.nombre+"-"+item.tipo);
                        var promocion = "";

                        if (item.detalle != null) {

                            if (item.promocion != undefined && item.promocion != "" && item.promocion != null && item.detalle.promocion != undefined && item.detalle.promocion != null) {
                                promocion = item.detalle.promocion;
                            }

                            if (item.tipo == "Streaming") {
                                if (item.promocion != undefined && item.promocion != "" && item.promocion != null && item.describePromo != undefined && item.describePromo != null) {
                                    promocion = item.describePromo;
                                }
                                htmlsteamings += " <li class=\"streaming\" id=\"" + item.Id + "\">\n                                <div class=\"img\">\n                                    <img src=\"" + item.detalle.logo + "\">\n                                </div>\n                                <div class=\"label\">\n                                    <img src=\"" + item.detalle.imagen + "\">\n                                </div>\n                                <div class=\"content\">\n                                    <p class=\"title\">" + item.nombre + "</p>\n                                    <p class=\"desc\">" + item.detalle.descripcion + "</p>\n                                    <p class=\"offer\">" + promocion + "</p>\n                                    <p class=\"price\">$ " + item.precio + " al mes</p>\n                                </div>\n                            </li>";
                                apuntadorClase.props.streamings.push(item);
                            }

                            if (item.tipo == "Equipos") {
                                var nombreequipo = item.nombre;

                                if (item.nombre.includes("video sounbox") || item.nombre.includes("video soundbox")) nombreequipo = "Totalplay TV";

                                htmladdons += "<li class=\"adicional my-4\">\n                                    <div class=\"row mt-4\"><img src=\"" + item.detalle.imagen + "\"></div>\n                                    <h1 class=\"mt-3 text-capitalize\">" + nombreequipo + "</h1>\n                                    <p class=\"descripcion mt-3\">" + item.detalle.descripcion + "</p>\n                                    <p class=\"promocion\">" + promocion + "</p>\n                                    <p class=\"precio mt-4\">+ $ " + item.precio + " al mes</p>\n                                    <div class=\"seccion-2\" id=\"" + item.Id + "\" style=\"display: none\">\n                                        <p>Elige la cantidad</p>\n                                        <div class=\"seccion-numero\">\n                                            <p class=\"numero\">\n                                                <span class=\"resta\">-</span>\n                                                <span class=\"texto\">1</span>\n                                                <span class=\"suma\">+</span>\n                                            </p>\n                                        </div>\n                                        <div class=\"confirma\">\n                                            <button class=\"boton boton-azul boton-adicional\" >Aceptar</button>\n                                        </div>\n                                    </div>\n                                </li>";
                                apuntadorClase.props.equipos.push(item);
                            }

                            if (item.tipo == "Canales") {

                                htmlcanales += "<li class=\"canal\" id=\"" + item.Id + "\">\n                            \n                                <div class=\"img\">\n                                    <img src=\"" + item.detalle.logo + "\">\n                                </div>\n                                <div class=\"label\">\n                                    <img src=\"" + item.detalle.imagen + "\" >\n                                </div>\n                                <div class=\"content mx-1\">\n                                    <p class=\"title\">" + item.nombre + "</p>\n                                    <p class=\"desc\">" + item.detalle.descripcion + "</p>\n                                    <p class=\"offer\">" + promocion + "</p>\n                                    <p class=\"price\">+ $ " + item.precio + " al mes</p>\n                                </div>\n                            </li>";
                                apuntadorClase.props.canales.push(item);
                            }
                        }

                        if (item.tipo == "Costo") {
                            apuntadorClase.props.costos.push(item);
                        }
                    });

                    $("#loaderAdicionales").hide();
                    $("#contrataAdicionales").show();

                    if (htmladdons != "") {
                        $("#seccionequipos").show();
                        $("#listaequipos").html(htmladdons);
                    }
                    if (htmlcanales != "") {
                        $("#seccioncanales").show();
                        $("#listacanales").html(htmlcanales);
                    }

                    if (htmlsteamings != "") {
                        $("#seccionstreaming").show();
                        $("#adicionales").html(htmlsteamings);
                    }

                    apuntadorClase.setListeners();
                } else {
                    $("#loaderAdicionales").hide();
                }
            }).catch(function (err) {
                console.error(err);
                $("#loaderAdicionales").hide();
            });
        }
    }, {
        key: "setListeners",
        value: function setListeners() {
            var apuntador = this;
            $(".adicional").on("click", function () {
                if (!$(this).hasClass("activo")) {
                    $(this).addClass("activo");

                    if ($(this).find(".seccion-2").css('display') == 'none') {
                        $(this).find(".seccion-2").css("display", "block");
                    }
                } else {
                    $(this).removeClass("activo");
                }
            });

            $(".suma").on("click", function () {
                var padreSuperior = $(this).closest(".seccion-2").attr("id");
                console.log(padreSuperior);
                var maxima = 0;
                console.log(apuntador.props.equipos);
                apuntador.props.equipos.forEach(function (elem) {
                    if (padreSuperior == elem.Id) {
                        maxima = elem.maximoAgregar;
                    }
                });
                var padre = $(this).closest('.numero').find(".texto");
                var cuantosint = parseInt(padre.text());
                if (cuantosint < maxima) {
                    cuantosint += 1;
                    padre.text(cuantosint);
                }
                apuntador.props.cantidadFinal = cuantosint;
            });

            $(".resta").on("click", function () {
                var padre = $(this).closest('.numero').find(".texto");
                var cuantosint = parseInt(padre.text()) - 1;
                if (cuantosint == 0) {
                    $("body").find($(this).closest(".seccion-2")).css("display", "none");
                }
                if (cuantosint > 0) {
                    padre.text(cuantosint);
                    apuntador.props.cantidadFinal = cuantosint;
                }
            });

            $(".boton-adicional").on("click", function () {
                var valor = $(this).closest(".seccion-2").attr("id");
                var padreSuperior = $(this).closest('.activo').find(".seccion-2").css("display", "none");
                apuntador.validaConvivencia(valor, "Equipos");
            });

            $(".canal").on("click", function () {
                var valor = this.id;
                apuntador.validaConvivencia(valor, "Canales");
            });

            $(".streaming").on("click", function () {
                var valor = this.id;
                console.log("id streaming", valor);
                apuntador.validaConvivencia(valor, "Streamings");
            });
        }
    }, {
        key: "validaConvivencia",
        value: function validaConvivencia(valor, tipo) {
            $("#modalLoad").modal('show');
            var apuntador = this;

            var seleccionados = [];
            var ids = {};

            if (tipo == "Canales") {
                localStorage.setItem("canales", JSON.stringify(apuntador.props.canales));
                var idscanales = [];
                var idspromociones = [];
                apuntador.props.canales.forEach(function (elem) {
                    console.log(elem);
                    if (valor == elem.Id) {
                        elem.cantidad = 1;
                        seleccionados.push(elem);
                        idscanales.push(elem.Id);
                        if (elem.promocion != null) idspromociones.push(elem.promocion);
                    }
                });
                ids.adicionales = idscanales;
                ids.promociones = idspromociones;
            }

            if (tipo == "Equipos") {
                localStorage.setItem("equipos", JSON.stringify(apuntador.props.equipos));
                var idsequipos = [];

                apuntador.props.equipos.forEach(function (elem) {
                    if (valor == elem.Id) {
                        elem.cantidad = apuntador.props.cantidadFinal;
                        seleccionados.push(elem);
                        idsequipos.push(elem.Id);
                    }
                });
                ids.adicionales = idsequipos;
                localStorage.setItem("costos", JSON.stringify(apuntador.props.costos));
            }
            //nuevo tipo
            if (tipo == "Streamings") {
                localStorage.setItem("streamings", JSON.stringify(apuntador.props.streamings));
                var idsstreamings = [];
                var idspromociones = [];
                apuntador.props.streamings.forEach(function (elem) {

                    console.log("streaming: ", elem);
                    if (valor == elem.Id) {
                        elem.cantidad = 1;
                        seleccionados.push(elem);
                        idsstreamings.push(elem.Id);
                        if (elem.promocion != null) idspromociones.push(elem.promocion);
                    }
                });
                ids.adicionales = idsstreamings;
                ids.promociones = idspromociones;
            }

            var url = CONSTANTES.endpoints.convivencia;
            var cabeceraMC = new Headers();
            cabeceraMC.append("Content-type", "application/json;charset=utf-8");
            cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

            console.log("ids: ", ids);
            var informacionEncriptada = otpyrc2(JSON.stringify(ids));
            var informacion = { "secdata": informacionEncriptada };

            fetch(url, {
                method: "POST",
                body: JSON.stringify(informacion),
                headers: cabeceraMC
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax";
                }
            }).then(function (respuesta) {
                console.log("respuesta convivencia: ", respuesta);
                $("#modalLoad").modal("hide");

                try {
                    if (respuesta.codigo == 0) {

                        localStorage.setItem("adicionales", JSON.stringify(seleccionados));
                        window.location = "Revisa.html";
                    } else {
                        $("#msjTitle").html("Atenci&oacute;n");
                        $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
                        $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
                        $('#modalrespuesta').modal('show');
                    }
                } catch (e) {
                    console.error(e);
                    $("#msjTitle").html("Atenci&oacute;n");
                    $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                    $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                    $('#modalrespuesta').modal('show');
                }
            }).catch(function (err) {
                console.error(err);
                $("#modalLoad").modal("hide");
                $("#msjTitle").html("Atenci&oacute;n");
                $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
                $("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
                $('#modalrespuesta').modal('show');
            });
        }
    }]);

    return Adicionales;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49,"../../utils/ModalMng":50}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Revisa = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _ModalMng = require("../../utils/ModalMng");

var _MiPlan = require("../miplan/MiPlan");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Revisa = exports.Revisa = function () {
	function Revisa() {
		_classCallCheck(this, Revisa);

		this.ch = new _CookieHelper.CookieHelper();
		this.props = {
			canales: [],
			adicionales: [],
			costos: [],
			listafechas: [],
			fechasdisponibles: [],
			datosCliente: null,
			fechaSeleccionada: null,
			turno: null,
			solounturno: null
		};
		this.init();
	}

	_createClass(Revisa, [{
		key: "init",
		value: function init() {

			var modalManager = new _ModalMng.ModalMng();
			modalManager.createModal(CONSTANTES.modals.recomendados);
			this.datosCliente();
			this.consultaSeleccionados();
			this.obtenerDisponibilidad();
			this.obtenerFechas();
			this.eventos();
		}
	}, {
		key: "datosCliente",
		value: function datosCliente() {
			console.log("consultando datos cliente........");
			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");
			cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());
			var apuntador = this;
			var key = CONSTANTES.storedKeys.dashboard;

			this.obtenDatosStorage(key).then(function (bean) {
				if (bean.stored) {
					return bean;
				} else {
					return fetch(url, {
						method: "POST",
						headers: cabeceraMC
					});
				}
			}).then(function (data) {
				if (data.constructor == {}.constructor) {
					return data;
				} else {
					if (data.ok) {
						return data.json();
					} else {
						throw "Error en la llamada Ajax a Dashboard";
					}
				}
			}).then(function (respuesta) {
				try {
					if (respuesta.status == 0) {
						var objBean = respuesta.bean;
						apuntador.props.datosCliente = objBean;
						Object.keys(objBean).forEach(function (key) {
							if (key == "celular") {
								var valor = objBean[key];
								var longitud1 = valor.length;
								if (valor != "ND" && valor != "") {
									var valor1 = "** ** ** *" + valor.substr(longitud1 - 3, longitud1);
									$("#numeroCelular1").html(valor1);
									$("#numeroCelular2").html(valor1);
								}
							}
							if (key == "correo") {
								var valorcorreo = objBean[key];
								var arroba = valorcorreo.split("@");
								var longitud2 = arroba[0].length;
								var antesarroba = arroba[0].substr(longitud2 - 3, longitud2);
								var valor2 = "******" + antesarroba + "@" + arroba[1];
								$("#correoEnviar1").html(valor2);
								$("#correoEnviar2").html(valor2);
							}
						});
					}
				} catch (e) {
					console.error(e);
					throw "Error al traer la informaci0n";
				}
			}).catch(function (err) {
				console.error(err);
			});
		}
	}, {
		key: "obtenDatosStorage",
		value: function obtenDatosStorage(key) {
			var bean = null;
			return new Promise(function (resolve, reject) {
				if (localStorage != null && localStorage != undefined) {
					var _bean = localStorage.getItem(key);
					if (_bean != null && _bean != undefined) {
						_bean = JSON.parse(_bean);
						_bean.stored = true;
						resolve(_bean);
					} else {
						_bean = { "stored": false };
						resolve(_bean);
					}
				} else {
					bean = { "stored": false };
					resolve(bean);
				}
			});
		}
	}, {
		key: "consultaSeleccionados",
		value: function consultaSeleccionados() {
			var apuntador = this;
			var adicionales = [];
			var costos = [];
			var tipoProducto;

			try {
				adicionales = JSON.parse(localStorage.getItem("adicionales"));
				if (adicionales != null) {
					apuntador.props.adicionales = adicionales;
				} else {
					adicionales = [];
				}

				costos = JSON.parse(localStorage.getItem("costos"));
				if (costos != null) {
					apuntador.props.costos = costos;
				} else {
					costos = [];
				}
			} catch (err) {
				console.log("error al parsear adicionales " + err);
			}

			var htmladdons = "";
			var suma = 0;
			adicionales.forEach(function (item) {
				var nombreequipo = item.nombre;
				if (item.nombre.includes("video sounbox") || item.nombre.includes("video soundbox")) nombreequipo = "Totalplay TV";

				var totalproducto = item.cantidad * item.precio;
				suma += totalproducto;
				if (item.detalle != null) {
					var promocion = "";
					if (item.promocion != undefined && item.promocion != "" && item.promocion != null && item.detalle.promocion != undefined && item.detalle.promocion != "") {
						promocion = '<p class="mt-2" style="color: #f16c00;font-size: 14px !important;">' + item.detalle.promocion + '</p>';
					}

					if (item.tipo == "Streaming") {
						if (item.promocion != undefined && item.promocion != "" && item.promocion != null && item.describePromo != undefined && item.describePromo != null) {
							promocion = '<p class="mt-2" style="color: #f16c00;font-size: 14px !important;">' + item.describePromo + '</p>';
							//+'<p style="font-size: 14px !important;" class="mt-2">El contenido estará disponible a través de tus dispositivos móviles.</p>';
						}
					}

					htmladdons += "<div class=\"row py-4 rectangulo-detalle-adicional\" id=\"adicional_" + item.Id + "\">\n\t                    <div class=\"col-6 col-md-2\" id=\"imagenDetalle\"><img src='" + item.detalle.imagen + "'></div>\n\t                    <div class=\"col-12 order-3 col-md-7 order-md-2 mt-4 mt-md-0\" id=\"descripcionDetalle\">\n\t                    \t<p class=\"font-weight-bold\">" + item.cantidad + " " + nombreequipo + "</p>\n\t\t\t\t\t\t\t" + promocion + "\n\t                    </div>\n\t                    <div class=\"col-2 order-1 col-md-1 order-md-3\" id=\"imagenElimina\">\n\t                    \t<i class=\"fa fa-trash elimina-adicional\" id=\"" + item.Id + "\"></i>\n\t                    </div>\n\t                    <div class=\"col-4 order-2 col-md-2 order-md-4 font-weight-bold\" id=\"precioDetalle\"> $ " + totalproducto + "</div>\n\t                </div>";
				}
			});
			var costomas = 0;
			costos.forEach(function (item) {
				costomas += item.precio;
			});

			if (costomas > 0) {
				suma = suma + costomas;
				$("#montoInstalacion").html("$ " + costomas);
			} else {

				$("#cargoInstalacion").hide();
				$("#fechaInstalacion").hide();
			}

			$("#adicionalesAComprar").html(htmladdons);
			$("#totalGral").html("$ " + suma);

			this.eventosPersonalizados();
		}
	}, {
		key: "eventosPersonalizados",
		value: function eventosPersonalizados() {
			var apuntador = this;
			$(".elimina-adicional").on("click", function () {
				/*var valor=this.id;
    console.log(apuntador.props.adicionales);
    var nuevoarray = apuntador.props.adicionales.filter((item)=>{return item.Id!=valor});
    		apuntador.props.adicionales=nuevoarray;
    localStorage.setItem("adicionales", JSON.stringify(nuevoarray));
    		if(nuevoarray.length>0){
    	$( "div" ).remove( "#adicional_"+valor);
    			var suma=100;
    	apuntador.props.adicionales.forEach(function(elem){
    		var totalproducto=elem.cantidad*elem.precio;
    		suma+=totalproducto;
    	});
    	$("#totalGral").html("$ "+suma);
    		}else{*/
				window.location = "Paquetes.html";
				//}
			});
		}
	}, {
		key: "obtenerDisponibilidad",
		value: function obtenerDisponibilidad() {
			var apuntador = this;
			var url = CONSTANTES.endpoints.disponibilidad;
			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");
			cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

			fetch(url, {
				method: "POST",
				headers: cabeceraMC
			}).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax";
				}
			}).then(function (respuesta) {
				//console.log(respuesta);
				if (respuesta.codigo == 0) {
					if (respuesta.bean.fechasDisponibles != null && respuesta.bean.fechasDisponibles != undefined) {
						apuntador.props.fechasdisponibles = respuesta.bean.fechasDisponibles;
					}
				}
			}).catch(function (err) {
				console.error(err);
			});
		}
	}, {
		key: "esperarfechas",
		value: function esperarfechas() {
			var apuntador = this;
			return new Promise(function (resolve, reject) {
				var contador = 0;
				var interval = setInterval(function () {
					if (apuntador.props.fechasdisponibles != null && apuntador.props.fechasdisponibles.length > 0) {

						clearInterval(interval);

						resolve("FOUND_ADDONS");
					}
				}, 300);
			});
		}
	}, {
		key: "obtenerFechas",
		value: function obtenerFechas() {
			var apuntador = this;
			//var myDate = new Date("2021-03-28 15:24:36");
			var ini = moment();
			ini.add(1, 'days');

			var horaActual = ini.format('HH');
			console.log("------" + horaActual);
			var horaint = parseInt(horaActual);
			//if(ini.format('ddd').includes("sáb"))ini.add(2, 'days')
			if (horaint > 14 && horaint < 19) apuntador.props.solounturno = "V";
			if (horaint >= 19) ini.add(1, 'days');

			var fechaActual = ini.format('MMMM') + " " + ini.format('YYYY');
			$("#mesAnioActual").html(fechaActual);
			var fechaInstalacion = ini.format('dddd') + " " + ini.format('DD') + " de " + ini.format('MMMM');
			$("#fechaInstalacion").html("Instalación disponible desde " + fechaInstalacion);

			var fechas = [];
			if (ini != undefined) {
				var i = 1;
				while (i < 11) {
					var dianombreabrev = ini.format('ddd');
					var dias = ini.format('dddd');
					var dianombre = dias[0].toUpperCase() + dias.slice(1);
					var mesnombre = ini.format('MMMM');
					//if(!dianombreabrev.includes("sáb") && !dianombreabrev.includes("dom") ){
					var arrayfecha = {
						idFecha: i,
						fechaCompleta: ini.format('YYYY-MM-DD'),
						dia: ini.format('DD'),
						nombrediaA: dianombreabrev,
						nombredia: dianombre,
						mes: mesnombre,
						anio: ini.format('YYYY') };
					fechas.push(arrayfecha);
					i++;
					//}
					ini.add(1, 'days');
				}
			}
			apuntador.props.listafechas = fechas;
			var htmlfechas = "";
			console.log("apuntador.props.listafechas------>", apuntador.props.listafechas);

			this.esperarfechas().then(function () {
				fechas.forEach(function (item, index) {
					apuntador.props.fechasdisponibles.forEach(function (elem) {

						if (elem.Fecha == item.fechaCompleta) {
							var mat = parseInt(elem.Mat);
							var vesp = parseInt(elem.Vesp);
							item.turno1 = mat;
							item.turno2 = vesp;
							console.log(elem.Fecha + "-mat" + mat + "-vesp" + vesp);
							var estatus = "inactiva";
							if (mat > 0 || vesp > 0) {
								estatus = "activa";
							}
							htmlfechas += "<div class=\"fecha " + estatus + "\" id=\"" + item.idFecha + "\">\n\t\t\t\t            \t\t\t\t<p>" + item.nombrediaA + "</p>\n\t\t\t\t            \t\t\t\t<p>" + item.dia + "</p>\n\t\t\t\t            \t\t\t</div>";
						}
					});
				});
				$("#fechasCalendario").html(htmlfechas);
				apuntador.eventosAgendamiento();
			}).catch(function (e) {
				console.log("ERROR AL ESPERAR FECHAS " + e);
			});
		}
	}, {
		key: "eventos",
		value: function eventos() {
			var apuntador = this;
			$("#regresaContrata").on("click", function () {
				window.location = "Paquetes.html";
			});

			$("#botonConfirma").on("click", function () {
				$("#codigoU1").val("");
				$("#codigoU2").val("");
				$("#codigoU3").val("");
				$("#codigoU4").val("");
				$(".codigos").find('.codigo').removeClass("erroneo");

				if (apuntador.props.adicionales.length > 0) {
					if (apuntador.props.datosCliente.celular != "") {
						var obj = {
							tipoautenticacion: "SMS",
							valor: apuntador.props.datosCliente.celular
						};

						/*var obj={ 
      	tipoautenticacion: "SMS",
      	 valor: "5519780321"
      }*/

						apuntador.generarCodigo(obj);

						/*$("#modalConfirmaContratacion").modal("hide");
              	$("#modalLoad").modal('hide');
              	apuntador.flujoCreacion();*/
					}
				}
			});

			$("#linkEnviarSMS").on("click", function () {
				if (apuntador.props.datosCliente.celular != "") {
					var obj = {
						tipoautenticacion: "SMS",
						valor: apuntador.props.datosCliente.celular
					};
					apuntador.generarCodigo(obj);
				}
			});

			$("#linkOtrasFormas").on("click", function () {
				//limpiar datos
				$(".caja").removeClass("seleccionada");
				$("input[name=radioUpsell]").prop('checked', false);
				$("#validaEnvio").hide();

				$("#modalConfirmaContratacion").modal("hide");
				$("#modalOtrasFormasEnvio").modal("show");
			});

			$("input[name=radioUpsell]").on("click", function () {
				var valor = this.id;
				apuntador.props.tipoenviar = valor;
				$(".caja").removeClass("seleccionada");
				$("#caja" + valor).addClass("seleccionada");
			});

			$("#botonReenviarCodigo").on("click", function () {
				var tipoAuth = $('input:radio:checked').val();
				var valor = "";
				if (tipoAuth == "Correo") {
					valor = apuntador.props.datosCliente.correo;
				};
				if (tipoAuth == "SMS") {
					valor = apuntador.props.datosCliente.celular;
				};
				if (tipoAuth != undefined && valor != "") {
					$("#modalOtrasFormasEnvio").modal("hide");
					var obj = { tipoautenticacion: tipoAuth, valor: valor };
					apuntador.generarCodigo(obj);
				} else {
					$("#validaEnvio").show();
				}
			});

			$("#codigoU4").on("keyup", function () {
				var valor = $("#codigoU1").val() + $("#codigoU2").val() + $("#codigoU3").val() + $("#codigoU4").val();
				console.log("codigo:" + valor);
				//$("#modalConfirmaContratacion").modal("hide");
				//apuntador.flujoCreacion();
				if (valor != "" && valor.length == 4) {

					apuntador.validarCodigo(valor);
				} else {
					$(".codigos").find('.codigo').addClass("erroneo");
				}
			});

			$("#botonActivaLicencia").on("click", function () {
				console.log("vamos activar la licencia");
			});
		}
	}, {
		key: "eventosAgendamiento",
		value: function eventosAgendamiento() {
			var apuntador = this;
			$(".fecha.activa").on("click", function () {
				var valor = this.id;
				$("#fechasCalendario").find('.fecha').removeClass("seleccionada");
				$(this).addClass('seleccionada');
				apuntador.props.listafechas.forEach(function (item, index) {
					if (item.idFecha == valor) {
						console.log("index---" + item.turno1 + "--" + item.turno2);
						apuntador.props.fechaSeleccionada = item;
						$("#mesAnioActual").html(item.mes + " " + item.anio);

						console.log(apuntador.props.solounturno);
						$(".horario").find('.turno').removeClass("seleccionado");
						apuntador.props.turno = null;
						$("#errorAgenda").hide();

						if (item.turno1 > 0) {
							$("#turno1").addClass('activo').removeClass('inactivo');
						}
						if (item.turno2 > 0) {
							$("#turno2").addClass('activo').removeClass('inactivo');
						}

						var revisarturno = "";
						//if(apuntador.props.turno!=null)revisarturno=$("#"+apuntador.props.turno).text().toLowerCase();
						$("#fechaFinalTexto").html(item.nombredia + " " + item.dia + " de " + item.mes + " " + revisarturno);

						apuntador.eventosdespuesfecha();
					}
				});
			});
			$("#botonConfirmaAgendamiento").on("click", function () {
				console.log("valores agendamiento");
				console.log(apuntador.props.fechaSeleccionada);
				console.log(apuntador.props.turno);
				if (apuntador.props.fechaSeleccionada != null && apuntador.props.turno != null) {
					$("#modalAgendamiento").modal("hide");
					apuntador.flujoAgendamiento();
				} else {
					$("#errorAgenda").show();
				}
			});
		}
	}, {
		key: "eventosdespuesfecha",
		value: function eventosdespuesfecha() {
			var apuntador = this;
			$(".turno.activo").on("click", function () {
				var valor = this.id;
				apuntador.props.turno = valor;
				var texto = $(this).text();
				$(".horario").find('.turno').removeClass("seleccionado");
				$(this).addClass('seleccionado');
				$("#fechaFinalTexto").html(apuntador.props.fechaSeleccionada.nombredia + " " + apuntador.props.fechaSeleccionada.dia + " de " + apuntador.props.fechaSeleccionada.mes + " " + texto);
			});
		}
	}, {
		key: "generarCodigo",
		value: function generarCodigo(objeto) {
			$("#modalLoad").modal('show');
			var apuntador = this;

			console.log("generando codigo.....");
			console.log(objeto);

			var informacionEncriptada = otpyrc2(JSON.stringify(objeto));
			var informacion = { "secdata": informacionEncriptada };

			var url = CONSTANTES.endpoints.generarauth;
			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");
			cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

			fetch(url, {
				method: "POST",
				body: JSON.stringify(informacion),
				headers: cabeceraMC
			}).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax";
				}
			}).then(function (respuesta) {
				$("#modalLoad").modal('hide');
				if (respuesta.status == 0) {
					$("#medioEnvioCodigo").html(objeto.tipoautenticacion);
					if (objeto.tipoautenticacion == "SMS") {
						$("#numeroCelular2").show();
						$("#correoEnviar2").hide();
					} else {
						$("#correoEnviar2").show();
						$("#numeroCelular2").hide();
					}
					$("#codigoU1").val("");$("#codigoU2").val("");$("#codigoU3").val("");$("#codigoU4").val("");
					$("#modalConfirmaContratacion").modal("show");
				} else {
					$("#msjTitle").html("Atenci&oacute;n");
					$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
					$("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
					$('#modalrespuesta').modal('show');
				}
			}).catch(function (err) {
				console.error(err);
				$("#modalLoad").modal("hide");
				$("#msjTitle").html("Atenci&oacute;n");
				$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
				$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
				$('#modalrespuesta').modal('show');
			});
		}
	}, {
		key: "validarCodigo",
		value: function validarCodigo(valor) {

			$("#modalLoad").modal('show');
			var apuntador = this;
			var objeto = { codigo: valor, cuenta: apuntador.props.datosCliente.cuenta };
			console.log("validando codigo...", objeto);
			var url = CONSTANTES.endpoints.verificarauth;

			fetch(url, {
				method: "POST",
				body: JSON.stringify(objeto)
			}).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax";
				}
			}).then(function (respuesta) {
				try {
					console.log("respuesta valida codigo", respuesta);
					if (respuesta.codigo == 0) {
						$("#modalConfirmaContratacion").modal("hide");
						$("#modalLoad").modal('hide');
						apuntador.flujoCreacion();
					} else {
						$("#modalLoad").modal('hide');
						$("#codigoU1").val("");
						$("#codigoU2").val("");
						$("#codigoU3").val("");
						$("#codigoU4").val("");
						$(".codigos").find('.codigo').addClass("erroneo");

						/*$("#modalLoad").modal("hide");
      $("#msjTitle").html("Atenci&oacute;n");
      $('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
      $("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
      $('#modalrespuesta').modal('show');*/
					}
				} catch (e) {
					console.log("error en valida codigo" + e);
					$("#modalConfirmaContratacion").modal("hide");
					$("#modalLoad").modal("hide");
					$("#msjTitle").html("Atenci&oacute;n");
					$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
					$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
					$('#modalrespuesta').modal('show');
				}
			}).catch(function (err) {
				console.error(err);
				$("#modalConfirmaContratacion").modal("hide");
				$("#modalLoad").modal("hide");
				$("#msjTitle").html("Atenci&oacute;n");
				$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
				$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
				$('#modalrespuesta').modal('show');
			});
		}
	}, {
		key: "flujoCreacion",
		value: function flujoCreacion() {

			var apuntador = this;

			var url = CONSTANTES.endpoints.compraraddons;
			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");
			cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

			var arrayproductos = {};
			var productosfin = [];
			var costosfin = [];

			var tipoProducto = null;
			apuntador.props.adicionales.forEach(function (item) {
				console.log("Item", item);
				//revisar si es streminng

				tipoProducto = item.tipo;
				var nuevotipo = tipoProducto;
				if (item.tipo == "Streaming") nuevotipo = "Equipos";
				var idPromocion = "";
				var nivel3 = "";
				if (item.promocion != undefined && item.promocion != null) idPromocion = item.promocion;
				if (item.detalle != null) nivel3 = item.detalle.nivel3;

				var itemaux = {
					Id: item.Id,
					cantidad: item.cantidad,
					nombre: item.nombre,
					nivel: nivel3,
					tipo: nuevotipo,
					idpromocion: idPromocion
				};
				productosfin.push(itemaux);
			});

			apuntador.props.costos.forEach(function (item) {
				var itemaux = { Id: item.Id, cantidad: item.cantidad, nombre: item.nombre };
				costosfin.push(itemaux);
			});

			arrayproductos.productos = productosfin;
			arrayproductos.costos = costosfin;
			console.log(arrayproductos);

			var informacionEncriptada = otpyrc2(JSON.stringify(arrayproductos));
			var informacion = { "secdata": informacionEncriptada };
			console.log(informacion);

			if (tipoProducto != null && tipoProducto == "Equipos") {
				$("#tituloCompraAddon").hide();
			} else {
				$("#tituloCompraAddon").show();
			}
			$("#modalCreacion").modal("show");

			fetch(url, {
				method: "POST",
				body: JSON.stringify(informacion),
				headers: cabeceraMC
			}).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax";
				}
			}).then(function (respuesta) {
				console.log(respuesta);
				$("#modalCreacion").modal("hide");
				try {
					if (respuesta.codigo == 0) {
						console.log("tipoProducto-----------" + tipoProducto);
						if (tipoProducto != null && tipoProducto == "Equipos") {
							$("#modalConfirmaContratacion").modal("hide");
							$("#errorAgenda").hide();
							$("#modalAgendamiento").modal("show");
						} else {
							apuntador.obtenerActivar(respuesta.bean.ticketNumero, tipoProducto);
						}
					} else {
						$("#msjTitle").html("Atenci&oacute;n");
						$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
						$("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
						$('#modalrespuesta').modal('show');
					}
				} catch (e) {
					console.error(e);
					$("#msjTitle").html("Atenci&oacute;n");
					$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
					$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
					$('#modalrespuesta').modal('show');
				}
			}).catch(function (err) {
				console.error(err);
				$("#modalCreacion").modal("hide");
				$("#msjTitle").html("Atenci&oacute;n");
				$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
				$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
				$('#modalrespuesta').modal('show');
			});
		}
	}, {
		key: "obtenerActivar",
		value: function obtenerActivar(ticket, tipoProducto) {
			var apuntador = this;
			$("#accionFlujo").html("Activando servicios");
			$("#modalCreacion").modal("show");

			var url = CONSTANTES.endpoints.obteneract;
			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");
			cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

			fetch(url, {
				method: "POST",
				headers: cabeceraMC
			}).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax";
				}
			}).then(function (respuesta) {

				try {

					if (respuesta.codigo == 0) {
						var item;
						for (var i = 0; i < respuesta.bean.length; i++) {
							item = respuesta.bean[i];
						}
						console.log("item activar .......", item);
						apuntador.flujoActivacion(item, ticket, tipoProducto);
					} else {
						$("#modalCreacion").modal("hide");

						$("#msjTitle").html("Atenci&oacute;n");
						$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
						$("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
						$('#modalrespuesta').modal('show');
					}
				} catch (e) {
					console.error(e);
					$("#modalCreacion").modal("hide");

					$("#msjTitle").html("Atenci&oacute;n");
					$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
					$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
					$('#modalrespuesta').modal('show');
				}
			}).catch(function (err) {
				console.error(err);
				$("#modalCreacion").modal("hide");

				$("#msjTitle").html("Atenci&oacute;n");
				$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
				$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
				$('#modalrespuesta').modal('show');
			});
		}
	}, {
		key: "flujoActivacion",
		value: function flujoActivacion(item, ticket, tipoProducto) {

			var apuntador = this;
			var url = CONSTANTES.endpoints.crearact;
			console.log("flujo activavion..." + url);
			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");
			cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

			var objentrada = { id: item };
			console.log("objentrada act", objentrada);
			var informacionEncriptada = otpyrc2(JSON.stringify(objentrada));
			var informacion = { "secdata": informacionEncriptada };
			console.log("informacion", informacion);

			fetch(url, {
				method: "POST",
				body: JSON.stringify(informacion),
				headers: cabeceraMC
			}).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax";
				}
			}).then(function (respuesta) {
				console.log("respuesta generar..", respuesta);
				if (respuesta.codigo == "0") {
					setTimeout(function () {
						apuntador.revisaActivacion(item, ticket, tipoProducto);
					}, 30000);
				} else {
					$("#modalCreacion").modal("hide");
					$("#msjTitle").html("Atenci&oacute;n");
					$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
					$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
					$('#modalrespuesta').modal('show');
				}
			}).catch(function (err) {
				console.error(err);
				$("#modalCreacion").modal("hide");
				$("#msjTitle").html("Atenci&oacute;n");
				$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
				$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
				$('#modalrespuesta').modal('show');
			});
		}
	}, {
		key: "revisaActivacion",
		value: function revisaActivacion(item, ticket, tipoProducto) {

			var apuntador = this;
			var url = CONSTANTES.endpoints.revisaract;
			console.log("revisando activavion....." + url);
			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");
			cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

			var objentrada = { idCot: item };
			console.log("objentrada act", objentrada);

			fetch(url, {
				method: "POST",
				body: JSON.stringify(objentrada),
				headers: cabeceraMC
			}).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax";
				}
			}).then(function (respuesta) {
				console.log("respuesta se realizo activavion", respuesta);
				if (respuesta.codigo == "0") {
					if (tipoProducto == "Canales") {
						$("#modalCreacion").modal("hide");
						$("#botonMisVisitas").hide();

						$("#botonEntendido").show();
						$("#mesajeAdicional").html("Ya puedes disfrutar de tus canales premium contratados");
						$("#numeroTicket").html(ticket);
						$("#modalAdicionalesExito").modal("show");
						var miPlanFun = new _MiPlan.MiPlan("refresh");
					}
					if (tipoProducto == "Streaming") {
						apuntador.revisarestatusdisney(ticket);
						//setTimeout(()=>{apuntador.revisarestatusdisney(ticket)},30000);
						//apuntador.obtenerUrlDisney(ticket);
					}
				} else {
					if (respuesta.codigo == "-1") {
						setTimeout(function () {
							apuntador.revisaActivacion(item, ticket, tipoProducto);
						}, 20000);
					} else {
						$("#modalCreacion").modal("hide");
						$("#msjTitle").html("Atenci&oacute;n");
						$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
						$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
						$('#modalrespuesta').modal('show');
					}
				}
			}).catch(function (err) {
				console.error(err);
				$("#modalCreacion").modal("hide");
				$("#msjTitle").html("Atenci&oacute;n");
				$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
				$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
				$('#modalrespuesta').modal('show');
			});
		}
	}, {
		key: "flujoAgendamiento",
		value: function flujoAgendamiento() {
			$("#modalLoad").modal('show');
			var apuntador = this;
			var turnofinal = "";
			var horaturno = "";

			if (apuntador.props.turno == "turno1") {
				turnofinal = "Matutino";
				horaturno = "11:00";
			}

			if (apuntador.props.turno == "turno2") {
				turnofinal = "Vespertino";
				horaturno = "4:00";
			}

			var obj = {
				shift: turnofinal,
				comments: 'comentarios',
				dateScheduled: apuntador.props.fechaSeleccionada.fechaCompleta,
				horaScheduled: horaturno
			};
			console.log(obj);
			var url = CONSTANTES.endpoints.agendamiento;
			var informacionEncriptada = otpyrc2(JSON.stringify(obj));
			var informacion = { "secdata": informacionEncriptada };

			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");
			cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

			fetch(url, {
				method: "POST",
				body: JSON.stringify(informacion),
				headers: cabeceraMC
			}).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax";
				}
			}).then(function (respuesta) {
				console.log(respuesta);
				$("#modalLoad").modal("hide");
				try {
					if (respuesta.codigo == 0) {
						$("#mesajeAdicional").html("Has agendado tu visita, revisa su estatus en la sección de <span>Mis Visitas</span>");
						$("#botonMisVisitas").show();
						$("#botonEntendido").hide();
						$("#numeroTicket").html(respuesta.bean);
						$("#modalAdicionalesExito").modal("show");
					} else {
						$("#msjTitle").html("Atenci&oacute;n");
						$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
						$("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
						$('#modalrespuesta').modal('show');
					}
				} catch (e) {
					console.error(e);
					$("#msjTitle").html("Atenci&oacute;n");
					$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
					$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
					$('#modalrespuesta').modal('show');
				}
			}).catch(function (err) {
				console.error(err);
				$("#modalLoad").modal("hide");
				$("#msjTitle").html("Atenci&oacute;n");
				$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
				$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
				$('#modalrespuesta').modal('show');
			});
		}
	}, {
		key: "revisarestatusdisney",
		value: function revisarestatusdisney(ticket) {

			//$("#modalLoad").modal('show');
			var apuntador = this;
			var url = CONSTANTES.endpoints.obtenerEstatusDisney;
			var data = null;

			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");
			cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

			fetch(url, {
				method: "POST",
				headers: cabeceraMC
			}).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax";
				}
			}).then(function (respuesta) {
				try {
					console.log("estatus disney : ", respuesta);

					if (respuesta.status == 0) {
						if (respuesta.bean.isActivated == "N") {
							if (respuesta.bean.idStatusBundle == 10062) {
								apuntador.obtenerUrlDisney(ticket);
							} else {
								setTimeout(function () {
									apuntador.revisarestatusdisney(ticket);
								}, 10000);
							}
							//apuntador.obtenerUrlDisney(ticket);
						} else if (respuesta.bean.isActivated == "Y") {
							if (respuesta.bean.idStatusBundle == 10063) {
								$("#modalCreacion").modal("hide");
								$("#botonMisVisitas").hide();
								$("#modalLoad").modal("hide");
								$("#botonActivaLicencia").show();
								$("#mesajeAdicional").html("Tu compra se ha realizado");
								$("#disneySuscription").hide();
								$("#numeroTicket").html(ticket);
								$("#modalAdicionalesExito").modal("show");
								$("#linkDisney").html("Inicia Sesión");
								var urldisney = "https://" + respuesta.bean.redirectUrl;
								console.log("urldisney", urldisney);
								$("#linkDisney").attr("href", urldisney);
								var miPlanFun = new _MiPlan.MiPlan("refresh");
							} else {
								setTimeout(function () {
									apuntador.revisarestatusdisney(ticket);
								}, 10000);
							}
						} else {

							$("#modalLoad").modal("hide");
							$("#modalCreacion").modal("hide");
							$("#msjTitle").html("Atenci&oacute;n");
							$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
							$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
							$('#modalrespuesta').modal('show');
						}
					} else {

						$("#modalLoad").modal("hide");
						$("#modalCreacion").modal("hide");
						$("#msjTitle").html("Atenci&oacute;n");
						$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
						$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
						$('#modalrespuesta').modal('show');
					}
				} catch (e) {
					console.error(e);
					$("#modalLoad").modal("hide");
					$("#modalCreacion").modal("hide");

					$("#msjTitle").html("Atenci&oacute;n");
					$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
					$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
					$('#modalrespuesta').modal('show');
				}
			}).catch(function (err) {

				$("#modalLoad").modal("hide");
				$("#modalCreacion").modal("hide");

				$("#msjTitle").html("Atenci&oacute;n");
				$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
				$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
				$('#modalrespuesta').modal('show');
				console.error("err=>" + err);
			});
		}
	}, {
		key: "obtenerUrlDisney",
		value: function obtenerUrlDisney(ticket) {
			//$('#modalLoad').modal('show');
			var apunta = this;
			var url = CONSTANTES.endpoints.obtenerUrlDisney;
			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");
			cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

			var payload = {
				method: "POST",
				headers: cabeceraMC
			};
			fetch(url, payload).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax load sin parametros";
				}
			}).then(function (respuesta) {
				try {
					if (respuesta.status == 0) {
						console.log("---------------------------------------");
						console.log(respuesta);

						$("#modalCreacion").modal("hide");
						$("#botonMisVisitas").hide();

						$("#botonActivaLicencia").show();
						$("#mesajeAdicional").html("Tu compra se ha realizado");
						$("#disneySuscription").show();
						$("#numeroTicket").html(ticket);
						$("#modalAdicionalesExito").modal("show");
						$("#linkDisney").attr("href", respuesta.bean.token);
						var miPlanFun = new _MiPlan.MiPlan("refresh");
					} else {
						$("#modalCreacion").modal("hide");
						$('#modalLoad').modal('hide');

						$("#msjTitle").html("Atenci&oacute;n");
						$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
						$("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
						$('#modalrespuesta').modal('show');
					}
				} catch (e) {
					console.error(e);
					$("#modalCreacion").modal("hide");
					$('#modalLoad').modal('hide');

					$("#msjTitle").html("Atenci&oacute;n");
					$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
					$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
					$('#modalrespuesta').modal('show');
					throw "Error al traer la informacion";
				}
			}).catch(function (err) {
				console.error("err=>" + err);
				$("#modalCreacion").modal("hide");
				$('#modalLoad').modal('hide');

				$("#msjTitle").html("Atenci&oacute;n");
				$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
				$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
				$('#modalrespuesta').modal('show');
			});
		}
	}]);

	return Revisa;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49,"../../utils/ModalMng":50,"../miplan/MiPlan":33}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Wifi = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CookieHelper = require("../../utils/CookieHelper");

var _Constantes = require("../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _ModalMng = require("../../utils/ModalMng");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Wifi = exports.Wifi = function () {
	function Wifi() {
		_classCallCheck(this, Wifi);

		this.init();
		this.ch = new _CookieHelper.CookieHelper();
	}

	_createClass(Wifi, [{
		key: "init",
		value: function init() {
			var _this = this;

			console.log("wifi");
			var modalManager = new _ModalMng.ModalMng();
			modalManager.createModal(CONSTANTES.modals.wifiModal);
			modalManager.createModal(CONSTANTES.modals.recomendados).then(function (status) {
				//confirmacion creacion del Primer modal
				_this.ojito();
				_this.loadData();
				_this.setListenerBoton();
				_this.setListeners();
			}).catch(function (err) {
				console.error("el error es" + err);
			});
			document.querySelector("#btnChangeWifi").style.cssText = "cursor:pointer";
			var initialSSID = void 0;
			var initialPWD = void 0;
			var initialSEC = void 0;
		}
	}, {
		key: "ojito",
		value: function ojito() {
			$("#iconEyeOff2").on("click", function () {
				if ($("#pwd").attr("type") == "text") {
					$("#pwd").attr("type", "password");
				} else if ($("#pwd").attr("type") == "password") {
					$("#pwd").attr("type", "text");
				}
			});
		}
	}, {
		key: "loadData",
		value: function loadData(refresh) {

			var apunta = this;
			$('#modalLoad').modal('show');

			var url = CONSTANTES.endpoints.infoWifi;
			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");
			cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

			var payload = {
				method: "POST",
				headers: cabeceraMC
			};

			if (refresh != undefined && refresh) {
				//payload["refresh"] = "refresh";
				payload.body = '{"refresh":"refresh"}';
			}

			fetch(url, payload).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax load sin parametros";
				}
			}).then(function (respuesta) {
				try {
					if (respuesta.status == 0) {

						Object.keys(respuesta.bean).forEach(function (item) {
							var domQry = "#" + item;
							var arrayDOM = document.querySelectorAll(domQry);
							if (arrayDOM.length > 0) {
								arrayDOM.forEach(function (itm) {
									if (itm.nodeName == "P") {
										itm.innerHTML = respuesta.bean[item];
									}

									itm.value = respuesta.bean[item];
								});
							}
						});
						//$("#loadercardwifi").hide();
					} else {
						//$("#loadercardwifi").hide();
						$("#encendido").text("Sin configurar");
						console.log("No se cargo bien la info");
					}
				} catch (e) {
					console.error(e);
					throw "Error al traer la informacion";
				}
			}).catch(function (err) {
				console.log("Informacion no Disponible");
				console.log("err=>" + err);
			}).finally(function () {
				$('#modalLoad').modal('hide');
				apunta.getInitialParams();
			});
		}
	}, {
		key: "changeWifi",
		value: function changeWifi(params) {
			$('#modalLoad').modal('show');
			var apuntador = this;
			var data = null;
			var formdata = undefined;
			var url = CONSTANTES.endpoints.changewifi;
			if (params != undefined) {
				if (params.data != undefined) {
					formdata = new URLSearchParams();
					Object.keys(params.data).forEach(function (key) {
						formdata.append(key, params.data[key]);
					});
				}
			}

			var maquetas = undefined;
			if (params != undefined) {
				if (params.maquetas != undefined) {
					maquetas = maquetas;
				}
			}

			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");
			cabeceraMC.append("totalplay", this.ch.obtenerCookieWeb());

			fetch(url, {
				method: "POST",
				body: JSON.stringify(params),
				headers: cabeceraMC
			}).then(function (data) {
				if (data.ok) {
					return data.json();
				} else {
					throw "Error en la llamada Ajax";
				}
			}).then(function (respuesta) {
				try {
					if (respuesta.status == 0) {
						$("#msjTitle").html("\xC9xito");
						$("#msjrespuesta").html("Tu configuraci&oacute;n se ha registrado exitosamente.");
						$('#iconrespuesta').html('<i class="far fa-check-circle fa-3x text-success"></i>');
						$('#modalrespuesta').modal('show');
					} else {
						$("#msjTitle").html("Atenci&oacute;n");
						$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
						$("#msjrespuesta").html(CONSTANTES.mensajes.errorservicio);
						$('#modalrespuesta').modal('show');
						throw "no data avaliable";
					}
				} catch (e) {
					$("#msjTitle").html("Atenci&oacute;n");
					$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
					$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
					$('#modalrespuesta').modal('show');
					console.error(e);
					throw "Error al traer la informacion";
				}
			}).catch(function (err) {
				$("#msjTitle").html("Atenci&oacute;n");
				$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-dangermod"></i>');
				$("#msjrespuesta").html(CONSTANTES.mensajes.errortry);
				$('#modalrespuesta').modal('show');

				console.log("err=>" + err);
			}).finally(function () {
				$('#modalLoad').modal('hide');
				apuntador.cleanData();
				apuntador.loadData(true);
			});
		}
	}, {
		key: "setListenerBoton",
		value: function setListenerBoton() {
			var apuntador = this;

			$("#btnChangeWifi").on("click", function () {
				var ssid = null;
				var sec = null;
				var pwd = null;
				var regSSID = new RegExp(/^[A-Za-z0-9]+$/);
				var flagSSID = false;
				var ssidError = "";
				var seguridadError = "";
				var contrasenaError = "";
				var flagSeguridad = false;
				var flagPassword = false;
				ssid = $("#ssid2").val().trim();
				pwd = $("#pwd").val().trim();
				sec = $("#sec").val().trim();

				if (ssid == apuntador.initialSSID && pwd == apuntador.initialPWD && sec == apuntador.initialSEC) {
					$('#btnChangeWifi').attr('disabled', 'true');

					$("#msjTitle").html("Atenci&oacute;n");
					$('#iconrespuesta').html('<i class=" fas  fa-exclamation-circle fa-3x text-warning"></i>');
					$("#msjrespuesta").html("Para sincronizar, debe cambiar al menos un dato");
					$('#modalrespuesta').modal('show');

					return;
				}

				if (ssid !== null && ssid !== "" && ssid.length >= 8) {
					if (ssid.length <= 20) {
						if (regSSID.test(ssid)) {
							flagSSID = true;
						} else {
							ssidError = "* M\xEDnimo 8,m\xE1ximo 20 caracteres. No uses caracteres especiales. Podr\xE1s cambiarlo cuantas veces quieras.";
							flagSSID = false;
						}
					} else {
						ssidError = "* M\xEDnimo 8, m\xE1ximo 20 caracteres. No uses caracteres especiales. Podr\xE1s cambiarlo cuantas veces quieras.";
						flagSSID = false;
					}
				} else {
					ssidError = "* M\xEDnimo 8, m\xE1ximo 20 caracteres. No uses caracteres especiales. Podr\xE1s cambiarlo cuantas veces quieras.";
					flagSSID = false;
				}

				if (sec === "WPA" || sec === "11i" || sec === "WPAand11i") {
					flagSeguridad = true;
				} else {
					seguridadError = "* Requerido";
					flagSeguridad = false;
				}

				if (pwd !== null && pwd !== "" && pwd.length >= 10) {
					if (pwd.length <= 15) {
						if (regSSID.test(pwd)) {
							if (pwd.match(/[A-Z]/) !== null && pwd.match(/[a-z]/) !== null && pwd.match(/[0-9]/) !== null) {
								flagPassword = true;
							} else {
								//contrasenaError = "* Debes incluir almenos una may\u00FAscula y un n\u00FAmero";
								contrasenaError = "* M\xEDnimo 10 caracteres, m\xE1ximo 15 caracteres. Recuerda incluir al menos una min\xFAscula,una may\xFAscula y un n\xFAmero.";
								flagPassword = false;
							}
						} else {
							//contrasenaError = "* No estan permitidos caracteres especiales, solo letras y numeros";
							contrasenaError = "* M\xEDnimo 10 caracteres, m\xE1ximo 15 caracteres. Recuerda incluir al menos una min\xFAscula,una may\xFAscula y un n\xFAmero.";
							flagPassword = false;
						}
					} else {
						//contrasenaError = "* La longitud m\u00EDnima es de 10 caracteres";
						contrasenaError = "* M\xEDnimo 10 caracteres, m\xE1ximo 15 caracteres. Recuerda incluir al menos una min\xFAscula,una may\xFAscula y un n\xFAmero.";
						flagPassword = false;
					}
				} else {
					//contrasenaError = "* Requerido";
					contrasenaError = "* M\xEDnimo 10 caracteres, m\xE1ximo 15 caracteres. Recuerda incluir al menos una min\xFAscula,una may\xFAscula y un n\xFAmero.";
					flagPassword = false;
				}

				if (flagSSID === true && flagSeguridad === true && flagPassword === true) {
					/*$("#helperPwd").css("display", "none");
     $("#helperSsid").css("display", "none");
     $("#helperSec").css("display", "none");*/
					$("#helperPwd").removeClass("text-danger");
					$("#helperPwd").addClass("text-muted");

					$("#helperSsid").removeClass("text-danger");
					$("#helperSsid").addClass("text-muted");

					$("#helperSec").removeClass("text-danger");
					$("#helperSec").addClass("text-muted");

					var payload = { ssid: ssid, ssid2: ssid, sec: sec, pwd: pwd };
					var secdat = otpyrc2(JSON.stringify(payload));

					apuntador.changeWifi({ secdata: secdat });
				} else {
					if (contrasenaError !== "") {
						/*$("#helperPwd").text(contrasenaError);
      $("#helperPwd").css("display", "block");*/
						$("#helperPwd").removeClass("text-muted");
						$("#helperPwd").addClass("text-danger");
					}

					if (ssidError !== "") {
						/*$("#helperSsid").text(ssidError);
      $("#helperSsid").css("display", "block");*/
						$("#helperSsid").removeClass("text-muted");
						$("#helperSsid").addClass("text-danger");
					}

					if (seguridadError !== "") {
						/*$("#helperSec").text(seguridadError);
      $("#helperSec").css("display", "block");*/
						$("#helperSec").removeClass("text-muted");
						$("#helperSec").addClass("text-danger");
					}
				}
			});
		}
	}, {
		key: "setListeners",
		value: function setListeners() {
			var apuntador = this;
			var timeout = null;

			$('#ssid2').keyup(function () {
				clearTimeout(timeout);

				timeout = setTimeout(function () {

					if (apuntador.initialSSID != $('#ssid2').val()) {

						$('#btnChangeWifi').removeAttr('disabled');
					} else {
						//$('#btnChangeWifi').attr('disabled','true');
					}
				}, 500);
			});

			$('#pwd').keyup(function () {
				clearTimeout(timeout);

				timeout = setTimeout(function () {

					if (apuntador.initialPWD != $('#pwd').val()) {

						$('#btnChangeWifi').removeAttr('disabled');
					} else {
						//$('#btnChangeWifi').attr('disabled','true');
					}
				}, 500);
			});

			$('#sec').change(function () {
				clearTimeout(timeout);

				timeout = setTimeout(function () {

					if (apuntador.initialSEC != $('#sec').val()) {

						$('#btnChangeWifi').removeAttr('disabled');
					} else {
						//$('#btnChangeWifi').attr('disabled','true');
					}
				}, 500);
			});
		}
	}, {
		key: "getInitialParams",
		value: function getInitialParams() {

			this.initialSSID = $('#ssid2').val();
			this.initialPWD = $('#pwd').val();
			this.initialSEC = $('#sec').val();
		}
	}, {
		key: "cleanData",
		value: function cleanData() {

			$('#ssid').val('');
			$('#ssid2').val('');
			$('#pwd').val('');
			$('#sec').val('');
		}
	}]);

	return Wifi;
}();

},{"../../utils/Constantes":48,"../../utils/CookieHelper":49,"../../utils/ModalMng":50}],46:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.JwtBO = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _JwtDAO = require('../../dao/JwtDAO/JwtDAO');

var _Constantes = require('../../../utils/Constantes');

var CONSTANTES = _interopRequireWildcard(_Constantes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var JwtBO = exports.JwtBO = function () {
    function JwtBO() {
        _classCallCheck(this, JwtBO);

        this.jwtDAO = new _JwtDAO.JwtDAO();
        this.init();
    }

    _createClass(JwtBO, [{
        key: 'init',
        value: function init() {}
    }, {
        key: 'solicitaSesionTotalShop',
        value: function solicitaSesionTotalShop() {
            var _this = this;

            return new Promise(function (done, reject) {
                _this.jwtDAO.solicitaSesionTotalShop().then(function (res) {
                    done(res);
                }, function (err) {
                    console.log(err);
                    reject('');
                }); /* fin del then*/
            }); /* fin de la promesa*/
        }
    }, {
        key: 'validarSesionTotalShop',
        value: function validarSesionTotalShop(id_token) {
            var _this2 = this;

            return new Promise(function (done, reject) {
                _this2.jwtDAO.validarSesionTotalShop(id_token).then(function (res) {
                    done(res);
                }, function (err) {
                    console.log(err);
                    reject('');
                }); /* fin del then*/
            }); /* fin de la promesa*/
        }
    }, {
        key: 'validaTokenRedirecciona',
        value: function validaTokenRedirecciona(urlRedirect) {
            var _this3 = this;

            $('#modalLoad').modal('show');

            if (localStorage.getItem("sesionTTSHP")) {
                if (localStorage.getItem("sesionTTSHP_Estatus") == "1") {
                    //solictar validacion de token y dependiendo lo que responda
                    // hacer lo siguiente
                    var token_id = JSON.parse(localStorage.getItem("sesionTTSHP")).bean.id_token;
                    this.validarSesionTotalShop(token_id).then(function (res) {
                        _this3.getInfoRedirect(urlRedirect);
                    }, function (err) {
                        _this3.solicitaTokenRedirect(urlRedirect);
                    });
                } else if (localStorage.getItem("sesionTTSHP_Estatus") == "0") {
                    this.getInfoRedirect(urlRedirect);
                }
            } else {
                this.solicitaTokenRedirect(urlRedirect);
            }
        }
    }, {
        key: 'solicitaTokenRedirect',
        value: function solicitaTokenRedirect(urlRedirect) {
            var _this4 = this;

            this.solicitaSesionTotalShop().then(function (res) {
                localStorage.setItem("sesionTTSHP", JSON.stringify(res));
                _this4.getInfoRedirect(urlRedirect);
            }, function (err) {
                console.log(err);
                alert("Ocurrio un error.");
            }).finally(function (final) {});
        }
    }, {
        key: 'modalLoading',
        value: function modalLoading(tiempo) {
            if ($('#modalLoad').is(":visible")) {
                setTimeout(function () {
                    $('#modalLoad').modal('hide');
                }, tiempo);
            }
        }
    }, {
        key: 'getInfoRedirect',
        value: function getInfoRedirect(urlRedirect) {

            var path02 = this.redireccionar("originPath");
            var parametro02 = path02 != false ? "&" + path02 : "";

            var token_id = JSON.parse(localStorage.getItem("sesionTTSHP")).bean.id_token;
            var url_redirect = JSON.parse(localStorage.getItem("sesionTTSHP")).bean.url_redirect;

            var urlTienda = urlRedirect != null ? urlRedirect : url_redirect;
            //let urlTienda = url_redirect;
            var path = "/login/token/";

            localStorage.setItem("sesionTTSHP_Estatus", "1");

            if (urlRedirect != null && urlRedirect == url_redirect) {
                this.modalLoading(1200000);
                window.location.href = urlTienda + path + "" + token_id + parametro02;
            } else if (urlRedirect == null) {
                this.modalLoading(1200000);
                window.location.href = urlTienda + path + "" + token_id + parametro02;
            } else {
                this.modalLoading(1200000);
                window.location.href = urlTienda + path + "" + token_id + parametro02;
                /* Para produccion descomentar estas lineas y eliminar las dos
                lineas anteriores para que no entre asi de facin si
                la url no es la autorizada
                
                this.modalLoading(10);
                alert("Redireccionamiento no autorizado.");
                */
            }
        }
    }, {
        key: 'redireccionar',
        value: function redireccionar(parametro) {
            switch (parametro) {
                case "originPath":
                    var valor = this.getUrlParameter(parametro);

                    if (this.isUndefined(valor)) {
                        return false;
                    } else {
                        return parametro + "=" + valor;
                    }

                    break;

                default:
                    var urlRedirect = this.getUrlParameter('fromSite');
                    if (this.isUndefined(urlRedirect)) {
                        return false;
                    } else {
                        return urlRedirect;
                    }
                    break;
            }
        }
    }, {
        key: 'isUndefined',
        value: function isUndefined(x) {
            return typeof x == "undefined";
        }
    }, {
        key: 'getUrlParameter',
        value: function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
        }
    }, {
        key: 'usuarioValido',
        value: function usuarioValido() {
            if (localStorage.getItem("sesionTTSHP")) {
                if (localStorage.getItem("sesionTTSHP") != "null") {
                    var status = JSON.parse(localStorage.getItem("sesionTTSHP")).status;
                    var autorizado = status == "-112" ? false : true;
                    return autorizado;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    }]);

    return JwtBO;
}();

},{"../../../utils/Constantes":48,"../../dao/JwtDAO/JwtDAO":47}],47:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.JwtDAO = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Constantes = require("../../../utils/Constantes");

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _CookieHelper = require("../../../utils/CookieHelper");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var JwtDAO = exports.JwtDAO = function () {
    function JwtDAO() {
        _classCallCheck(this, JwtDAO);

        this.ch = new _CookieHelper.CookieHelper();
        this.init();
    }

    _createClass(JwtDAO, [{
        key: "init",
        value: function init() {}
    }, {
        key: "solicitaSesionTotalShop",
        value: function solicitaSesionTotalShop() {
            var _this = this;

            return new Promise(function (done, reject) {
                var urlGetjwt = CONSTANTES.endpoints.urlGetjwt;
                var apuntador = _this;
                var datosRes = null;

                var cabeceraMC = new Headers();
                cabeceraMC.append("Content-Type", "application/json");
                cabeceraMC.append("totalplay", "2020jwt");

                var raw = JSON.stringify({
                    headers: {
                        "totalplay": _this.ch.obtenerCookieWeb()
                    },
                    method: "POST",
                    body: {
                        "jwtSesion": "true"
                    }

                });

                fetch(urlGetjwt, {
                    method: "POST",
                    headers: cabeceraMC,
                    body: raw
                }).then(function (data) {
                    if (data.ok) {
                        return data.json();
                    } else {
                        throw "Error en la llamada Ajax getJWT load sin parametros";
                    }
                }).then(function (respuesta) {
                    if (respuesta.status == 0 || respuesta.status - 112) {
                        datosRes = respuesta;
                    }
                }).catch(function (err) {
                    console.log("Informacion JWT no Disponible");
                    console.log("err=>" + err);
                }).finally(function () {
                    /* cuando termina la peticion post */
                    done(datosRes);
                });
            }); /* fin de la promesa*/
        }
    }, {
        key: "validarSesionTotalShop",
        value: function validarSesionTotalShop(id_token) {
            var _this2 = this;

            return new Promise(function (done, reject) {
                var urlGetjwt = CONSTANTES.endpoints.urlGetjwt;
                var apuntador = _this2;
                var datosRes = null;

                var cabeceraMC = new Headers();
                cabeceraMC.append("Content-Type", "application/json");
                cabeceraMC.append("totalplay", "2020jwt");

                var raw = JSON.stringify({
                    headers: {
                        "totalplay": _this2.ch.obtenerCookieWeb()
                    },
                    method: "POST",
                    body: {
                        "id_token": id_token
                    }

                });

                var estatus = false;

                fetch(urlGetjwt, {
                    method: "POST",
                    headers: cabeceraMC,
                    body: raw
                }).then(function (data) {
                    if (data.ok) {
                        return data.json();
                    } else {
                        throw "Error en la llamada Ajax getJWT load sin parametros";
                    }
                }).then(function (respuesta) {
                    if (respuesta.status == 0) {
                        datosRes = respuesta;
                        estatus = true;
                    }
                }).catch(function (err) {
                    console.log("Informacion JWT no Disponible");
                    console.log("err=>" + err);
                }).finally(function () {
                    /* cuando termina la peticion post */
                    if (estatus == true) {
                        done(datosRes);
                    } else {
                        reject();
                    }
                });
            }); /* fin de la promesa*/
        }
    }]);

    return JwtDAO;
}();

},{"../../../utils/Constantes":48,"../../../utils/CookieHelper":49}],48:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _base = "https://hyubm2fzmb.execute-api.us-east-1.amazonaws.com/DESAROLLO/micuenta/";
var _baseshop = "https://hyubm2fzmb.execute-api.us-east-1.amazonaws.com/DESAROLLO/totalplayshop/";

//let _base="https://s6jn0rk3z1.execute-api.us-east-1.amazonaws.com/PROD/micuenta/";
//let _baseshop="https://s6jn0rk3z1.execute-api.us-east-1.amazonaws.com/PROD/totalplayshop/";

if (window.location.host.includes("avisopago.totalplay.com.mx")) {

    _base = "https://www.avisopago.totalplay.com.mx/PROD/micuenta/";
    _baseshop = "https://www.avisopago.totalplay.com.mx/PROD/totalplayshop/";
}

var endpoints = exports.endpoints = {
    login: _base + "login",
    crearcuenta: _base + "crear-cuenta",
    logout: _base + "logout",
    getdatoscliente: _base + "obtener-datos-cliente",
    recuperacontrasenia: _base + "recuperar-contrasenia",
    recomendados: _base + "obtener-recomendados",
    insertRecomendado: _base + "crear-recomendados",
    getserviciobin: _base + "obtener-info-bin",
    guardartarjeta: _base + "guardar-tarjeta",
    tarjetas: _base + "obtener-tarjetas",
    saldo: _base + "obtener-estatus-pago",
    urlPlan: _base + "obtener-plan",
    changepass: _base + "actualizar-contrasenia",
    infoWifi: _base + "validar-wifi",
    changewifi: _base + "actualizar-wifi",
    getportabilidad: _base + "obtener-portabilidad",
    guardaportabilidad: _base + "guardar-portabilidad",
    pagotarjetaexistente: _base + "pagar-tarjeta-existente",
    pagonuevatarjeta: _base + "pagar-nueva-tarjeta",
    ottParams: _base + "obtener-ott-param",
    sendinterfact: _base + "enviar-interfactura",
    obtenerEstatusOt: _base + "seg-obtener-ots",
    getFotografia: _base + "seg-obtener-fotografia",
    getEstatusOt: _base + "seg-obtener-estatus-ot",
    getInfoPaquete: _base + "seg-obtener-paquete",
    getDatosEmpleado: _base + "seg-obtener-instalador",
    getEncuesta: _base + "seg-obtener-encuesta",
    saveEncuesta: _base + "obtener-guardar-encuesta",
    ultimasfacturas: _base + "obtener-ultimas-facturas",
    validasession: _base + "validar-session",
    validarnetflix: _base + "obtener-es-netflix",
    verificarnetflix: _base + "obtener-estatus-netflix",
    generartok: _base + "obtener-token-netflix",
    getaddonsnetflix: _base + "obtener-netflix-addons",
    compraraddonsnetflix: _base + "crear-compra-addon-netflix",
    editatarjeta: _base + "actualizar-tarjeta",
    eliminatarjeta: _base + "eliminar-tarjeta",
    getcontrato: _base + "obtener-contrato",
    obteneroferta: _base + "obtener-oferta-prepago",
    obtenerhistorial: _base + "obtener-historial-prepago",
    comprarecarga: _base + "comprar-recarga-prepago",
    saldoprepago: _base + "obtener-saldo-prepago",
    getRecargaActual: _base + "obtener-recarga-actual",
    planprepago: _base + "obtener-plan-prepago",
    obtenerbitacora: _base + "consultar-bitacora",
    obtenerbundle: _base + "obtener-tipo-bundle",
    obtenerestatusamazon: _base + "obtener-estatus-amazon",
    obtenerurlamazon: _base + "obtener-url-amazon",
    obtenersegmentacion: _base + "obtener-segmentacion",
    generarregistro: _base + "registrar-addon-amazon",
    generarauth: _base + "generar-autenticacion",
    verificarauth: _base + "verificar-autenticacion",
    urlGetjwt: _baseshop + "administrar-token-jwt",
    obteneraddons: _base + "consultar-adicionales",
    compraraddons: _base + "comprar-adicionales",
    obteneract: _base + "consultar-activaciones",
    crearact: _base + "generar-activaciones",
    revisaract: _base + "revisar-activacion",
    disponibilidad: _base + "consultar-disponibilidad",
    agendamiento: _base + "generar-agendamiento",
    convivencia: _base + "validar-convivencia",
    guardarpaypal: _base + "guardar-paypal",
    obtenerFacturas: _base + "obtener-facturas",
    obtenerDocumentos: _base + "obtener-documentos",
    adminGC: _base + "admin-users-genera-codigo",
    adminVC: _base + "admin-users-verifica-codigo",
    clubmovilConsultar: _base + "consultar-club-wifi",
    clubmovilActivar: _base + "agregar-club-wifi",
    clubmovilDesactivar: _base + "remover-club-wifi",
    clubmovilSesiones: _base + "eliminar-sesiones-club-wifi",
    clubmovilUbicacion: _base + "obtener-coordenadas",
    clubmovilSP: _base + "localizar-sitios",
    obtenerEstatusDisney: _base + "obtener-estatus-disney",
    obtenerUrlDisney: _base + "obtener-url-disney",
    obtenerEstatusMigracion: _base + "obtener-estatus-migracion",
    creditoTarjeta: _base + "credito-obtener-tarjeta",
    creditoPago: _base + "credito-pagar-tarjeta",
    creditoPagoTE: _base + "credito-pagar-tarjeta-existente",
    creditoNIP: _base + "credito-obtener-nip",
    creditoBloqueoTarjeta: _base + "credito-bloqueo-tarjeta",
    creditoMovimientos: _base + "credito-obtener-movimientos",
    creditoReferencias: _base + "credito-obtener-referencias",
    creditoObtenerEstadoCuenta: _base + "credito-obtener-estado-cuenta",
    creditoEnviarEstadoCuenta: _base + "credito-enviar-estado-cuenta",
    reformafiscalconsultar: _base + "rf-consultar",
    reformafiscaleditar: _base + "rf-editar",
    reformafiscalcreaticket: _base + "ticket-servicio-cliente",
    dobleautenticacion: _base + "doble-autenticacion",
    revisarSesiones: _base + "revisar-session",
    cerrarSesiones: _base + "cerrar-sessiones",
    validarFactibilidad: _base + "consultar-factibilidad",
    obtenerDisponibilidad: _base + "consulta-disponibilidad-cd",
    crearTicketCD: _base + "crear-ticket-sf",
    crearAgendamiento: _base + "crear-agendamiento-cd",
    enviarValidarToken: _base + "enviar_token",
    actualizarPassword: _base + "actualizar-password",
    obtieneUrlAcuerdoPayPal: _base + "url-agreement-paypal",
    procesaPagoPayPalF2: _base + "pay-process-paypal"
};

var varSitioBase = "";

if (location.pathname.includes("micuenta")) varSitioBase = "micuenta/";

var sitioBase = exports.sitioBase = "/" + varSitioBase;

var storedKeys = exports.storedKeys = {
    dashboard: "dashboardData",
    pn: "pn",
    storenet1: "isnetflix",
    storenet2: "statusnetflix",
    storeprepago: "tipocliente",
    recargaprepago: "recarga",
    storebundle: "tipobundle",
    storeshop: "sesionTTSHP",
    statusshop: "sesionTTSHP_Estatus"

};

var EndpointNetflix = exports.EndpointNetflix = "https://www.netflix.com/partner/home?ptoken=";

var modals = exports.modals = {
    modalRegistroCuenta: {
        id: "logMdlNewAcc",
        title: "Reg&iacute;strate en Mi Cuenta Totalplay",
        dismisable: true,
        contenido: "<div class=\"row mt-3\">\n                    <div class=\"col-12 col-sm-12 col-md-10 mx-auto\">\n                        <p style=\"text-align: justify;\">Consulta de manera segura y sencilla el saldo de tu cuenta, realiza tu pago en l&iacute;nea y mucho m&aacute;s.</p>\n                    </div>\n                </div>\n                <div class=\"row mt-3\">                    \n                    <div class=\"col-12 col-sm-12 col-md-10 mx-auto\">\n                        <p style=\"text-align: justify;\">Para iniciar tu registro, deber&aacute;s proporcionar uno de los siguientes datos:</p>                        \n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-12 col-sm-12 col-md-10 mx-auto\">\n                        <p>- N&uacute;mero de cuenta</p>    \n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-12 col-sm-12 col-md-10 mx-auto\">\n                        <p>- N&uacute;mero telef&oacute;nico de Totalplay (a 10 d&iacute;gitos)</p>    \n                    </div>\n                </div>\n                <div class=\"row mt-3\">\n                    <div class=\"col-12 col-sm-12 col-md-10 mx-auto\">\n                        <p style=\"text-align: justify;\"> Con esta informaci&oacute;n te enviaremos al correo electr&oacute;nico que registraste tu contrase&ntilde;a temporal con la que podr&aacute;s acceder a tu cuenta. </p>    \n                    </div>\n                </div>\n                <div class=\"row mt-3\">\n                    <div class=\"col-12 col-sm-12 col-md-10 mx-auto\">\n                        <p class=\"clr-red\"> Te recomendamos cambiar tu contrase&ntilde;a temporal desde la opci&oacute;n \"Inicio de sesi&oacute;n y Seguridad\" </p>\n                        </br>    \n                    </div>\n                </div>\n                <div class=\"row mt-3\">\n                    <div class=\"col-10 mx-auto\">\n\n                        <div class=\"floating-label\">      \n                            <input class=\"borinp floating-input\" id=\"inputUserNwAcc\" maxlength=\"10\" type=\"text\" placeholder=\" \" autocomplete=\"off\">\n                            <label>N&uacute;mero de cuenta &oacute; tel&eacute;fono:</label>\n                        </div>\n                        <div class=\"div-err\">\n                            <span class=\"text-danger\" id=\"err-log-md-1\" style=\"display:none\"></span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row mt-3\">\n                    <div class=\"col-12 col-lg-10 mx-auto\">\n                            <div class=\"alert alert-danger\" role=\"alert\" id=\"log-msj-err-md-1\" style=\"display:none;font-size:1.5rem;\"></div>\n                            <div class=\"alert alert-success\" role=\"alert\" id=\"log-msj-suc-md-1\" style=\"display:none;font-size:1.5rem;\"></div>\n                    </div>\n                </div>\n                <div class=\"row mt-3\">\n                    <div class=\"col-12 col-sm-12 col-md-8 col-lg-6 mx-auto d-flex justify-content-center\">\n                        <button type=\"button\" class=\"boton boton-azul\" id=\"log-btn-crecue\" disabled>Crear cuenta</button>\n                    </div>\n                </div>"
    },
    modalPassRecovery: {
        id: "logMdlRecPas",
        title: "Recupera tu contrase&ntilde;a",
        dismisable: true,
        contenido: "<div class=\"row mt-3\">\n                    <div class=\"col-12 col-sm-12 col-md-10 mx-auto\">\n                        <p style=\"text-align: justify;\">Para recuperar tu contrase&ntilde;a, deber&aacute;s proporcionar uno de los siguientes datos:</p>\n                    </div>\n                </div>                \n                <div class=\"row\">\n                    <div class=\"col-12 col-sm-12 col-md-10 mx-auto\">\n                        <p>- N&uacute;mero de cuenta</p>    \n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-12 col-sm-12 col-md-10 mx-auto\">\n                        <p>- N&uacute;mero telef&oacute;nico de Totalplay (a 10 d&iacute;gitos)</p>    \n                    </div>\n                </div>\n                <div class=\"row mt-3\">\n                    <div class=\"col-12 col-sm-12 col-md-10 mx-auto\">\n                        <p style=\"text-align: justify;\"> Con esta informaci&oacute;n te enviaremos al correo electr&oacute;nico que registraste tu contrase&ntilde;a temporal con la que podr&aacute;s acceder a tu cuenta. </p>    \n                    </div>\n                </div>\n                <div class=\"row mt-3\">\n                    <div class=\"col-12 col-sm-12 col-md-10 mx-auto\">\n                        <p class=\"clr-red\" style=\"text-align: justify;\"> Te recomendamos cambiar tu contrase&ntilde;a temporal desde la opci&oacute;n  \"Inicio de sesi&oacute;n y Seguridad\" </p>    \n                        </br> \n                    </div>\n                </div>\n                <div class=\"row mt-3\">\n                    <div class=\"col-10 mx-auto\">\n                        <div class=\"floating-label\">      \n                            <input class=\"borinp floating-input\" id=\"inputPassRecoverys\" maxlength=\"10\" type=\"text\" placeholder=\" \" autocomplete=\"off\">\n                            <label>N&uacute;mero de cuenta &oacute; tel&eacute;fono:</label>\n                            \n                        </div>\n                        <div class=\"div-err\">\n                            <span class=\"text-danger sz-12\" id=\"err-log-md-2\" style=\"display:none\"></span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row mt-3\">\n                    <div class=\"col-12 col-lg-10 mx-auto\">\n                            <div class=\"alert alert-danger\" role=\"alert\" id=\"log-msj-err-md-2\" style=\"display:none;font-size:1.5rem;\"></div>\n                            <div class=\"alert alert-success\" role=\"alert\" id=\"log-msj-suc-md-2\" style=\"display:none;font-size:1.5rem;\"></div>\n                    </div>\n                </div>\n                <div class=\"row mt-3\">\n                    <div class=\"col-12 col-sm-12 col-md-8 col-lg-6 mx-auto d-flex justify-content-center\">\n                        <button type=\"button\" class=\"boton boton-azul\" id=\"log-btn-recpas\" disabled>Recuperar contrase&ntilde;a</button>\n\n                    </div>\n                </div>"
    },
    logMdlMsjToUser: {
        id: "logMdlMsjToUser",
        //title: `<span id="mdlTitToUser"></span>`,
        dismisable: true,
        contenido: "<div class=\"row\">                    \n                    <div class=\"col-12 col-md-10 mx-auto\">\n                        <div class=\"text-center\">\n                            <p class=\"phIconResp\" id=\"iconrespuesta\"></p>\n                        </div>\n                        <div class=\"text-center\">\n                            <p class=\"modal-titulo\"><span id=\"mdlTitToUser\"></span></p>\n                        </div>\n                        <div id=\"mdlBodyToUser\">\n                \n                        </div>\n                    </div>\n                </div>                \n                <div class=\"row pt-5\">\n                    <div class=\"col-6 col-md-8 mx-auto\" align=\"center\">\n                        <button class=\"boton boton-azul\" data-dismiss=\"modal\">Aceptar</button>\n                    </div>\n                </div>                \n            </div>"
    },
    wifiModal: {
        id: "myModalMsj",
        title: "<span id=\"msjTitleWiFi\"></span>",
        dismisable: true,
        contenido: "<div class=\"row text-center m-3\">\n                <div class=\"col-12 mt-4\">\n                    <p class=\"sz-18 mt-4\" id=\"msjBody\"></p>\n                </div>\n                <div class=\"col-8 offset-2 py-3\">\n                    <button id=\"btnOkWifi\" type=\"button\" class=\"btn btn-primary btn-br-34 p-3\" data-dismiss=\"modal\">ACEPTAR</button>\n                </div>\n            </div> "
    },
    recomendados: {
        id: "modalrespuesta",
        dismisable: true,
        contenido: "<div class=\"row text-center\">\n                    <div class=\"col-12 mt-3 mb-3\">\n                        <p class=\"phIconResp\" id=\"iconrespuesta\"></p>\n                    </div>\n                    <div class=\"col-12 mb-3\">\n                        <p class=\"modal-titulo\"><span id=\"msjTitle\"></span></p>\n                    </div>\n                    <div class=\"col-12 mb-3\">\n                        <span class=\"spnMsjResp mx-2\" id=\"msjrespuesta\"></span>\n                    </div>\n                    <div class=\"col-12 mt-4 mb-2\" align=\"center\">\n                        <button id=\"aceptarespuesta\" class=\"boton boton-azul\" data-dismiss=\"modal\">Entendido</button>\n                    </div>\n                </div>"
    },
    seguridad: {
        id: "modalcambiacontrasenia",
        title: "Edita tu contrase&ntilde;a",
        dismisable: false,
        contenido: "\n                <div class=\"col-10 offset-1 my-4 subtitulo\" >\n                    <p id=\"subtitulo\" class=\"modal-subseguridad\" >Al menos debe tener 8 carateres, 1 may\xFAscula y 1 n\xFAmero.</p>\n                </div>\n                <div class=\"col-10 offset-1 mt-4\">\n                    <div class=\"form-group mt-4\">\n                        <div class=\"floating-label\">      \n                            <input class=\"borinp floating-input\" type=\"password\" id=\"passnew\" placeholder=\" \"\n                            autocomplete=\"off\" maxlength=\"50\">\n                            <label>Tu nueva contrase\xF1a</label>\n                        </div>\n                        <p class=\"helper text-danger\" id=\"errorpass\"></p>\n                    </div>                                                        \n                    <div class=\"form-group mt-4\">\n                        <div class=\"floating-label\">      \n                            <input class=\"borinp floating-input\" type=\"password\" id=\"passconf\" placeholder=\" \"\n                            autocomplete=\"off\" maxlength=\"50\">\n                            <label>Repite tu nueva contrase\xF1a</label>\n                        </div>\n                        <p class=\"helper text-danger\" id=\"errorconf\"></p>\n                    </div>\n                    <div class=\"form-group\">\n                        <p class=\"password text-left\">Nivel de seguridad:</p>\n                        <div class=\"progress mt-3\" >\n                            <div class=\"progress-bar\" id=\"nivel\" ></div>\n                        </div>\n                        <p class=\"col-12 niveltxt pt-3 password text-center\" id=\"niveltxt\"></p>\n                    </div>\n                </div><br>",
        botonera: "<div class=\"form-group\" align=\"center\">\n                <button id=\"btnAceptar\" type=\"button\" class=\"boton boton-azul\" disabled>Aceptar</button>\n            </div>\n            <div class=\"col-8 offset-2 py-2 text-center\">\n                <span id=\"errorenvio\" class=\"helper text-danger\"></span>\n            </div> "
    }
};

var mensajes = exports.mensajes = {
    errorservicio: "El proceso no pudo completarse, int&eacute;ntalo nuevamente o " + "comun&iacute;cate a nuestro centro de Atenci&oacute;n a Clientes.",
    errortry: "El proceso no pudo completarse, int&eacute;ntalo nuevamente o comun&iacute;cate " + "a nuestro centro de Atenci&oacute;n a Clientes."
};

var captcha = exports.captcha = {
    valor: "6LctDsEUAAAAADnJHJ90zZl27kLv8o2Wsstd6h3E"
    //valor: "6LfacNYUAAAAAI1KmaqiAbDF0pkws8wAPX1wrsc1"
};

},{}],49:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CookieHelper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.obtenerCookieWeb = obtenerCookieWeb;

var _Constantes = require('./Constantes');

var CONSTANTES = _interopRequireWildcard(_Constantes);

var _helpers = require('./helpers');

var _JwtBO = require('../servicios/bo/JwtBO/JwtBO');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function obtenerCookieWeb(nombre) {
	var nameEQ = nombre + "=";
	var ca = document.cookie.split(';');

	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1, c.length);
		}if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

var CookieHelper = exports.CookieHelper = function () {
	function CookieHelper(signature) {
		_classCallCheck(this, CookieHelper);

		this.props = {
			cookieSignature: signature,
			cookieName: "Y29va2lldHAyMDE5",
			tipocliente: null
		};
		this.siteBase = CONSTANTES.sitioBase;
		this.revisatipocliente();
	}

	_createClass(CookieHelper, [{
		key: 'revisatipocliente',
		value: function revisatipocliente() {
			var key = CONSTANTES.storedKeys.storeprepago;
			var bean = localStorage.getItem(key);
			var tipo = 0;
			if (bean != null && bean != undefined) {
				bean = JSON.parse(bean);
				if (bean.tipocliente != undefined && bean.tipocliente != null && bean.tipocliente != "") {
					tipo = bean.tipocliente;
				}
			}
			this.props.tipocliente = tipo;
			//this.props.tipocliente=tipo
		}
	}, {
		key: 'redirigeTipoCliente',
		value: function redirigeTipoCliente(ruta, tCliente) {
			ruta = ruta.replace(/\.html/g, "").replace(/^\//g, "");
			var rutas = (0, _helpers.RouteS)(CONSTANTES.sitioBase);
			console.log(rutas[ruta].tipo);
			var estatus = true;

			rutas[ruta].tipo.forEach(function (elem) {
				//console.log("******************"+elem+"--"+tCliente);
				if (elem != "publico") {
					if (tCliente == elem) {
						estatus = false;
					}
				} else {
					estatus = false;
				}
			});
			if (estatus) {
				window.location.replace(CONSTANTES.sitioBase + "errores/accesodenegado");
			}
		}
	}, {
		key: 'leakContainer',
		value: function leakContainer() {
			var _this = this;

			var apunta = this;
			var ruta = window.location.pathname;
			if (!this.checkCookie() && !(0, _helpers.RouteMatcher)(ruta, this.siteBase)) {
				//si no hay cookie
				apunta.dismissCookie();
				window.location.replace(apunta.siteBase);
			} else {
				this.checkSession().then(function (response) {
					if (!response) {
						//cookie existente pero invalida
						if (!(0, _helpers.RouteMatcher)(ruta, apunta.siteBase)) {
							apunta.dismissCookie();
							window.location.replace(apunta.siteBase);
						}
					} else {
						_this.jwtBO = new _JwtBO.JwtBO();
						if ((0, _helpers.RouteMatcher)(ruta, apunta.siteBase)) {
							var redireccion = _this.jwtBO.redireccionar(null);
							if (redireccion == false) {
								window.location.replace(apunta.siteBase + "dashboard.html");
							} else {
								if (_this.jwtBO.usuarioValido()) {
									_this.jwtBO.validaTokenRedirecciona(redireccion);
								} else {
									window.location.replace(apunta.siteBase + "dashboard.html");
								}
							}
						}
						apunta.redirigeTipoCliente(ruta, apunta.props.tipocliente);
					}
				}).catch(console.error);
			}
		}
	}, {
		key: 'obtenerCookieWeb',
		value: function obtenerCookieWeb() {
			var nameEQ = this.props.cookieName + "=";
			var ca = document.cookie.split(";");

			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == " ") {
					c = c.substring(1, c.length);
				}if (c.indexOf(nameEQ) == 0) {
					return c.substring(nameEQ.length, c.length);
				}
			}
			return null;
		}
	}, {
		key: 'crearCookie',
		value: function crearCookie() {
			var _this2 = this;

			if (!this.checkCookie()) {
				var d = new Date();
				var cant = 60;
				d.setTime(d.getTime() + cant * 60 * 60 * 1000);
				var expires = ";expires=" + d.toUTCString();
				this.secureRandomNumber().then(function (rdnSecure) {
					document.cookie = _this2.props.cookieName + "=" + rdnSecure + expires + ";path=" + _this2.siteBase + ";domain=" + document.location.hostname + ";SameSite=strict;";
				}).catch(function (error) {

					var caracteres = "abcdefghijkmnpqrtuvwxyzABCDEFGHJKMNPQRTUVWXYZ2346789";
					var aleatoriocokie = "";
					for (i = 0; i < 40; i++) {
						aleatoriocokie += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
					}document.cookie = _this2.props.cookieName + "=" + aleatoriocokie + expires + ";path=" + _this2.siteBase + ";domain=" + document.location.hostname + ";SameSite=strict;";
				});
			}
		}
	}, {
		key: 'cookieIntentos',
		value: function cookieIntentos() {
			console.log("vamo a intentar................... nueva cokkie");

			var d = new Date();
			var mas = 10 * 60 * 1000;
			console.log("minutos... mas", mas);
			d.setTime(d.getTime() + mas);
			var expires = ";expires=" + d.toUTCString();
			console.log("expires", expires);

			var data = this.obtenerCookieWebN("intentos");
			console.log("data obtenerCookieWebN", data);
			if (data != "" && data != null) {
				var numintentos = parseInt(data) + 1;
				console.log("numintentos", numintentos);
				document.cookie = "intentos=" + numintentos + expires + ";path=" + this.siteBase + ";domain=" + document.location.hostname + ";SameSite=strict;";
			} else {

				document.cookie = "intentos=1" + expires + ";path=" + this.siteBase + ";domain=" + document.location.hostname + ";SameSite=strict;";
			}
		}
	}, {
		key: 'obtenerCookieWebN',
		value: function obtenerCookieWebN(nombre) {
			var nameEQ = nombre + "=";
			var ca = document.cookie.split(';');

			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1, c.length);
				}if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
			}
			return null;
		}
	}, {
		key: 'clearStorage',
		value: function clearStorage() {
			return new Promise(function (resolve, reject) {
				if (localStorage != null && localStorage != undefined) {

					Object.keys(CONSTANTES.storedKeys).forEach(function (key) {
						localStorage.removeItem(CONSTANTES.storedKeys[key]);
					});
					resolve("cleared");
				} else {
					resolve("no data 2 clear");
				}
			});
		}
	}, {
		key: 'secureRandomNumber',
		value: function secureRandomNumber() {
			var array = new Uint32Array(3);
			var rdnVal = window.crypto.getRandomValues(array);
			return this.digestMessage(rdnVal);
		}
	}, {
		key: 'digestMessage',
		value: async function digestMessage(message) {
			var msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
			var hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8); // hash the message
			var hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
			var hashHex = hashArray.map(function (b) {
				return b.toString(16).padStart(2, '0');
			}).join(''); // convert bytes to hex string

			return hashHex.substring(0, 16);
		}
	}, {
		key: 'dismissCookie',
		value: function dismissCookie() {
			var _this3 = this;

			var apuntador = this;
			this.clearStorage().then(function () {
				document.cookie = _this3.props.cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
				return "exito";
			}).then(function () {
				_this3.crearCookie();
			});
		}
	}, {
		key: 'checkCookie',
		value: function checkCookie() {
			var data = this.obtenerCookieWeb();
			if (data != "" && data != null) {
				return true;
			}
			return false;
		}
	}, {
		key: 'checkSession',
		value: function checkSession() {
			var validSession = false;
			var url = CONSTANTES.endpoints.validasession;

			var cabeceraMC = new Headers();
			cabeceraMC.append("Content-type", "application/json;charset=utf-8");
			cabeceraMC.append("totalplay", this.obtenerCookieWeb());

			var cookie = this.obtenerCookieWeb();
			if (cookie == null) {
				return new Promise(function (resolve) {
					resolve(false);
				});
			}
			return new Promise(function (resolve, reject) {

				fetch(url, {
					method: "POST",
					headers: cabeceraMC
				}).then(function (data) {
					if (data.ok) {
						return data.json();
					} else {
						throw "Fail 2 fech Valid Session";
					}
				}).then(resolve).catch(function (err) {
					console.error(err);
					reject(err);
				});
			});
		}
	}]);

	return CookieHelper;
}();

},{"../servicios/bo/JwtBO/JwtBO":46,"./Constantes":48,"./helpers":53}],50:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ModalMng = exports.ModalMng = function () {
	function ModalMng() {
		_classCallCheck(this, ModalMng);

		this.props = {
			modalBase: "generic-modal"
		};
	}

	_createClass(ModalMng, [{
		key: "createModal",
		value: function createModal(propsModal) {
			var apuntadorClase = this;
			var props = propsModal;
			return new Promise(function (resolve, reject) {
				var modalBase = document.getElementById(apuntadorClase.props.modalBase);

				if (modalBase != undefined) {
					var clonedModal = modalBase.cloneNode(true);
					if (props.id != undefined && props.id != null && props.id != "") {
						clonedModal.id = props.id;
					}
					if (props.title != undefined && props.title != null && props.title != "") {
						var titulo = clonedModal.querySelector(".modal-titulo");
						titulo.innerHTML = props.title;
					} else {
						var _titulo = clonedModal.querySelector(".modal-titulo");
						var padre = _titulo.parentNode;
						padre.parentNode.removeChild(padre);
					}
					if (props.contenido != undefined && props.contenido != null && props.contenido != "") {
						var contDom = apuntadorClase.htmlToElement(props.contenido);
						var subtitulo = clonedModal.querySelector(".modal-contenido");
						subtitulo.append(contDom);
					}

					if (props.botonera != undefined && props.botonera != null && props.botonera != "") {
						var _contDom = apuntadorClase.htmlToElement(props.botonera);
						var _subtitulo = clonedModal.querySelector(".modal-boton-container");
						_subtitulo.append(_contDom);
					}
					if (props.dismisable != undefined && props.dismisable != null && props.dismisable == true) {
						clonedModal.setAttribute("data-backdrop", "static");
						clonedModal.setAttribute("data-keyboard", "false");
					}

					apuntadorClase.insertAfter(clonedModal, modalBase);
					resolve(true);
				} else {
					reject(Error("No base modal found"));
				}
			});
		}
	}, {
		key: "htmlToElement",
		value: function htmlToElement(html) {
			var template = document.createElement('template');
			html = html.trim();
			template.innerHTML = html;
			return template.content;
		}
	}, {
		key: "insertAfter",
		value: function insertAfter(el, referenceNode) {
			referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
		}
	}, {
		key: "insertBefore",
		value: function insertBefore(el, referenceNode) {
			referenceNode.parentNode.insertBefore(el, referenceNode);
		}
	}]);

	return ModalMng;
}();

},{}],51:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ValidaCookieDev = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Constantes = require("./Constantes");

var Constantes = _interopRequireWildcard(_Constantes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ValidaCookieDev = exports.ValidaCookieDev = function () {
    function ValidaCookieDev() {
        _classCallCheck(this, ValidaCookieDev);

        this.init();
    }

    _createClass(ValidaCookieDev, [{
        key: "init",
        value: function init() {
            var host = window.location.host;
            this.checkIfCookie();
            this.setListeners();
        }
    }, {
        key: "checkIfCookie",
        value: function checkIfCookie() {
            if (this.getCookie("accesDev") == undefined) {
                $('#bodyID').append('<div class="modal-backdrop fade show" id="divCover"></div>');
                $('#modalCookieRequestCel').modal('show');
            } else {
                $('#divCover').css('opacity', '0');
                var xcov = document.getElementById("divCover");
                if (xcov != undefined) {
                    xcov.parentNode.removeChild(xcov);
                }
            }
        }
    }, {
        key: "setListeners",
        value: function setListeners() {
            var apuntador = this;
            $('#cookieRequestCel').on('keyup', function () {
                $('#errorCookieRequestCel').html('');
                $('#errorCookieRequestCelCorreo').html('');
            });

            $('#cookieRequestCelCorreo').on('keyup', function () {
                $('#errorCookieRequestCelCorreo').html('');
                $('#errorCookieRequestCel').html('');
            });

            $('#btnCookieRequestCel').on('click', function () {
                var cookieRequestCel = $('#cookieRequestCel').val().trim();
                var cookieRequestCelCorreo = $('#cookieRequestCelCorreo').val().trim();

                if (cookieRequestCel !== "") {
                    $('#btnCookieRequestCel').html('Validando <i class="fas fa-circle-notch fa-spin"></i>');
                    apuntador.enviaCodigoVerficicacion(1, cookieRequestCel);
                } else {
                    if (cookieRequestCelCorreo == "") $('#errorCookieRequestCel').html('*Por favor llena este campo o el de correo');
                }

                if (cookieRequestCelCorreo !== "") {
                    $('#btnCookieRequestCel').html('Validando <i class="fas fa-circle-notch fa-spin"></i>');
                    apuntador.enviaCodigoVerficicacion(2, cookieRequestCelCorreo);
                } else {
                    if (cookieRequestCel == "") $('#errorCookieRequestCelCorreo').html('*Por favor llena este campo o el de empleado');
                }
            });

            $("body").on('keyup', '.campoCodigoDev', function () {
                var campoNumero = parseInt($(this).attr('data-num'));
                if (campoNumero == 6) {

                    var codigoContratacion = $('#nip_dev_1').val() + $('#nip_dev_2').val() + $('#nip_dev_3').val() + $('#nip_dev_4').val() + $('#nip_dev_5').val() + $('#nip_dev_6').val();
                    $('#showCircle').html('<i class="fas fa-circle-notch fa-spin"></i>');
                    console.log(codigoContratacion);
                    apuntador.verificaCodigoVerificacion(codigoContratacion); //*/
                } else {
                    campoNumero++;
                    $('#nip_dev_' + campoNumero).focus();
                }
            });
        }
    }, {
        key: "getCookie",
        value: function getCookie(name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length === 2) return parts.pop().split(';').shift();
        }
    }, {
        key: "enviaCodigoVerficicacion",
        value: function enviaCodigoVerficicacion(opt, param1) {
            var host = window.location.host;
            var url = Constantes.endpoints.adminGC;
            var correo = "";var noempleado = "";

            if (opt == 1) {
                noempleado = param1;
            } else {
                correo = param1;
            }
            var payload = {
                "correo": correo,
                "noempleado": noempleado,
                "path": host
            };

            fetch(url, {
                method: 'POST',
                body: JSON.stringify(payload),
                headers: { 'Content-Type': 'application/json' }
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                console.log(JSON.stringify(respuesta));
                if (respuesta.codigo == 0) {
                    $('#modalCookieRequestCel').modal('hide');
                    $('#verificaCookieCodigoModal').modal('show');
                    setTimeout(function () {
                        document.getElementById('nip_dev_1').focus();
                        $('#nip_dev_1').focus();
                    }, 980);
                    console.log("ok");
                } else {
                    $('#errorBuscaRegistroCookie').html('Lo sentimos, no encontramos tus datos');
                    console.log("else " + respuesta.status);
                }
            }).catch(function (err) {
                $('#errorBuscaRegistroCookie').html('Lo sentimos ocurrió un error, intenta de nuevo');
                console.log("error" + err);
            }).finally(function () {
                $('#btnCookieRequestCel').html('Enviar');
            });
        }
    }, {
        key: "verificaCodigoVerificacion",
        value: function verificaCodigoVerificacion(codigoContratacion) {
            var url = Constantes.endpoints.adminVC;
            var payload = {
                "codigoContratacion": codigoContratacion
            };

            fetch(url, {
                method: 'POST',
                body: JSON.stringify(payload),
                headers: { 'Content-Type': 'application/json' }
            }).then(function (data) {
                if (data.ok) {
                    return data.json();
                } else {
                    throw "Error en la llamada Ajax load sin parametros";
                }
            }).then(function (respuesta) {
                console.log(JSON.stringify(respuesta));
                if (respuesta.codigo == 0) {
                    $('#verificaCookieCodigoModal').modal('hide');
                    var now = new Date();
                    now.setTime(now.getTime() + 5 * 3600 * 1000); //cookie expira después de 5 horas
                    document.cookie = "accesDev=" + respuesta.bean + ";" + ";expires=" + now.toUTCString() + "path=/";

                    $('#divCover').css('opacity', '0');
                    var xcov = document.getElementById("divCover");
                    if (xcov != undefined) {
                        xcov.parentNode.removeChild(xcov);
                    }
                    location.reload();
                } else {

                    $('#nip_dev_1').val('');
                    $('#nip_dev_2').val('');
                    $('#nip_dev_3').val('');
                    $('#nip_dev_4').val('');
                    $('#nip_dev_5').val('');
                    $('#nip_dev_6').val('');
                    $('#nip_dev_1').focus();

                    switch (respuesta.codigo) {
                        case 1:
                            $('#errorVerificaRegistroCookie').html('El código ha expirado, haz click en Enviar de nuevo');
                            break;
                        case 2:
                            $('#errorVerificaRegistroCookie').html('El código es inválido, haz click en Enviar de nuevo');
                            break;
                        case 3:
                            $('#errorVerificaRegistroCookie').html('Intenta nuevamente');
                            break;
                        default:
                            $('#errorVerificaRegistroCookie').html('Intenta nuevamente');
                    }

                    $('#errorVerificaRegistroCookie').html();
                }
            }).catch(function (err) {
                $('#errorVerificaRegistroCookie').html('Lo sentimos ocurrió un error, intenta de nuevo');
                console.log("error" + err);
            }).finally(function () {
                $('#showCircle').html('');
            });
        }
    }]);

    return ValidaCookieDev;
}();

},{"./Constantes":48}],52:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSrcTarjeta = getSrcTarjeta;
var prettifyDate = exports.prettifyDate = function prettifyDate(date) {
    var responseDate = "";
    var cant = "";
    if (date.includes("D")) {
        cant = date.replace("D", "");
        responseDate = cant + " D&iacute;a";
        if (cant != "1") responseDate = responseDate + "s";
    }
    if (date.includes("H")) {
        cant = date.replace("H", "");
        responseDate = cant + " Hora";
        if (cant != "1") responseDate = responseDate + "s";
    }
    if (date.includes("M")) {
        cant = date.replace("M", "");
        responseDate = cant + " Minuto";
        if (cant != "1") responseDate = responseDate + "s";
    }
    return responseDate;
};
function getSrcTarjeta(proveedor) {
    var iconoTarjeta = "";

    if (proveedor == "VISA") {
        iconoTarjeta = "assets/images/icons/visa.svg";
    }
    if (proveedor == "MASTERCARD") {
        iconoTarjeta = "assets/images/icons/mastercard.svg";
    }
    if (proveedor == "AMEX") {
        iconoTarjeta = "assets/images/icons/amex.svg";
    }

    return iconoTarjeta;
}

},{}],53:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouteS = RouteS;
exports.RouteMatcher = RouteMatcher;
exports.RouteNoCompatible = RouteNoCompatible;
var Routes = exports.Routes = function Routes(_base) {

  return {
    login: "" + _base,
    dashboard: _base + "dashboard",
    home: _base + "home",
    edoCuenta: _base + "EstadoCuenta",
    formasPago: _base + "FormasPago",
    tarjetaTotalplay: _base + "TarjetaTotalplay",
    cambioDomicilio: _base + "cambio-domicilio",
    redWifi: _base + "RedWiFi",
    seguimiento: _base + "seguimiento-visita",
    //recomendados:           `${_base}recomendados`,
    seguridad: _base + "seguridad",
    infoGeneral: _base + "informacion-general",
    portabilidad: _base + "portabilidad",
    terminos: _base + "Terminos-Condiciones",
    paquetes: _base + "Paquetes",
    mispagos: _base + "Mispagos",
    revisa: _base + "Revisa",
    hostpostmap: _base + "hostpostmap",
    tycclubwifi: _base + "tycclubwifi"

  };
};

function RouteS(_base) {

  var arrayrutas = {
    login: { "url": "" + _base, tipo: ["publico"] },
    dashboard: { "url": _base + "dashboard", tipo: ["0", "1"] },
    home: { "url": _base + "home", tipo: ["0", "1"] },
    FormasPago: { "url": _base + "FormasPago", tipo: ["0", "1"] },
    TarjetaTotalplay: { "url": _base + "TarjetaTotalplay", tipo: ["0", "1"] },
    RedWiFi: { "url": _base + "RedWiFi", tipo: ["0", "1"] },
    "seguimiento-visita": { "url": _base + "seguimiento-visita", tipo: ["0", "1"] },
    //recomendados:             {"url":`${_base}recomendados`,tipo:["0","1"]},
    seguridad: { "url": _base + "seguridad", tipo: ["0", "1"] },
    "informacion-general": { "url": _base + "informacion-general", tipo: ["0", "1"] },
    portabilidad: { "url": _base + "portabilidad", tipo: ["0", "1"] },
    "Terminos-Condiciones": { "url": _base + "Terminos-Condiciones", tipo: ["0", "1"] },
    Paquetes: { "url": _base + "Paquetes", tipo: ["0", "1"] },
    Mispagos: { "url": _base + "Mispagos", tipo: ["1", "3"] },
    EstadoCuenta: { "url": _base + "EstadoCuenta", tipo: ["0", "2"] },
    Revisa: { "url": _base + "Revisa", tipo: ["0", "1"] },
    hostpostmap: { "url": "" + _base, tipo: ["publico"] },
    tycclubwifi: { "url": "" + _base, tipo: ["publico"] }
  };
  return arrayrutas;
}

function RouteMatcher(_base, ruta) {
  if (_base == ruta) return true;
  if (_base == ruta + "/") return true;
  if (_base == ruta + "index.html") return true;
  if (_base == ruta + ".html") return true;
  return false;
}

function RouteNoCompatible(ruta, tipo) {
  if (ruta.tipo == "publico") return false;
  if (ruta.tipo == tipo) return false;
  return false;
}

},{}]},{},[3]);
